import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '../graphql/ApolloHooksWithContext';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  Dict: { input: any; output: any; }
  EmailAddress: { input: any; output: any; }
  JSON: { input: any; output: any; }
  JWT: { input: any; output: any; }
  Markdown: { input: any; output: any; }
};

export type Account = {
  __typename?: 'Account';
  /** Actor */
  actor?: Maybe<Actor>;
  /** Actors */
  actors: Array<Maybe<Actor>>;
  /** Address data */
  address: Address;
  /** Birthday */
  birthday?: Maybe<Scalars['DateTime']['output']>;
  /** Contact data */
  contact: Contact;
  /** Returns expiration date of last accepted tax document, null - if document not found */
  expirationDateOfLastAcceptedTaxDocument?: Maybe<Scalars['DateTime']['output']>;
  /** Returns true if model has a webmasterId */
  hasWebmasterId: Scalars['Boolean']['output'];
  /** Is account from EU */
  isAccountFromEU: Scalars['Boolean']['output'];
  /** Is account from Germany */
  isAccountFromGermany: Scalars['Boolean']['output'];
  /** Returns true if model may add a new actor */
  isAllowedToAddNewActor: Scalars['Boolean']['output'];
  /** Is conform to model verification policy */
  isModelVerified: Scalars['Boolean']['output'];
  /** Is now online on vxlive.net */
  isOnlineOnVXLive: Scalars['Boolean']['output'];
  /** Is registration complete */
  isRegistrationComplete: Scalars['Boolean']['output'];
  /** Returns true if model account belongs to the studio */
  isStudio: Scalars['Boolean']['output'];
  /** Returns true if account taxable and upload of tax document is required */
  isTaxDocumentRequired: Scalars['Boolean']['output'];
  /** Key accounter */
  keyAccounter?: Maybe<KeyAccounter>;
  /** Language */
  language: Scalars['String']['output'];
  /** Model verification status */
  modelVerificationStatus: ModelVerificationStatusEnum;
  /** Originator / Account owner */
  originator?: Maybe<Originator>;
  /** Personal documents of host (no real persons!) */
  personalDocuments: DocumentsOfHostAccount;
  /** Signup date */
  signupDate: Scalars['Date']['output'];
  /** User-Id */
  userId: Scalars['Int']['output'];
  /** Username */
  userName: Scalars['String']['output'];
  /** Was online on vxlive.net */
  wasOnlineOnVXLive: Scalars['Boolean']['output'];
  /** Webmaster ID */
  webmasterId?: Maybe<Scalars['Int']['output']>;
};


export type AccountActorArgs = {
  actorId: Scalars['Int']['input'];
};


export type AccountActorsArgs = {
  actorId?: InputMaybe<Scalars['Int']['input']>;
  leadActorsOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AccountMutation = {
  __typename?: 'AccountMutation';
  /** Change e-mail address and send welcome email */
  changeEmailAddressAndSendRegistrationMail?: Maybe<MutationResult>;
  /** Change e-mail address and send verification email */
  changeEmailAddressAndSendVerificationMail?: Maybe<MutationResult>;
  /** Change phone number */
  changePhoneNumberAndSendVerificationCode?: Maybe<MutationResult>;
  /** Resend welcome email */
  resendRegistrationMail?: Maybe<MutationResult>;
  /** Resend verification code to phone number */
  resendVerificationCodeToPhoneNumber?: Maybe<MutationResult>;
  /** Resend verification email */
  resendVerificationMail?: Maybe<MutationResult>;
  /** Add or update an actor */
  saveActor?: Maybe<SaveRealPersonMutationResult>;
  /** Save birthday */
  saveBirthday?: Maybe<MutationResult>;
  /** Save contact language */
  saveLanguage?: Maybe<MutationResult>;
  /** Save firstname, lastname or company name */
  saveName?: Maybe<MutationResult>;
  /** Check verification code */
  verifyPhoneNumber?: Maybe<MutationResult>;
};


export type AccountMutationChangeEmailAddressAndSendRegistrationMailArgs = {
  email: Scalars['String']['input'];
};


export type AccountMutationChangeEmailAddressAndSendVerificationMailArgs = {
  email: Scalars['String']['input'];
};


export type AccountMutationChangePhoneNumberAndSendVerificationCodeArgs = {
  phoneNumber: Scalars['String']['input'];
};


export type AccountMutationResendVerificationCodeToPhoneNumberArgs = {
  phoneNumber: Scalars['String']['input'];
};


export type AccountMutationSaveActorArgs = {
  data: InputSaveRealPersonData;
};


export type AccountMutationSaveBirthdayArgs = {
  birthday: Scalars['Date']['input'];
};


export type AccountMutationSaveLanguageArgs = {
  language: ApiLangEnum;
};


export type AccountMutationSaveNameArgs = {
  company?: InputMaybe<Scalars['String']['input']>;
  firstname?: InputMaybe<Scalars['String']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
};


export type AccountMutationVerifyPhoneNumberArgs = {
  code: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type Actor = {
  __typename?: 'Actor';
  /** Returns true if originator is a company */
  address?: Maybe<Address>;
  /** User-Id */
  birthday?: Maybe<Scalars['DateTime']['output']>;
  /** Returns true if actor is lead */
  isLeadActor: Scalars['Boolean']['output'];
  /** Returns true if real person added by model and not yet checked by payment */
  isNew: Scalars['Boolean']['output'];
  /** Returns true if actor is verified (has all required documents) */
  isVerified: Scalars['Boolean']['output'];
  /** Personal documents */
  personalDocuments: DocumentsPersonalRealPerson;
  /** Personal documents status */
  personalDocumentsStatus: ProfileStatusEnum;
  /** User-Id */
  userId: Scalars['Int']['output'];
};

export type Address = {
  __typename?: 'Address';
  /** City */
  city?: Maybe<Scalars['String']['output']>;
  /** Company name */
  companyName?: Maybe<Scalars['String']['output']>;
  /** Country code */
  countryCode?: Maybe<Scalars['String']['output']>;
  /** Firstname */
  firstname?: Maybe<Scalars['String']['output']>;
  /** Is company */
  isCompany: Scalars['Boolean']['output'];
  /** Return true if address can be changed by model */
  isEditable: Scalars['Boolean']['output'];
  /** Lastname */
  lastname?: Maybe<Scalars['String']['output']>;
  /** Street */
  street?: Maybe<Scalars['String']['output']>;
  /** Street number */
  streetNumber?: Maybe<Scalars['String']['output']>;
  /** ZIP code */
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type Adlinks = {
  __typename?: 'Adlinks';
  /** VISIT-X adlink */
  visitx?: Maybe<Scalars['String']['output']>;
  /** VXModels adlink */
  vxmodels: Scalars['String']['output'];
  /** VXSocials adlink */
  vxsocials: Scalars['String']['output'];
};

/** Api stuff */
export type Api = {
  __typename?: 'Api';
  /** JSON representation of context for debugging */
  context?: Maybe<Scalars['JSON']['output']>;
  /** JSON representation of headers for debugging */
  headers?: Maybe<Scalars['JSON']['output']>;
  /** hostname of the server */
  hostname?: Maybe<Scalars['String']['output']>;
  /** current selected lang */
  lang?: Maybe<ApiLangEnum>;
  /** current used PHP version */
  phpVersion?: Maybe<Scalars['String']['output']>;
  /** JSON representation of request for debugging */
  request?: Maybe<Scalars['JSON']['output']>;
};

/** Languages used for API */
export enum ApiLangEnum {
  /** {"de":"Deutsch","en":"German"} */
  De = 'de',
  /** {"de":"Englisch","en":"English"} */
  En = 'en'
}

export type App = {
  __typename?: 'App';
  /** Autologin link for VXLive. */
  autologinLinkVXLive?: Maybe<Scalars['String']['output']>;
  /** Autologin link for VXModels. */
  autologinLinkVXModels?: Maybe<Scalars['String']['output']>;
  /** Hotline code */
  hotlineCode?: Maybe<Scalars['String']['output']>;
};


export type AppAutologinLinkVxModelsArgs = {
  redirect?: InputMaybe<Scalars['String']['input']>;
};

/** Auth stuff */
export type Auth = {
  __typename?: 'Auth';
  /** current used access token */
  accessToken?: Maybe<Scalars['String']['output']>;
  /** DEBUG ONLY, will be removed: Auth prefix, for debugging purpose: Basic|Bearer|etc. */
  authPrefix?: Maybe<Scalars['JWT']['output']>;
  /** expiry date time */
  exp?: Maybe<Scalars['DateTime']['output']>;
  /** issue date time */
  iat?: Maybe<Scalars['DateTime']['output']>;
  /** current logged in user */
  user?: Maybe<AuthUser>;
};

export type AuthMutation = {
  __typename?: 'AuthMutation';
  /** Change password */
  changePassword?: Maybe<PasswordSetResult>;
  /** Login with username/email and password */
  login?: Maybe<AuthResult>;
  /** Login with JWT Token */
  loginWithToken?: Maybe<AuthResult>;
  /** Reset password */
  resetPassword?: Maybe<PasswordResetResult>;
  /** Set new password */
  setPassword?: Maybe<PasswordSetResult>;
  /** Initial Signup with email and password */
  signup?: Maybe<AuthResult>;
};


export type AuthMutationChangePasswordArgs = {
  currentPassword: Scalars['String']['input'];
  isMasterPassword?: InputMaybe<Scalars['Boolean']['input']>;
  newPassword: Scalars['String']['input'];
};


export type AuthMutationLoginArgs = {
  password: Scalars['String']['input'];
  usernameOrEmail: Scalars['String']['input'];
};


export type AuthMutationLoginWithTokenArgs = {
  token: Scalars['String']['input'];
};


export type AuthMutationResetPasswordArgs = {
  email: Scalars['String']['input'];
  username?: InputMaybe<Scalars['String']['input']>;
};


export type AuthMutationSetPasswordArgs = {
  hash: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
};


export type AuthMutationSignupArgs = {
  signupData: InputSignupData;
};

/** Login/Signup result */
export type AuthResult = AuthResultAccountLocked | AuthResultInsufficientRights | AuthResultInvalidCredentials | AuthResultSuccessful | SignupResultFail;

/** Failed login while account is locked */
export type AuthResultAccountLocked = {
  __typename?: 'AuthResultAccountLocked';
  /** Hotline code for contacting model support; Only filled, if model is allowed to use it */
  hotlineCode?: Maybe<Scalars['String']['output']>;
  /** If account locked account, date until lock is active */
  lockedUntil?: Maybe<Scalars['DateTime']['output']>;
  /** Additional information, why login failed */
  message: Scalars['String']['output'];
  /** Information topic of failed login */
  topic: Scalars['String']['output'];
  /** UserId of user */
  userId?: Maybe<Scalars['ID']['output']>;
};

/** Failed login while account has insufficient rights to login */
export type AuthResultInsufficientRights = {
  __typename?: 'AuthResultInsufficientRights';
  /** Hotline code for contacting model support; Only filled, if model is allowed to use it */
  hotlineCode?: Maybe<Scalars['String']['output']>;
  /** Additional information, why login failed */
  message: Scalars['String']['output'];
  /** Information topic of failed login */
  topic: Scalars['String']['output'];
  /** UserId of user */
  userId?: Maybe<Scalars['ID']['output']>;
};

/** Failed login with invalid credentials */
export type AuthResultInvalidCredentials = {
  __typename?: 'AuthResultInvalidCredentials';
  /** Additional information, why login failed */
  message: Scalars['String']['output'];
  /** Information topic of failed login */
  topic: Scalars['String']['output'];
};

/** Successful login result */
export type AuthResultSuccessful = {
  __typename?: 'AuthResultSuccessful';
  /** JWT access token */
  accessToken: Scalars['JWT']['output'];
  /** Redirect URL */
  redirectUrl?: Maybe<Scalars['String']['output']>;
  /** JWT refresh token, only set in login response */
  refreshToken: Scalars['JWT']['output'];
  /** Authenticated user */
  user?: Maybe<AuthUser>;
};

/** Auth user */
export type AuthUser = {
  __typename?: 'AuthUser';
  /** Users default language */
  lang: ApiLangEnum;
  /** User permissions */
  permissions: Array<AuthUserPermissionEnum>;
  /** User roles */
  roles: Array<SecurityRoleEnum>;
  /** Auth scope */
  scope: ScopeEnum;
  /** User ID */
  userId: Scalars['ID']['output'];
  /** Username */
  username: Scalars['String']['output'];
};

/** User permissions */
export enum AuthUserPermissionEnum {
  ChatPricesView = 'CHAT_PRICES_VIEW',
  FinanceStatsView = 'FINANCE_STATS_VIEW',
  FinanceView = 'FINANCE_VIEW',
  MessengerGoOnline = 'MESSENGER_GO_ONLINE',
  VxfeedView = 'VXFEED_VIEW'
}

export enum BodyFigureEnum {
  /** {"de":"athletisch", "en":"athletic"} */
  Athletic = 'athletic',
  /** {"de":"mollig", "en":"chubby"} */
  Chubby = 'chubby',
  /** {"de":"dick", "en":"fat"} */
  Fat = 'fat',
  /** {"de":"schlank", "en":"slim"} */
  Slim = 'slim',
  /** {"de":"durchschnittlich", "en":"standard"} */
  Standard = 'standard'
}

/** Body Modification */
export enum BodyModificationsEnum {
  /** {"de":"stark tätowiert", "en":"heavily tattooed"} */
  HeavilyTattooed = 'heavilyTattooed',
  /** {"de":"intim piercing", "en":"intimate pierching"} */
  IntimatePiercing = 'intimatePiercing',
  /** {"de":"intim tattoo", "en":"intimate tattoo"} */
  IntimateTattoo = 'intimateTattoo',
  /** {"de":"keine Veränderungen", "en":"no body modifications"} */
  NoModifications = 'noModifications',
  /** {"de":"Brustpiercing", "en":"pectoral piercing"} */
  PectoralPiercing = 'pectoralPiercing'
}

/** Breast Size */
export enum BreastSizeEnum {
  /** {"de":"A", "en":"A"} */
  A = 'A',
  /** {"de":"AA", "en":"AA"} */
  Aa = 'AA',
  /** {"de":"B", "en":"B"} */
  B = 'B',
  /** {"de":"C", "en":"C"} */
  C = 'C',
  /** {"de":"D", "en":"D"} */
  D = 'D',
  /** {"de":"DD", "en":"DD"} */
  Dd = 'DD',
  /** {"de":"E", "en":"E"} */
  E = 'E',
  /** {"de":"F", "en":"F"} */
  F = 'F',
  /** {"de":">F", "en":">F"} */
  GtF = 'GT_F',
  /** {"de":"Keine Angabe", "en":"Not specified"} */
  Null = '_NULL_'
}

/** Chat Practices */
export enum ChatPracticesEnum {
  /** {"de":"Chatten/Flirten", "en":"chatten flirten"} */
  Chatflirt = 'chatflirt',
  /** {"de":"Dirty-Talk", "en":"dirtytalk"} */
  Dirtytalk = 'dirtytalk',
  /** {"de":"Livesex", "en":"livesex"} */
  Livesex = 'livesex',
  /** {"de":"Selbstbefriedigung", "en":"masturbation"} */
  Masturbation = 'masturbation',
  /** {"de":"Striptease", "en":"striptease"} */
  Striptease = 'striptease'
}

export type Cms = {
  __typename?: 'Cms';
  /** article */
  article?: Maybe<CmsArticle>;
};


export type CmsArticleArgs = {
  id: Scalars['ID']['input'];
  lang?: InputMaybe<ApiLangEnum>;
  rev?: InputMaybe<Scalars['Int']['input']>;
};

/** CMS Article */
export type CmsArticle = {
  __typename?: 'CmsArticle';
  /** content */
  content: Scalars['String']['output'];
  /** articleId */
  id: Scalars['ID']['output'];
  /** language */
  lang: ApiLangEnum;
  /** Current Revision of article */
  revision: CmsArticleRevision;
  /** Exisiting revisions */
  revisions: Array<CmsArticleRevision>;
  /** title */
  title?: Maybe<Scalars['String']['output']>;
  /** Type of Content */
  type: ContentTypeEnum;
};

/** CMS Article Revision */
export type CmsArticleRevision = {
  __typename?: 'CmsArticleRevision';
  /** content */
  comment: Scalars['String']['output'];
  /** revision */
  modified: Scalars['DateTime']['output'];
  /** PDF download Url */
  pdfUrl?: Maybe<Scalars['String']['output']>;
  /** content */
  published: Scalars['DateTime']['output'];
  /** articleId */
  rev: Scalars['Int']['output'];
  /** language */
  status: ApiLangEnum;
  /** title */
  title: Scalars['String']['output'];
};

export type Contact = {
  __typename?: 'Contact';
  /** Returns current email address */
  currentEmailAddress: Scalars['String']['output'];
  /** Returns current mobile phone number */
  currentMobileNumber?: Maybe<PhoneNumber>;
  /** Actual e-mail address */
  emailAddress: Scalars['String']['output'];
  /** Facebook (profile name) */
  facebook?: Maybe<Scalars['String']['output']>;
  /** Actual fixed phone number */
  fixedPhoneNumber?: Maybe<PhoneNumber>;
  /** Instagram account */
  instagram?: Maybe<Scalars['String']['output']>;
  /** Returns true if current email address is verified */
  isCurrentEmailAddressVerified: Scalars['Boolean']['output'];
  /** Returns true if current mobile phone number is verified */
  isCurrentMobileNumberVerified: Scalars['Boolean']['output'];
  /** Is e-mail address verified */
  isEmailAddressVerified: Scalars['Boolean']['output'];
  /** New not verified e-mail address */
  newEmailAddress?: Maybe<Scalars['String']['output']>;
  /** New not verified fixed phone number */
  newFixedPhoneNumber?: Maybe<PhoneNumber>;
  /** Skype account */
  skype?: Maybe<Scalars['String']['output']>;
  /** Twitter account */
  twitter?: Maybe<Scalars['String']['output']>;
  /** Whatsapp */
  whatsapp?: Maybe<PhoneNumber>;
  /** Youtube account */
  youtube?: Maybe<Scalars['String']['output']>;
};

/** Content types */
export enum ContentTypeEnum {
  Html = 'html',
  Markdown = 'markdown',
  Plaintext = 'plaintext'
}

/** Class CountryEnum @package Api\Services\Profile\Values\Enum */
export enum CountryEnum {
  /** {"de":"Andorra","en":"Andorra"} */
  Ad = 'AD',
  /** {"de":"Vereinigte Arabische Emirate","en":"United Arab Emirates"} */
  Ae = 'AE',
  /** {"de":"Afghanistan","en":"Afghanistan"} */
  Af = 'AF',
  /** {"de":"Antigua und Barbuda","en":"Antigua and Barbuda"} */
  Ag = 'AG',
  /** {"de":"Anguilla","en":"Anguilla"} */
  Ai = 'AI',
  /** {"de":"Albanien","en":"Albania"} */
  Al = 'AL',
  /** {"de":"Armenien","en":"Armenia"} */
  Am = 'AM',
  /** {"de":"Niederlaendische Antillen","en":"Netherlands Antilles"} */
  An = 'AN',
  /** {"de":"Angola","en":"Angola"} */
  Ao = 'AO',
  /** {"de":"Antarktis","en":"Antarctica"} */
  Aq = 'AQ',
  /** {"de":"Argentinien","en":"Argentina"} */
  Ar = 'AR',
  /** {"de":"Amerikanisch Samoa","en":"American Samoa"} */
  As = 'AS',
  /** {"de":"Österreich","en":"Austria (EU)"} */
  At = 'AT',
  /** {"de":"Australien","en":"Australia"} */
  Au = 'AU',
  /** {"de":"Aruba","en":"Aruba"} */
  Aw = 'AW',
  /** {"de":"Aland Islands","en":"Aland Islands"} */
  Ax = 'AX',
  /** {"de":"Aserbaidschan","en":"Azerbaijan"} */
  Az = 'AZ',
  /** {"de":"Bosnien-Herzegowina","en":"Bosnia-Herzegovina"} */
  Ba = 'BA',
  /** {"de":"Barbados","en":"Barbados"} */
  Bb = 'BB',
  /** {"de":"Bangladesch","en":"Bangladesh"} */
  Bd = 'BD',
  /** {"de":"Belgien","en":"Belgium"} */
  Be = 'BE',
  /** {"de":"Burkina Faso","en":"Burkina Faso"} */
  Bf = 'BF',
  /** {"de":"Bulgarien","en":"Bulgaria"} */
  Bg = 'BG',
  /** {"de":"Bahrain","en":"Bahrein"} */
  Bh = 'BH',
  /** {"de":"Burundi","en":"Burundi"} */
  Bi = 'BI',
  /** {"de":"Benin","en":"Benin"} */
  Bj = 'BJ',
  /** {"de":"Bermudas","en":"Bermuda"} */
  Bm = 'BM',
  /** {"de":"Brunei","en":"Brunei Darussalam"} */
  Bn = 'BN',
  /** {"de":"Bolivien","en":"Bolivia"} */
  Bo = 'BO',
  /** {"de":"Brasilien","en":"Brazil"} */
  Br = 'BR',
  /** {"de":"Bahamas","en":"Bahamas"} */
  Bs = 'BS',
  /** {"de":"Bhutan","en":"Bhutan"} */
  Bt = 'BT',
  /** {"de":"Bouvet Insel","en":"Bouvet Island"} */
  Bv = 'BV',
  /** {"de":"Botswana","en":"Botswana"} */
  Bw = 'BW',
  /** {"de":"Weissrussland","en":"Belarus"} */
  By = 'BY',
  /** {"de":"Belize","en":"Belize"} */
  Bz = 'BZ',
  /** {"de":"Kanada","en":"Canada"} */
  Ca = 'CA',
  /** {"de":"Cocos (Keeling) Inseln","en":"Cocos Islands"} */
  Cc = 'CC',
  /** {"de":"Kongo","en":"Congo"} */
  Cd = 'CD',
  /** {"de":"Zentralafrikanische Republik","en":"Central African Republic"} */
  Cf = 'CF',
  /** {"de":"Congo","en":"Congo"} */
  Cg = 'CG',
  /** {"de":"Schweiz","en":"Switzerland"} */
  Ch = 'CH',
  /** {"de":"Cote d`Ivoire","en":"Cote dIvoire"} */
  Ci = 'CI',
  /** {"de":"Cook Inseln","en":"Cook Islands"} */
  Ck = 'CK',
  /** {"de":"Chile","en":"Chile"} */
  Cl = 'CL',
  /** {"de":"Kamerun","en":"Cameroon"} */
  Cm = 'CM',
  /** {"de":"China","en":"China"} */
  Cn = 'CN',
  /** {"de":"Kolumbien","en":"Columbia"} */
  Co = 'CO',
  /** {"de":"Costa Rica","en":"Costa Rica"} */
  Cr = 'CR',
  /** {"de":"Serbien Montenegro","en":"Serbia Montenegro"} */
  Cs = 'CS',
  /** {"de":"Kuba","en":"Cuba"} */
  Cu = 'CU',
  /** {"de":"Kap Verde","en":"Cape Verde"} */
  Cv = 'CV',
  /** {"de":"Weihnachtsinseln","en":"Christmas Island"} */
  Cx = 'CX',
  /** {"de":"Zypern","en":"Cypern"} */
  Cy = 'CY',
  /** {"de":"Tschechische Republik","en":"Czech Republic"} */
  Cz = 'CZ',
  /** {"de":"Deutschland","en":"Germany (EU)"} */
  De = 'DE',
  /** {"de":"Dschibuti","en":"Djibouti"} */
  Dj = 'DJ',
  /** {"de":"Dänemark","en":"Denmark (EU)"} */
  Dk = 'DK',
  /** {"de":"Dominica","en":"Dominica"} */
  Dm = 'DM',
  /** {"de":"Dominikanische Republik","en":"Dominican Republic"} */
  Do = 'DO',
  /** {"de":"Algerien","en":"Algeria"} */
  Dz = 'DZ',
  /** {"de":"Spanien, Kanarische Inseln","en":"Spain (Canari Islands)"} */
  E5 = 'E5',
  /** {"de":"Ecuador","en":"Ecuador"} */
  Ec = 'EC',
  /** {"de":"Estland","en":"Estonia"} */
  Ee = 'EE',
  /** {"de":"Ägypten","en":"Egypt"} */
  Eg = 'EG',
  /** {"de":"Western Sahara","en":"Western Sahara"} */
  Eh = 'EH',
  /** {"de":"Eritrea","en":"Eritrea"} */
  Er = 'ER',
  /** {"de":"Spanien","en":"Spain (EU)"} */
  Es = 'ES',
  /** {"de":"Äthiopien","en":"Ethiopia"} */
  Et = 'ET',
  /** {"de":"Finnland","en":"Finland (EU)"} */
  Fi = 'FI',
  /** {"de":"Fidschi","en":"Fiji Islands"} */
  Fj = 'FJ',
  /** {"de":"Falkland Inseln","en":"Falkland Islands"} */
  Fk = 'FK',
  /** {"de":"Färöer Inseln","en":"Faeroe Islands"} */
  Fo = 'FO',
  /** {"de":"Frankreich","en":"France (EU)"} */
  Fr = 'FR',
  /** {"de":"Gabun","en":"Gabon"} */
  Ga = 'GA',
  /** {"de":"Grenada","en":"Grenada"} */
  Gd = 'GD',
  /** {"de":"Georgien","en":"Georgia"} */
  Ge = 'GE',
  /** {"de":"Französisch-Guyana","en":"French Guiana"} */
  Gf = 'GF',
  /** {"de":"Guernsey","en":"Guernsey"} */
  Gg = 'GG',
  /** {"de":"Ghana","en":"Ghana"} */
  Gh = 'GH',
  /** {"de":"Gibraltar","en":"Gibraltar"} */
  Gi = 'GI',
  /** {"de":"Grönland","en":"Greenland"} */
  Gl = 'GL',
  /** {"de":"Gambia","en":"Gambia"} */
  Gm = 'GM',
  /** {"de":"Guinea","en":"Guinea"} */
  Gn = 'GN',
  /** {"de":"Guadeloupe","en":"Guadeloupe"} */
  Gp = 'GP',
  /** {"de":"Äquatorial-Guinea","en":"Equatorial Guinea"} */
  Gq = 'GQ',
  /** {"de":"Griechenland","en":"Greece (EU)"} */
  Gr = 'GR',
  /** {"de":"Guatemala","en":"Guatemala"} */
  Gt = 'GT',
  /** {"de":"Guam","en":"Guam"} */
  Gu = 'GU',
  /** {"de":"Guinea-Bissau","en":"Guinea-Bissau"} */
  Gw = 'GW',
  /** {"de":"Guyana","en":"Guyana"} */
  Gy = 'GY',
  /** {"de":"Hong Kong","en":"Hong Kong"} */
  Hk = 'HK',
  /** {"de":"Heard und McDonald Inseln","en":"Heard and McDonald Islands"} */
  Hm = 'HM',
  /** {"de":"Honduras","en":"Honduras"} */
  Hn = 'HN',
  /** {"de":"Kroatien","en":"Croatia"} */
  Hr = 'HR',
  /** {"de":"Haiti","en":"Haiti"} */
  Ht = 'HT',
  /** {"de":"Ungarn","en":"Hungary"} */
  Hu = 'HU',
  /** {"de":"Indonesien","en":"Indonesia"} */
  Id = 'ID',
  /** {"de":"Irland","en":"Ireland (EU)"} */
  Ie = 'IE',
  /** {"de":"Israel","en":"Israel"} */
  Il = 'IL',
  /** {"de":"Isle of Man","en":"Isle of Man"} */
  Im = 'IM',
  /** {"de":"Indien","en":"India"} */
  In = 'IN',
  /** {"de":"Irak","en":"Iraq"} */
  Iq = 'IQ',
  /** {"de":"Iran","en":"Iran"} */
  Ir = 'IR',
  /** {"de":"Island","en":"Iceland"} */
  Is = 'IS',
  /** {"de":"Italien","en":"Italy (EU)"} */
  It = 'IT',
  /** {"de":"Jersey","en":"Jersey"} */
  Je = 'JE',
  /** {"de":"Jamaika","en":"Jamaica"} */
  Jm = 'JM',
  /** {"de":"Jordanien","en":"Jordan"} */
  Jo = 'JO',
  /** {"de":"Japan","en":"Japan"} */
  Jp = 'JP',
  /** {"de":"Kenia","en":"Kenya"} */
  Ke = 'KE',
  /** {"de":"Kirgistan","en":"Kyrgyzstan"} */
  Kg = 'KG',
  /** {"de":"Kambodscha","en":"Cambodia"} */
  Kh = 'KH',
  /** {"de":"Kiribati","en":"Kiribati"} */
  Ki = 'KI',
  /** {"de":"Komoren","en":"Comoros"} */
  Km = 'KM',
  /** {"de":"Saint Kitts und Nevis","en":"St.Kitts and Nevis"} */
  Kn = 'KN',
  /** {"de":"Korea, Sued","en":"South Korea"} */
  Kr = 'KR',
  /** {"de":"Kuwait","en":"Kuwait"} */
  Kw = 'KW',
  /** {"de":"Cayman Inseln","en":"Cayman Islands"} */
  Ky = 'KY',
  /** {"de":"Kasachstan","en":"Kazakhstan"} */
  Kz = 'KZ',
  /** {"de":"Laos","en":"Laos"} */
  La = 'LA',
  /** {"de":"Libanon","en":"Lebanon"} */
  Lb = 'LB',
  /** {"de":"Saint Lucia","en":"St.Lucia"} */
  Lc = 'LC',
  /** {"de":"Liechtenstein","en":"Liechtenstein"} */
  Li = 'LI',
  /** {"de":"Sri Lanka","en":"Sri Lanka"} */
  Lk = 'LK',
  /** {"de":"Liberia","en":"Liberia"} */
  Lr = 'LR',
  /** {"de":"Lesotho","en":"Lesotho"} */
  Ls = 'LS',
  /** {"de":"Litauen","en":"Lithuania"} */
  Lt = 'LT',
  /** {"de":"Luxemburg","en":"Luxembourg (EU)"} */
  Lu = 'LU',
  /** {"de":"Lettland","en":"Latvia"} */
  Lv = 'LV',
  /** {"de":"Libyen","en":"Libya"} */
  Ly = 'LY',
  /** {"de":"Marokko","en":"Morocco"} */
  Ma = 'MA',
  /** {"de":"Monaco","en":"Monaco"} */
  Mc = 'MC',
  /** {"de":"Moldawien","en":"Moldova, Republic of"} */
  Md = 'MD',
  /** {"de":"Montenegro","en":"Montenegro"} */
  Me = 'ME',
  /** {"de":"Madagaskar","en":"Madagascar"} */
  Mg = 'MG',
  /** {"de":"Marshall Islands","en":"Marshall Islands"} */
  Mh = 'MH',
  /** {"de":"Midway Islands","en":"Midway Islands"} */
  Mi = 'MI',
  /** {"de":"Mazedonien","en":"Macedonia"} */
  Mk = 'MK',
  /** {"de":"Mali","en":"Mali"} */
  Ml = 'ML',
  /** {"de":"Myanmar","en":"Myanmar"} */
  Mm = 'MM',
  /** {"de":"Mongolei","en":"Mongolia"} */
  Mn = 'MN',
  /** {"de":"Macau","en":"Macau"} */
  Mo = 'MO',
  /** {"de":"Nördliche Mariana Inseln","en":"Northern Mariana Islands"} */
  Mp = 'MP',
  /** {"de":"Martinique","en":"Martinique"} */
  Mq = 'MQ',
  /** {"de":"Mauritanien","en":"Mauritania"} */
  Mr = 'MR',
  /** {"de":"Montserrat","en":"Montserrat"} */
  Ms = 'MS',
  /** {"de":"Malta","en":"Malta"} */
  Mt = 'MT',
  /** {"de":"Mauritius","en":"Mauritius"} */
  Mu = 'MU',
  /** {"de":"Malediven","en":"Maldives"} */
  Mv = 'MV',
  /** {"de":"Malawi","en":"Malawi"} */
  Mw = 'MW',
  /** {"de":"Mexiko","en":"Mexico"} */
  Mx = 'MX',
  /** {"de":"Malaysia","en":"Malaysia"} */
  My = 'MY',
  /** {"de":"Mosambik","en":"Mozambique"} */
  Mz = 'MZ',
  /** {"de":"Namibia","en":"Namibia"} */
  Na = 'NA',
  /** {"de":"Neukaledonien","en":"New Caladonia"} */
  Nc = 'NC',
  /** {"de":"Niger","en":"Niger"} */
  Ne = 'NE',
  /** {"de":"Norfolk Inseln","en":"Norfolk Island"} */
  Nf = 'NF',
  /** {"de":"Nigeria","en":"Nigeria"} */
  Ng = 'NG',
  /** {"de":"Nicaragua","en":"Nicaragua"} */
  Ni = 'NI',
  /** {"de":"Niederlande","en":"Netherlands (EU)"} */
  Nl = 'NL',
  /** {"de":"Norwegen","en":"Norway"} */
  No = 'NO',
  /** {"de":"Nepal","en":"Nepal"} */
  Np = 'NP',
  /** {"de":"Nauru","en":"Nauru"} */
  Nr = 'NR',
  /** {"de":"Niue","en":"Niue"} */
  Nu = 'NU',
  /** {"de":"Neuseeland","en":"New Zealand"} */
  Nz = 'NZ',
  /** {"de":"Oman","en":"Oman"} */
  Om = 'OM',
  /** {"de":"Panama","en":"Panama"} */
  Pa = 'PA',
  /** {"de":"Peru","en":"Peru"} */
  Pe = 'PE',
  /** {"de":"Französisch Polynesien","en":"French Polynesia"} */
  Pf = 'PF',
  /** {"de":"Papua-Neuguinea","en":"Papua New Guinea"} */
  Pg = 'PG',
  /** {"de":"Philippinen","en":"Philippines"} */
  Ph = 'PH',
  /** {"de":"Pakistan","en":"Pakistan"} */
  Pk = 'PK',
  /** {"de":"Polen","en":"Poland"} */
  Pl = 'PL',
  /** {"de":"Saint Pierre und Miquelon","en":"St.Pierre and Miquelon"} */
  Pm = 'PM',
  /** {"de":"Pitcairn","en":"Pitcairn"} */
  Pn = 'PN',
  /** {"de":"Puerto Rico","en":"Puerto Rico"} */
  Pr = 'PR',
  /** {"de":"Palestinian Territory","en":"Palestinian Territory"} */
  Ps = 'PS',
  /** {"de":"Portugal","en":"Portugal (EU)"} */
  Pt = 'PT',
  /** {"de":"Palau","en":"Palau"} */
  Pw = 'PW',
  /** {"de":"Paraguay","en":"Paraguay"} */
  Py = 'PY',
  /** {"de":"Katar","en":"Qatar"} */
  Qa = 'QA',
  /** {"de":"Reunion","en":"Reunion"} */
  Re = 'RE',
  /** {"de":"Rumänien","en":"Romania"} */
  Ro = 'RO',
  /** {"de":"Serbia","en":"Serbia"} */
  Rs = 'RS',
  /** {"de":"Russische Föderation","en":"Russian Federation"} */
  Ru = 'RU',
  /** {"de":"Ruanda","en":"Rwanda"} */
  Rw = 'RW',
  /** {"de":"Saudi Arabien","en":"Saudi Arabia"} */
  Sa = 'SA',
  /** {"de":"Solomon Islands","en":"Solomon Islands"} */
  Sb = 'SB',
  /** {"de":"Seychellen","en":"Seychelles"} */
  Sc = 'SC',
  /** {"de":"Sudan","en":"Sudan"} */
  Sd = 'SD',
  /** {"de":"Schweden","en":"Sweden (EU)"} */
  Se = 'SE',
  /** {"de":"Singapur","en":"Singapore"} */
  Sg = 'SG',
  /** {"de":"Saint Helena","en":"St.Helena"} */
  Sh = 'SH',
  /** {"de":"Slowenien","en":"Slovenia"} */
  Si = 'SI',
  /** {"de":"Slowakei","en":"Slovak Republic"} */
  Sk = 'SK',
  /** {"de":"Sierra Leone","en":"Sierra Leone"} */
  Sl = 'SL',
  /** {"de":"San Marino","en":"San Marino"} */
  Sm = 'SM',
  /** {"de":"Senegal","en":"Senegal"} */
  Sn = 'SN',
  /** {"de":"Somalia","en":"Somalia"} */
  So = 'SO',
  /** {"de":"Surinam","en":"Suriname"} */
  Sr = 'SR',
  /** {"de":"Sao Tome und Principe","en":"Sao Tome and Principe"} */
  St = 'ST',
  /** {"de":"El Salvador","en":"El Salvador"} */
  Sv = 'SV',
  /** {"de":"Syrien","en":"Syria"} */
  Sy = 'SY',
  /** {"de":"Swaziland","en":"Swaziland"} */
  Sz = 'SZ',
  /** {"de":"Turks und Caicos Inseln","en":"Turks and Caicos Islands"} */
  Tc = 'TC',
  /** {"de":"Tschad","en":"Chad"} */
  Td = 'TD',
  /** {"de":"French Southern Territories","en":"French Southern Territories"} */
  Tf = 'TF',
  /** {"de":"Togo","en":"Togo"} */
  Tg = 'TG',
  /** {"de":"Thailand","en":"Thailand"} */
  Th = 'TH',
  /** {"de":"Tadschikistan","en":"Tajikistan"} */
  Tj = 'TJ',
  /** {"de":"Tokelau","en":"Tokelau"} */
  Tk = 'TK',
  /** {"de":"Turkmenistan","en":"Turkmenistan"} */
  Tm = 'TM',
  /** {"de":"Tunesien","en":"Tunesia"} */
  Tn = 'TN',
  /** {"de":"Tonga","en":"Tonga"} */
  To = 'TO',
  /** {"de":"Ost Timor","en":"East Timor"} */
  Tp = 'TP',
  /** {"de":"Türkei","en":"Turkey"} */
  Tr = 'TR',
  /** {"de":"Trinidad und Tobago","en":"Trinidad and Tobago"} */
  Tt = 'TT',
  /** {"de":"Tuvalu","en":"Tuvalu"} */
  Tv = 'TV',
  /** {"de":"Taiwan","en":"Taiwan"} */
  Tw = 'TW',
  /** {"de":"Tansania","en":"Tanzania"} */
  Tz = 'TZ',
  /** {"de":"Ukraine","en":"Ukraine"} */
  Ua = 'UA',
  /** {"de":"Uganda","en":"Uganda"} */
  Ug = 'UG',
  /** {"de":"Grossbritannien","en":"United Kingdom"} */
  Uk = 'UK',
  /** {"de":"United States Minor Outlying Islands","en":"United States Minor Outlying Islands"} */
  Um = 'UM',
  /** {"de":"USA","en":"U.S.A."} */
  Us = 'US',
  /** {"de":"Uruguay","en":"Uruguay"} */
  Uy = 'UY',
  /** {"de":"Usbekistan","en":"Uzbekistan"} */
  Uz = 'UZ',
  /** {"de":"Vatikanstadt","en":"Vatican City"} */
  Va = 'VA',
  /** {"de":"Venezuela","en":"Venezuela"} */
  Ve = 'VE',
  /** {"de":"Virgin Islands (Britisch)","en":"British Virgin Island"} */
  Vg = 'VG',
  /** {"de":"Virgin Islands (USA)","en":"US Virgin Islands"} */
  Vi = 'VI',
  /** {"de":"Vietnam","en":"Vietnam"} */
  Vn = 'VN',
  /** {"de":"Vanuatu","en":"Vanuatu"} */
  Vu = 'VU',
  /** {"de":"Wallis und Futuna Inseln","en":"Wallis and Fortuna Islands"} */
  Wf = 'WF',
  /** {"de":"Samoa","en":"Samoa"} */
  Ws = 'WS',
  /** {"de":"Kosovo","en":"Kosovo"} */
  Xk = 'XK',
  /** {"de":"Jemen","en":"Yemen"} */
  Ye = 'YE',
  /** {"de":"Mayotte","en":"Mayotte"} */
  Yt = 'YT',
  /** {"de":"Jugoslawien","en":"Yugoslavia"} */
  Yu = 'YU',
  /** {"de":"Süd Afrika","en":"South Africa"} */
  Za = 'ZA',
  /** {"de":"Sambia","en":"Zambia"} */
  Zm = 'ZM',
  /** {"de":"Zimbabwe","en":"Zimbabwe"} */
  Zw = 'ZW'
}

/** Deep Lang Types */
export enum DeeplLangEnum {
  De = 'de',
  En = 'en',
  Es = 'es'
}

/** Media Text */
export type DeeplTranslateText = {
  __typename?: 'DeeplTranslateText';
  /** language */
  lang: Scalars['String']['output'];
  /** text */
  text: Scalars['String']['output'];
};

export type Document = {
  __typename?: 'Document';
  /** Original file name */
  filename: Scalars['String']['output'];
  /** Document ID */
  id: Scalars['Int']['output'];
  /** Returns true if document can is an image */
  isImage: Scalars['Boolean']['output'];
  /** Rejection reason if document us rejected */
  rejectionReason?: Maybe<Scalars['String']['output']>;
  /** Document side */
  side: DocumentSideEnum;
  /** Document status */
  status: DocumentStatusEnum;
  /** Document type */
  type: DocumentTypeEnum;
  /** Document type name */
  typeName: Scalars['String']['output'];
  /** Upload date */
  uploadDate: Scalars['DateTime']['output'];
  /** Download URL (expires in 2 hours) */
  url: Scalars['String']['output'];
  /** User-ID of document owner */
  userId: Scalars['Int']['output'];
};

/** Document side */
export enum DocumentSideEnum {
  Backside = 'backside',
  EntireDocument = 'entireDocument',
  Frontside = 'frontside'
}

/** Document status */
export enum DocumentStatusEnum {
  /** Document in check */
  Checking = 'checking',
  /** Document is missing */
  Missing = 'missing',
  /** Document is verified */
  Ok = 'ok',
  /** Document is rejected */
  Rejected = 'rejected'
}

export enum DocumentTypeEnum {
  /** Address proof */
  AddressProof = 'addressProof',
  /** Businnes (tax) registration */
  BusinnesRegistration = 'businnesRegistration',
  /** GEMA Nachweis */
  GemaNachweis = 'gemaNachweis',
  /** ID Shot (Ausweis mit Gesicht) */
  IdShot = 'idShot',
  /** Identity proof */
  IdentityProof = 'identityProof',
  /** Model release form */
  ModelReleaseForm = 'modelReleaseForm',
  /** Other document type */
  Other = 'other',
  /** Perso snapshot */
  PersoSnapshot = 'persoSnapshot',
  /** Sales contract */
  SalesContract = 'salesContract',
  /** Self-protection statement */
  SelfProtectionStatement = 'selfProtectionStatement',
  /** Document for transfer ownership */
  TransferOwnership = 'transferOwnership',
  /** VAT document */
  Vat = 'vat'
}

export type DocumentUploadAssistant = {
  __typename?: 'DocumentUploadAssistant';
  /** tour completeness in percent */
  completenessPercent: Scalars['Int']['output'];
  /** Current step. If NULL - all steps complete */
  currentStep?: Maybe<DocumentUploadAssistantStep>;
  /** Firstname */
  firstname: Scalars['String']['output'];
  /** Lastname */
  lastname: Scalars['String']['output'];
  /** All step of tour */
  steps: Array<Maybe<DocumentUploadAssistantStep>>;
  /** Total steps */
  totalSteps: Scalars['Int']['output'];
  /** User ID */
  userId: Scalars['Int']['output'];
};

export type DocumentUploadAssistantStep = {
  __typename?: 'DocumentUploadAssistantStep';
  /** Document type */
  documentType: DocumentTypeEnum;
  /** Example URL */
  exampleUrl?: Maybe<Scalars['String']['output']>;
  /** Last uploaded document */
  lastUploadedDocument?: Maybe<Document>;
  /** Step name */
  name: DocumentUploadAssistantStepEnum;
  /** Position */
  position: Scalars['Int']['output'];
  /** Step status */
  status: DocumentUploadAssistantStepStatusEnum;
  /** Template URL */
  templateUrl?: Maybe<Scalars['String']['output']>;
  /** Upload URL */
  uploadUrl: Scalars['String']['output'];
};

/** Document upload step */
export enum DocumentUploadAssistantStepEnum {
  /** Upload-Step: Proof of address */
  AddressProof = 'addressProof',
  /** Upload-Step: ID-Shot */
  IdShot = 'idShot',
  /** Upload-Step: Identity proof (back side) */
  IdentityProofBackside = 'identityProofBackside',
  /** Upload-Step: Identity proof (front side) */
  IdentityProofFrontside = 'identityProofFrontside',
  /** Upload-Step:  Model release form */
  ModelReleaseForm = 'modelReleaseForm',
  /** Upload-Step: VAT document */
  SalesTaxClassification = 'salesTaxClassification',
  /** Upload-Step:  Businnes (tax) verification */
  SalesTaxObligation = 'salesTaxObligation'
}

/** Document upload step status */
export enum DocumentUploadAssistantStepStatusEnum {
  /** Documents in check */
  Checking = 'checking',
  /** Tour complete */
  Complete = 'complete',
  /** Missing documents */
  Open = 'open',
  /** Documents rejected */
  Rejected = 'rejected'
}

/** Document upload flow */
export enum DocumentUploadAssistantTypeEnum {
  /** Flow: Account owner verification */
  AccountOwnerVerification = 'accountOwnerVerification',
  /** Flow: Actor verification */
  ActorVerification = 'actorVerification'
}

export type Documents = {
  __typename?: 'Documents';
  /** Query for a active or valid Model Release Form (MRF) for a user. */
  modelReleaseForm?: Maybe<FormManagerPaperlessForm>;
  /** Document upload assistant */
  tour: DocumentUploadAssistant;
  /** Document upload URL */
  uploadUrl: Scalars['String']['output'];
};


export type DocumentsModelReleaseFormArgs = {
  lang?: InputMaybe<ModelReleaseFormLanguageEnum>;
  requestContext?: InputMaybe<ModelReleaseFormRequestContextEnum>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type DocumentsTourArgs = {
  name: DocumentUploadAssistantTypeEnum;
  step?: InputMaybe<DocumentUploadAssistantStepEnum>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type DocumentsUploadUrlArgs = {
  side?: InputMaybe<DocumentSideEnum>;
  type: DocumentTypeEnum;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type DocumentsFinancialRealPerson = {
  __typename?: 'DocumentsFinancialRealPerson';
  /** Returns true if proof of address is required */
  isProofOfAddressRequired: Scalars['Boolean']['output'];
  /** Returns true if tax document is required */
  isTaxDocumentRequired: Scalars['Boolean']['output'];
  /** Proof of address */
  proofOfAddress?: Maybe<Document>;
  /** Tax document */
  taxDocument?: Maybe<Document>;
  /** Real person ID */
  userId: Scalars['Int']['output'];
};

export type DocumentsMutation = {
  __typename?: 'DocumentsMutation';
  /** Init a Model Release Form (MRF) for a user. If the user already has an MRF, it will be returned */
  initModelReleaseForm: FormManagerPaperlessForm;
  /** Skip upload for backside of document */
  skipBacksideUpload?: Maybe<Scalars['Boolean']['output']>;
};


export type DocumentsMutationInitModelReleaseFormArgs = {
  lang?: InputMaybe<ModelReleaseFormLanguageEnum>;
  requestContext?: InputMaybe<ModelReleaseFormRequestContextEnum>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type DocumentsMutationSkipBacksideUploadArgs = {
  type?: InputMaybe<DocumentTypeEnum>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type DocumentsOfHostAccount = {
  __typename?: 'DocumentsOfHostAccount';
  /** Number of uploaded personal documents */
  documentsCount: Scalars['Int']['output'];
  /** ID-Shot */
  idShot?: Maybe<Document>;
  /** Identity proof (back side) */
  identityProofBack?: Maybe<Document>;
  /** Identity proof (front side) */
  identityProofFront?: Maybe<Document>;
  /** Model release form of real person */
  modelReleaseForm?: Maybe<Document>;
  /** Model ID */
  userId: Scalars['Int']['output'];
};

export type DocumentsPersonalRealPerson = {
  __typename?: 'DocumentsPersonalRealPerson';
  /** ID-Shot */
  idShot?: Maybe<Document>;
  /** Identity proof (back side) */
  identityProofBack?: Maybe<Document>;
  /** Identity proof (front side) */
  identityProofFront?: Maybe<Document>;
  /** Returns true if ID-Shot is required */
  isIdShotRequired: Scalars['Boolean']['output'];
  /** Returns true if Model release form is required */
  isModelReleaseFormRequired: Scalars['Boolean']['output'];
  /** Model release form of real person */
  modelReleaseForm?: Maybe<Document>;
  /** Real person ID */
  userId: Scalars['Int']['output'];
};

export enum EyeColorEnum {
  /** {"de":"Blau", "en":"blue"} */
  Blue = 'blue',
  /** {"de":"Braun", "en":"brown"} */
  Brown = 'brown',
  /** {"de":"Grün", "en":"green"} */
  Green = 'green',
  /** {"de":"Grau", "en":"grey"} */
  Grey = 'grey',
  /** {"de":"Andere", "en":"other"} */
  Other = 'other'
}

export type Finances = {
  __typename?: 'Finances';
  /** Returns BIC by IBAN */
  bicByIban: Scalars['String']['output'];
  /** Billings */
  billings: Array<Maybe<FinancesBilling>>;
  /** Invoices (performed payouts) */
  invoices: FinancesInvoices;
  /** Payout assistant */
  payoutAssistant: FinancesPayoutAssistant;
  /** Payout conditions */
  payoutConditions: FinancesPayoutConditions;
  /** Payout status: payable amount, status, payout date and other information */
  payoutStatus: FinancesPayoutStatus;
  /** Payout time table */
  payoutTimeTable: Array<Maybe<FinancesPayoutTimeTable>>;
  /** Tax obligation */
  taxObligation: FinancesTaxObligation;
  /** Turnover for period grouped by day */
  turnoverForPeriodGroupedByDay?: Maybe<Array<Maybe<StatisticDaily>>>;
  /** Turnover for period grouped by day */
  turnoverForPeriodGroupedByType?: Maybe<Array<Maybe<FinancesTurnoverGroupedByGroup>>>;
  /** Total turnover for period */
  turnoverForPeriodTotal: Scalars['Float']['output'];
};


export type FinancesBicByIbanArgs = {
  iban: Scalars['String']['input'];
};


export type FinancesBillingsArgs = {
  year?: InputMaybe<Scalars['Int']['input']>;
};


export type FinancesInvoicesArgs = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};


export type FinancesTurnoverForPeriodGroupedByDayArgs = {
  endDate: Scalars['Date']['input'];
  startDate: Scalars['Date']['input'];
};


export type FinancesTurnoverForPeriodGroupedByTypeArgs = {
  endDate: Scalars['Date']['input'];
  startDate: Scalars['Date']['input'];
};


export type FinancesTurnoverForPeriodTotalArgs = {
  endDate: Scalars['Date']['input'];
  startDate: Scalars['Date']['input'];
};

export type FinancesBilling = {
  __typename?: 'FinancesBilling';
  /** Amount */
  amount: Scalars['Float']['output'];
  /** Bill number */
  billNumber: Scalars['String']['output'];
  /** Billing end date */
  billingEndDate: Scalars['Date']['output'];
  /** Billing start date */
  billingStartDate: Scalars['Date']['output'];
  /** Company */
  company: FinancesBillingCompanyEnum;
  /** Company name */
  companyName: Scalars['String']['output'];
  /** ID */
  id: Scalars['Int']['output'];
  /** Issue date */
  issueDate: Scalars['Date']['output'];
  /** Status */
  status?: Maybe<FinancesBillingStatusEnum>;
  /** Status */
  type: FinancesBillingTypeEnum;
};

/** Billing companies */
export enum FinancesBillingCompanyEnum {
  Campoint = 'campoint',
  Cfg = 'cfg'
}

/** Billing status */
export enum FinancesBillingStatusEnum {
  Checked = 'checked',
  Created = 'created',
  Paid = 'paid'
}

/** Billing types */
export enum FinancesBillingTypeEnum {
  Billing = 'billing',
  Cancellation = 'cancellation',
  Correction = 'correction',
  Invoice = 'invoice'
}

export type FinancesInvoice = {
  __typename?: 'FinancesInvoice';
  /** Amount */
  amount: Scalars['Float']['output'];
  /** Billing end date */
  billingEndDate: Scalars['Date']['output'];
  /** Billing start date */
  billingStartDate: Scalars['Date']['output'];
  /** Status information */
  message: Scalars['String']['output'];
  /** Payout date */
  payoutDate: Scalars['Date']['output'];
  /** Status */
  status: FinancesInvoiceStatusEnum;
};

/** Invoice status */
export enum FinancesInvoiceStatusEnum {
  /** Payout can not be made */
  Error = 'error',
  /** Payout successfully completed */
  Ok = 'ok',
  /** Waiting for payout */
  Waiting = 'waiting'
}

export type FinancesInvoices = {
  __typename?: 'FinancesInvoices';
  /** count */
  count: Scalars['Int']['output'];
  /** Array of invoices */
  invoices?: Maybe<Array<Maybe<FinancesInvoice>>>;
  /** Max date, null if count = 0 */
  maxDate?: Maybe<Scalars['Date']['output']>;
  /** Min date, null if count = 0 */
  minDate?: Maybe<Scalars['Date']['output']>;
};

export type FinancesMutation = {
  __typename?: 'FinancesMutation';
  /** Cancel request of a payout (currently without function) */
  cancelPayout: FinancesPayoutStatus;
  /** Manual request a payout (currently without function) */
  requestPayout: FinancesPayoutStatus;
  /** Cancel request of a payout (currently without function) */
  savePayoutAssistant: MutationResult;
};


export type FinancesMutationSavePayoutAssistantArgs = {
  amount: Scalars['Float']['input'];
  rhythm: FinancesPayoutAssistantRhythmEnum;
};

export type FinancesPayoutAssistant = {
  __typename?: 'FinancesPayoutAssistant';
  /** Allowed amounts */
  allowedAmounts: Array<Maybe<Scalars['Float']['output']>>;
  /** Allowed rhythms */
  allowedRhythms: Array<Maybe<FinancesPayoutAssistantRhythmItem>>;
  /** Current min amount */
  currentMinAmount: Scalars['Float']['output'];
  /** Current rhythm */
  currentRhythm: FinancesPayoutAssistantRhythmItem;
  /** Is allowed to set up a payout assisteant */
  isAssistantAllowed: Scalars['Boolean']['output'];
};

/** Payout status */
export enum FinancesPayoutAssistantRhythmEnum {
  /** Automatic payout / begining of month */
  BeginOfMonth = 'beginOfMonth',
  /** Automatic payout / beweekly */
  Biweekly = 'biweekly',
  /** Automatic payout / middle of month */
  MiddleOfMonth = 'middleOfMonth',
  /** Manual payout / on deamand */
  Ondemand = 'ondemand'
}

export type FinancesPayoutAssistantRhythmItem = {
  __typename?: 'FinancesPayoutAssistantRhythmItem';
  /** Rhythm ID */
  id: FinancesPayoutAssistantRhythmEnum;
  /** Rhythm name */
  label: Scalars['String']['output'];
  /** Next possible payout date */
  nextPossiblePayoutDate?: Maybe<Scalars['DateTime']['output']>;
};

export type FinancesPayoutConditions = {
  __typename?: 'FinancesPayoutConditions';
  /** Fee for other bank transfer */
  feeBank3L: Scalars['Float']['output'];
  /** Fee for german bank transfer */
  feeBankDE: Scalars['Float']['output'];
  /** Fee for EU bank transfer */
  feeBankEU: Scalars['Float']['output'];
  /** Fee for paxum */
  feePaxum: Scalars['Float']['output'];
  /** Under min amount fee */
  feeUnderMinAmount: Scalars['Float']['output'];
  /** Min amount for other bank transfer */
  minAmountBank3L: Scalars['Float']['output'];
  /** Min amount for german bank transfer */
  minAmountBankDE: Scalars['Float']['output'];
  /** Min amount for EU bank transfer */
  minAmountBankEU: Scalars['Float']['output'];
  /** Min amount for paxum */
  minAmountPaxum: Scalars['Float']['output'];
};

/** Payout method */
export enum FinancesPayoutMethodEnum {
  /** Payout via bank */
  Bank = 'bank',
  /** Payout via cheque */
  Cheque = 'cheque',
  /** Payout via Paxum */
  Paxum = 'paxum'
}

export type FinancesPayoutStatus = {
  __typename?: 'FinancesPayoutStatus';
  /** Billing end date */
  billingEndDate: Scalars['Date']['output'];
  /** Billing from date */
  billingFromDate: Scalars['Date']['output'];
  /** Is cancellation of payout request allowed */
  isCancellationAllowed: Scalars['Boolean']['output'];
  /** Is first payout */
  isFirstPayout: Scalars['Boolean']['output'];
  /** Minimal payable amount */
  minimalPayableAmount: Scalars['Float']['output'];
  /** Payable amount */
  payableAmount: Scalars['Float']['output'];
  /** Payout date */
  payoutDate?: Maybe<Scalars['Date']['output']>;
  /** Status */
  status: FinancesPayoutStatusEnum;
};

/** Payout status */
export enum FinancesPayoutStatusEnum {
  /** Model has set up the payout assistant */
  AutomaticPayoutCreated = 'automaticPayoutCreated',
  /** Payout not allowed: internal account */
  InternalAccount = 'internalAccount',
  /** Payout not allowed: invalid payout data */
  InvalidPayoutData = 'invalidPayoutData',
  /** Manual payout allowed */
  ManualPayoutAllowed = 'manualPayoutAllowed',
  /** Payout not allowed: missing required documents */
  MissingDocuments = 'missingDocuments',
  /** Payout not allowed: common error */
  NotAllowed = 'notAllowed',
  /** Payout already requested */
  PayoutAlreadyRequested = 'payoutAlreadyRequested'
}

export type FinancesPayoutTimeTable = {
  __typename?: 'FinancesPayoutTimeTable';
  /** End date of billing period */
  billingEndDate: Scalars['Date']['output'];
  /** Start date of billing period */
  billingFromDate: Scalars['Date']['output'];
  /** Payout date */
  payoutDate: Scalars['Date']['output'];
};

export type FinancesTaxObligation = {
  __typename?: 'FinancesTaxObligation';
  /** Is account taxable */
  isTaxable: Scalars['Boolean']['output'];
  /** Last uploaded document */
  lastUploadedDocument?: Maybe<Document>;
  /** Tax number status */
  status?: Maybe<FinancesTaxObligationStatusEnum>;
  /** Tax document upload URL */
  taxDocumentUploadUrl?: Maybe<Scalars['String']['output']>;
  /** Returns tax-ID (TIN) */
  taxId?: Maybe<Scalars['String']['output']>;
  /** Returns tax-ID (TIN) */
  taxIdCountry?: Maybe<Scalars['String']['output']>;
  /** Returns tax number if account taxable */
  taxNumber?: Maybe<Scalars['String']['output']>;
};

/** Tax number status */
export enum FinancesTaxObligationStatusEnum {
  Accepted = 'accepted',
  Incomplete = 'incomplete',
  Open = 'open',
  Pending = 'pending',
  Rejected = 'rejected'
}

/** Turnover groups */
export enum FinancesTurnoverGroupEnum {
  Chargeback = 'chargeback',
  Chat = 'chat',
  Competition = 'competition',
  Contentmodell = 'contentmodell',
  Diverses = 'diverses',
  Inkasso = 'inkasso',
  Messenger = 'messenger',
  Service0900 = 'service0900',
  Shop = 'shop',
  Telegram = 'telegram',
  Voice = 'voice',
  Vxpages = 'vxpages'
}

export type FinancesTurnoverGroupedByGroup = {
  __typename?: 'FinancesTurnoverGroupedByGroup';
  /** Translated label */
  label: Scalars['String']['output'];
  /** Turnover type */
  type: FinancesTurnoverGroupEnum;
  /** Value */
  value: Scalars['Float']['output'];
};

/** FormManager Form */
export type FormManagerForm = {
  /** formular class */
  class: Scalars['String']['output'];
  /** formular data */
  formdata?: Maybe<Scalars['Dict']['output']>;
  /** formular id */
  id?: Maybe<Scalars['ID']['output']>;
  /** Metadata as dict */
  metadata?: Maybe<Scalars['Dict']['output']>;
  /** formular status */
  status: FormStatusEnum;
  /** formular created from userid */
  userId: Scalars['Int']['output'];
};

/** FormManager Paperless Form */
export type FormManagerGenericForm = FormManagerForm & {
  __typename?: 'FormManagerGenericForm';
  /** formular class */
  class: Scalars['String']['output'];
  /** formular data */
  formdata?: Maybe<Scalars['Dict']['output']>;
  /** formular id */
  id?: Maybe<Scalars['ID']['output']>;
  /** Metadata as dict */
  metadata?: Maybe<Scalars['Dict']['output']>;
  /** formular status */
  status: FormStatusEnum;
  /** formular created from userid */
  userId: Scalars['Int']['output'];
};

/** FormManager Paperless Form */
export type FormManagerPaperlessForm = FormManagerForm & {
  __typename?: 'FormManagerPaperlessForm';
  /** formular class */
  class: Scalars['String']['output'];
  /**
   * Paperless Document information
   * @deprecated Use paperlessDocument instead
   */
  document?: Maybe<PaperlessDocument>;
  /** Form URL (null if already completed) */
  formUrl?: Maybe<Scalars['String']['output']>;
  /** formular data */
  formdata?: Maybe<Scalars['Dict']['output']>;
  /** formular id */
  id?: Maybe<Scalars['ID']['output']>;
  /** Metadata as dict */
  metadata?: Maybe<Scalars['Dict']['output']>;
  /** Paperless Document information */
  paperlessDocument?: Maybe<PaperlessDocument>;
  /** Paperless Submission information */
  paperlessSubmission?: Maybe<PaperlessSubmission>;
  /** formular status */
  status: FormStatusEnum;
  /**
   * Paperless Submission information
   * @deprecated Use paperlessSubmission instead
   */
  submission?: Maybe<PaperlessSubmission>;
  /** User Document information */
  userDocument?: Maybe<Document>;
  /** formular created from userid */
  userId: Scalars['Int']['output'];
};


/** FormManager Paperless Form */
export type FormManagerPaperlessFormFormUrlArgs = {
  redirUrl: Scalars['String']['input'];
};

/** Document status */
export enum FormStatusEnum {
  Accepted = 'accepted',
  Complete = 'complete',
  Draft = 'draft',
  Incomplete = 'incomplete',
  Pending = 'pending',
  Rejected = 'rejected'
}

/** Gender */
export enum GenderEnum {
  /** {"de":"weiblich", "en":"female"} */
  Female = 'female',
  /** {"de":"männlich", "en":"male"} */
  Male = 'male',
  /** {"de":"transgender", "en":"transgender"} */
  Transgender = 'transgender'
}

export enum HairColorEnum {
  /** {"de":"Schwarz", "en":"black"} */
  Black = 'black',
  /** {"de":"Blond", "en":"blonde"} */
  Blonde = 'blonde',
  /** {"de":"Braun", "en":"brown"} */
  Brown = 'brown',
  /** {"de":"Bunt", "en":"colorful"} */
  Colorful = 'colorful',
  /** {"de":"Grau", "en":"grey"} */
  Gray = 'gray',
  /** {"de":"Rot", "en":"red"} */
  Red = 'red'
}

/** Helpcenter Root */
export type Helpcenter = {
  __typename?: 'Helpcenter';
  /** Helpcenter FAQ */
  faq?: Maybe<HelpcenterFaq>;
  /** Helpcenter hints */
  hints?: Maybe<HelpcenterHints>;
  /** Income sources */
  incomeSources?: Maybe<IncomeSources>;
  /** Helpcenter tips */
  tips?: Maybe<Tips>;
  /** Helpcenter URL */
  url?: Maybe<Scalars['String']['output']>;
};


/** Helpcenter Root */
export type HelpcenterHintsArgs = {
  type: HelpcenterHintsTypeEnum;
};

/** Helpcenter FAQ */
export type HelpcenterFaq = {
  __typename?: 'HelpcenterFaq';
  /** FAQ entries */
  entries: Array<Maybe<HelpcenterFaqEntry>>;
};

/** Helpcenter FAQ entry */
export type HelpcenterFaqEntry = {
  __typename?: 'HelpcenterFaqEntry';
  /** FAQ answer */
  answer: Scalars['Markdown']['output'];
  /** FAQ question */
  question: Scalars['Markdown']['output'];
};

/** Helpcenter FAQ entry */
export type HelpcenterHintEntry = {
  __typename?: 'HelpcenterHintEntry';
  /** Hint body */
  body: Scalars['Markdown']['output'];
  /** Hint image URL */
  image: Image;
  /** Hint title */
  title: Scalars['String']['output'];
};

/** Helpcenter FAQ */
export type HelpcenterHints = {
  __typename?: 'HelpcenterHints';
  /** Helpcenter hint entries */
  entries: Array<Maybe<HelpcenterHintEntry>>;
};

/** Hints type */
export enum HelpcenterHintsTypeEnum {
  /** Hints for go online */
  Goonline = 'goonline',
  /** Hints for onboarding */
  Onboarding = 'onboarding'
}

export type HelpcenterMutation = {
  __typename?: 'HelpcenterMutation';
  /** everything updating a income sources status */
  incomeSources?: Maybe<IncomeSourcesMutation>;
  /** everything updating a tips status */
  tips?: Maybe<TipsMutation>;
};

export type Image = {
  __typename?: 'Image';
  /** Image alt, see HTML img alt */
  alt: Scalars['String']['output'];
  /** Image src, see HTML img src */
  src: Scalars['String']['output'];
  /** Image srcSet, see HTML img srcset */
  srcset: Scalars['String']['output'];
};


export type ImageSrcArgs = {
  size?: ImageSizeEnum;
};

/** Image sizes */
export enum ImageSizeEnum {
  Orig = 'ORIG',
  W40 = 'W40',
  W60 = 'W60',
  W140 = 'W140',
  W160 = 'W160',
  W320 = 'W320',
  W640 = 'W640',
  W1024 = 'W1024'
}

/** Income sources */
export type IncomeSources = {
  __typename?: 'IncomeSources';
  /** Income sources entries */
  entries: Array<Maybe<IncomeSourcesEntry>>;
  /** List of all allowed recipient groups */
  experienceTags: Array<Maybe<TipsTag>>;
  /** Returns income source by Id */
  incomeSourceById?: Maybe<IncomeSourcesEntry>;
  /** List of all allowed tags */
  intentionTags: Array<Maybe<TipsTag>>;
};


/** Income sources */
export type IncomeSourcesEntriesArgs = {
  experienceTags?: InputMaybe<Array<InputMaybe<TipsExperienceTagEnum>>>;
  intentionTags?: InputMaybe<Array<InputMaybe<TipsIntentionTagEnum>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  targets?: InputMaybe<Array<InputMaybe<TipsTargetEnum>>>;
};


/** Income sources */
export type IncomeSourcesIncomeSourceByIdArgs = {
  id: Scalars['ID']['input'];
};

/** Income source entry */
export type IncomeSourcesEntry = {
  __typename?: 'IncomeSourcesEntry';
  /** Returns the date when feature was activated, NULL if not yet active */
  activatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Body */
  body: Scalars['Markdown']['output'];
  /** Experience tags */
  experienceTags?: Maybe<Array<Maybe<TipsTag>>>;
  /** Teaser image */
  headerImage: Image;
  /** Income source ID */
  id: Scalars['ID']['output'];
  /** Intention tags */
  intentionTags?: Maybe<Array<Maybe<TipsTag>>>;
  /** Returns true if income source labeled as new */
  isLabeledNew: Scalars['Boolean']['output'];
  /** Returns the date when income source was read, NULL if not yet read */
  readAt?: Maybe<Scalars['DateTime']['output']>;
  /** Teaser text */
  teaserText: Scalars['String']['output'];
  /** Title */
  title: Scalars['String']['output'];
};

export type IncomeSourcesMutation = {
  __typename?: 'IncomeSourcesMutation';
  /** Activate feature */
  activate?: Maybe<IncomeSourcesEntry>;
  /** Deactivate feature */
  deactivate?: Maybe<IncomeSourcesEntry>;
  /** Mark an income source as read */
  markAsRead?: Maybe<IncomeSourcesEntry>;
  /** Mark an income source as unread */
  markAsUnread?: Maybe<IncomeSourcesEntry>;
};


export type IncomeSourcesMutationActivateArgs = {
  id: Scalars['String']['input'];
};


export type IncomeSourcesMutationDeactivateArgs = {
  id: Scalars['String']['input'];
};


export type IncomeSourcesMutationMarkAsReadArgs = {
  id: Scalars['String']['input'];
};


export type IncomeSourcesMutationMarkAsUnreadArgs = {
  id: Scalars['String']['input'];
};

export type InputLangText = {
  /** language */
  lang?: InputMaybe<LanguagesEnum>;
  /** text */
  text?: InputMaybe<Scalars['String']['input']>;
  /** translate language true or false */
  translate?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputPaymentBillingAddress = {
  /** Payment Billing Address - City */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Payment Billing Address - Company Name */
  companyname?: InputMaybe<Scalars['String']['input']>;
  /** Payment Billing Address - Country */
  country?: InputMaybe<CountryEnum>;
  /** Payment Billing Address - Document */
  document?: InputMaybe<Scalars['Int']['input']>;
  /** Payment Billing Address - City */
  firstname?: InputMaybe<Scalars['String']['input']>;
  /** Payment Billing Address - is Company */
  isCompany?: InputMaybe<Scalars['Boolean']['input']>;
  /** Payment Billing Address - City */
  lastname?: InputMaybe<Scalars['String']['input']>;
  /** Payment Billing Address - PostalCode */
  postalCode?: InputMaybe<Scalars['String']['input']>;
  /** Payment Billing Address - street */
  street?: InputMaybe<Scalars['String']['input']>;
  /** Payment Billing Address - street number */
  streetNumber?: InputMaybe<Scalars['String']['input']>;
};

export type InputPaymentPayoutData = {
  /** Payout Bankaccountowner */
  bankAccountOwner?: InputMaybe<Scalars['String']['input']>;
  /** Payout BIC */
  bankBic?: InputMaybe<Scalars['String']['input']>;
  /** Payout IBAN */
  bankIban?: InputMaybe<Scalars['String']['input']>;
  /** Payout Paxum Email Account */
  paxumEmailAccount?: InputMaybe<Scalars['String']['input']>;
  /** Payout Type of Transaction (paxum, bank, cheque) */
  payoutMethod?: InputMaybe<FinancesPayoutMethodEnum>;
};

export type InputPaymentTaxData = {
  /** Payout Tax Document */
  document?: InputMaybe<Scalars['Int']['input']>;
  /** Payout Is Model Taxable */
  isTaxable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Payout Tax Number, possible VAT ID or Tax ID (__not EU Taxpayer Identification Number TIN__) */
  taxNumber?: InputMaybe<Scalars['String']['input']>;
  /** EU Taxpayer Identification Number (TIN) */
  tin?: InputMaybe<Scalars['String']['input']>;
  /** Taxpayer Identification Number (TIN) registration country */
  tinCountry?: InputMaybe<TaxCountryEnum>;
};

export type InputPictureListFilter = {
  /** filter for picture status */
  status?: InputMaybe<Array<InputMaybe<MediaPictureStatusEnum>>>;
};

export type InputPictureListSort = {
  /** language */
  lang: LanguagesEnum;
  /** text */
  text?: InputMaybe<Scalars['String']['input']>;
};

export type InputProfileCollectionAccountV1 = {
  /** Account city */
  accountAddressCity?: InputMaybe<Scalars['String']['input']>;
  /** Account address company name */
  accountAddressCompany?: InputMaybe<Scalars['String']['input']>;
  /** Account address country */
  accountAddressCountry?: InputMaybe<CountryEnum>;
  /** Account address postal code */
  accountAddressPostalCode?: InputMaybe<Scalars['String']['input']>;
  /** Account address street name */
  accountAddressStreet?: InputMaybe<Scalars['String']['input']>;
  /** Account address street number */
  accountAddressStreetNumber?: InputMaybe<Scalars['String']['input']>;
  /** Account birthdate */
  accountBirthdate?: InputMaybe<Scalars['Date']['input']>;
  /** Account contact email address */
  accountContactEmailAdress?: InputMaybe<Scalars['String']['input']>;
  /** Account contact (fixed) phone */
  accountContactFixedPhone?: InputMaybe<Scalars['String']['input']>;
  /** Account contact mobile phone */
  accountContactMobilePhone?: InputMaybe<Scalars['String']['input']>;
  /** Account firstname */
  accountFirstname?: InputMaybe<Scalars['String']['input']>;
  /** Account language (used for emails, etc.) */
  accountLanguage?: InputMaybe<ApiLangEnum>;
  /** Account lastname */
  accountLastname?: InputMaybe<Scalars['String']['input']>;
  /** Model Username (a.k.a login, screenname) [alfanum, 6-16] */
  modelUsername?: InputMaybe<Scalars['String']['input']>;
};

export type InputProfileCollectionMobileAboutMeV1 = {
  /** Model About Me */
  modelAboutMe?: InputMaybe<Array<InputLangText>>;
  /** Model Birthdate, may differ from account (real person) birthdate [YYYY-MM-DD] */
  modelBirthdate?: InputMaybe<Scalars['Date']['input']>;
  /** Model Chat Parctices [chatflirt, dirtytalk, striptease, livesex, masturbation] */
  modelChatPractices?: InputMaybe<Array<ChatPracticesEnum>>;
  /** Model city */
  modelCity?: InputMaybe<Scalars['String']['input']>;
  /** Model country */
  modelCountry?: InputMaybe<CountryEnum>;
  /** Model gender [female, male, transgender] */
  modelGender?: InputMaybe<GenderEnum>;
  /** Model Language [de, en, fr ....] */
  modelLanguage?: InputMaybe<Array<LanguagesEnum>>;
  /** Model Motto (a.k.a. Chat Motto) [string, 10-100] */
  modelMotto?: InputMaybe<Array<InputLangText>>;
  /** Model Postal Code */
  modelPostalCode?: InputMaybe<Scalars['String']['input']>;
  /** Model gender [single, seeking, inOpenRelationship, inRelationship, engaged, married] */
  modelRelationshipState?: InputMaybe<RelationshipEnum>;
  /** Model sexuality [heterosexual, homesexual, bisexual] */
  modelSexuality?: InputMaybe<SexualityEnum>;
  /** Model Username (a.k.a login, screenname) [alfanum, 6-16] */
  modelUsername?: InputMaybe<Scalars['String']['input']>;
};

export type InputProfileCollectionMobileAppearanceV1 = {
  /** Model Body Figure [athletic, chubby, fat ....] */
  modelBodyFigure?: InputMaybe<BodyFigureEnum>;
  /** Model Body Height */
  modelBodyHeight?: InputMaybe<Scalars['Int']['input']>;
  /** Model Body Modifcations [heavily tattooed, intimate (piercing, tattoo), pectoral piercing, no body modifications] */
  modelBodyModifications?: InputMaybe<Array<BodyModificationsEnum>>;
  /** Model Body Weight */
  modelBodyWeight?: InputMaybe<Scalars['Int']['input']>;
  /** Model Breast Size [_NULL_,AA,A,B,C,D,DD,E,F,>F] */
  modelBreastSize?: InputMaybe<BreastSizeEnum>;
  /** Model Eye color [blue, green, brown....] */
  modelEyeColor?: InputMaybe<EyeColorEnum>;
  /** Model Hair Color [blonde, brown, black ....] */
  modelHairColor?: InputMaybe<HairColorEnum>;
  /** Model Penize Size [_NULL_, s,m,l,xl,xxl] */
  modelPenisSize?: InputMaybe<PenisSizeEnum>;
  /** Model Pubic Hair [hollywood, landing strip, bikini cut ....] */
  modelPubicHair?: InputMaybe<PubicHairEnum>;
  /** Model Skin Type [asian, black skinned ...] */
  modelSkinType?: InputMaybe<SkinTypeEnum>;
};

export type InputProfileCollectionMobileInterviewV1 = {
  /** Model Interview Enterprise [string, 0-250] */
  modelInterviewEnterprise?: InputMaybe<Array<InputLangText>>;
  /** Model Interview Erotic Experience [string, 0-250] */
  modelInterviewEroticExperience?: InputMaybe<Array<InputLangText>>;
  /** Model Interview Hobbies [string, 0-250] */
  modelInterviewHobbies?: InputMaybe<Array<InputLangText>>;
  /** Model Interview Island [string, 0-250] */
  modelInterviewIsland?: InputMaybe<Array<InputLangText>>;
  /** Model Interview Partner [string, 0-250] */
  modelInterviewPartner?: InputMaybe<Array<InputLangText>>;
  /** Model Interview Sex No Go [string, 0-250] */
  modelInterviewSexNotOk?: InputMaybe<Array<InputLangText>>;
  /** Model Interview Sex Go [string, 0-250] */
  modelInterviewSexOk?: InputMaybe<Array<InputLangText>>;
  /** Model Interview Sexual Fantasies [string, 0-250] */
  modelInterviewSexualFantasies?: InputMaybe<Array<InputLangText>>;
  /** Model Interview Sexual Position [string, 0-250] */
  modelInterviewSexualPosition?: InputMaybe<Array<InputLangText>>;
};

export type InputProfileCollectionMobileMediaV1 = {
  /** Model avatar picture, from FSK12 sedcard  (ratio 1:1, displayed as cropped circle) */
  modelPictureFSK12Avatar?: InputMaybe<Scalars['Int']['input']>;
  /** Model sedcard pictures, from FSK12 */
  modelPictureFSK12Sedcard?: InputMaybe<Scalars['Int']['input']>;
  /** Model avatar picture, from FSK16 sedcard  (ratio 1:1, displayed as cropped circle) */
  modelPictureFSK16Avatar?: InputMaybe<Scalars['Int']['input']>;
  /** Model sedcard pictures, from FSK16 */
  modelPictureFSK16Sedcard?: InputMaybe<Scalars['Int']['input']>;
  /** Model avatar picture, from FSK18 sedcard  (ratio 1:1, displayed as cropped circle) */
  modelPictureFSK18Avatar?: InputMaybe<Scalars['Int']['input']>;
  /** Model sedcard pictures, from FSK18 */
  modelPictureFSK18Sedcard?: InputMaybe<Scalars['Int']['input']>;
  /** Model title picture as landscape, from FSK16 sedcard (ratio 25:10) */
  modelPictureTitleLandscape?: InputMaybe<Scalars['Int']['input']>;
};

export type InputProfileCollectionMobileProfileV1 = {
  /** Model About Me */
  modelAboutMe?: InputMaybe<Array<InputLangText>>;
  /** Model Birthdate, may differ from account (real person) birthdate [YYYY-MM-DD] */
  modelBirthdate?: InputMaybe<Scalars['Date']['input']>;
  /** Model Body Height */
  modelBodyHeight?: InputMaybe<Scalars['Int']['input']>;
  /** Model Body Weight */
  modelBodyWeight?: InputMaybe<Scalars['Int']['input']>;
  /** Model Breast Size [_NULL_,AA,A,B,C,D,DD,E,F,>F] */
  modelBreastSize?: InputMaybe<BreastSizeEnum>;
  /** Model gender [female, male, transgender] */
  modelGender?: InputMaybe<GenderEnum>;
  /** Model Motto (a.k.a. Chat Motto) [string, 10-100] */
  modelMotto?: InputMaybe<Array<InputLangText>>;
  /** Model Penize Size [_NULL_, s,m,l,xl,xxl] */
  modelPenisSize?: InputMaybe<PenisSizeEnum>;
  /** @deprecated use ModelPictureFSK16Avatar instead Model avatar picture, from FSK16 sedcard  (ratio 1:1, displayed as cropped circle) */
  modelPictureAvatar?: InputMaybe<Scalars['Int']['input']>;
  /** Model title picture as landscape, from FSK16 sedcard (ratio 25:10) */
  modelPictureTitleLandscape?: InputMaybe<Scalars['Int']['input']>;
  /** Model sexuality [heterosexual, homesexual, bisexual] */
  modelSexuality?: InputMaybe<SexualityEnum>;
  /** Model Username (a.k.a login, screenname) [alfanum, 6-16] */
  modelUsername?: InputMaybe<Scalars['String']['input']>;
};

export type InputProfileCollectionModelReleaseFormV1 = {
  /** @deprecated use MrfModelBirthdate instead Model Release Form Birthdate [YYYY-MM-DD] */
  mrfBirthdate?: InputMaybe<Scalars['Date']['input']>;
  /** @deprecated use MrfModelBirthplace instead Model Release Form birthplace */
  mrfBirthplace?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated use MrfModelCity instead Model Release Form city */
  mrfCity?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated use MrfModelCountry instead Model Release Form country */
  mrfCountry?: InputMaybe<CountryEnum>;
  /** @deprecated use MrfModelFirstname instead Model Release Form firstname */
  mrfFirstname?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated @alias MrfModelForm */
  mrfForm?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated use MrfModelLastname instead Model Release Form lastname */
  mrfLastname?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated use MrfModelPostalCode instead Model Release Form postal code */
  mrfPostalCode?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated use MrfModelStreet instead Model Release Form street */
  mrfStreet?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated use MrfModelStreetNumber instead Model Release Form street number */
  mrfStreetNumber?: InputMaybe<Scalars['String']['input']>;
};

export type InputProfileCollectionOnboardingV1 = {
  /** Model Birthdate, may differ from account (real person) birthdate [YYYY-MM-DD] */
  modelBirthdate?: InputMaybe<Scalars['Date']['input']>;
  /** Model gender [female, male, transgender] */
  modelGender?: InputMaybe<GenderEnum>;
  /** Model Motto (a.k.a. Chat Motto) [string, 10-100] */
  modelMotto?: InputMaybe<Array<InputLangText>>;
  /** @deprecated use ModelPictureFSK16Avatar instead Model avatar picture, from FSK16 sedcard  (ratio 1:1, displayed as cropped circle) */
  modelPictureAvatar?: InputMaybe<Scalars['Int']['input']>;
  /** Model sexuality [heterosexual, homesexual, bisexual] */
  modelSexuality?: InputMaybe<SexualityEnum>;
  /** Model Username (a.k.a login, screenname) [alfanum, 6-16] */
  modelUsername?: InputMaybe<Scalars['String']['input']>;
};

export type InputProfileCollectionPayoutV1 = {
  /** @deprecated use PaymentBillingAddressCity instead Payout Proof of Addresse - City */
  payoutAddressCity?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated use PaymentBillingAddressCompanyname instead Payout Proof of Addresse - Company Name */
  payoutAddressCompanyname?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated use PaymentBillingAddressCountry instead Payout Proof of Address - Country */
  payoutAddressCountry?: InputMaybe<CountryEnum>;
  /** @deprecated use PaymentBillingAddressDocument instead Payout Tax Document */
  payoutAddressDocument?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated use  PaymentBillingAddressDocument Payout Address Document ID */
  payoutAddressDocumentId?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated use PaymentBillingAddressFirstname instead Payout Proof of Addresse - City */
  payoutAddressFirstname?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated use PaymentBillingAddressIsCompany instead Payout Proof of Adress - is Company */
  payoutAddressIsCompany?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated use PaymentBillingAddressLastname instead Payout Proof of Addresse - City */
  payoutAddressLastname?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated use PaymentBillingAddressPostalCode instead Payout Proof of Address - PostalCode */
  payoutAddressPostalCode?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated use PaymentBillingAddressStreet instead Payout Proof of Address - street */
  payoutAddressStreet?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated use PaymentBillingAddressStreetNumber instead Payout Proof of Address - street number */
  payoutAddressStreetNumber?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated use  PaymentPayoutDataBa Payout Bankaccountowner */
  payoutBankaccountOwner?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated use PaymentPayoutDataBankBic instead Payout BIC */
  payoutBic?: InputMaybe<Scalars['String']['input']>;
  /** Payout Company or Full Legal Name */
  payoutCompanyOrFullLegalName?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated use PaymentPayoutDataBankIban instead Payout IBAN */
  payoutIban?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated use PaymentPayoutDataIsTaxable Payout Is Model Taxable */
  payoutIsTaxable?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated use PaymentPayoutDataPaxumEmailAccount instead Payout Paxum Email Account */
  payoutPaxumEmailAccount?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated use PaymentTaxDataDocument Payout Tax Document */
  payoutTaxDocument?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated use PaymentTaxDataDocument Payout Tax Document ID */
  payoutTaxDocumentId?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated use PaymentTaxDataTaxNumber Payout Tax Number */
  payoutTaxId?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated use PaymentTaxDataTin Payout Tax TIN */
  payoutTaxTin?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated use PaymentTaxDataTinCountry Payout Tax TIN Country */
  payoutTaxTinCountry?: InputMaybe<TaxCountryEnum>;
  /** @deprecated use PaymentPayoutDataPayoutMethod instead Payout Type of Transaction (paxum, bank, cheque) */
  payoutTransactionType?: InputMaybe<FinancesPayoutMethodEnum>;
};

export type InputSaveRealPersonData = {
  /** Birthday. Default: null */
  birthday?: InputMaybe<Scalars['Date']['input']>;
  /** Firstname */
  firstname: Scalars['String']['input'];
  /** Is leading actor. Default: false */
  isLeadingActor?: InputMaybe<Scalars['Boolean']['input']>;
  /** Lastname */
  lastname: Scalars['String']['input'];
  /** User ID. Must be NULL to create a new real person. */
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type InputSignupData = {
  /** email address */
  email: Scalars['EmailAddress']['input'];
  /** password */
  password: Scalars['String']['input'];
  /** Studio hash */
  studioHash?: InputMaybe<Scalars['String']['input']>;
  /** Username of referer from adlink */
  userReferer?: InputMaybe<Scalars['String']['input']>;
};

export type InputTourModelReleaseFormV1 = {
  /** @deprecated use MrfModelBirthdate instead Model Release Form Birthdate [YYYY-MM-DD] */
  mrfBirthdate?: InputMaybe<Scalars['Date']['input']>;
  /** @deprecated use MrfModelBirthplace instead Model Release Form birthplace */
  mrfBirthplace?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated use MrfModelCity instead Model Release Form city */
  mrfCity?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated use MrfModelCountry instead Model Release Form country */
  mrfCountry?: InputMaybe<CountryEnum>;
  /** @deprecated use MrfModelFirstname instead Model Release Form firstname */
  mrfFirstname?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated @alias MrfModelForm */
  mrfForm?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated use MrfModelLastname instead Model Release Form lastname */
  mrfLastname?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated use MrfModelPostalCode instead Model Release Form postal code */
  mrfPostalCode?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated use MrfModelStreet instead Model Release Form street */
  mrfStreet?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated use MrfModelStreetNumber instead Model Release Form street number */
  mrfStreetNumber?: InputMaybe<Scalars['String']['input']>;
  /** name of current step */
  stepName?: InputMaybe<Scalars['ID']['input']>;
};

export type InputTourOnboardingV1 = {
  /** Model Birthdate, may differ from account (real person) birthdate [YYYY-MM-DD] */
  modelBirthdate?: InputMaybe<Scalars['Date']['input']>;
  /** Model gender [female, male, transgender] */
  modelGender?: InputMaybe<GenderEnum>;
  /** Model Motto (a.k.a. Chat Motto) [string, 10-100] */
  modelMotto?: InputMaybe<Array<InputLangText>>;
  /** @deprecated use ModelPictureFSK16Avatar instead Model avatar picture, from FSK16 sedcard  (ratio 1:1, displayed as cropped circle) */
  modelPictureAvatar?: InputMaybe<Scalars['Int']['input']>;
  /** Model sexuality [heterosexual, homesexual, bisexual] */
  modelSexuality?: InputMaybe<SexualityEnum>;
  /** Model Username (a.k.a login, screenname) [alfanum, 6-16] */
  modelUsername?: InputMaybe<Scalars['String']['input']>;
  /** name of current step */
  stepName?: InputMaybe<Scalars['ID']['input']>;
};

export type InputTourPayoutV1 = {
  /** @deprecated use PaymentBillingAddressCity instead Payout Proof of Addresse - City */
  payoutAddressCity?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated use PaymentBillingAddressCompanyname instead Payout Proof of Addresse - Company Name */
  payoutAddressCompanyname?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated use PaymentBillingAddressCountry instead Payout Proof of Address - Country */
  payoutAddressCountry?: InputMaybe<CountryEnum>;
  /** @deprecated use PaymentBillingAddressDocument instead Payout Tax Document */
  payoutAddressDocument?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated use  PaymentBillingAddressDocument Payout Address Document ID */
  payoutAddressDocumentId?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated use PaymentBillingAddressFirstname instead Payout Proof of Addresse - City */
  payoutAddressFirstname?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated use PaymentBillingAddressIsCompany instead Payout Proof of Adress - is Company */
  payoutAddressIsCompany?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated use PaymentBillingAddressLastname instead Payout Proof of Addresse - City */
  payoutAddressLastname?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated use PaymentBillingAddressPostalCode instead Payout Proof of Address - PostalCode */
  payoutAddressPostalCode?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated use PaymentBillingAddressStreet instead Payout Proof of Address - street */
  payoutAddressStreet?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated use PaymentBillingAddressStreetNumber instead Payout Proof of Address - street number */
  payoutAddressStreetNumber?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated use  PaymentPayoutDataBa Payout Bankaccountowner */
  payoutBankaccountOwner?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated use PaymentPayoutDataBankBic instead Payout BIC */
  payoutBic?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated use PaymentPayoutDataBankIban instead Payout IBAN */
  payoutIban?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated use PaymentPayoutDataIsTaxable Payout Is Model Taxable */
  payoutIsTaxable?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated use PaymentPayoutDataPaxumEmailAccount instead Payout Paxum Email Account */
  payoutPaxumEmailAccount?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated use PaymentTaxDataDocument Payout Tax Document */
  payoutTaxDocument?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated use PaymentTaxDataDocument Payout Tax Document ID */
  payoutTaxDocumentId?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated use PaymentTaxDataTaxNumber Payout Tax Number */
  payoutTaxId?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated use PaymentTaxDataTin Payout Tax TIN */
  payoutTaxTin?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated use PaymentTaxDataTinCountry Payout Tax TIN Country */
  payoutTaxTinCountry?: InputMaybe<TaxCountryEnum>;
  /** @deprecated use PaymentPayoutDataPayoutMethod instead Payout Type of Transaction (paxum, bank, cheque) */
  payoutTransactionType?: InputMaybe<FinancesPayoutMethodEnum>;
  /** name of current step */
  stepName?: InputMaybe<Scalars['ID']['input']>;
};

export type InputTourPayoutV2 = {
  /** Originator Model Release Form Birthdate [YYYY-MM-DD] */
  mrfOriginatorBirthdate?: InputMaybe<Scalars['Date']['input']>;
  /** Originator Model Release Form birthplace */
  mrfOriginatorBirthplace?: InputMaybe<Scalars['String']['input']>;
  /** Model Release Form for Signage */
  mrfOriginatorForm?: InputMaybe<Scalars['String']['input']>;
  /** Originator IDproof back side */
  originatorIdentityProofBack?: InputMaybe<Scalars['Int']['input']>;
  /** Originator IDproof front side */
  originatorIdentityProofFront?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated use PaymentBillingAddressCity instead Payout Proof of Addresse - City */
  payoutAddressCity?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated use PaymentBillingAddressCompanyname instead Payout Proof of Addresse - Company Name */
  payoutAddressCompanyname?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated use PaymentBillingAddressCountry instead Payout Proof of Address - Country */
  payoutAddressCountry?: InputMaybe<CountryEnum>;
  /** @deprecated use PaymentBillingAddressDocument instead Payout Tax Document */
  payoutAddressDocument?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated use  PaymentBillingAddressDocument Payout Address Document ID */
  payoutAddressDocumentId?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated use PaymentBillingAddressFirstname instead Payout Proof of Addresse - City */
  payoutAddressFirstname?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated use PaymentBillingAddressIsCompany instead Payout Proof of Adress - is Company */
  payoutAddressIsCompany?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated use PaymentBillingAddressLastname instead Payout Proof of Addresse - City */
  payoutAddressLastname?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated use PaymentBillingAddressPostalCode instead Payout Proof of Address - PostalCode */
  payoutAddressPostalCode?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated use PaymentBillingAddressStreet instead Payout Proof of Address - street */
  payoutAddressStreet?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated use PaymentBillingAddressStreetNumber instead Payout Proof of Address - street number */
  payoutAddressStreetNumber?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated use  PaymentPayoutDataBa Payout Bankaccountowner */
  payoutBankaccountOwner?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated use PaymentPayoutDataBankBic instead Payout BIC */
  payoutBic?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated use PaymentPayoutDataBankIban instead Payout IBAN */
  payoutIban?: InputMaybe<Scalars['String']['input']>;
  /** Is model originator */
  payoutIsModelOriginator?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated use PaymentPayoutDataIsTaxable Payout Is Model Taxable */
  payoutIsTaxable?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated use PaymentPayoutDataPaxumEmailAccount instead Payout Paxum Email Account */
  payoutPaxumEmailAccount?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated use PaymentTaxDataDocument Payout Tax Document */
  payoutTaxDocument?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated use PaymentTaxDataDocument Payout Tax Document ID */
  payoutTaxDocumentId?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated use PaymentTaxDataTaxNumber Payout Tax Number */
  payoutTaxId?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated use PaymentTaxDataTin Payout Tax TIN */
  payoutTaxTin?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated use PaymentTaxDataTinCountry Payout Tax TIN Country */
  payoutTaxTinCountry?: InputMaybe<TaxCountryEnum>;
  /** @deprecated use PaymentPayoutDataPayoutMethod instead Payout Type of Transaction (paxum, bank, cheque) */
  payoutTransactionType?: InputMaybe<FinancesPayoutMethodEnum>;
};

/** input Video */
export type InputVideo = {
  /** Album ID (UMA_ID) */
  albumId: Scalars['Int']['input'];
  /** Must be set to true if all necessary ID-Cards are presents */
  allIDCardsUploaded?: InputMaybe<Scalars['Boolean']['input']>;
  /** Must be set to true if all necessary MRFs are presents */
  allModelReleaseFormsUploaded?: InputMaybe<Scalars['Boolean']['input']>;
  /** Contest ID (UMPA_ID) */
  contestId?: InputMaybe<Scalars['Int']['input']>;
  /** description */
  descriptions?: InputMaybe<Array<InputLangText>>;
  /** discount */
  discount?: InputMaybe<Scalars['Int']['input']>;
  /** discount end */
  discountEnd?: InputMaybe<Scalars['DateTime']['input']>;
  /** discount start */
  discountStart?: InputMaybe<Scalars['DateTime']['input']>;
  /** planned release date */
  plannedReleaseDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Preview picture ID (FSK-16) */
  previewPictureId16?: InputMaybe<Scalars['Int']['input']>;
  /** Preview picture ID (FSK-18) */
  previewPictureId18?: InputMaybe<Scalars['Int']['input']>;
  /** price */
  price?: InputMaybe<Scalars['Float']['input']>;
  /** released status */
  releasedStatus?: InputMaybe<VideoReleasedStatusEnum>;
  /** tags as list */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** title */
  titles?: InputMaybe<Array<InputLangText>>;
};

export type KeyAccounter = {
  __typename?: 'KeyAccounter';
  /** Email of key accounter */
  email?: Maybe<Scalars['String']['output']>;
  /** Name of key accounter */
  name: Scalars['String']['output'];
  /** Phone number of key accounter */
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

/** Text */
export type LangText = {
  __typename?: 'LangText';
  /** available languages */
  lang: LanguagesEnum;
  /** status */
  status: Scalars['String']['output'];
  /** text */
  text: Scalars['String']['output'];
};

/** Class LanguagesEnum @package App\Enum */
export enum LanguagesEnum {
  /** {"de":"Tschechisch", "en":"Czech"} */
  Cz = 'cz',
  /** {"de":"Dänisch", "en":"Danish"} */
  Da = 'da',
  /** {"de":"Deutsch", "en":"German"} */
  De = 'de',
  /** {"de":"Englisch", "en":"English"} */
  En = 'en',
  /** {"de":"Spanisch", "en":"Spanish"} */
  Es = 'es',
  /** {"de":"Finnisch", "en":"Finnish"} */
  Fi = 'fi',
  /** {"de":"Französisch", "en":"French"} */
  Fr = 'fr',
  /** {"de":"Ungarisch", "en":"Hungarian"} */
  Hu = 'hu',
  /** {"de":"Italienisch", "en":"Italian"} */
  It = 'it',
  /** {"de":"Niederländisch", "en":"Dutch"} */
  Nl = 'nl',
  /** {"de":"Polnisch", "en":"Polish"} */
  Pl = 'pl',
  /** {"de":"Portugiesisch", "en":"Portuguese"} */
  Pt = 'pt',
  /** {"de":"Rumänisch", "en":"Romanian"} */
  Ro = 'ro',
  /** {"de":"Russisch", "en":"Russian"} */
  Ru = 'ru',
  /** {"de":"Türkisch", "en":"Turkish"} */
  Tr = 'tr'
}

export type Marketing = {
  __typename?: 'Marketing';
  /** User-Id */
  adlinks: Adlinks;
};

export type Media = {
  __typename?: 'Media';
  /** Media comments list */
  comments: MediaCommentsList;
  /** Contest */
  contest?: Maybe<MediaContest>;
  /** Media likes list */
  likes: MediaLikesList;
  /** Photoalbums */
  photoalbums: Photoalbums;
  /** Media sales list */
  sales: MediaSalesList;
  /** Returns list of tags by fragment */
  tags: Array<Maybe<MediaTag>>;
  /** Videos */
  videos: Videos;
};


export type MediaCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  albumId: Scalars['Int']['input'];
  first: Scalars['Int']['input'];
};


export type MediaContestArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<MediaContestTypeEnum>;
};


export type MediaLikesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  albumId: Scalars['Int']['input'];
  first: Scalars['Int']['input'];
};


export type MediaSalesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  albumId: Scalars['Int']['input'];
  first: Scalars['Int']['input'];
};


export type MediaTagsArgs = {
  fragment: Scalars['String']['input'];
};

export type MediaComment = {
  __typename?: 'MediaComment';
  /** Album ID */
  albumId: Scalars['Int']['output'];
  /** Avatar URL */
  avatarUrl?: Maybe<Scalars['String']['output']>;
  /** Date */
  date: Scalars['DateTime']['output'];
  /** Comment ID */
  id: Scalars['Int']['output'];
  /** Reply */
  reply?: Maybe<MediaCommentReply>;
  /** Text */
  text: Scalars['String']['output'];
  /** User ID */
  userId: Scalars['Int']['output'];
  /** User name */
  userName: Scalars['String']['output'];
};

export type MediaCommentReply = {
  __typename?: 'MediaCommentReply';
  /** Date */
  date: Scalars['DateTime']['output'];
  /** Reply ID */
  id: Scalars['Int']['output'];
  /** Text */
  text: Scalars['String']['output'];
};

export type MediaCommentsList = {
  __typename?: 'MediaCommentsList';
  /** Edges */
  edges: Array<Maybe<MediaCommentsPaginationEdge>>;
  /** Page info */
  pageInfo?: Maybe<PaginationPageInfo>;
  /** Total edges */
  totalCount: Scalars['Int']['output'];
};

export type MediaCommentsPaginationEdge = {
  __typename?: 'MediaCommentsPaginationEdge';
  /** Cursor for cursor-based pagination */
  cursor?: Maybe<Scalars['String']['output']>;
  /** Comment item */
  node: MediaComment;
};

export type MediaContest = {
  __typename?: 'MediaContest';
  /** Contest description */
  description: Scalars['String']['output'];
  /** Contest ID */
  id: Scalars['Int']['output'];
  /** Contest images */
  images: MediaContestImages;
  /** Photoalbum */
  photoalbum?: Maybe<Photoalbum>;
  /** Prizes */
  prizes: Array<Maybe<MediaContestPrize>>;
  /**
   * Teaser URL
   * @deprecated Please use a property [images]
   */
  teaserUrl: Scalars['String']['output'];
  /** Contest title */
  title: Scalars['String']['output'];
  /** Contest type */
  type: MediaContestTypeEnum;
  /** Upload end */
  uploadEnd: Scalars['DateTime']['output'];
  /** Upload limit */
  uploadLimit: Scalars['Int']['output'];
  /** Upload start */
  uploadStart: Scalars['DateTime']['output'];
  /** User likes count */
  userLikesCount?: Maybe<Scalars['Int']['output']>;
  /** User Place */
  userPlace?: Maybe<Scalars['Int']['output']>;
  /** Video */
  video?: Maybe<Video>;
  /** Voting end */
  votingEnd: Scalars['DateTime']['output'];
  /** Voting start */
  votingStart: Scalars['DateTime']['output'];
};

export type MediaContestImages = {
  __typename?: 'MediaContestImages';
  /** URL of coming soon image */
  comingSoonImage?: Maybe<Scalars['String']['output']>;
  /** URL of paytour signup image */
  payturSignupImage?: Maybe<Scalars['String']['output']>;
  /** URL of title image */
  titleImage?: Maybe<Scalars['String']['output']>;
};

export type MediaContestPrize = {
  __typename?: 'MediaContestPrize';
  /** Prize value */
  amount: Scalars['Float']['output'];
  /** Place */
  place: Scalars['Int']['output'];
};

/** Media contest type */
export enum MediaContestTypeEnum {
  Photo = 'photo',
  Video = 'video'
}

export type MediaLike = {
  __typename?: 'MediaLike';
  /** Album ID */
  albumId: Scalars['Int']['output'];
  /** Avatar URL */
  avatarUrl?: Maybe<Scalars['String']['output']>;
  /** Date */
  date: Scalars['DateTime']['output'];
  /** User ID */
  userId: Scalars['Int']['output'];
  /** User name */
  userName: Scalars['String']['output'];
};

export type MediaLikesList = {
  __typename?: 'MediaLikesList';
  /** Edges */
  edges: Array<Maybe<MediaLikesPaginationEdge>>;
  /** Page info */
  pageInfo?: Maybe<PaginationPageInfo>;
  /** Total edges */
  totalCount: Scalars['Int']['output'];
};

export type MediaLikesPaginationEdge = {
  __typename?: 'MediaLikesPaginationEdge';
  /** Cursor for cursor-based pagination */
  cursor?: Maybe<Scalars['String']['output']>;
  /** Like item */
  node: MediaLike;
};

export type MediaMutation = {
  __typename?: 'MediaMutation';
  /** Remove photoalbum or video */
  deleteMedia?: Maybe<Scalars['Boolean']['output']>;
  /** Photoalbum mutations */
  photoalbum: PhotoalbumsMutation;
  /** Reply to the comment */
  replyToComment: MediaComment;
  /** Mutations for videos */
  video: VideosMutation;
};


export type MediaMutationDeleteMediaArgs = {
  albumId: Scalars['Int']['input'];
};


export type MediaMutationReplyToCommentArgs = {
  commentId: Scalars['Int']['input'];
  text: Scalars['String']['input'];
};

/** Media Picture */
export type MediaPicture = {
  __typename?: 'MediaPicture';
  /** FSK */
  fsk: Scalars['Int']['output'];
  /** Image */
  image: Image;
  /** Position in Sedcard */
  position: Scalars['Int']['output'];
  /** String Type */
  rejectReason?: Maybe<Scalars['String']['output']>;
  /** Picture Type */
  status: MediaPictureStatusEnum;
  /** Picture Type */
  type: Scalars['String']['output'];
  /** Album ID */
  umaId: Scalars['Int']['output'];
  /** Picture ID */
  umpId: Scalars['Int']['output'];
  /** Uploaded At */
  uploadedAt: Scalars['DateTime']['output'];
};

/** Picture states */
export enum MediaPictureStatusEnum {
  /** Picture is broken (-3) */
  Broken = 'broken',
  /** Picture is deleted (-2) */
  Deleted = 'deleted',
  /** Picture is verified and ok (1) */
  Ok = 'ok',
  /** Picture is not checked (!picture::isChecked() && !picture::isReChecked()) */
  Pending = 'pending',
  /** Picture was rejected (-10) */
  Rejected = 'rejected'
}

export type MediaSale = {
  __typename?: 'MediaSale';
  /** Album ID */
  albumId: Scalars['Int']['output'];
  /** Avatar URL */
  avatarUrl?: Maybe<Scalars['String']['output']>;
  /** Date */
  date: Scalars['DateTime']['output'];
  /** Discount percent */
  discountPercent?: Maybe<Scalars['Int']['output']>;
  /** Guest price */
  guestPrice: Scalars['Float']['output'];
  /** Model sharing */
  modelSharing: Scalars['Float']['output'];
  /** User ID */
  userId: Scalars['Int']['output'];
  /** User name */
  userName: Scalars['String']['output'];
};

export type MediaSalesList = {
  __typename?: 'MediaSalesList';
  /** Edges */
  edges: Array<Maybe<MediaSalesPaginationEdge>>;
  /** Page info */
  pageInfo?: Maybe<PaginationPageInfo>;
  /** Total edges */
  totalCount: Scalars['Int']['output'];
  /** Total guest price */
  totalGuestPrice: Scalars['Float']['output'];
  /** Total model sharing */
  totalModelSharing: Scalars['Float']['output'];
};

export type MediaSalesPaginationEdge = {
  __typename?: 'MediaSalesPaginationEdge';
  /** Cursor for cursor-based pagination */
  cursor?: Maybe<Scalars['String']['output']>;
  /** Sale item */
  node: MediaSale;
};

/** Media Tag */
export type MediaTag = {
  __typename?: 'MediaTag';
  /** label */
  flags?: Maybe<Scalars['Int']['output']>;
  /** type */
  id?: Maybe<Scalars['Int']['output']>;
  /** label */
  isChecked?: Maybe<Scalars['Boolean']['output']>;
  /** value */
  value?: Maybe<Scalars['String']['output']>;
};

/** Media Text */
export type MediaText = {
  __typename?: 'MediaText';
  /** language */
  lang?: Maybe<Scalars['String']['output']>;
  /** text */
  text?: Maybe<Scalars['String']['output']>;
};

/** Media Text */
export type MediaTextCollection = {
  __typename?: 'MediaTextCollection';
  /** visitx descriptions */
  visitxDescriptions?: Maybe<Array<Maybe<MediaText>>>;
  /** visitx titles */
  visitxTitles?: Maybe<Array<Maybe<MediaText>>>;
};

/** Model Release Form language */
export enum ModelReleaseFormLanguageEnum {
  /** German (de) */
  De = 'de',
  /** English (en) */
  En = 'en'
}

/** Model Release Form language */
export enum ModelReleaseFormRequestContextEnum {
  /** MRF indended for actor */
  Actor = 'actor',
  /** MRF indended for model/host */
  Model = 'model',
  /** MRF indended for originator */
  Originator = 'originator'
}

/** Model verification status */
export enum ModelVerificationStatusEnum {
  /** Account accepted */
  Accepted = 'accepted',
  /** Missing documents */
  Incomplete = 'incomplete',
  /** Account in check */
  Pending = 'pending',
  /** At least one document is rejected */
  Rejected = 'rejected'
}

/** Multi Language Text */
export type MultiLangText = {
  __typename?: 'MultiLangText';
  /** available languages */
  langs: Array<LanguagesEnum>;
  /** original text written by the model */
  origText: Scalars['String']['output'];
  /** language */
  status: Scalars['String']['output'];
  /** title */
  texts: Array<LangText>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** everything updating an account */
  account?: Maybe<AccountMutation>;
  /** everything with authentication and signup */
  auth?: Maybe<AuthMutation>;
  /** everything updating a documents */
  documents?: Maybe<DocumentsMutation>;
  /** everything updating an payout data */
  finances?: Maybe<FinancesMutation>;
  /** everything updating a helpcenter */
  helpcenter?: Maybe<HelpcenterMutation>;
  /** Media mutations */
  media?: Maybe<MediaMutation>;
  /** Payment stuff */
  payment: PaymentMutation;
  /** everything updating a profile */
  profile?: Maybe<ProfileMutation>;
  /** Statistics settings update */
  statistics?: Maybe<StatisticsMutation>;
  /** Update terms */
  terms?: Maybe<TermsMutation>;
  /** everything updating a tour */
  tour?: Maybe<TourMutation>;
  /** VXCash mutations */
  vxcash: VxCashMutation;
};


export type MutationTourArgs = {
  name: TourNameEnum;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type MutationResult = {
  __typename?: 'MutationResult';
  /** Message */
  message?: Maybe<Scalars['String']['output']>;
  /** Mutation result */
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Abstract Option Entry */
export type OptionEntry = {
  __typename?: 'OptionEntry';
  /** Option deprecation */
  deprecated?: Maybe<Scalars['Boolean']['output']>;
  /** Option label */
  label: Scalars['String']['output'];
  /** Option value */
  name: Scalars['String']['output'];
  /** Option translation key */
  translationKey?: Maybe<Scalars['String']['output']>;
  /** Option value */
  value: Scalars['String']['output'];
};

export type Originator = {
  __typename?: 'Originator';
  /** Returns true if originator is a company */
  address?: Maybe<Address>;
  /** User-Id */
  birthday?: Maybe<Scalars['DateTime']['output']>;
  /** Financial documents */
  financialDocuments: DocumentsFinancialRealPerson;
  /** Financial documents status */
  financialDocumentsStatus: ProfileStatusEnum;
  /** Returns true if originator is actor */
  isActor: Scalars['Boolean']['output'];
  /** Returns true if real person added by model and not yet checked by payment */
  isNew: Scalars['Boolean']['output'];
  /** Returns true if originator is verified (has all required documents / second check verification) */
  isVerified: Scalars['Boolean']['output'];
  /** Personal documents */
  personalDocuments: DocumentsPersonalRealPerson;
  /** Personal documents status */
  personalDocumentsStatus: ProfileStatusEnum;
  /** User-Id */
  userId: Scalars['Int']['output'];
};

export type PaginationPageInfo = {
  __typename?: 'PaginationPageInfo';
  /** Returns true if collection has next page */
  hasNextPage: Scalars['Boolean']['output'];
};

/** Paperless Document */
export type PaperlessDocument = {
  __typename?: 'PaperlessDocument';
  /** Option value */
  id: Scalars['ID']['output'];
  /** Option value */
  name: Scalars['String']['output'];
  /** Option value */
  state: Scalars['String']['output'];
};

/** Abstract Option Entry */
export type PaperlessSubmission = {
  __typename?: 'PaperlessSubmission';
  /** Option value */
  name: Scalars['String']['output'];
};

/** Password reset result */
export type PasswordResetResult = PasswordResetResultFail | PasswordResetResultSuccessful;

/** Password reset request failed */
export type PasswordResetResultFail = {
  __typename?: 'PasswordResetResultFail';
  /** Error message */
  message: Scalars['String']['output'];
};

/** Password reset request successful */
export type PasswordResetResultSuccessful = {
  __typename?: 'PasswordResetResultSuccessful';
  /** Message */
  message: Scalars['String']['output'];
};

/** Password set result */
export type PasswordSetResult = PasswordSetResultFail | PasswordSetResultSuccessful;

/** Set new password failed */
export type PasswordSetResultFail = {
  __typename?: 'PasswordSetResultFail';
  /** Error message */
  message: Scalars['String']['output'];
};

/** Set new password successful */
export type PasswordSetResultSuccessful = {
  __typename?: 'PasswordSetResultSuccessful';
  /** Message */
  message: Scalars['String']['output'];
};

/** Payment related stuff */
export type Payment = {
  __typename?: 'Payment';
  /** Payment address */
  billingAddress: PaymentBillingAddress;
  /** Payment payout data information */
  payoutData: PaymentPayoutData;
  /** Tax related */
  taxData: PaymentTaxData;
};

/** Billing address data (Originator) */
export type PaymentBillingAddress = {
  __typename?: 'PaymentBillingAddress';
  /** Payment Billing Address - City */
  city?: Maybe<ProfileFieldTypeString>;
  /** Payment Billing Address - Company Name */
  companyname?: Maybe<ProfileFieldTypeString>;
  /** Payment Billing Address - Country */
  country?: Maybe<ProfileFieldTypeEnum>;
  /** Payment Billing Address - Document */
  document?: Maybe<ProfileFieldTypeUploadDocument>;
  /** Payment Billing Address - City */
  firstname?: Maybe<ProfileFieldTypeString>;
  /** Payment Billing Address - is Company */
  isCompany?: Maybe<ProfileFieldTypeBoolean>;
  /** Payment Billing Address - City */
  lastname?: Maybe<ProfileFieldTypeString>;
  /** Payment Billing Address - PostalCode */
  postalCode?: Maybe<ProfileFieldTypeString>;
  rejectReason?: Maybe<Scalars['String']['output']>;
  rejectReasonTitle?: Maybe<Scalars['String']['output']>;
  status?: Maybe<PaymentBillingAddressStatusEnum>;
  /** Payment Billing Address - street */
  street?: Maybe<ProfileFieldTypeString>;
  /** Payment Billing Address - street number */
  streetNumber?: Maybe<ProfileFieldTypeString>;
};

/** Billing address data (Originator) */
export type PaymentBillingAddressMutation = {
  __typename?: 'PaymentBillingAddressMutation';
  /** update billing address */
  updateBillingAddress?: Maybe<PaymentBillingAddressMutationResult>;
};


/** Billing address data (Originator) */
export type PaymentBillingAddressMutationUpdateBillingAddressArgs = {
  data: InputPaymentBillingAddress;
};

/** A specified result set for Api\GraphQL\Schema\PaymentBillingAddressMutation */
export type PaymentBillingAddressMutationResult = PaymentBillingAddress | ProfileFieldValidationSet;

/** Billing address status ENUM */
export enum PaymentBillingAddressStatusEnum {
  Accepted = 'accepted',
  Incomplete = 'incomplete',
  Pending = 'pending',
  Rejected = 'rejected'
}

/** Basic Query */
export type PaymentMutation = {
  __typename?: 'PaymentMutation';
  /** Functions to modify billing address */
  billingAddress: PaymentBillingAddressMutation;
  /** Functions to modify payout data */
  payoutData: PaymentPayoutDataMutation;
  /** Functions to modify tax data */
  taxData: PaymentTaxDataMutation;
};

/** Payout data information */
export type PaymentPayoutData = {
  __typename?: 'PaymentPayoutData';
  /** Payout Bankaccountowner */
  bankAccountOwner?: Maybe<ProfileFieldTypeString>;
  /** Payout BIC */
  bankBic?: Maybe<ProfileFieldTypeString>;
  /** Payout IBAN */
  bankIban?: Maybe<ProfileFieldTypeString>;
  /** Payout Paxum Email Account */
  paxumEmailAccount?: Maybe<ProfileFieldTypeString>;
  /** Payout Type of Transaction (paxum, bank, cheque) */
  payoutMethod?: Maybe<ProfileFieldTypeEnum>;
  rejectReason?: Maybe<Scalars['String']['output']>;
  rejectReasonTitle?: Maybe<Scalars['String']['output']>;
  showBankAccount: Scalars['Boolean']['output'];
  showPaxum: Scalars['Boolean']['output'];
  status: Scalars['String']['output'];
};

/** Payout data information */
export type PaymentPayoutDataMutation = {
  __typename?: 'PaymentPayoutDataMutation';
  /** update billing address */
  updatePayoutData?: Maybe<PaymentPayoutDataMutationResult>;
};


/** Payout data information */
export type PaymentPayoutDataMutationUpdatePayoutDataArgs = {
  data: InputPaymentPayoutData;
};

/** A specified result set for Api\GraphQL\Schema\PaymentPayoutDataMutation */
export type PaymentPayoutDataMutationResult = PaymentPayoutData | ProfileFieldValidationSet;

/** Tax related information */
export type PaymentTaxData = {
  __typename?: 'PaymentTaxData';
  /** Payout Tax Document */
  document?: Maybe<ProfileFieldTypeUploadDocument>;
  isDocumentRequired: Scalars['Boolean']['output'];
  isRequired: Scalars['Boolean']['output'];
  /** Payout Is Model Taxable */
  isTaxable?: Maybe<ProfileFieldTypeBoolean>;
  rejectReason?: Maybe<Scalars['String']['output']>;
  rejectReasonTitle?: Maybe<Scalars['String']['output']>;
  showTin: Scalars['Boolean']['output'];
  status: Scalars['String']['output'];
  /** Payout Tax Number, possible VAT ID or Tax ID (__not EU Taxpayer Identification Number TIN__) */
  taxNumber?: Maybe<ProfileFieldTypeString>;
  /** EU Taxpayer Identification Number (TIN) */
  tin?: Maybe<ProfileFieldTypeString>;
  /** Taxpayer Identification Number (TIN) registration country */
  tinCountry?: Maybe<ProfileFieldTypeEnum>;
};

/** Tax related information */
export type PaymentTaxDataMutation = {
  __typename?: 'PaymentTaxDataMutation';
  /** update billing address */
  updateTaxData?: Maybe<PaymentTaxDataMutationResult>;
};


/** Tax related information */
export type PaymentTaxDataMutationUpdateTaxDataArgs = {
  data: InputPaymentTaxData;
};

/** A specified result set for Api\GraphQL\Schema\PaymentTaxDataMutation */
export type PaymentTaxDataMutationResult = PaymentTaxData | ProfileFieldValidationSet;

export enum PenisSizeEnum {
  /** {"de":"Keine Angabe", "en":"Not specified"} */
  Null = '_NULL_',
  /** {"de":"Groß", "en":"Large"} */
  L = 'l',
  /** {"de":"Mittel", "en":"Mid-Size"} */
  M = 'm',
  /** {"de":"Klein", "en":"Small"} */
  S = 's',
  /** {"de":"Sehr groß", "en":"Extra Large"} */
  Xl = 'xl',
  /** {"de":"Sehr sehr groß", "en":"Extra Extra Large"} */
  Xxl = 'xxl'
}

export type PhoneNumber = {
  __typename?: 'PhoneNumber';
  /** Country code ISO 3166-1 alpha-2. For example: DE */
  country: Scalars['String']['output'];
  /** Dialing country code. For example: +49 */
  countryCode: Scalars['String']['output'];
  /** Full phone number. For example: +4961821234567 */
  fullPhoneNumber: Scalars['String']['output'];
  /** Phone number without country code. For example: 61821234567 */
  phoneNumber: Scalars['String']['output'];
};

export type Photoalbum = {
  __typename?: 'Photoalbum';
  /** Album-Id (UMA_ID) */
  albumId: Scalars['Int']['output'];
  /** Contest id */
  contestId?: Maybe<Scalars['Int']['output']>;
  /** Feedbacks count */
  feedbacksCount?: Maybe<Scalars['Int']['output']>;
  /** Returns true if price can be displayed */
  isPriceVisible?: Maybe<Scalars['Boolean']['output']>;
  /** likes count */
  likesCount?: Maybe<Scalars['Int']['output']>;
  /** Count of rejected pictures */
  pictureCountRejected?: Maybe<Scalars['Int']['output']>;
  /** Count of released pictures */
  pictureCountReleased?: Maybe<Scalars['Int']['output']>;
  /** Picture count total (released and rejected) */
  pictureCountTotal?: Maybe<Scalars['Int']['output']>;
  /** Preview picture FSK-16 */
  previewPicture16?: Maybe<MediaPicture>;
  /** Preview picture FSK-18 */
  previewPicture18?: Maybe<MediaPicture>;
  /** Price */
  price?: Maybe<Scalars['Float']['output']>;
  /** Price max */
  priceMax?: Maybe<Scalars['Float']['output']>;
  /** Released date */
  releasedDate?: Maybe<Scalars['DateTime']['output']>;
  /** Released status */
  releasedStatus: PhotoalbumReleasedStatusEnum;
  /** Sales count */
  salesCount?: Maybe<Scalars['Int']['output']>;
  /** Status */
  status?: Maybe<PhotoalbumStatusEnum>;
  /** tag collection */
  tagCollection?: Maybe<Array<Maybe<MediaTag>>>;
  /** text collection */
  textCollection?: Maybe<MediaTextCollection>;
  /** Photoalbum type */
  type?: Maybe<PhotoalbumTypeEnum>;
  /** User-Id */
  userId: Scalars['Int']['output'];
};

export type PhotoalbumList = {
  __typename?: 'PhotoalbumList';
  /** Edges */
  edges: Array<Maybe<PhotoalbumPaginationEdge>>;
  /** Page info */
  pageInfo?: Maybe<PaginationPageInfo>;
  /** Total edges */
  totalCount: Scalars['Int']['output'];
};

export type PhotoalbumPaginationEdge = {
  __typename?: 'PhotoalbumPaginationEdge';
  /** Cursor for cursor-based pagination */
  cursor?: Maybe<Scalars['String']['output']>;
  /** Photoalbum item */
  node: Photoalbum;
};

/** Released status */
export enum PhotoalbumReleasedStatusEnum {
  Offline = 'offline',
  Online = 'online'
}

/** Released status */
export enum PhotoalbumSortFieldsEnum {
  AlbumType = 'albumType',
  GuestRating = 'guestRating',
  Id = 'id',
  Name = 'name',
  Price = 'price',
  Sales = 'sales',
  Status = 'status',
  UploadDate = 'uploadDate'
}

/** Photoalbum status */
export enum PhotoalbumStatusEnum {
  Rejected = 'rejected',
  Released = 'released'
}

/** Photoalbum types */
export enum PhotoalbumTypeEnum {
  Contest = 'contest',
  Free = 'free',
  Pool = 'pool',
  Shop = 'shop'
}

export type Photoalbums = {
  __typename?: 'Photoalbums';
  /** Photoalbum */
  photoalbum?: Maybe<Photoalbum>;
  /** Photoalbum list */
  photoalbumList: PhotoalbumList;
  /** Picture list */
  pictureList: PictureList;
  /** Picture upload URL */
  pictureUploadUrl?: Maybe<Scalars['String']['output']>;
};


export type PhotoalbumsPhotoalbumArgs = {
  albumId: Scalars['Int']['input'];
};


export type PhotoalbumsPhotoalbumListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  mediaTypes?: InputMaybe<Array<InputMaybe<PhotoalbumTypeEnum>>>;
  sortDescending?: InputMaybe<Scalars['Boolean']['input']>;
  sortField?: InputMaybe<PhotoalbumSortFieldsEnum>;
  status?: InputMaybe<Array<InputMaybe<PhotoalbumStatusEnum>>>;
};


export type PhotoalbumsPictureListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  albumId: Scalars['Int']['input'];
  first: Scalars['Int']['input'];
};


export type PhotoalbumsPictureUploadUrlArgs = {
  flags?: InputMaybe<Scalars['Int']['input']>;
  fsk?: InputMaybe<Scalars['Int']['input']>;
  pictureType: Scalars['Int']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
  umaId: Scalars['Int']['input'];
};

export type PhotoalbumsMutation = {
  __typename?: 'PhotoalbumsMutation';
  /** Remove picture from photoalbum */
  deletePicture?: Maybe<Scalars['Boolean']['output']>;
  /** Update released status of photoalbum */
  updateReleasedStatus?: Maybe<Photoalbum>;
};


export type PhotoalbumsMutationDeletePictureArgs = {
  albumId: Scalars['Int']['input'];
  pictureId: Scalars['Int']['input'];
};


export type PhotoalbumsMutationUpdateReleasedStatusArgs = {
  albumId: Scalars['Int']['input'];
  status: PhotoalbumReleasedStatusEnum;
};

export type PictureList = {
  __typename?: 'PictureList';
  /** Edges */
  edges: Array<Maybe<PicturePaginationEdge>>;
  /** Page info */
  pageInfo?: Maybe<PaginationPageInfo>;
  /** Total edges */
  totalCount: Scalars['Int']['output'];
};

export type PicturePaginationEdge = {
  __typename?: 'PicturePaginationEdge';
  /** Cursor for cursor-based pagination */
  cursor?: Maybe<Scalars['String']['output']>;
  /** Picture item */
  node: MediaPicture;
};

/** Profile Root */
export type Profile = {
  __typename?: 'Profile';
  /** Profile collection */
  collection?: Maybe<ProfileCollection>;
  /** Profile field */
  field?: Maybe<ProfileField>;
};


/** Profile Root */
export type ProfileCollectionArgs = {
  name: ProfileCollectionNameEnum;
};


/** Profile Root */
export type ProfileFieldArgs = {
  name: ProfileFieldsEnum;
};

/** A specified profile collection */
export type ProfileCollection = ProfileCollectionAccountV1 | ProfileCollectionMobileAboutMeV1 | ProfileCollectionMobileAppearanceV1 | ProfileCollectionMobileInterviewV1 | ProfileCollectionMobileMediaV1 | ProfileCollectionMobileProfileV1 | ProfileCollectionModelReleaseFormV1 | ProfileCollectionOnboardingV1 | ProfileCollectionPayoutV1;

export type ProfileCollectionAccountV1 = {
  __typename?: 'ProfileCollectionAccountV1';
  /** Name */
  completeness: ProfileCollectionCompleteness;
  /** Collection fields */
  fields: ProfileCollectionAccountV1Fields;
  /** Collection values */
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  /** Name */
  name: ProfileCollectionNameEnum;
  /** Name */
  status: ProfileStatusEnum;
  /** Collection values */
  values: ProfileCollectionAccountV1Values;
};

export type ProfileCollectionAccountV1Fields = {
  __typename?: 'ProfileCollectionAccountV1Fields';
  /** Account city */
  accountAddressCity?: Maybe<ProfileFieldTypeString>;
  /** Account address company name */
  accountAddressCompany?: Maybe<ProfileFieldTypeString>;
  /** Account address country */
  accountAddressCountry?: Maybe<ProfileFieldTypeEnum>;
  /** Account address postal code */
  accountAddressPostalCode?: Maybe<ProfileFieldTypeString>;
  /** Account address street name */
  accountAddressStreet?: Maybe<ProfileFieldTypeString>;
  /** Account address street number */
  accountAddressStreetNumber?: Maybe<ProfileFieldTypeString>;
  /** Account birthdate */
  accountBirthdate?: Maybe<ProfileFieldTypeDate>;
  /** Account contact email address */
  accountContactEmailAdress?: Maybe<ProfileFieldTypeString>;
  /** Account contact (fixed) phone */
  accountContactFixedPhone?: Maybe<ProfileFieldTypeString>;
  /** Account contact mobile phone */
  accountContactMobilePhone?: Maybe<ProfileFieldTypeString>;
  /** Account firstname */
  accountFirstname?: Maybe<ProfileFieldTypeString>;
  /** Account language (used for emails, etc.) */
  accountLanguage?: Maybe<ProfileFieldTypeEnum>;
  /** Account lastname */
  accountLastname?: Maybe<ProfileFieldTypeString>;
  /** Model Username (a.k.a login, screenname) [alfanum, 6-16] */
  modelUsername?: Maybe<ProfileFieldTypeString>;
};

export type ProfileCollectionAccountV1Mutation = {
  __typename?: 'ProfileCollectionAccountV1Mutation';
  /** Update values */
  update: ProfileCollectionAccountV1Result;
};


export type ProfileCollectionAccountV1MutationUpdateArgs = {
  data: InputProfileCollectionAccountV1;
};

/** A specified profile collection */
export type ProfileCollectionAccountV1Result = ProfileCollectionAccountV1 | ProfileFieldValidationSet;

export type ProfileCollectionAccountV1Values = {
  __typename?: 'ProfileCollectionAccountV1Values';
  /** Account city */
  accountAddressCity?: Maybe<Scalars['String']['output']>;
  /** Account address company name */
  accountAddressCompany?: Maybe<Scalars['String']['output']>;
  /** Account address country */
  accountAddressCountry?: Maybe<CountryEnum>;
  /** Account address postal code */
  accountAddressPostalCode?: Maybe<Scalars['String']['output']>;
  /** Account address street name */
  accountAddressStreet?: Maybe<Scalars['String']['output']>;
  /** Account address street number */
  accountAddressStreetNumber?: Maybe<Scalars['String']['output']>;
  /** Account birthdate */
  accountBirthdate?: Maybe<Scalars['Date']['output']>;
  /** Account contact email address */
  accountContactEmailAdress?: Maybe<Scalars['String']['output']>;
  /** Account contact (fixed) phone */
  accountContactFixedPhone?: Maybe<Scalars['String']['output']>;
  /** Account contact mobile phone */
  accountContactMobilePhone?: Maybe<Scalars['String']['output']>;
  /** Account firstname */
  accountFirstname?: Maybe<Scalars['String']['output']>;
  /** Account language (used for emails, etc.) */
  accountLanguage?: Maybe<ApiLangEnum>;
  /** Account lastname */
  accountLastname?: Maybe<Scalars['String']['output']>;
  /** Model Username (a.k.a login, screenname) [alfanum, 6-16] */
  modelUsername?: Maybe<Scalars['String']['output']>;
};

/** Profile Completeness */
export type ProfileCollectionCompleteness = {
  __typename?: 'ProfileCollectionCompleteness';
  /** Names of all fields in Profile/Tour */
  allFields: Array<ProfileFieldsEnum>;
  /** Count of complete fields in Profile/Tour */
  complete: Scalars['Int']['output'];
  /** Timestamp, when Profile/Tour was started for the first time. Maybe be null in Profile */
  firstStarted?: Maybe<Scalars['DateTime']['output']>;
  /** Timestamp, when Profile/Tour all fields were "accepted" for the last time. Null on never completed. */
  lastCompleted?: Maybe<Scalars['DateTime']['output']>;
  /** Count of missing fields in Profile/Tour */
  missing: Scalars['Int']['output'];
  /** Field names in Profile/Tour which are "incomplete" or "rejected" */
  missingFields: Array<ProfileFieldsEnum>;
  /** Percent of Profile/Tour completeness */
  percent: Scalars['Int']['output'];
  /** Count of all fields in Profile/Tour */
  total: Scalars['Int']['output'];
};

export type ProfileCollectionMobileAboutMeV1 = {
  __typename?: 'ProfileCollectionMobileAboutMeV1';
  /** Name */
  completeness: ProfileCollectionCompleteness;
  /** Collection fields */
  fields: ProfileCollectionMobileAboutMeV1Fields;
  /** Collection values */
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  /** Name */
  name: ProfileCollectionNameEnum;
  /** Name */
  status: ProfileStatusEnum;
  /** Collection values */
  values: ProfileCollectionMobileAboutMeV1Values;
};

export type ProfileCollectionMobileAboutMeV1Fields = {
  __typename?: 'ProfileCollectionMobileAboutMeV1Fields';
  /** Model About Me */
  modelAboutMe?: Maybe<ProfileFieldTypeMultiLangString>;
  /** Model Birthdate, may differ from account (real person) birthdate [YYYY-MM-DD] */
  modelBirthdate?: Maybe<ProfileFieldTypeDate>;
  /** Model Chat Parctices [chatflirt, dirtytalk, striptease, livesex, masturbation] */
  modelChatPractices?: Maybe<ProfileFieldTypeEnumList>;
  /** Model city */
  modelCity?: Maybe<ProfileFieldTypeString>;
  /** Model country */
  modelCountry?: Maybe<ProfileFieldTypeEnum>;
  /** Model gender [female, male, transgender] */
  modelGender?: Maybe<ProfileFieldTypeEnum>;
  /** Model Language [de, en, fr ....] */
  modelLanguage?: Maybe<ProfileFieldTypeEnumList>;
  /** Model Motto (a.k.a. Chat Motto) [string, 10-100] */
  modelMotto?: Maybe<ProfileFieldTypeMultiLangString>;
  /** Model Postal Code */
  modelPostalCode?: Maybe<ProfileFieldTypeString>;
  /** Model gender [single, seeking, inOpenRelationship, inRelationship, engaged, married] */
  modelRelationshipState?: Maybe<ProfileFieldTypeEnum>;
  /** Model sexuality [heterosexual, homesexual, bisexual] */
  modelSexuality?: Maybe<ProfileFieldTypeEnum>;
  /** Model Username (a.k.a login, screenname) [alfanum, 6-16] */
  modelUsername?: Maybe<ProfileFieldTypeString>;
};

export type ProfileCollectionMobileAboutMeV1Mutation = {
  __typename?: 'ProfileCollectionMobileAboutMeV1Mutation';
  /** Update values */
  update: ProfileCollectionMobileAboutMeV1Result;
};


export type ProfileCollectionMobileAboutMeV1MutationUpdateArgs = {
  data: InputProfileCollectionMobileAboutMeV1;
};

/** A specified profile collection */
export type ProfileCollectionMobileAboutMeV1Result = ProfileCollectionMobileAboutMeV1 | ProfileFieldValidationSet;

export type ProfileCollectionMobileAboutMeV1Values = {
  __typename?: 'ProfileCollectionMobileAboutMeV1Values';
  /** Model About Me */
  modelAboutMe?: Maybe<MultiLangText>;
  /** Model Birthdate, may differ from account (real person) birthdate [YYYY-MM-DD] */
  modelBirthdate?: Maybe<Scalars['Date']['output']>;
  /** Model Chat Parctices [chatflirt, dirtytalk, striptease, livesex, masturbation] */
  modelChatPractices?: Maybe<Array<ChatPracticesEnum>>;
  /** Model city */
  modelCity?: Maybe<Scalars['String']['output']>;
  /** Model country */
  modelCountry?: Maybe<CountryEnum>;
  /** Model gender [female, male, transgender] */
  modelGender?: Maybe<GenderEnum>;
  /** Model Language [de, en, fr ....] */
  modelLanguage?: Maybe<Array<LanguagesEnum>>;
  /** Model Motto (a.k.a. Chat Motto) [string, 10-100] */
  modelMotto?: Maybe<MultiLangText>;
  /** Model Postal Code */
  modelPostalCode?: Maybe<Scalars['String']['output']>;
  /** Model gender [single, seeking, inOpenRelationship, inRelationship, engaged, married] */
  modelRelationshipState?: Maybe<RelationshipEnum>;
  /** Model sexuality [heterosexual, homesexual, bisexual] */
  modelSexuality?: Maybe<SexualityEnum>;
  /** Model Username (a.k.a login, screenname) [alfanum, 6-16] */
  modelUsername?: Maybe<Scalars['String']['output']>;
};

export type ProfileCollectionMobileAppearanceV1 = {
  __typename?: 'ProfileCollectionMobileAppearanceV1';
  /** Name */
  completeness: ProfileCollectionCompleteness;
  /** Collection fields */
  fields: ProfileCollectionMobileAppearanceV1Fields;
  /** Collection values */
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  /** Name */
  name: ProfileCollectionNameEnum;
  /** Name */
  status: ProfileStatusEnum;
  /** Collection values */
  values: ProfileCollectionMobileAppearanceV1Values;
};

export type ProfileCollectionMobileAppearanceV1Fields = {
  __typename?: 'ProfileCollectionMobileAppearanceV1Fields';
  /** Model Body Figure [athletic, chubby, fat ....] */
  modelBodyFigure?: Maybe<ProfileFieldTypeEnum>;
  /** Model Body Height */
  modelBodyHeight?: Maybe<ProfileFieldTypeInt>;
  /** Model Body Modifcations [heavily tattooed, intimate (piercing, tattoo), pectoral piercing, no body modifications] */
  modelBodyModifications?: Maybe<ProfileFieldTypeEnumList>;
  /** Model Body Weight */
  modelBodyWeight?: Maybe<ProfileFieldTypeInt>;
  /** Model Breast Size [_NULL_,AA,A,B,C,D,DD,E,F,>F] */
  modelBreastSize?: Maybe<ProfileFieldTypeEnum>;
  /** Model Eye color [blue, green, brown....] */
  modelEyeColor?: Maybe<ProfileFieldTypeEnum>;
  /** Model Hair Color [blonde, brown, black ....] */
  modelHairColor?: Maybe<ProfileFieldTypeEnum>;
  /** Model Penize Size [_NULL_, s,m,l,xl,xxl] */
  modelPenisSize?: Maybe<ProfileFieldTypeEnum>;
  /** Model Pubic Hair [hollywood, landing strip, bikini cut ....] */
  modelPubicHair?: Maybe<ProfileFieldTypeEnum>;
  /** Model Skin Type [asian, black skinned ...] */
  modelSkinType?: Maybe<ProfileFieldTypeEnum>;
};

export type ProfileCollectionMobileAppearanceV1Mutation = {
  __typename?: 'ProfileCollectionMobileAppearanceV1Mutation';
  /** Update values */
  update: ProfileCollectionMobileAppearanceV1Result;
};


export type ProfileCollectionMobileAppearanceV1MutationUpdateArgs = {
  data: InputProfileCollectionMobileAppearanceV1;
};

/** A specified profile collection */
export type ProfileCollectionMobileAppearanceV1Result = ProfileCollectionMobileAppearanceV1 | ProfileFieldValidationSet;

export type ProfileCollectionMobileAppearanceV1Values = {
  __typename?: 'ProfileCollectionMobileAppearanceV1Values';
  /** Model Body Figure [athletic, chubby, fat ....] */
  modelBodyFigure?: Maybe<BodyFigureEnum>;
  /** Model Body Height */
  modelBodyHeight?: Maybe<Scalars['Int']['output']>;
  /** Model Body Modifcations [heavily tattooed, intimate (piercing, tattoo), pectoral piercing, no body modifications] */
  modelBodyModifications?: Maybe<Array<BodyModificationsEnum>>;
  /** Model Body Weight */
  modelBodyWeight?: Maybe<Scalars['Int']['output']>;
  /** Model Breast Size [_NULL_,AA,A,B,C,D,DD,E,F,>F] */
  modelBreastSize?: Maybe<BreastSizeEnum>;
  /** Model Eye color [blue, green, brown....] */
  modelEyeColor?: Maybe<EyeColorEnum>;
  /** Model Hair Color [blonde, brown, black ....] */
  modelHairColor?: Maybe<HairColorEnum>;
  /** Model Penize Size [_NULL_, s,m,l,xl,xxl] */
  modelPenisSize?: Maybe<PenisSizeEnum>;
  /** Model Pubic Hair [hollywood, landing strip, bikini cut ....] */
  modelPubicHair?: Maybe<PubicHairEnum>;
  /** Model Skin Type [asian, black skinned ...] */
  modelSkinType?: Maybe<SkinTypeEnum>;
};

export type ProfileCollectionMobileInterviewV1 = {
  __typename?: 'ProfileCollectionMobileInterviewV1';
  /** Name */
  completeness: ProfileCollectionCompleteness;
  /** Collection fields */
  fields: ProfileCollectionMobileInterviewV1Fields;
  /** Collection values */
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  /** Name */
  name: ProfileCollectionNameEnum;
  /** Name */
  status: ProfileStatusEnum;
  /** Collection values */
  values: ProfileCollectionMobileInterviewV1Values;
};

export type ProfileCollectionMobileInterviewV1Fields = {
  __typename?: 'ProfileCollectionMobileInterviewV1Fields';
  /** Model Interview Enterprise [string, 0-250] */
  modelInterviewEnterprise?: Maybe<ProfileFieldTypeMultiLangString>;
  /** Model Interview Erotic Experience [string, 0-250] */
  modelInterviewEroticExperience?: Maybe<ProfileFieldTypeMultiLangString>;
  /** Model Interview Hobbies [string, 0-250] */
  modelInterviewHobbies?: Maybe<ProfileFieldTypeMultiLangString>;
  /** Model Interview Island [string, 0-250] */
  modelInterviewIsland?: Maybe<ProfileFieldTypeMultiLangString>;
  /** Model Interview Partner [string, 0-250] */
  modelInterviewPartner?: Maybe<ProfileFieldTypeMultiLangString>;
  /** Model Interview Sex No Go [string, 0-250] */
  modelInterviewSexNotOk?: Maybe<ProfileFieldTypeMultiLangString>;
  /** Model Interview Sex Go [string, 0-250] */
  modelInterviewSexOk?: Maybe<ProfileFieldTypeMultiLangString>;
  /** Model Interview Sexual Fantasies [string, 0-250] */
  modelInterviewSexualFantasies?: Maybe<ProfileFieldTypeMultiLangString>;
  /** Model Interview Sexual Position [string, 0-250] */
  modelInterviewSexualPosition?: Maybe<ProfileFieldTypeMultiLangString>;
};

export type ProfileCollectionMobileInterviewV1Mutation = {
  __typename?: 'ProfileCollectionMobileInterviewV1Mutation';
  /** Update values */
  update: ProfileCollectionMobileInterviewV1Result;
};


export type ProfileCollectionMobileInterviewV1MutationUpdateArgs = {
  data: InputProfileCollectionMobileInterviewV1;
};

/** A specified profile collection */
export type ProfileCollectionMobileInterviewV1Result = ProfileCollectionMobileInterviewV1 | ProfileFieldValidationSet;

export type ProfileCollectionMobileInterviewV1Values = {
  __typename?: 'ProfileCollectionMobileInterviewV1Values';
  /** Model Interview Enterprise [string, 0-250] */
  modelInterviewEnterprise?: Maybe<MultiLangText>;
  /** Model Interview Erotic Experience [string, 0-250] */
  modelInterviewEroticExperience?: Maybe<MultiLangText>;
  /** Model Interview Hobbies [string, 0-250] */
  modelInterviewHobbies?: Maybe<MultiLangText>;
  /** Model Interview Island [string, 0-250] */
  modelInterviewIsland?: Maybe<MultiLangText>;
  /** Model Interview Partner [string, 0-250] */
  modelInterviewPartner?: Maybe<MultiLangText>;
  /** Model Interview Sex No Go [string, 0-250] */
  modelInterviewSexNotOk?: Maybe<MultiLangText>;
  /** Model Interview Sex Go [string, 0-250] */
  modelInterviewSexOk?: Maybe<MultiLangText>;
  /** Model Interview Sexual Fantasies [string, 0-250] */
  modelInterviewSexualFantasies?: Maybe<MultiLangText>;
  /** Model Interview Sexual Position [string, 0-250] */
  modelInterviewSexualPosition?: Maybe<MultiLangText>;
};

export type ProfileCollectionMobileMediaV1 = {
  __typename?: 'ProfileCollectionMobileMediaV1';
  /** Name */
  completeness: ProfileCollectionCompleteness;
  /** Collection fields */
  fields: ProfileCollectionMobileMediaV1Fields;
  /** Collection values */
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  /** Name */
  name: ProfileCollectionNameEnum;
  /** Name */
  status: ProfileStatusEnum;
  /** Collection values */
  values: ProfileCollectionMobileMediaV1Values;
};

export type ProfileCollectionMobileMediaV1Fields = {
  __typename?: 'ProfileCollectionMobileMediaV1Fields';
  /** Model avatar picture, from FSK12 sedcard  (ratio 1:1, displayed as cropped circle) */
  modelPictureFSK12Avatar?: Maybe<ProfileFieldTypePicture>;
  /** Model sedcard pictures, from FSK12 */
  modelPictureFSK12Sedcard?: Maybe<ProfileFieldTypePictureList>;
  /** Model avatar picture, from FSK16 sedcard  (ratio 1:1, displayed as cropped circle) */
  modelPictureFSK16Avatar?: Maybe<ProfileFieldTypePicture>;
  /** Model sedcard pictures, from FSK16 */
  modelPictureFSK16Sedcard?: Maybe<ProfileFieldTypePictureList>;
  /** Model avatar picture, from FSK18 sedcard  (ratio 1:1, displayed as cropped circle) */
  modelPictureFSK18Avatar?: Maybe<ProfileFieldTypePicture>;
  /** Model sedcard pictures, from FSK18 */
  modelPictureFSK18Sedcard?: Maybe<ProfileFieldTypePictureList>;
  /** Model title picture as landscape, from FSK16 sedcard (ratio 25:10) */
  modelPictureTitleLandscape?: Maybe<ProfileFieldTypePicture>;
};

export type ProfileCollectionMobileMediaV1Mutation = {
  __typename?: 'ProfileCollectionMobileMediaV1Mutation';
  /** Delete */
  deleteSedcardPicture: Scalars['Boolean']['output'];
  /** Update values */
  update: ProfileCollectionMobileMediaV1Result;
};


export type ProfileCollectionMobileMediaV1MutationDeleteSedcardPictureArgs = {
  umaId: Scalars['Int']['input'];
  umpId: Scalars['Int']['input'];
};


export type ProfileCollectionMobileMediaV1MutationUpdateArgs = {
  data: InputProfileCollectionMobileMediaV1;
};

/** A specified profile collection */
export type ProfileCollectionMobileMediaV1Result = ProfileCollectionMobileMediaV1 | ProfileFieldValidationSet;

export type ProfileCollectionMobileMediaV1Values = {
  __typename?: 'ProfileCollectionMobileMediaV1Values';
  /** Model avatar picture, from FSK12 sedcard  (ratio 1:1, displayed as cropped circle) */
  modelPictureFSK12Avatar?: Maybe<MediaPicture>;
  /** Model sedcard pictures, from FSK12 */
  modelPictureFSK12Sedcard?: Maybe<Array<MediaPicture>>;
  /** Model avatar picture, from FSK16 sedcard  (ratio 1:1, displayed as cropped circle) */
  modelPictureFSK16Avatar?: Maybe<MediaPicture>;
  /** Model sedcard pictures, from FSK16 */
  modelPictureFSK16Sedcard?: Maybe<Array<MediaPicture>>;
  /** Model avatar picture, from FSK18 sedcard  (ratio 1:1, displayed as cropped circle) */
  modelPictureFSK18Avatar?: Maybe<MediaPicture>;
  /** Model sedcard pictures, from FSK18 */
  modelPictureFSK18Sedcard?: Maybe<Array<MediaPicture>>;
  /** Model title picture as landscape, from FSK16 sedcard (ratio 25:10) */
  modelPictureTitleLandscape?: Maybe<MediaPicture>;
};

export type ProfileCollectionMobileProfileV1 = {
  __typename?: 'ProfileCollectionMobileProfileV1';
  /** Name */
  completeness: ProfileCollectionCompleteness;
  /** Collection fields */
  fields: ProfileCollectionMobileProfileV1Fields;
  /** Collection values */
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  /** Name */
  name: ProfileCollectionNameEnum;
  /** Name */
  status: ProfileStatusEnum;
  /** Collection values */
  values: ProfileCollectionMobileProfileV1Values;
};

export type ProfileCollectionMobileProfileV1Fields = {
  __typename?: 'ProfileCollectionMobileProfileV1Fields';
  /** Model About Me */
  modelAboutMe?: Maybe<ProfileFieldTypeMultiLangString>;
  /** Model Birthdate, may differ from account (real person) birthdate [YYYY-MM-DD] */
  modelBirthdate?: Maybe<ProfileFieldTypeDate>;
  /** Model Body Height */
  modelBodyHeight?: Maybe<ProfileFieldTypeInt>;
  /** Model Body Weight */
  modelBodyWeight?: Maybe<ProfileFieldTypeInt>;
  /** Model Breast Size [_NULL_,AA,A,B,C,D,DD,E,F,>F] */
  modelBreastSize?: Maybe<ProfileFieldTypeEnum>;
  /** Model gender [female, male, transgender] */
  modelGender?: Maybe<ProfileFieldTypeEnum>;
  /** Model Motto (a.k.a. Chat Motto) [string, 10-100] */
  modelMotto?: Maybe<ProfileFieldTypeMultiLangString>;
  /** Model Penize Size [_NULL_, s,m,l,xl,xxl] */
  modelPenisSize?: Maybe<ProfileFieldTypeEnum>;
  /** @deprecated use ModelPictureFSK16Avatar instead Model avatar picture, from FSK16 sedcard  (ratio 1:1, displayed as cropped circle) */
  modelPictureAvatar?: Maybe<ProfileFieldTypePicture>;
  /** Model title picture as landscape, from FSK16 sedcard (ratio 25:10) */
  modelPictureTitleLandscape?: Maybe<ProfileFieldTypePicture>;
  /** Model sexuality [heterosexual, homesexual, bisexual] */
  modelSexuality?: Maybe<ProfileFieldTypeEnum>;
  /** Model Username (a.k.a login, screenname) [alfanum, 6-16] */
  modelUsername?: Maybe<ProfileFieldTypeString>;
};

export type ProfileCollectionMobileProfileV1Mutation = {
  __typename?: 'ProfileCollectionMobileProfileV1Mutation';
  /** Update values */
  update: ProfileCollectionMobileProfileV1Result;
};


export type ProfileCollectionMobileProfileV1MutationUpdateArgs = {
  data: InputProfileCollectionMobileProfileV1;
};

/** A specified profile collection */
export type ProfileCollectionMobileProfileV1Result = ProfileCollectionMobileProfileV1 | ProfileFieldValidationSet;

export type ProfileCollectionMobileProfileV1Values = {
  __typename?: 'ProfileCollectionMobileProfileV1Values';
  /** Model About Me */
  modelAboutMe?: Maybe<MultiLangText>;
  /** Model Birthdate, may differ from account (real person) birthdate [YYYY-MM-DD] */
  modelBirthdate?: Maybe<Scalars['Date']['output']>;
  /** Model Body Height */
  modelBodyHeight?: Maybe<Scalars['Int']['output']>;
  /** Model Body Weight */
  modelBodyWeight?: Maybe<Scalars['Int']['output']>;
  /** Model Breast Size [_NULL_,AA,A,B,C,D,DD,E,F,>F] */
  modelBreastSize?: Maybe<BreastSizeEnum>;
  /** Model gender [female, male, transgender] */
  modelGender?: Maybe<GenderEnum>;
  /** Model Motto (a.k.a. Chat Motto) [string, 10-100] */
  modelMotto?: Maybe<MultiLangText>;
  /** Model Penize Size [_NULL_, s,m,l,xl,xxl] */
  modelPenisSize?: Maybe<PenisSizeEnum>;
  /** @deprecated use ModelPictureFSK16Avatar instead Model avatar picture, from FSK16 sedcard  (ratio 1:1, displayed as cropped circle) */
  modelPictureAvatar?: Maybe<MediaPicture>;
  /** Model title picture as landscape, from FSK16 sedcard (ratio 25:10) */
  modelPictureTitleLandscape?: Maybe<MediaPicture>;
  /** Model sexuality [heterosexual, homesexual, bisexual] */
  modelSexuality?: Maybe<SexualityEnum>;
  /** Model Username (a.k.a login, screenname) [alfanum, 6-16] */
  modelUsername?: Maybe<Scalars['String']['output']>;
};

export type ProfileCollectionModelReleaseFormV1 = {
  __typename?: 'ProfileCollectionModelReleaseFormV1';
  /** Name */
  completeness: ProfileCollectionCompleteness;
  /** Collection fields */
  fields: ProfileCollectionModelReleaseFormV1Fields;
  /** Collection values */
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  /** Name */
  name: ProfileCollectionNameEnum;
  /** Name */
  status: ProfileStatusEnum;
  /** Collection values */
  values: ProfileCollectionModelReleaseFormV1Values;
};

export type ProfileCollectionModelReleaseFormV1Fields = {
  __typename?: 'ProfileCollectionModelReleaseFormV1Fields';
  /** @deprecated use MrfModelBirthdate instead Model Release Form Birthdate [YYYY-MM-DD] */
  mrfBirthdate?: Maybe<ProfileFieldTypeDate>;
  /** @deprecated use MrfModelBirthplace instead Model Release Form birthplace */
  mrfBirthplace?: Maybe<ProfileFieldTypeString>;
  /** @deprecated use MrfModelCity instead Model Release Form city */
  mrfCity?: Maybe<ProfileFieldTypeString>;
  /** @deprecated use MrfModelCountry instead Model Release Form country */
  mrfCountry?: Maybe<ProfileFieldTypeEnum>;
  /** @deprecated use MrfModelFirstname instead Model Release Form firstname */
  mrfFirstname?: Maybe<ProfileFieldTypeString>;
  /** @deprecated @alias MrfModelForm */
  mrfForm?: Maybe<ProfileFieldTypeFormManagerForm>;
  /** @deprecated use MrfModelLastname instead Model Release Form lastname */
  mrfLastname?: Maybe<ProfileFieldTypeString>;
  /** @deprecated use MrfModelPostalCode instead Model Release Form postal code */
  mrfPostalCode?: Maybe<ProfileFieldTypeString>;
  /** @deprecated use MrfModelStreet instead Model Release Form street */
  mrfStreet?: Maybe<ProfileFieldTypeString>;
  /** @deprecated use MrfModelStreetNumber instead Model Release Form street number */
  mrfStreetNumber?: Maybe<ProfileFieldTypeString>;
};

export type ProfileCollectionModelReleaseFormV1Mutation = {
  __typename?: 'ProfileCollectionModelReleaseFormV1Mutation';
  /** Update values */
  update: ProfileCollectionModelReleaseFormV1Result;
};


export type ProfileCollectionModelReleaseFormV1MutationUpdateArgs = {
  data: InputProfileCollectionModelReleaseFormV1;
};

/** A specified profile collection */
export type ProfileCollectionModelReleaseFormV1Result = ProfileCollectionModelReleaseFormV1 | ProfileFieldValidationSet;

export type ProfileCollectionModelReleaseFormV1Values = {
  __typename?: 'ProfileCollectionModelReleaseFormV1Values';
  /** @deprecated use MrfModelBirthdate instead Model Release Form Birthdate [YYYY-MM-DD] */
  mrfBirthdate?: Maybe<Scalars['Date']['output']>;
  /** @deprecated use MrfModelBirthplace instead Model Release Form birthplace */
  mrfBirthplace?: Maybe<Scalars['String']['output']>;
  /** @deprecated use MrfModelCity instead Model Release Form city */
  mrfCity?: Maybe<Scalars['String']['output']>;
  /** @deprecated use MrfModelCountry instead Model Release Form country */
  mrfCountry?: Maybe<CountryEnum>;
  /** @deprecated use MrfModelFirstname instead Model Release Form firstname */
  mrfFirstname?: Maybe<Scalars['String']['output']>;
  /** @deprecated @alias MrfModelForm */
  mrfForm?: Maybe<FormManagerForm>;
  /** @deprecated use MrfModelLastname instead Model Release Form lastname */
  mrfLastname?: Maybe<Scalars['String']['output']>;
  /** @deprecated use MrfModelPostalCode instead Model Release Form postal code */
  mrfPostalCode?: Maybe<Scalars['String']['output']>;
  /** @deprecated use MrfModelStreet instead Model Release Form street */
  mrfStreet?: Maybe<Scalars['String']['output']>;
  /** @deprecated use MrfModelStreetNumber instead Model Release Form street number */
  mrfStreetNumber?: Maybe<Scalars['String']['output']>;
};

export type ProfileCollectionMutation = ProfileCollectionAccountV1Mutation | ProfileCollectionMobileAboutMeV1Mutation | ProfileCollectionMobileAppearanceV1Mutation | ProfileCollectionMobileInterviewV1Mutation | ProfileCollectionMobileMediaV1Mutation | ProfileCollectionMobileProfileV1Mutation | ProfileCollectionModelReleaseFormV1Mutation | ProfileCollectionOnboardingV1Mutation | ProfileCollectionPayoutV1Mutation;

/** Profile Collection Names */
export enum ProfileCollectionNameEnum {
  /** Account (v1) collection */
  AccountV1 = 'AccountV1',
  /** Model About Me (v1) collection */
  MobileAboutMeV1 = 'MobileAboutMeV1',
  /** Model Appearance (v1) collection */
  MobileAppearanceV1 = 'MobileAppearanceV1',
  /** Model Interview (v1) collection */
  MobileInterviewV1 = 'MobileInterviewV1',
  /** Mobile Media (v1) collection */
  MobileMediaV1 = 'MobileMediaV1',
  /** Mobile Profile (v1) collection */
  MobileProfileV1 = 'MobileProfileV1',
  /** Model Release Form (v1) collection */
  ModelReleaseFormV1 = 'ModelReleaseFormV1',
  /** Onboarding (v1) collection */
  OnboardingV1 = 'OnboardingV1',
  /** Payment Billing Address (v1) collection */
  PaymentBillingAddressV1 = 'PaymentBillingAddressV1',
  /** Payment Tax (v1) collection */
  PaymentPayoutDataV1 = 'PaymentPayoutDataV1',
  /** Payment Tax Data (v1) collection */
  PaymentTaxDataV1 = 'PaymentTaxDataV1',
  /** Payout (v1) collection */
  PayoutV1 = 'PayoutV1'
}

export type ProfileCollectionOnboardingV1 = {
  __typename?: 'ProfileCollectionOnboardingV1';
  /** Name */
  completeness: ProfileCollectionCompleteness;
  /** Collection fields */
  fields: ProfileCollectionOnboardingV1Fields;
  /** Collection values */
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  /** Name */
  name: ProfileCollectionNameEnum;
  /** Name */
  status: ProfileStatusEnum;
  /** Collection values */
  values: ProfileCollectionOnboardingV1Values;
};

export type ProfileCollectionOnboardingV1Fields = {
  __typename?: 'ProfileCollectionOnboardingV1Fields';
  /** Model Birthdate, may differ from account (real person) birthdate [YYYY-MM-DD] */
  modelBirthdate?: Maybe<ProfileFieldTypeDate>;
  /** Model gender [female, male, transgender] */
  modelGender?: Maybe<ProfileFieldTypeEnum>;
  /** Model Motto (a.k.a. Chat Motto) [string, 10-100] */
  modelMotto?: Maybe<ProfileFieldTypeMultiLangString>;
  /** @deprecated use ModelPictureFSK16Avatar instead Model avatar picture, from FSK16 sedcard  (ratio 1:1, displayed as cropped circle) */
  modelPictureAvatar?: Maybe<ProfileFieldTypePicture>;
  /** Model sexuality [heterosexual, homesexual, bisexual] */
  modelSexuality?: Maybe<ProfileFieldTypeEnum>;
  /** Model Username (a.k.a login, screenname) [alfanum, 6-16] */
  modelUsername?: Maybe<ProfileFieldTypeString>;
};

export type ProfileCollectionOnboardingV1Mutation = {
  __typename?: 'ProfileCollectionOnboardingV1Mutation';
  /** Update values */
  update: ProfileCollectionOnboardingV1Result;
};


export type ProfileCollectionOnboardingV1MutationUpdateArgs = {
  data: InputProfileCollectionOnboardingV1;
};

/** A specified profile collection */
export type ProfileCollectionOnboardingV1Result = ProfileCollectionOnboardingV1 | ProfileFieldValidationSet;

export type ProfileCollectionOnboardingV1Values = {
  __typename?: 'ProfileCollectionOnboardingV1Values';
  /** Model Birthdate, may differ from account (real person) birthdate [YYYY-MM-DD] */
  modelBirthdate?: Maybe<Scalars['Date']['output']>;
  /** Model gender [female, male, transgender] */
  modelGender?: Maybe<GenderEnum>;
  /** Model Motto (a.k.a. Chat Motto) [string, 10-100] */
  modelMotto?: Maybe<MultiLangText>;
  /** @deprecated use ModelPictureFSK16Avatar instead Model avatar picture, from FSK16 sedcard  (ratio 1:1, displayed as cropped circle) */
  modelPictureAvatar?: Maybe<MediaPicture>;
  /** Model sexuality [heterosexual, homesexual, bisexual] */
  modelSexuality?: Maybe<SexualityEnum>;
  /** Model Username (a.k.a login, screenname) [alfanum, 6-16] */
  modelUsername?: Maybe<Scalars['String']['output']>;
};

export type ProfileCollectionPayoutV1 = {
  __typename?: 'ProfileCollectionPayoutV1';
  /** Name */
  completeness: ProfileCollectionCompleteness;
  /** Collection fields */
  fields: ProfileCollectionPayoutV1Fields;
  /** Name */
  name: ProfileCollectionNameEnum;
  /** Name */
  status: ProfileStatusEnum;
  /** Collection values */
  values: ProfileCollectionPayoutV1Values;
};

export type ProfileCollectionPayoutV1Fields = {
  __typename?: 'ProfileCollectionPayoutV1Fields';
  /** @deprecated use PaymentBillingAddressCity instead Payout Proof of Addresse - City */
  payoutAddressCity?: Maybe<ProfileFieldTypeString>;
  /** @deprecated use PaymentBillingAddressCompanyname instead Payout Proof of Addresse - Company Name */
  payoutAddressCompanyname?: Maybe<ProfileFieldTypeString>;
  /** @deprecated use PaymentBillingAddressCountry instead Payout Proof of Address - Country */
  payoutAddressCountry?: Maybe<ProfileFieldTypeEnum>;
  /** @deprecated use PaymentBillingAddressDocument instead Payout Tax Document */
  payoutAddressDocument?: Maybe<ProfileFieldTypeUploadDocument>;
  /** @deprecated use  PaymentBillingAddressDocument Payout Address Document ID */
  payoutAddressDocumentId?: Maybe<ProfileFieldTypeInt>;
  /** @deprecated use PaymentBillingAddressFirstname instead Payout Proof of Addresse - City */
  payoutAddressFirstname?: Maybe<ProfileFieldTypeString>;
  /** @deprecated use PaymentBillingAddressIsCompany instead Payout Proof of Adress - is Company */
  payoutAddressIsCompany?: Maybe<ProfileFieldTypeBoolean>;
  /** @deprecated use PaymentBillingAddressLastname instead Payout Proof of Addresse - City */
  payoutAddressLastname?: Maybe<ProfileFieldTypeString>;
  /** @deprecated use PaymentBillingAddressPostalCode instead Payout Proof of Address - PostalCode */
  payoutAddressPostalCode?: Maybe<ProfileFieldTypeString>;
  /** @deprecated use PaymentBillingAddressStreet instead Payout Proof of Address - street */
  payoutAddressStreet?: Maybe<ProfileFieldTypeString>;
  /** @deprecated use PaymentBillingAddressStreetNumber instead Payout Proof of Address - street number */
  payoutAddressStreetNumber?: Maybe<ProfileFieldTypeString>;
  /** @deprecated use  PaymentPayoutDataBa Payout Bankaccountowner */
  payoutBankaccountOwner?: Maybe<ProfileFieldTypeString>;
  /** @deprecated use PaymentPayoutDataBankBic instead Payout BIC */
  payoutBic?: Maybe<ProfileFieldTypeString>;
  /** Payout Company or Full Legal Name */
  payoutCompanyOrFullLegalName?: Maybe<ProfileFieldTypeString>;
  /** @deprecated use PaymentPayoutDataBankIban instead Payout IBAN */
  payoutIban?: Maybe<ProfileFieldTypeString>;
  /** @deprecated use PaymentPayoutDataIsTaxable Payout Is Model Taxable */
  payoutIsTaxable?: Maybe<ProfileFieldTypeBoolean>;
  /** @deprecated use PaymentPayoutDataPaxumEmailAccount instead Payout Paxum Email Account */
  payoutPaxumEmailAccount?: Maybe<ProfileFieldTypeString>;
  /** @deprecated use PaymentTaxDataDocument Payout Tax Document */
  payoutTaxDocument?: Maybe<ProfileFieldTypeUploadDocument>;
  /** @deprecated use PaymentTaxDataDocument Payout Tax Document ID */
  payoutTaxDocumentId?: Maybe<ProfileFieldTypeInt>;
  /** @deprecated use PaymentTaxDataTaxNumber Payout Tax Number */
  payoutTaxId?: Maybe<ProfileFieldTypeString>;
  /** @deprecated use PaymentTaxDataTin Payout Tax TIN */
  payoutTaxTin?: Maybe<ProfileFieldTypeString>;
  /** @deprecated use PaymentTaxDataTinCountry Payout Tax TIN Country */
  payoutTaxTinCountry?: Maybe<ProfileFieldTypeEnum>;
  /** @deprecated use PaymentPayoutDataPayoutMethod instead Payout Type of Transaction (paxum, bank, cheque) */
  payoutTransactionType?: Maybe<ProfileFieldTypeEnum>;
};

export type ProfileCollectionPayoutV1Mutation = {
  __typename?: 'ProfileCollectionPayoutV1Mutation';
  /** Update values */
  update: ProfileCollectionPayoutV1Result;
};


export type ProfileCollectionPayoutV1MutationUpdateArgs = {
  data: InputProfileCollectionPayoutV1;
};

/** A specified profile collection */
export type ProfileCollectionPayoutV1Result = ProfileCollectionPayoutV1 | ProfileFieldValidationSet;

export type ProfileCollectionPayoutV1Values = {
  __typename?: 'ProfileCollectionPayoutV1Values';
  /** @deprecated use PaymentBillingAddressCity instead Payout Proof of Addresse - City */
  payoutAddressCity?: Maybe<Scalars['String']['output']>;
  /** @deprecated use PaymentBillingAddressCompanyname instead Payout Proof of Addresse - Company Name */
  payoutAddressCompanyname?: Maybe<Scalars['String']['output']>;
  /** @deprecated use PaymentBillingAddressCountry instead Payout Proof of Address - Country */
  payoutAddressCountry?: Maybe<CountryEnum>;
  /** @deprecated use PaymentBillingAddressDocument instead Payout Tax Document */
  payoutAddressDocument?: Maybe<UploadDocument>;
  /** @deprecated use  PaymentBillingAddressDocument Payout Address Document ID */
  payoutAddressDocumentId?: Maybe<Scalars['Int']['output']>;
  /** @deprecated use PaymentBillingAddressFirstname instead Payout Proof of Addresse - City */
  payoutAddressFirstname?: Maybe<Scalars['String']['output']>;
  /** @deprecated use PaymentBillingAddressIsCompany instead Payout Proof of Adress - is Company */
  payoutAddressIsCompany?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated use PaymentBillingAddressLastname instead Payout Proof of Addresse - City */
  payoutAddressLastname?: Maybe<Scalars['String']['output']>;
  /** @deprecated use PaymentBillingAddressPostalCode instead Payout Proof of Address - PostalCode */
  payoutAddressPostalCode?: Maybe<Scalars['String']['output']>;
  /** @deprecated use PaymentBillingAddressStreet instead Payout Proof of Address - street */
  payoutAddressStreet?: Maybe<Scalars['String']['output']>;
  /** @deprecated use PaymentBillingAddressStreetNumber instead Payout Proof of Address - street number */
  payoutAddressStreetNumber?: Maybe<Scalars['String']['output']>;
  /** @deprecated use  PaymentPayoutDataBa Payout Bankaccountowner */
  payoutBankaccountOwner?: Maybe<Scalars['String']['output']>;
  /** @deprecated use PaymentPayoutDataBankBic instead Payout BIC */
  payoutBic?: Maybe<Scalars['String']['output']>;
  /** Payout Company or Full Legal Name */
  payoutCompanyOrFullLegalName?: Maybe<Scalars['String']['output']>;
  /** @deprecated use PaymentPayoutDataBankIban instead Payout IBAN */
  payoutIban?: Maybe<Scalars['String']['output']>;
  /** @deprecated use PaymentPayoutDataIsTaxable Payout Is Model Taxable */
  payoutIsTaxable?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated use PaymentPayoutDataPaxumEmailAccount instead Payout Paxum Email Account */
  payoutPaxumEmailAccount?: Maybe<Scalars['String']['output']>;
  /** @deprecated use PaymentTaxDataDocument Payout Tax Document */
  payoutTaxDocument?: Maybe<UploadDocument>;
  /** @deprecated use PaymentTaxDataDocument Payout Tax Document ID */
  payoutTaxDocumentId?: Maybe<Scalars['Int']['output']>;
  /** @deprecated use PaymentTaxDataTaxNumber Payout Tax Number */
  payoutTaxId?: Maybe<Scalars['String']['output']>;
  /** @deprecated use PaymentTaxDataTin Payout Tax TIN */
  payoutTaxTin?: Maybe<Scalars['String']['output']>;
  /** @deprecated use PaymentTaxDataTinCountry Payout Tax TIN Country */
  payoutTaxTinCountry?: Maybe<TaxCountryEnum>;
  /** @deprecated use PaymentPayoutDataPayoutMethod instead Payout Type of Transaction (paxum, bank, cheque) */
  payoutTransactionType?: Maybe<FinancesPayoutMethodEnum>;
};

/** Generic Profile Field */
export type ProfileField = {
  /** Is field disabled */
  disabled: Scalars['Boolean']['output'];
  /** Field class (for Debug purpose only) */
  fieldClass: Scalars['String']['output'];
  /** Field last modified */
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  /** Field name */
  name: Scalars['String']['output'];
  /** Is field disabled */
  nullable: Scalars['Boolean']['output'];
  /** Is field read only */
  readOnly: Scalars['Boolean']['output'];
  /** Field reject reason */
  rejectReason?: Maybe<Scalars['String']['output']>;
  /** Field status */
  status: ProfileStatusEnum;
};

/** Profile Field Boolean Type */
export type ProfileFieldTypeBoolean = ProfileField & {
  __typename?: 'ProfileFieldTypeBoolean';
  /** Is field disabled */
  disabled: Scalars['Boolean']['output'];
  /** Field class (for Debug purpose only) */
  fieldClass: Scalars['String']['output'];
  /** Field last modified */
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  /** Field name */
  name: Scalars['String']['output'];
  /** Is field disabled */
  nullable: Scalars['Boolean']['output'];
  /** Is field read only */
  readOnly: Scalars['Boolean']['output'];
  /** Field reject reason */
  rejectReason?: Maybe<Scalars['String']['output']>;
  /** Field status */
  status: ProfileStatusEnum;
  /** field class (for Debug purpose only) */
  value?: Maybe<Scalars['Boolean']['output']>;
};

/** Profile Field Date Type */
export type ProfileFieldTypeDate = ProfileField & {
  __typename?: 'ProfileFieldTypeDate';
  /** Is field disabled */
  disabled: Scalars['Boolean']['output'];
  /** Field class (for Debug purpose only) */
  fieldClass: Scalars['String']['output'];
  /** Field last modified */
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  /** maximum date, upper range */
  maxDate?: Maybe<Scalars['Date']['output']>;
  /** minimum date, lower range */
  minDate?: Maybe<Scalars['Date']['output']>;
  /** Field name */
  name: Scalars['String']['output'];
  /** Is field disabled */
  nullable: Scalars['Boolean']['output'];
  /** Is field read only */
  readOnly: Scalars['Boolean']['output'];
  /** Field reject reason */
  rejectReason?: Maybe<Scalars['String']['output']>;
  /** Field status */
  status: ProfileStatusEnum;
  /** field class (for Debug purpose only) */
  value?: Maybe<Scalars['Date']['output']>;
};

/** Profile Field Enum Type */
export type ProfileFieldTypeEnum = ProfileField & {
  __typename?: 'ProfileFieldTypeEnum';
  /** Is field disabled */
  disabled: Scalars['Boolean']['output'];
  /** Field class (for Debug purpose only) */
  fieldClass: Scalars['String']['output'];
  /** Field last modified */
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  /** Field name */
  name: Scalars['String']['output'];
  /** Is field disabled */
  nullable: Scalars['Boolean']['output'];
  /** Valid input values */
  quickpickValues: Array<OptionEntry>;
  /** Is field read only */
  readOnly: Scalars['Boolean']['output'];
  /** Field reject reason */
  rejectReason?: Maybe<Scalars['String']['output']>;
  /** Field status */
  status: ProfileStatusEnum;
  /** Valid input values */
  validValues: Array<OptionEntry>;
  /** field class (for Debug purpose only) */
  value?: Maybe<Scalars['String']['output']>;
};

/** Profile Field Multi Select Type */
export type ProfileFieldTypeEnumList = ProfileField & {
  __typename?: 'ProfileFieldTypeEnumList';
  /** Is field disabled */
  disabled: Scalars['Boolean']['output'];
  /** Field class (for Debug purpose only) */
  fieldClass: Scalars['String']['output'];
  /** Field last modified */
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  /** Field name */
  name: Scalars['String']['output'];
  /** Is field disabled */
  nullable: Scalars['Boolean']['output'];
  /** Is field read only */
  readOnly: Scalars['Boolean']['output'];
  /** Field reject reason */
  rejectReason?: Maybe<Scalars['String']['output']>;
  /** Field status */
  status: ProfileStatusEnum;
  /** Valid input values */
  validValues: Array<OptionEntry>;
  /** field class (for Debug purpose only) */
  value?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/** Profile Field Form Manager */
export type ProfileFieldTypeFormManagerForm = ProfileFieldTypeFormManagerGenericForm | ProfileFieldTypeFormManagerPaperlessForm;

/** Profile Field generic form */
export type ProfileFieldTypeFormManagerGenericForm = ProfileField & {
  __typename?: 'ProfileFieldTypeFormManagerGenericForm';
  /** Is field disabled */
  disabled: Scalars['Boolean']['output'];
  /** Field class (for Debug purpose only) */
  fieldClass: Scalars['String']['output'];
  /** Field last modified */
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  /** Field name */
  name: Scalars['String']['output'];
  /** Is field disabled */
  nullable: Scalars['Boolean']['output'];
  /** Is field read only */
  readOnly: Scalars['Boolean']['output'];
  /** Field reject reason */
  rejectReason?: Maybe<Scalars['String']['output']>;
  /** Field status */
  status: ProfileStatusEnum;
  /** FormManager Generic Form */
  value?: Maybe<FormManagerGenericForm>;
};

/** Profile Field generic form */
export type ProfileFieldTypeFormManagerPaperlessForm = ProfileField & {
  __typename?: 'ProfileFieldTypeFormManagerPaperlessForm';
  /** Is field disabled */
  disabled: Scalars['Boolean']['output'];
  /** Field class (for Debug purpose only) */
  fieldClass: Scalars['String']['output'];
  /** Field last modified */
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  /** Field name */
  name: Scalars['String']['output'];
  /** Is field disabled */
  nullable: Scalars['Boolean']['output'];
  /** Is field read only */
  readOnly: Scalars['Boolean']['output'];
  /** Field reject reason */
  rejectReason?: Maybe<Scalars['String']['output']>;
  /** Field status */
  status: ProfileStatusEnum;
  /** FormManager Paperless Form */
  value?: Maybe<FormManagerPaperlessForm>;
};

/** Profile Field String Type */
export type ProfileFieldTypeInt = ProfileField & {
  __typename?: 'ProfileFieldTypeInt';
  /** Is field disabled */
  disabled: Scalars['Boolean']['output'];
  /** Field class (for Debug purpose only) */
  fieldClass: Scalars['String']['output'];
  /** Field last modified */
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  /** Minimal length */
  maxValue?: Maybe<Scalars['Int']['output']>;
  /** Minimal length */
  minValue?: Maybe<Scalars['Int']['output']>;
  /** Field name */
  name: Scalars['String']['output'];
  /** Is field disabled */
  nullable: Scalars['Boolean']['output'];
  /** Is field read only */
  readOnly: Scalars['Boolean']['output'];
  /** Field reject reason */
  rejectReason?: Maybe<Scalars['String']['output']>;
  /** Field status */
  status: ProfileStatusEnum;
  /** field class (for Debug purpose only) */
  value?: Maybe<Scalars['Int']['output']>;
};

/** Profile Field String Type */
export type ProfileFieldTypeMultiLangString = ProfileField & {
  __typename?: 'ProfileFieldTypeMultiLangString';
  /** Is field disabled */
  disabled: Scalars['Boolean']['output'];
  /** Field class (for Debug purpose only) */
  fieldClass: Scalars['String']['output'];
  /** Minimal length */
  langs: Array<OptionEntry>;
  /** Field last modified */
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  /** Minimal length */
  maxLength: Scalars['Int']['output'];
  /** Minimal length */
  minLength: Scalars['Int']['output'];
  /** Field name */
  name: Scalars['String']['output'];
  /** Is field disabled */
  nullable: Scalars['Boolean']['output'];
  /** Is field read only */
  readOnly: Scalars['Boolean']['output'];
  /** Field reject reason */
  rejectReason?: Maybe<Scalars['String']['output']>;
  /** Required langs */
  requiredLangs: Array<Maybe<ApiLangEnum>>;
  /** Field status */
  status: ProfileStatusEnum;
  /** Value */
  value?: Maybe<MultiLangText>;
};

/** Profile Field String Type */
export type ProfileFieldTypePicture = ProfileField & ProfileFieldUploadAware & {
  __typename?: 'ProfileFieldTypePicture';
  /** Is field disabled */
  disabled: Scalars['Boolean']['output'];
  /** Field class (for Debug purpose only) */
  fieldClass: Scalars['String']['output'];
  /** Field last modified */
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  /** Field name */
  name: Scalars['String']['output'];
  /** Is field disabled */
  nullable: Scalars['Boolean']['output'];
  /** Is field read only */
  readOnly: Scalars['Boolean']['output'];
  /** Field reject reason */
  rejectReason?: Maybe<Scalars['String']['output']>;
  /** Field status */
  status: ProfileStatusEnum;
  /** Upload Info */
  upload: UploadInfo;
  /** field class (for Debug purpose only) */
  value?: Maybe<MediaPicture>;
};


/** Profile Field String Type */
export type ProfileFieldTypePictureUploadArgs = {
  position?: InputMaybe<Scalars['Int']['input']>;
};

/** Profile Field List Type */
export type ProfileFieldTypePictureList = ProfileField & ProfileFieldUploadAware & {
  __typename?: 'ProfileFieldTypePictureList';
  /** Is field disabled */
  disabled: Scalars['Boolean']['output'];
  /** Field class (for Debug purpose only) */
  fieldClass: Scalars['String']['output'];
  /** Field last modified */
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  /** Field name */
  name: Scalars['String']['output'];
  /** Is field disabled */
  nullable: Scalars['Boolean']['output'];
  /** Is field read only */
  readOnly: Scalars['Boolean']['output'];
  /** Field reject reason */
  rejectReason?: Maybe<Scalars['String']['output']>;
  /** Field status */
  status: ProfileStatusEnum;
  /** Upload Info */
  upload: UploadInfo;
  /** field class (for Debug purpose only) */
  value: Array<MediaPicture>;
};


/** Profile Field List Type */
export type ProfileFieldTypePictureListUploadArgs = {
  position?: InputMaybe<Scalars['Int']['input']>;
};


/** Profile Field List Type */
export type ProfileFieldTypePictureListValueArgs = {
  filter?: InputMaybe<InputPictureListFilter>;
  sort?: InputMaybe<InputPictureListSort>;
};

/** Profile Field String Type */
export type ProfileFieldTypeString = ProfileField & {
  __typename?: 'ProfileFieldTypeString';
  /** Is field disabled */
  disabled: Scalars['Boolean']['output'];
  /** Field class (for Debug purpose only) */
  fieldClass: Scalars['String']['output'];
  /** Field last modified */
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  /** Minimal length */
  maxLength?: Maybe<Scalars['Int']['output']>;
  /** Minimal length */
  minLength?: Maybe<Scalars['Int']['output']>;
  /** Field name */
  name: Scalars['String']['output'];
  /** Is field disabled */
  nullable: Scalars['Boolean']['output'];
  /** Is field read only */
  readOnly: Scalars['Boolean']['output'];
  /** Field reject reason */
  rejectReason?: Maybe<Scalars['String']['output']>;
  /** Field status */
  status: ProfileStatusEnum;
  /** Value */
  value?: Maybe<Scalars['String']['output']>;
};

/** Profile Field Upload Document Type */
export type ProfileFieldTypeUploadDocument = ProfileField & ProfileFieldUploadAware & {
  __typename?: 'ProfileFieldTypeUploadDocument';
  /** Is field disabled */
  disabled: Scalars['Boolean']['output'];
  /** Field class (for Debug purpose only) */
  fieldClass: Scalars['String']['output'];
  /** Field last modified */
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  /** Field name */
  name: Scalars['String']['output'];
  /** Is field disabled */
  nullable: Scalars['Boolean']['output'];
  /** Is field read only */
  readOnly: Scalars['Boolean']['output'];
  /** Field reject reason */
  rejectReason?: Maybe<Scalars['String']['output']>;
  /** Field status */
  status: ProfileStatusEnum;
  /** Upload Info */
  upload: UploadInfo;
  /** field class (for Debug purpose only) */
  value?: Maybe<UploadDocument>;
};


/** Profile Field Upload Document Type */
export type ProfileFieldTypeUploadDocumentUploadArgs = {
  position?: InputMaybe<Scalars['Int']['input']>;
};

/** Profile Field Int Type */
export type ProfileFieldTypeValidationBoolean = ProfileFieldValidation & {
  __typename?: 'ProfileFieldTypeValidationBoolean';
  /** Validation field alias */
  alias: Scalars['String']['output'];
  /** Validation errors */
  errors?: Maybe<Array<ProfileFieldValidationError>>;
  /**
   * Validation field name
   * @deprecated Use `name` instead of `field`
   */
  field: ProfileFieldsEnum;
  /** Is validation successful */
  isValid: Scalars['Boolean']['output'];
  /** Validation field name */
  name: ProfileFieldsEnum;
  /** Value */
  value?: Maybe<Scalars['Int']['output']>;
};

/** Profile Field Date Type */
export type ProfileFieldTypeValidationDate = ProfileFieldValidation & {
  __typename?: 'ProfileFieldTypeValidationDate';
  /** Validation field alias */
  alias: Scalars['String']['output'];
  /** Validation errors */
  errors?: Maybe<Array<ProfileFieldValidationError>>;
  /**
   * Validation field name
   * @deprecated Use `name` instead of `field`
   */
  field: ProfileFieldsEnum;
  /** Is validation successful */
  isValid: Scalars['Boolean']['output'];
  /** Validation field name */
  name: ProfileFieldsEnum;
  /** field class (for Debug purpose only) */
  value?: Maybe<Scalars['Date']['output']>;
};

/** Profile Field Enum Validation */
export type ProfileFieldTypeValidationEnum = ProfileFieldValidation & {
  __typename?: 'ProfileFieldTypeValidationEnum';
  /** Validation field alias */
  alias: Scalars['String']['output'];
  /** Validation errors */
  errors?: Maybe<Array<ProfileFieldValidationError>>;
  /**
   * Validation field name
   * @deprecated Use `name` instead of `field`
   */
  field: ProfileFieldsEnum;
  /** Is validation successful */
  isValid: Scalars['Boolean']['output'];
  /** Validation field name */
  name: ProfileFieldsEnum;
  /** field class (for Debug purpose only) */
  value?: Maybe<Scalars['String']['output']>;
};

/** Profile Field Enum Validation */
export type ProfileFieldTypeValidationEnumList = ProfileFieldValidation & {
  __typename?: 'ProfileFieldTypeValidationEnumList';
  /** Validation field alias */
  alias: Scalars['String']['output'];
  /** Validation errors */
  errors?: Maybe<Array<ProfileFieldValidationError>>;
  /**
   * Validation field name
   * @deprecated Use `name` instead of `field`
   */
  field: ProfileFieldsEnum;
  /** Is validation successful */
  isValid: Scalars['Boolean']['output'];
  /** Validation field name */
  name: ProfileFieldsEnum;
  /** field class (for Debug purpose only) */
  value?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/** Profile Field Int Type */
export type ProfileFieldTypeValidationInt = ProfileFieldValidation & {
  __typename?: 'ProfileFieldTypeValidationInt';
  /** Validation field alias */
  alias: Scalars['String']['output'];
  /** Validation errors */
  errors?: Maybe<Array<ProfileFieldValidationError>>;
  /**
   * Validation field name
   * @deprecated Use `name` instead of `field`
   */
  field: ProfileFieldsEnum;
  /** Is validation successful */
  isValid: Scalars['Boolean']['output'];
  /** Validation field name */
  name: ProfileFieldsEnum;
  /** Value */
  value?: Maybe<Scalars['Int']['output']>;
};

/** Profile Field String Type */
export type ProfileFieldTypeValidationMultiLangString = ProfileFieldValidation & {
  __typename?: 'ProfileFieldTypeValidationMultiLangString';
  /** Validation field alias */
  alias: Scalars['String']['output'];
  /** Validation errors */
  errors?: Maybe<Array<ProfileFieldValidationErrorMultiLang>>;
  /**
   * Validation field name
   * @deprecated Use `name` instead of `field`
   */
  field: ProfileFieldsEnum;
  /** Is validation successful */
  isValid: Scalars['Boolean']['output'];
  /** Validation field name */
  name: ProfileFieldsEnum;
  /** Value */
  value?: Maybe<MultiLangText>;
};

/** Profile Field Picture Type */
export type ProfileFieldTypeValidationPicture = ProfileFieldValidation & {
  __typename?: 'ProfileFieldTypeValidationPicture';
  /** Validation field alias */
  alias: Scalars['String']['output'];
  /** Validation errors */
  errors?: Maybe<Array<ProfileFieldValidationError>>;
  /**
   * Validation field name
   * @deprecated Use `name` instead of `field`
   */
  field: ProfileFieldsEnum;
  /** Is validation successful */
  isValid: Scalars['Boolean']['output'];
  /** Validation field name */
  name: ProfileFieldsEnum;
  /** field class (for Debug purpose only) */
  value?: Maybe<MediaPicture>;
};

/** Profile Field Pictiure List Type */
export type ProfileFieldTypeValidationPictureList = ProfileFieldValidation & {
  __typename?: 'ProfileFieldTypeValidationPictureList';
  /** Validation field alias */
  alias: Scalars['String']['output'];
  /** Validation errors */
  errors?: Maybe<Array<ProfileFieldValidationError>>;
  /**
   * Validation field name
   * @deprecated Use `name` instead of `field`
   */
  field: ProfileFieldsEnum;
  /** Is validation successful */
  isValid: Scalars['Boolean']['output'];
  /** Validation field name */
  name: ProfileFieldsEnum;
  /** field class (for Debug purpose only) */
  value: Array<MediaPicture>;
};


/** Profile Field Pictiure List Type */
export type ProfileFieldTypeValidationPictureListValueArgs = {
  filter?: InputMaybe<InputPictureListFilter>;
  sort?: InputMaybe<InputPictureListSort>;
};

/** Profile Field String Type */
export type ProfileFieldTypeValidationString = ProfileFieldValidation & {
  __typename?: 'ProfileFieldTypeValidationString';
  /** Validation field alias */
  alias: Scalars['String']['output'];
  /** Validation errors */
  errors?: Maybe<Array<ProfileFieldValidationError>>;
  /**
   * Validation field name
   * @deprecated Use `name` instead of `field`
   */
  field: ProfileFieldsEnum;
  /** Is validation successful */
  isValid: Scalars['Boolean']['output'];
  /** Validation field name */
  name: ProfileFieldsEnum;
  /** Value */
  value?: Maybe<Scalars['String']['output']>;
};

/** Profile Field Upload Document Type */
export type ProfileFieldTypeValidationUploadDocument = ProfileFieldValidation & {
  __typename?: 'ProfileFieldTypeValidationUploadDocument';
  /** Validation field alias */
  alias: Scalars['String']['output'];
  /** Validation errors */
  errors?: Maybe<Array<ProfileFieldValidationError>>;
  /**
   * Validation field name
   * @deprecated Use `name` instead of `field`
   */
  field: ProfileFieldsEnum;
  /** Is validation successful */
  isValid: Scalars['Boolean']['output'];
  /** Validation field name */
  name: ProfileFieldsEnum;
  /** field class (for Debug purpose only) */
  value?: Maybe<UploadDocument>;
};

/** UploadInfo aware profile field */
export type ProfileFieldUploadAware = {
  /** Upload Info */
  upload: UploadInfo;
};


/** UploadInfo aware profile field */
export type ProfileFieldUploadAwareUploadArgs = {
  position?: InputMaybe<Scalars['Int']['input']>;
};

/** Generic Profile Field Validation */
export type ProfileFieldValidation = {
  /** Validation field alias */
  alias: Scalars['String']['output'];
  /**
   * Validation field name
   * @deprecated Use `name` instead of `field`
   */
  field: ProfileFieldsEnum;
  /** Is validation successful */
  isValid: Scalars['Boolean']['output'];
  /** Validation field name */
  name: ProfileFieldsEnum;
};

/** Profile field validation error */
export type ProfileFieldValidationError = {
  __typename?: 'ProfileFieldValidationError';
  /** Error message */
  message: Scalars['String']['output'];
};

/** Profile field validation error */
export type ProfileFieldValidationErrorMultiLang = {
  __typename?: 'ProfileFieldValidationErrorMultiLang';
  /** message lang */
  lang: Scalars['String']['output'];
  /** Error message */
  message: Scalars['String']['output'];
};

/** Profile Field String Type */
export type ProfileFieldValidationSet = {
  __typename?: 'ProfileFieldValidationSet';
  /** Validation field */
  field: Array<ProfileFieldValidation>;
  /** Validation errors */
  hasErrors: Scalars['Boolean']['output'];
};

/** Class FieldNamesEnum @package Api\Services\Profile\Fields */
export enum ProfileFieldsEnum {
  /** Account city */
  AccountAddressCity = 'accountAddressCity',
  /** Account address company name */
  AccountAddressCompany = 'accountAddressCompany',
  /** Account address country */
  AccountAddressCountry = 'accountAddressCountry',
  /** Account address postal code */
  AccountAddressPostalCode = 'accountAddressPostalCode',
  /** Account address street name */
  AccountAddressStreet = 'accountAddressStreet',
  /** Account address street number */
  AccountAddressStreetNumber = 'accountAddressStreetNumber',
  /** Account birthdate */
  AccountBirthdate = 'accountBirthdate',
  /** Account contact email address */
  AccountContactEmailAdress = 'accountContactEmailAdress',
  /** Account contact (fixed) phone */
  AccountContactFixedPhone = 'accountContactFixedPhone',
  /** Account contact mobile phone */
  AccountContactMobilePhone = 'accountContactMobilePhone',
  /** Account firstname */
  AccountFirstname = 'accountFirstname',
  /** Account language (used for emails, etc.) */
  AccountLanguage = 'accountLanguage',
  /** Account lastname */
  AccountLastname = 'accountLastname',
  /** Model About Me */
  ModelAboutMe = 'modelAboutMe',
  /** Model Birthdate, may differ from account (real person) birthdate [YYYY-MM-DD] */
  ModelBirthdate = 'modelBirthdate',
  /** Model Body Figure [athletic, chubby, fat ....] */
  ModelBodyFigure = 'modelBodyFigure',
  /** Model Body Height */
  ModelBodyHeight = 'modelBodyHeight',
  /** Model Body Modifcations [heavily tattooed, intimate (piercing, tattoo), pectoral piercing, no body modifications] */
  ModelBodyModifications = 'modelBodyModifications',
  /** Model Body Weight */
  ModelBodyWeight = 'modelBodyWeight',
  /** Model Breast Size [_NULL_,AA,A,B,C,D,DD,E,F,>F] */
  ModelBreastSize = 'modelBreastSize',
  /** Model Chat Parctices [chatflirt, dirtytalk, striptease, livesex, masturbation] */
  ModelChatPractices = 'modelChatPractices',
  /** Model city */
  ModelCity = 'modelCity',
  /** Model country */
  ModelCountry = 'modelCountry',
  /** Model Eye color [blue, green, brown....] */
  ModelEyeColor = 'modelEyeColor',
  /** Model gender [female, male, transgender] */
  ModelGender = 'modelGender',
  /** Model Hair Color [blonde, brown, black ....] */
  ModelHairColor = 'modelHairColor',
  /** Model Interview Enterprise [string, 0-250] */
  ModelInterviewEnterprise = 'modelInterviewEnterprise',
  /** Model Interview Erotic Experience [string, 0-250] */
  ModelInterviewEroticExperience = 'modelInterviewEroticExperience',
  /** Model Interview Hobbies [string, 0-250] */
  ModelInterviewHobbies = 'modelInterviewHobbies',
  /** Model Interview Island [string, 0-250] */
  ModelInterviewIsland = 'modelInterviewIsland',
  /** Model Interview Partner [string, 0-250] */
  ModelInterviewPartner = 'modelInterviewPartner',
  /** Model Interview Sex No Go [string, 0-250] */
  ModelInterviewSexNotOk = 'modelInterviewSexNotOk',
  /** Model Interview Sex Go [string, 0-250] */
  ModelInterviewSexOk = 'modelInterviewSexOk',
  /** Model Interview Sexual Fantasies [string, 0-250] */
  ModelInterviewSexualFantasies = 'modelInterviewSexualFantasies',
  /** Model Interview Sexual Position [string, 0-250] */
  ModelInterviewSexualPosition = 'modelInterviewSexualPosition',
  /** Model Language [de, en, fr ....] */
  ModelLanguage = 'modelLanguage',
  /** Model Motto (a.k.a. Chat Motto) [string, 10-100] */
  ModelMotto = 'modelMotto',
  /** Model Penize Size [_NULL_, s,m,l,xl,xxl] */
  ModelPenisSize = 'modelPenisSize',
  /** Model avatar picture, from FSK16 sedcard  (ratio 1:1, displayed as cropped circle) */
  ModelPictureAvatar = 'modelPictureAvatar',
  /** Model avatar picture, from FSK12 sedcard  (ratio 1:1, displayed as cropped circle) */
  ModelPictureFsk12Avatar = 'modelPictureFSK12Avatar',
  /** Model sedcard pictures, from FSK12 */
  ModelPictureFsk12Sedcard = 'modelPictureFSK12Sedcard',
  /** Model avatar picture, from FSK16 sedcard  (ratio 1:1, displayed as cropped circle) */
  ModelPictureFsk16Avatar = 'modelPictureFSK16Avatar',
  /** Model sedcard pictures, from FSK16 */
  ModelPictureFsk16Sedcard = 'modelPictureFSK16Sedcard',
  /** Model avatar picture, from FSK18 sedcard  (ratio 1:1, displayed as cropped circle) */
  ModelPictureFsk18Avatar = 'modelPictureFSK18Avatar',
  /** Model sedcard pictures, from FSK18 */
  ModelPictureFsk18Sedcard = 'modelPictureFSK18Sedcard',
  /** Model title picture as landscape, from FSK16 sedcard (ratio 25:10) */
  ModelPictureTitleLandscape = 'modelPictureTitleLandscape',
  /** Model Postal Code */
  ModelPostalCode = 'modelPostalCode',
  /** Model Pubic Hair [hollywood, landing strip, bikini cut ....] */
  ModelPubicHair = 'modelPubicHair',
  /** Model gender [single, seeking, inOpenRelationship, inRelationship, engaged, married] */
  ModelRelationshipState = 'modelRelationshipState',
  /** Model sexuality [heterosexual, homesexual, bisexual] */
  ModelSexuality = 'modelSexuality',
  /** Model Skin Type [asian, black skinned ...] */
  ModelSkinType = 'modelSkinType',
  /** Model Username (a.k.a login, screenname) [alfanum, 6-16] */
  ModelUsername = 'modelUsername',
  /** Model Release Form Birthdate [YYYY-MM-DD] */
  MrfBirthdate = 'mrfBirthdate',
  /** Model Release Form birthplace */
  MrfBirthplace = 'mrfBirthplace',
  /** Model Release Form city */
  MrfCity = 'mrfCity',
  /** Model Release Form country */
  MrfCountry = 'mrfCountry',
  /** Model Release Form firstname */
  MrfFirstname = 'mrfFirstname',
  MrfForm = 'mrfForm',
  /** Model Release Form lastname */
  MrfLastname = 'mrfLastname',
  /** Model Release Form Birthdate [YYYY-MM-DD] */
  MrfModelBirthdate = 'mrfModelBirthdate',
  /** Model Release Form birthplace */
  MrfModelBirthplace = 'mrfModelBirthplace',
  /** Model Release Form city */
  MrfModelCity = 'mrfModelCity',
  /** Model Release Form country */
  MrfModelCountry = 'mrfModelCountry',
  /** Model Release Form firstname */
  MrfModelFirstname = 'mrfModelFirstname',
  /** Model Release Form for Signage */
  MrfModelForm = 'mrfModelForm',
  /** Model Release Form lastname */
  MrfModelLastname = 'mrfModelLastname',
  /** Model Release Form postal code */
  MrfModelPostalCode = 'mrfModelPostalCode',
  /** Model Release Form street */
  MrfModelStreet = 'mrfModelStreet',
  /** Model Release Form street number */
  MrfModelStreetNumber = 'mrfModelStreetNumber',
  /** Originator Model Release Form Birthdate [YYYY-MM-DD] */
  MrfOriginatorBirthdate = 'mrfOriginatorBirthdate',
  /** Originator Model Release Form birthplace */
  MrfOriginatorBirthplace = 'mrfOriginatorBirthplace',
  /** Model Release Form for Signage */
  MrfOriginatorForm = 'mrfOriginatorForm',
  /** Model Release Form postal code */
  MrfPostalCode = 'mrfPostalCode',
  /** Model Release Form street */
  MrfStreet = 'mrfStreet',
  /** Model Release Form street number */
  MrfStreetNumber = 'mrfStreetNumber',
  /** Originator IDshot front side */
  OriginatorIDshotBack = 'originatorIDshotBack',
  /** Originator IDshot front side */
  OriginatorIDshotFront = 'originatorIDshotFront',
  /** Originator IDshot */
  OriginatorIdShot = 'originatorIdShot',
  /** Originator IDproof back side */
  OriginatorIdentityProofBack = 'originatorIdentityProofBack',
  /** Originator IDproof front side */
  OriginatorIdentityProofFront = 'originatorIdentityProofFront',
  /** Payment Billing Address - City */
  PaymentBillingAddressCity = 'paymentBillingAddressCity',
  /** Payment Billing Address - Company Name */
  PaymentBillingAddressCompanyname = 'paymentBillingAddressCompanyname',
  /** Payment Billing Address - Country */
  PaymentBillingAddressCountry = 'paymentBillingAddressCountry',
  /** Payment Billing Address - Document */
  PaymentBillingAddressDocument = 'paymentBillingAddressDocument',
  /** Payment Billing Address - City */
  PaymentBillingAddressFirstname = 'paymentBillingAddressFirstname',
  /** Payment Billing Address - is Company */
  PaymentBillingAddressIsCompany = 'paymentBillingAddressIsCompany',
  /** Payment Billing Address - City */
  PaymentBillingAddressLastname = 'paymentBillingAddressLastname',
  /** Payment Billing Address - PostalCode */
  PaymentBillingAddressPostalCode = 'paymentBillingAddressPostalCode',
  /** Payment Billing Address - street */
  PaymentBillingAddressStreet = 'paymentBillingAddressStreet',
  /** Payment Billing Address - street number */
  PaymentBillingAddressStreetNumber = 'paymentBillingAddressStreetNumber',
  /** Payout BIC */
  PaymentPayoutDataBankBic = 'paymentPayoutDataBankBic',
  /** Payout IBAN */
  PaymentPayoutDataBankIban = 'paymentPayoutDataBankIban',
  /** Payout Bankaccountowner */
  PaymentPayoutDataBankaccountOwner = 'paymentPayoutDataBankaccountOwner',
  /** Payout Paxum Email Account */
  PaymentPayoutDataPaxumEmailAccount = 'paymentPayoutDataPaxumEmailAccount',
  /** Payout Type of Transaction (paxum, bank, cheque) */
  PaymentPayoutDataPayoutMethod = 'paymentPayoutDataPayoutMethod',
  /** Payout Tax Document */
  PaymentTaxDataDocument = 'paymentTaxDataDocument',
  /** Payout Is Model Taxable */
  PaymentTaxDataIsTaxable = 'paymentTaxDataIsTaxable',
  /** Payout Tax Number, possible VAT ID or Tax ID (__not EU Taxpayer Identification Number TIN__) */
  PaymentTaxDataTaxNumber = 'paymentTaxDataTaxNumber',
  /** EU Taxpayer Identification Number (TIN) */
  PaymentTaxDataTin = 'paymentTaxDataTin',
  /** Taxpayer Identification Number (TIN) registration country */
  PaymentTaxDataTinCountry = 'paymentTaxDataTinCountry',
  /** Payout Proof of Addresse - City */
  PayoutAddressCity = 'payoutAddressCity',
  /** Payout Proof of Addresse - Company Name */
  PayoutAddressCompanyname = 'payoutAddressCompanyname',
  /** Payout Proof of Address - Country */
  PayoutAddressCountry = 'payoutAddressCountry',
  /** Payout Tax Document */
  PayoutAddressDocument = 'payoutAddressDocument',
  /** Payout Address Document ID */
  PayoutAddressDocumentId = 'payoutAddressDocumentId',
  /** Payout Proof of Addresse - City */
  PayoutAddressFirstname = 'payoutAddressFirstname',
  /** Payout Proof of Adress - is Company */
  PayoutAddressIsCompany = 'payoutAddressIsCompany',
  /** Payout Proof of Addresse - City */
  PayoutAddressLastname = 'payoutAddressLastname',
  /** Payout Proof of Address - PostalCode */
  PayoutAddressPostalCode = 'payoutAddressPostalCode',
  /** Payout Proof of Address - street */
  PayoutAddressStreet = 'payoutAddressStreet',
  /** Payout Proof of Address - street number */
  PayoutAddressStreetNumber = 'payoutAddressStreetNumber',
  /** Payout Bankaccountowner */
  PayoutBankaccountOwner = 'payoutBankaccountOwner',
  /** Payout BIC */
  PayoutBic = 'payoutBic',
  /** Payout Company or Full Legal Name */
  PayoutCompanyOrFullLegalName = 'payoutCompanyOrFullLegalName',
  /** Payout IBAN */
  PayoutIban = 'payoutIban',
  /** Is model originator */
  PayoutIsModelOriginator = 'payoutIsModelOriginator',
  /** Payout Is Model Taxable */
  PayoutIsTaxable = 'payoutIsTaxable',
  /** Payout Paxum Email Account */
  PayoutPaxumEmailAccount = 'payoutPaxumEmailAccount',
  /** Payout Tax Document */
  PayoutTaxDocument = 'payoutTaxDocument',
  /** Payout Tax Document ID */
  PayoutTaxDocumentId = 'payoutTaxDocumentId',
  /** Payout Tax Number */
  PayoutTaxId = 'payoutTaxId',
  /** Payout Tax TIN */
  PayoutTaxTin = 'payoutTaxTin',
  /** Payout Tax TIN Country */
  PayoutTaxTinCountry = 'payoutTaxTinCountry',
  /** Payout Type of Transaction (paxum, bank, cheque) */
  PayoutTransactionType = 'payoutTransactionType'
}

export type ProfileMutation = {
  __typename?: 'ProfileMutation';
  /** everything updating a collection */
  collection?: Maybe<ProfileCollectionMutation>;
  /** Validate a value in context of a specified field */
  validate?: Maybe<ProfileFieldValidation>;
};


export type ProfileMutationCollectionArgs = {
  name: ProfileCollectionNameEnum;
};


export type ProfileMutationValidateArgs = {
  name: ProfileFieldsEnum;
  value: Scalars['String']['input'];
};

/** Profile status */
export enum ProfileStatusEnum {
  /** Profile is complete and verified by support */
  Accepted = 'accepted',
  /** Profile incomplete or in checking */
  Incomplete = 'incomplete',
  /**
   * Profile not filled
   * @deprecated  you'll get 'incomplete' instead
   */
  Open = 'open',
  /** Profile in checking */
  Pending = 'pending',
  /** Profile property is rejected */
  Rejected = 'rejected'
}

export enum PubicHairEnum {
  /** {"de":"Bikini Cut (Dreieck)", "en":"bikini cut"} */
  BikiniCut = 'bikiniCut',
  /** {"de":"Freestyle (Herz, Pfeil, etc.)", "en":"freestyle"} */
  Freestyle = 'freestyle',
  /** {"de":"Hollywood Cut (komplett)", "en":"hollywood cut"} */
  HollywoodCut = 'hollywoodCut',
  /** {"de":"Landing Strip (Streifen)", "en":"landing strip"} */
  LandingStrip = 'landingStrip',
  /** {"de":"Natur", "en":"natural"} */
  Natural = 'natural',
  /** {"de":"Andere", "en":"other"} */
  Other = 'other'
}

/** Basic Query */
export type Query = {
  __typename?: 'Query';
  /** Account data */
  account: Account;
  /** API stuff */
  api: Api;
  /** APP information */
  app: App;
  /** Auth stuff, null if user has insufficient rights */
  auth?: Maybe<Auth>;
  /** ContentManagementSystem stuff */
  cms: Cms;
  /** Documents */
  documents: Documents;
  /** Finances */
  finances: Finances;
  /** Help center stuff */
  helpcenter: Helpcenter;
  /** Marketing */
  marketing: Marketing;
  /** Media */
  media: Media;
  /** Payment related stuff */
  payment: Payment;
  /** Profile stuff */
  profile: Profile;
  /** Ranking */
  ranking: Ranking;
  /** Diverse statistics (online time, chat duration, chat rating e.t.c.) */
  statistics: Statistics;
  /** Support stuff */
  support: Support;
  /** Terms */
  terms: Terms;
  /** Query a Tour */
  tour: Tour;
  /** Translate */
  translate: Translate;
  /** VXLive */
  vxlive: VxLive;
};


/** Basic Query */
export type QueryCmsArgs = {
  lang: ApiLangEnum;
};


/** Basic Query */
export type QueryTourArgs = {
  type: TourNameEnum;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type Ranking = {
  __typename?: 'Ranking';
  /** Rank among the all models */
  globalRank: Scalars['Int']['output'];
  /** Rank among the models online */
  onlineRank: Scalars['Int']['output'];
};

/** Relationship State */
export enum RelationshipEnum {
  /** {"de":"verlobt", "en":"engaged"} */
  Engaged = 'engaged',
  /** {"de":"in einer offenen Beziehung", "en":"in open relationship"} */
  InOpenRelationship = 'inOpenRelationship',
  /** {"de":"vergeben", "en":"in relationship"} */
  InRelationship = 'inRelationship',
  /** {"de":"verheiratet", "en":"married"} */
  Married = 'married',
  /** {"de":"suchend", "en":"seeking"} */
  Seeking = 'seeking',
  /** {"de":"ledig", "en":"single"} */
  Single = 'single'
}

export type SaveRealPersonMutationResult = {
  __typename?: 'SaveRealPersonMutationResult';
  /** Created actor */
  allActors?: Maybe<Array<Maybe<Actor>>>;
  /** Error message if actor can not be added */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Saved actor */
  savedActor?: Maybe<Actor>;
  /** Returns true if ner actor successfully added */
  success: Scalars['Boolean']['output'];
};

/** Scope */
export enum ScopeEnum {
  /** ContentPartner; requires a user from content partner list */
  Contentpartner = 'contentpartner',
  /** CONTROLVX; requires a user from CONTROLVX */
  Controlvx = 'controlvx',
  /** for internal purpose; Server2Server communication */
  Internal = 'internal',
  /** VXModels; requires a user with access to VXModels */
  Vxmodels = 'vxmodels',
  /** VXStudio; requires a user with acces to VXStudio */
  Vxstudio = 'vxstudio'
}

/** Security Roles */
export enum SecurityRoleEnum {
  /** authenticated user via password */
  VxUser = 'VX_USER',
  /** authenticated admin user via CT autologin token */
  VxUserAdmin = 'VX_USER_ADMIN',
  /** authenticated user is an internal account */
  VxUserInternalAccount = 'VX_USER_INTERNAL_ACCOUNT',
  /** authenticated user via master password */
  VxUserMaster = 'VX_USER_MASTER',
  /** authenticated originator user */
  VxUserOriginator = 'VX_USER_ORIGINATOR',
  /** authenticated user has access to SEXOLE / IFACUS */
  VxUserSexole = 'VX_USER_SEXOLE',
  /**
   * authenticated user (deprecated)
   * @deprecated  VX_USER_STANDARD, use VX_USER instead
   */
  VxUserStandard = 'VX_USER_STANDARD',
  /** authenticated user has access to VXMODELS */
  VxUserVxmodels = 'VX_USER_VXMODELS'
}

/** Sexuality, a.k.a sexual orientation */
export enum SexualityEnum {
  /** {"de":"Bisexuell", "en":"bisexual"} */
  Bisexual = 'bisexual',
  /** {"de":"Heterosexuell", "en":"heterosexual"} */
  Heterosexual = 'heterosexual',
  /** {"de":"Homosexuell", "en":"homosexual"} */
  Homosexual = 'homosexual'
}

/** Signup data field */
export type SignupDataField = {
  __typename?: 'SignupDataField';
  /** Array of errors, if any */
  errorMessages: Array<Maybe<Scalars['String']['output']>>;
  /** Has field validation or process errors */
  hasErrors?: Maybe<Scalars['Boolean']['output']>;
  /** Name of field */
  name: Scalars['ID']['output'];
  /** Current value of field */
  value?: Maybe<Scalars['String']['output']>;
};

/** Generic fail type with topic and message */
export type SignupResultFail = {
  __typename?: 'SignupResultFail';
  /** Invalid fields from  */
  invalidFields: Array<Maybe<SignupDataField>>;
  /** Additional information, operation is failed */
  message: Scalars['String']['output'];
  /** Topic of failed operation */
  topic: Scalars['String']['output'];
};

export enum SkinTypeEnum {
  /** {"de":"asiatisch", "en":"asian"} */
  Asian = 'asian',
  /** {"de":"hell", "en":"caucasian"} */
  Caucasian = 'caucasian',
  /** {"de":"schwarz", "en":"black skinned"} */
  DarkSkinned = 'dark_skinned',
  /** {"de":"mediterran", "en":"mediterranean"} */
  Mediterranean = 'mediterranean'
}

export type StatisticDaily = {
  __typename?: 'StatisticDaily';
  /** Day in ISO format */
  date: Scalars['Date']['output'];
  /** Label / Weekday */
  label?: Maybe<Scalars['String']['output']>;
  /** Value */
  value: Scalars['Float']['output'];
};

export type Statistics = {
  __typename?: 'Statistics';
  /** Statistics Adhoc entries */
  adhoc: StatisticsQueryAdhoc;
  /**
   * Available statistic entries
   * @deprecated Use adhoc availableEntries instead
   */
  availableEntries: Array<StatisticsEntry>;
  /** Statistics detailed entries */
  detailed: StatisticsQueryDetailed;
  /**
   * Statistic entries
   * @deprecated Use adhoc entries instead
   */
  entries: Array<StatisticsEntry>;
};


export type StatisticsAvailableEntriesArgs = {
  name?: InputMaybe<StatisticsSetNameEnum>;
};


export type StatisticsEntriesArgs = {
  name?: InputMaybe<StatisticsSetNameEnum>;
};

export type StatisticsDetailedFeed = {
  __typename?: 'StatisticsDetailedFeed';
  /** tipping over period */
  tipping: Array<StatisticsDetailedTypeFeedTippingTurnover>;
  /** total turnover over period */
  totalTurnover?: Maybe<Scalars['Float']['output']>;
  /** user list of purchases */
  userListOfPurchases: Array<StatisticsDetailedTypeUserListOfPurchcases>;
};

export type StatisticsDetailedLiveChat = {
  __typename?: 'StatisticsDetailedLiveChat';
  /** actual live placing */
  actualLivePlacing: Scalars['Int']['output'];
  /** online time actual month */
  onlineTimeActualMonth: Array<StatisticsModelOnlineTime>;
  /** sales over period */
  sales: Array<StatisticsDetailedTypeLiveChatSales>;
  /** total turover over period */
  totalTurover?: Maybe<Scalars['Float']['output']>;
  /** user list of purchases */
  userListOfPurchases: Array<StatisticsDetailedTypeUserListOfPurchcases>;
};

export type StatisticsDetailedMessenger = {
  __typename?: 'StatisticsDetailedMessenger';
  /** total turover over period */
  totalTurover?: Maybe<Scalars['Float']['output']>;
};

export type StatisticsDetailedOverAll = {
  __typename?: 'StatisticsDetailedOverAll';
  /** total turover over period */
  totalTurover?: Maybe<Scalars['Float']['output']>;
};

export type StatisticsDetailedPhoneService = {
  __typename?: 'StatisticsDetailedPhoneService';
  /** total turover over period */
  totalTurover?: Maybe<Scalars['Float']['output']>;
};

export type StatisticsDetailedPictures = {
  __typename?: 'StatisticsDetailedPictures';
  /** total turover over period */
  totalTurover?: Maybe<Scalars['Float']['output']>;
};

export type StatisticsDetailedTelegram = {
  __typename?: 'StatisticsDetailedTelegram';
  /** total turover over period */
  totalTurover?: Maybe<Scalars['Float']['output']>;
};

export type StatisticsDetailedTypeFeedTippingTurnover = {
  __typename?: 'StatisticsDetailedTypeFeedTippingTurnover';
  /** amount from tipping */
  amount?: Maybe<Scalars['Int']['output']>;
  /** amount coins from tipping */
  amountCoins: Scalars['Int']['output'];
  /** count from tipping */
  count: Scalars['Int']['output'];
  /** date from tipping */
  date?: Maybe<Scalars['String']['output']>;
};

export type StatisticsDetailedTypeLiveChatSales = {
  __typename?: 'StatisticsDetailedTypeLiveChatSales';
  /** user media id */
  count: Scalars['Int']['output'];
  /** user media video date */
  date: Scalars['String']['output'];
  /** user media price */
  price?: Maybe<Scalars['Float']['output']>;
};

export type StatisticsDetailedTypePeriods = {
  __typename?: 'StatisticsDetailedTypePeriods';
  /** list of allwoed montths */
  allowedMonths: Array<Maybe<Scalars['Int']['output']>>;
  /** list of allwoed years */
  allowedYears: Array<Maybe<Scalars['Int']['output']>>;
  /** list of days first half of month */
  fistHalfOfMonth: Array<Maybe<Scalars['Int']['output']>>;
  /** max day in period */
  maxDays: Scalars['Int']['output'];
  /** max years in periods */
  maxYears: Scalars['Int']['output'];
  /** list of days second half of month */
  secondHalfOfMonth: Array<Maybe<Scalars['Int']['output']>>;
};

export type StatisticsDetailedTypeUserListOfPurchcases = {
  __typename?: 'StatisticsDetailedTypeUserListOfPurchcases';
  /** content title from purchase */
  contentTitle: Scalars['String']['output'];
  /** content type from purchase */
  contentType: Scalars['String']['output'];
  /** date from purchase */
  date: Scalars['String']['output'];
  /** duration from purchase */
  duration: Scalars['Int']['output'];
  /** extra info from purchase */
  extraInfo: Scalars['String']['output'];
  /** guest id from purchase */
  guestId: Scalars['Int']['output'];
  /** guest name from purchase */
  guestName: Scalars['String']['output'];
  /** id from purchase */
  id: Scalars['Int']['output'];
  /** check is 5 min for free from purchase */
  is5MinForFree: Scalars['Boolean']['output'];
  /** check is chat dollar from purchase */
  isChatDollar: Scalars['Boolean']['output'];
  /** check is single from purchase */
  isSingleSession: Scalars['Boolean']['output'];
  /** check is voyeur from purchase */
  isVoyeur: Scalars['Boolean']['output'];
  /** provision from purchase */
  provision: Scalars['Float']['output'];
  /** type of purchase */
  type: Scalars['String']['output'];
};

export type StatisticsDetailedTypeVideoLibrarySales = {
  __typename?: 'StatisticsDetailedTypeVideoLibrarySales';
  /** user media id */
  count: Scalars['Int']['output'];
  /** user media video date */
  date: Scalars['String']['output'];
  /** user media video like */
  like?: Maybe<Scalars['Int']['output']>;
  /** user media price */
  price?: Maybe<Scalars['Float']['output']>;
};

export type StatisticsDetailedVideoLibrary = {
  __typename?: 'StatisticsDetailedVideoLibrary';
  /** likes over period */
  likes: Array<StatisticsDetailedTypeVideoLibrarySales>;
  /** sales over period */
  sales: Array<StatisticsDetailedTypeVideoLibrarySales>;
  /** total turover over period */
  totalTurover?: Maybe<Scalars['Float']['output']>;
};

export type StatisticsEntry = {
  /** category of statistic */
  category: StatisticsEntryCategoryEnum;
  /** Entry icon */
  icon: Scalars['String']['output'];
  /** Entry name */
  id: StatisticsEntryNameEnum;
  /** Entry label */
  label: Scalars['String']['output'];
  /** Trend */
  trend?: Maybe<StatisticsTrend>;
  /** Statistic values */
  values: Array<Maybe<StatisticsEntryValue>>;
};

/** Category of statistic */
export enum StatisticsEntryCategoryEnum {
  CustomerLoyalty = 'customerLoyalty',
  Income = 'income',
  Ranking = 'ranking',
  ServiceQuality = 'serviceQuality',
  Vxfeed = 'vxfeed'
}

/** Entry-Name of statistic */
export enum StatisticsEntryNameEnum {
  ContentLikesTotal = 'ContentLikesTotal',
  FollowerTotal = 'FollowerTotal',
  OnlineTimeCurrentMonth = 'OnlineTimeCurrentMonth',
  ProfileCompleteness = 'ProfileCompleteness',
  VisitXCurrentRank = 'VisitXCurrentRank',
  VxFeedContentSalesMonthAmount = 'VxFeedContentSalesMonthAmount',
  VxFeedContentSalesMonthCount = 'VxFeedContentSalesMonthCount',
  VxFeedContentSalesWeekAmount = 'VxFeedContentSalesWeekAmount',
  VxFeedContentSalesWeekCount = 'VxFeedContentSalesWeekCount',
  VxFeedPostTotalCount = 'VxFeedPostTotalCount',
  VxFeedTippingMonthAmount = 'VxFeedTippingMonthAmount',
  VxFeedTippingMonthCount = 'VxFeedTippingMonthCount',
  VxFeedTippingWeekAmount = 'VxFeedTippingWeekAmount',
  VxFeedTippingWeekCount = 'VxFeedTippingWeekCount'
}

export type StatisticsEntrySingleCurrency = StatisticsEntry & {
  __typename?: 'StatisticsEntrySingleCurrency';
  /** category of statistic */
  category: StatisticsEntryCategoryEnum;
  /** Decimals */
  decimals: Scalars['Int']['output'];
  /** Entry icon */
  icon: Scalars['String']['output'];
  /** Entry name */
  id: StatisticsEntryNameEnum;
  /** Entry label */
  label: Scalars['String']['output'];
  /** Trend */
  trend?: Maybe<StatisticsTrend>;
  /** Unit */
  unit: Scalars['String']['output'];
  /** Statistic value */
  value: StatisticsEntryValue;
  /** Statistic values */
  values: Array<Maybe<StatisticsEntryValue>>;
};

export type StatisticsEntrySingleDuration = StatisticsEntry & {
  __typename?: 'StatisticsEntrySingleDuration';
  /** category of statistic */
  category: StatisticsEntryCategoryEnum;
  /** Entry icon */
  icon: Scalars['String']['output'];
  /** Entry name */
  id: StatisticsEntryNameEnum;
  /** Entry label */
  label: Scalars['String']['output'];
  /** Trend */
  trend?: Maybe<StatisticsTrend>;
  /** Unit */
  unit: Scalars['String']['output'];
  /** Statistic value */
  value: StatisticsEntryValue;
  /** Statistic values */
  values: Array<Maybe<StatisticsEntryValue>>;
};

export type StatisticsEntrySingleNumber = StatisticsEntry & {
  __typename?: 'StatisticsEntrySingleNumber';
  /** category of statistic */
  category: StatisticsEntryCategoryEnum;
  /** Decimals */
  decimals: Scalars['Int']['output'];
  /** Entry icon */
  icon: Scalars['String']['output'];
  /** Entry name */
  id: StatisticsEntryNameEnum;
  /** Entry label */
  label: Scalars['String']['output'];
  /** Trend */
  trend?: Maybe<StatisticsTrend>;
  /** Unit */
  unit: Scalars['String']['output'];
  /** Statistic value */
  value: StatisticsEntryValue;
  /** Statistic values */
  values: Array<Maybe<StatisticsEntryValue>>;
};

export type StatisticsEntryValue = {
  __typename?: 'StatisticsEntryValue';
  /** Date of value */
  dateTime: Scalars['DateTime']['output'];
  /** Timestamp */
  ts: Scalars['Int']['output'];
  /** Statistic value */
  value: Scalars['String']['output'];
};

export type StatisticsModelOnlineTime = {
  __typename?: 'StatisticsModelOnlineTime';
  /** list of days first half of month */
  date: Scalars['Date']['output'];
  /** list of days first half of month */
  secondsOnline: Scalars['Int']['output'];
};

export type StatisticsMutation = {
  __typename?: 'StatisticsMutation';
  /** Statistic entries */
  adhoc: StatisticsMutationAdhoc;
  /**
   * Set selected statistics entries for user
   * @deprecated Use adhoc setSelectedEntries instead
   */
  setSelectedEntries: Array<StatisticsEntry>;
};


export type StatisticsMutationSetSelectedEntriesArgs = {
  entryNames: Array<StatisticsEntryNameEnum>;
  setName?: InputMaybe<StatisticsSetNameEnum>;
};

export type StatisticsMutationAdhoc = {
  __typename?: 'StatisticsMutationAdhoc';
  /** Set selected statistics entries for user */
  setSelectedEntries: Array<StatisticsEntry>;
};


export type StatisticsMutationAdhocSetSelectedEntriesArgs = {
  entryNames: Array<StatisticsEntryNameEnum>;
  setName?: InputMaybe<StatisticsSetNameEnum>;
};

export type StatisticsQueryAdhoc = {
  __typename?: 'StatisticsQueryAdhoc';
  /** Available statistic entries */
  availableEntries: Array<StatisticsEntry>;
  /** Statistic entries */
  entries: Array<StatisticsEntry>;
};


export type StatisticsQueryAdhocAvailableEntriesArgs = {
  name?: InputMaybe<StatisticsSetNameEnum>;
};


export type StatisticsQueryAdhocEntriesArgs = {
  name?: InputMaybe<StatisticsSetNameEnum>;
};

export type StatisticsQueryDetailed = {
  __typename?: 'StatisticsQueryDetailed';
  /** feed statistics */
  feed?: Maybe<StatisticsDetailedFeed>;
  /** live chat statistics */
  liveChat?: Maybe<StatisticsDetailedLiveChat>;
  /** messenger statistics */
  messenger?: Maybe<StatisticsDetailedMessenger>;
  /** over all statistics */
  overAll?: Maybe<StatisticsDetailedOverAll>;
  /** alowed periods */
  periods: StatisticsDetailedTypePeriods;
  /** phoneService statistics */
  phoneService?: Maybe<StatisticsDetailedPhoneService>;
  /** pictures statistics */
  pictures?: Maybe<StatisticsDetailedPictures>;
  /** telegram statistics */
  telegram?: Maybe<StatisticsDetailedTelegram>;
  /** video library statistics */
  videoLibrary?: Maybe<StatisticsDetailedVideoLibrary>;
};


export type StatisticsQueryDetailedFeedArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type StatisticsQueryDetailedLiveChatArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type StatisticsQueryDetailedMessengerArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type StatisticsQueryDetailedOverAllArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type StatisticsQueryDetailedPhoneServiceArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type StatisticsQueryDetailedPicturesArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type StatisticsQueryDetailedTelegramArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type StatisticsQueryDetailedVideoLibraryArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

/** Statistic Set-Name */
export enum StatisticsSetNameEnum {
  Dashboard = 'dashboard',
  ModelProfile = 'modelProfile'
}

export type StatisticsTrend = {
  __typename?: 'StatisticsTrend';
  /** -x for down, 0 equal, +x for up --> 1 = 100 %, -1 = -100% */
  percent: Scalars['Float']['output'];
};

export type Support = {
  __typename?: 'Support';
  /** Support */
  available: Array<SupportAgentTypeEnum>;
  /** Support */
  mailto: Scalars['String']['output'];
  /** Support */
  tel: Scalars['String']['output'];
};

/** Support Agents */
export enum SupportAgentTypeEnum {
  /** Model Support */
  ModelSupport = 'modelSupport',
  /** Payment */
  Payment = 'payment'
}

/** Class TaxCountryEnum @package Api\Services\Profile\Values\Enum */
export enum TaxCountryEnum {
  /** {"de":"Österreich","en":"Austria (EU)"} */
  At = 'AT',
  /** {"de":"Belgien","en":"Belgium"} */
  Be = 'BE',
  /** {"de":"Bulgarien","en":"Bulgaria"} */
  Bg = 'BG',
  /** {"de":"Zypern","en":"Cypern"} */
  Cy = 'CY',
  /** {"de":"Tschechische Republik","en":"Czech Republic"} */
  Cz = 'CZ',
  /** {"de":"Deutschland","en":"Germany (EU)"} */
  De = 'DE',
  /** {"de":"Dänemark","en":"Denmark (EU)"} */
  Dk = 'DK',
  /** {"de":"Estland","en":"Estonia"} */
  Ee = 'EE',
  /** {"de":"Spanien","en":"Spain (EU)"} */
  Es = 'ES',
  /** {"de":"Finnland","en":"Finland (EU)"} */
  Fi = 'FI',
  /** {"de":"Frankreich","en":"France (EU)"} */
  Fr = 'FR',
  /** {"de":"Griechenland","en":"Greece (EU)"} */
  Gr = 'GR',
  /** {"de":"Kroatien","en":"Croatia"} */
  Hr = 'HR',
  /** {"de":"Ungarn","en":"Hungary"} */
  Hu = 'HU',
  /** {"de":"Irland","en":"Ireland (EU)"} */
  Ie = 'IE',
  /** {"de":"Italien","en":"Italy (EU)"} */
  It = 'IT',
  /** {"de":"Litauen","en":"Lithuania"} */
  Lt = 'LT',
  /** {"de":"Luxemburg","en":"Luxembourg (EU)"} */
  Lu = 'LU',
  /** {"de":"Lettland","en":"Latvia"} */
  Lv = 'LV',
  /** {"de":"Malta","en":"Malta"} */
  Mt = 'MT',
  /** {"de":"Niederlande","en":"Netherlands (EU)"} */
  Nl = 'NL',
  /** {"de":"Polen","en":"Poland"} */
  Pl = 'PL',
  /** {"de":"Portugal","en":"Portugal (EU)"} */
  Pt = 'PT',
  /** {"de":"Rumänien","en":"Romania"} */
  Ro = 'RO',
  /** {"de":"Schweden","en":"Sweden (EU)"} */
  Se = 'SE',
  /** {"de":"Slowenien","en":"Slovenia"} */
  Si = 'SI',
  /** {"de":"Slowakei","en":"Slovak Republic"} */
  Sk = 'SK'
}

/** Term Acceptance */
export type TermAcceptance = {
  __typename?: 'TermAcceptance';
  /** accept date */
  acceptDate?: Maybe<Scalars['Date']['output']>;
  /** accepted version */
  acceptedVersion?: Maybe<Scalars['Date']['output']>;
  /** get cms article data */
  cmsArticle: CmsArticle;
  /** consent required */
  consentRequired: Scalars['Boolean']['output'];
  /** acceept current verion */
  currentVersion: Scalars['Date']['output'];
  /** terms are accepted */
  hasAccepted: Scalars['Boolean']['output'];
  /** accepted any version of terms */
  hasAcceptedAnyVersion: Scalars['Boolean']['output'];
  /** is password requrired */
  isPasswordRequrired: Scalars['Boolean']['output'];
  /** type of terms */
  type: TermsAcceptanceTypeEnum;
};

/** Terms Root */
export type Terms = {
  __typename?: 'Terms';
  /** Terms Acceptance Types */
  acceptance?: Maybe<TermAcceptance>;
};


/** Terms Root */
export type TermsAcceptanceArgs = {
  type: TermsAcceptanceTypeEnum;
};

export type TermsAcceptResult = {
  __typename?: 'TermsAcceptResult';
  /** Additional acceptance data */
  acceptance?: Maybe<TermAcceptance>;
  /** Returns true if password invalid */
  isPasswordInvalid: Scalars['Boolean']['output'];
  /** Returns true if terms succesfully accepted */
  wasSuccsessful: Scalars['Boolean']['output'];
};

/** Terms Acceptance Types */
export enum TermsAcceptanceTypeEnum {
  /** Telegram terms */
  TelegramTerms = 'TELEGRAM_TERMS',
  /** VXModels Privacy policy */
  VxmodelsPrivacyPolicy = 'VXMODELS_PRIVACY_POLICY',
  /** VXModels Terms and conditions */
  VxmodelsTermsAndConditions = 'VXMODELS_TERMS_AND_CONDITIONS'
}

/** Terms mutation root */
export type TermsMutation = {
  __typename?: 'TermsMutation';
  /** Update any terms */
  accept?: Maybe<TermsAcceptResult>;
};


/** Terms mutation root */
export type TermsMutationAcceptArgs = {
  password?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TermsAcceptanceTypeEnum>;
};

/** Tips */
export type Tips = {
  __typename?: 'Tips';
  /** Tips entries */
  entries: Array<Maybe<TipsEntry>>;
  /** List of all allowed recipient groups */
  experienceTags: Array<Maybe<TipsTag>>;
  /** List of all allowed tags */
  intentionTags: Array<Maybe<TipsTag>>;
  /** Returns tip by Id */
  tipById?: Maybe<TipsEntry>;
};


/** Tips */
export type TipsEntriesArgs = {
  experienceTags?: InputMaybe<Array<InputMaybe<TipsExperienceTagEnum>>>;
  intentionTags?: InputMaybe<Array<InputMaybe<TipsIntentionTagEnum>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  targets?: InputMaybe<Array<InputMaybe<TipsTargetEnum>>>;
};


/** Tips */
export type TipsTipByIdArgs = {
  id: Scalars['ID']['input'];
};

/** Helpcenter tip entry */
export type TipsEntry = {
  __typename?: 'TipsEntry';
  /** Body */
  body: Scalars['Markdown']['output'];
  /** Experience tags */
  experienceTags?: Maybe<Array<Maybe<TipsTag>>>;
  /** Teaser image */
  headerImage: Image;
  /** Tip ID */
  id: Scalars['ID']['output'];
  /** Intention tags */
  intentionTags?: Maybe<Array<Maybe<TipsTag>>>;
  /** Returns true if tipp labeled as new */
  isLabeledNew: Scalars['Boolean']['output'];
  /** Returns the date when tip was read, NULL if not yet read */
  readAt?: Maybe<Scalars['DateTime']['output']>;
  /** Teaser text */
  teaserText: Scalars['String']['output'];
  /** Title */
  title: Scalars['String']['output'];
};

/** Experience tag of tip */
export enum TipsExperienceTagEnum {
  /** {"de":"Fortgeschritten","en":"Advanced"} */
  Advanced = 'advanced',
  /** {"de":"Anfänger","en":"Beginner"} */
  Beginner = 'beginner',
  /** {"de":"Profi","en":"Profi"} */
  Profi = 'profi'
}

/** Intention tag of tip */
export enum TipsIntentionTagEnum {
  /** {"de":"Reichweite steigern","en":"Increase reach"} */
  IncreaseReach = 'increaseReach',
  /** {"de":"Umsatz steigern","en":"Increase turnover"} */
  IncreaseTurnover = 'increaseTurnover',
  /** {"de":"Kunden binden","en":"Retain customers"} */
  RetainCustomers = 'retainCustomers',
  /** {"de":"Kunden gewinnen","en":"Win customers"} */
  WinCustomers = 'winCustomers'
}

export type TipsMutation = {
  __typename?: 'TipsMutation';
  /** Mark a tip as read */
  markAsRead?: Maybe<TipsEntry>;
  /** Mark a tip as unread */
  markAsUnread?: Maybe<TipsEntry>;
};


export type TipsMutationMarkAsReadArgs = {
  id: Scalars['String']['input'];
};


export type TipsMutationMarkAsUnreadArgs = {
  id: Scalars['String']['input'];
};

/** Tags of tips */
export type TipsTag = {
  __typename?: 'TipsTag';
  /** Tag ID */
  id: Scalars['ID']['output'];
  /** Tag value */
  value?: Maybe<Scalars['String']['output']>;
};

/** Tip targets */
export enum TipsTargetEnum {
  /** {"de":"Dashboard","en":"Dashboard"} */
  Dashboard = 'dashboard',
  /** {"de":"Go Online","en":"Go online"} */
  Goonline = 'goonline'
}

/** A specified tour */
export type Tour = TourModelReleaseFormV1 | TourOnboardingV1 | TourPayoutV1 | TourPayoutV2;

export type TourModelReleaseFormV1 = {
  __typename?: 'TourModelReleaseFormV1';
  /** Active state of a tour; may differs from status, e.g. if the tour was already completed in the past, but for now it would be incomplete */
  active: Scalars['Boolean']['output'];
  /** Name */
  completeness: ProfileCollectionCompleteness;
  /** Current step */
  currentStep?: Maybe<TourStep>;
  /** Number steps finished */
  finishedSteps: Scalars['Int']['output'];
  /** DateTime of last successful verification of requested values */
  lastVerified?: Maybe<Scalars['DateTime']['output']>;
  /** Tour name */
  name: TourNameEnum;
  /** Tour status, represents the current status summary of all steps */
  status: ProfileStatusEnum;
  /** All tour steps  */
  steps: Array<TourStep>;
  /** Total steps */
  totalSteps: Scalars['Int']['output'];
  /** Tour userId, may be overridden for special forms, e.g. for xref actors */
  userId: Scalars['Int']['output'];
  /** Validate input data, null if no input given, e.g. in query context */
  validate?: Maybe<TourValidation>;
  /** Tour current values */
  values: TourModelReleaseFormV1Values;
};

export type TourModelReleaseFormV1Mutation = {
  __typename?: 'TourModelReleaseFormV1Mutation';
  /** Reset tour */
  reset: TourModelReleaseFormV1;
  /** Tour values */
  update: TourModelReleaseFormV1;
};


export type TourModelReleaseFormV1MutationUpdateArgs = {
  data: InputTourModelReleaseFormV1;
  step: Scalars['ID']['input'];
};

export type TourModelReleaseFormV1Values = {
  __typename?: 'TourModelReleaseFormV1Values';
  /** @deprecated use MrfModelBirthdate instead Model Release Form Birthdate [YYYY-MM-DD] */
  mrfBirthdate?: Maybe<Scalars['Date']['output']>;
  /** @deprecated use MrfModelBirthplace instead Model Release Form birthplace */
  mrfBirthplace?: Maybe<Scalars['String']['output']>;
  /** @deprecated use MrfModelCity instead Model Release Form city */
  mrfCity?: Maybe<Scalars['String']['output']>;
  /** @deprecated use MrfModelCountry instead Model Release Form country */
  mrfCountry?: Maybe<CountryEnum>;
  /** @deprecated use MrfModelFirstname instead Model Release Form firstname */
  mrfFirstname?: Maybe<Scalars['String']['output']>;
  /** @deprecated @alias MrfModelForm */
  mrfForm?: Maybe<FormManagerForm>;
  /** @deprecated use MrfModelLastname instead Model Release Form lastname */
  mrfLastname?: Maybe<Scalars['String']['output']>;
  /** @deprecated use MrfModelPostalCode instead Model Release Form postal code */
  mrfPostalCode?: Maybe<Scalars['String']['output']>;
  /** @deprecated use MrfModelStreet instead Model Release Form street */
  mrfStreet?: Maybe<Scalars['String']['output']>;
  /** @deprecated use MrfModelStreetNumber instead Model Release Form street number */
  mrfStreetNumber?: Maybe<Scalars['String']['output']>;
};

export type TourMutation = TourModelReleaseFormV1Mutation | TourOnboardingV1Mutation | TourPayoutV1Mutation | TourPayoutV2Mutation;

/** Tour Types */
export enum TourNameEnum {
  /** Tour for Model Release Form (v1) */
  ModelReleaseFormV1 = 'ModelReleaseFormV1',
  /** Tour for onboarding (v1) */
  OnboardingV1 = 'OnboardingV1',
  /** Tour for payout (v1) */
  PayoutV1 = 'PayoutV1',
  /** Tour for payout (v2), based on workflow */
  PayoutV2 = 'PayoutV2'
}

export type TourOnboardingV1 = {
  __typename?: 'TourOnboardingV1';
  /** Active state of a tour; may differs from status, e.g. if the tour was already completed in the past, but for now it would be incomplete */
  active: Scalars['Boolean']['output'];
  /** Name */
  completeness: ProfileCollectionCompleteness;
  /** Current step */
  currentStep?: Maybe<TourStep>;
  /** Number steps finished */
  finishedSteps: Scalars['Int']['output'];
  /** DateTime of last successful verification of requested values */
  lastVerified?: Maybe<Scalars['DateTime']['output']>;
  /** Tour name */
  name: TourNameEnum;
  /** Tour status, represents the current status summary of all steps */
  status: ProfileStatusEnum;
  /** All tour steps  */
  steps: Array<TourStep>;
  /** Total steps */
  totalSteps: Scalars['Int']['output'];
  /** Validate input data, null if no input given, e.g. in query context */
  validate?: Maybe<TourValidation>;
  /** Tour current values */
  values: TourOnboardingV1Values;
};

export type TourOnboardingV1Mutation = {
  __typename?: 'TourOnboardingV1Mutation';
  /** Tour values */
  update: TourOnboardingV1;
};


export type TourOnboardingV1MutationUpdateArgs = {
  data: InputTourOnboardingV1;
  step: Scalars['ID']['input'];
};

export type TourOnboardingV1Values = {
  __typename?: 'TourOnboardingV1Values';
  /** Model Birthdate, may differ from account (real person) birthdate [YYYY-MM-DD] */
  modelBirthdate?: Maybe<Scalars['Date']['output']>;
  /** Model gender [female, male, transgender] */
  modelGender?: Maybe<GenderEnum>;
  /** Model Motto (a.k.a. Chat Motto) [string, 10-100] */
  modelMotto?: Maybe<MultiLangText>;
  /** @deprecated use ModelPictureFSK16Avatar instead Model avatar picture, from FSK16 sedcard  (ratio 1:1, displayed as cropped circle) */
  modelPictureAvatar?: Maybe<MediaPicture>;
  /** Model sexuality [heterosexual, homesexual, bisexual] */
  modelSexuality?: Maybe<SexualityEnum>;
  /** Model Username (a.k.a login, screenname) [alfanum, 6-16] */
  modelUsername?: Maybe<Scalars['String']['output']>;
};

export type TourPayoutV1 = {
  __typename?: 'TourPayoutV1';
  /** Active state of a tour; may differs from status, e.g. if the tour was already completed in the past, but for now it would be incomplete */
  active: Scalars['Boolean']['output'];
  /** Name */
  completeness: ProfileCollectionCompleteness;
  /** Current step */
  currentStep?: Maybe<TourStep>;
  /** Number steps finished */
  finishedSteps: Scalars['Int']['output'];
  /** DateTime of last successful verification of requested values */
  lastVerified?: Maybe<Scalars['DateTime']['output']>;
  /** Tour name */
  name: TourNameEnum;
  /** Tour status, represents the current status summary of all steps */
  status: ProfileStatusEnum;
  /** All tour steps  */
  steps: Array<TourStep>;
  /** Total steps */
  totalSteps: Scalars['Int']['output'];
  /** Validate input data, null if no input given, e.g. in query context */
  validate?: Maybe<TourValidation>;
  /** Tour current values */
  values: TourPayoutV1Values;
};

export type TourPayoutV1Mutation = {
  __typename?: 'TourPayoutV1Mutation';
  /** Tour values */
  update: TourPayoutV1;
};


export type TourPayoutV1MutationUpdateArgs = {
  data: InputTourPayoutV1;
  step: Scalars['ID']['input'];
};

export type TourPayoutV1Values = {
  __typename?: 'TourPayoutV1Values';
  /** @deprecated use PaymentBillingAddressCity instead Payout Proof of Addresse - City */
  payoutAddressCity?: Maybe<Scalars['String']['output']>;
  /** @deprecated use PaymentBillingAddressCompanyname instead Payout Proof of Addresse - Company Name */
  payoutAddressCompanyname?: Maybe<Scalars['String']['output']>;
  /** @deprecated use PaymentBillingAddressCountry instead Payout Proof of Address - Country */
  payoutAddressCountry?: Maybe<CountryEnum>;
  /** @deprecated use PaymentBillingAddressDocument instead Payout Tax Document */
  payoutAddressDocument?: Maybe<UploadDocument>;
  /** @deprecated use  PaymentBillingAddressDocument Payout Address Document ID */
  payoutAddressDocumentId?: Maybe<Scalars['Int']['output']>;
  /** @deprecated use PaymentBillingAddressFirstname instead Payout Proof of Addresse - City */
  payoutAddressFirstname?: Maybe<Scalars['String']['output']>;
  /** @deprecated use PaymentBillingAddressIsCompany instead Payout Proof of Adress - is Company */
  payoutAddressIsCompany?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated use PaymentBillingAddressLastname instead Payout Proof of Addresse - City */
  payoutAddressLastname?: Maybe<Scalars['String']['output']>;
  /** @deprecated use PaymentBillingAddressPostalCode instead Payout Proof of Address - PostalCode */
  payoutAddressPostalCode?: Maybe<Scalars['String']['output']>;
  /** @deprecated use PaymentBillingAddressStreet instead Payout Proof of Address - street */
  payoutAddressStreet?: Maybe<Scalars['String']['output']>;
  /** @deprecated use PaymentBillingAddressStreetNumber instead Payout Proof of Address - street number */
  payoutAddressStreetNumber?: Maybe<Scalars['String']['output']>;
  /** @deprecated use  PaymentPayoutDataBa Payout Bankaccountowner */
  payoutBankaccountOwner?: Maybe<Scalars['String']['output']>;
  /** @deprecated use PaymentPayoutDataBankBic instead Payout BIC */
  payoutBic?: Maybe<Scalars['String']['output']>;
  /** @deprecated use PaymentPayoutDataBankIban instead Payout IBAN */
  payoutIban?: Maybe<Scalars['String']['output']>;
  /** @deprecated use PaymentPayoutDataIsTaxable Payout Is Model Taxable */
  payoutIsTaxable?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated use PaymentPayoutDataPaxumEmailAccount instead Payout Paxum Email Account */
  payoutPaxumEmailAccount?: Maybe<Scalars['String']['output']>;
  /** @deprecated use PaymentTaxDataDocument Payout Tax Document */
  payoutTaxDocument?: Maybe<UploadDocument>;
  /** @deprecated use PaymentTaxDataDocument Payout Tax Document ID */
  payoutTaxDocumentId?: Maybe<Scalars['Int']['output']>;
  /** @deprecated use PaymentTaxDataTaxNumber Payout Tax Number */
  payoutTaxId?: Maybe<Scalars['String']['output']>;
  /** @deprecated use PaymentTaxDataTin Payout Tax TIN */
  payoutTaxTin?: Maybe<Scalars['String']['output']>;
  /** @deprecated use PaymentTaxDataTinCountry Payout Tax TIN Country */
  payoutTaxTinCountry?: Maybe<TaxCountryEnum>;
  /** @deprecated use PaymentPayoutDataPayoutMethod instead Payout Type of Transaction (paxum, bank, cheque) */
  payoutTransactionType?: Maybe<FinancesPayoutMethodEnum>;
};

export type TourPayoutV2 = {
  __typename?: 'TourPayoutV2';
  /** Active state of a tour; may differs from status, e.g. if the tour was already completed in the past, but for now it would be incomplete */
  active: Scalars['Boolean']['output'];
  /** Name */
  completeness: ProfileCollectionCompleteness;
  /** Current step */
  currentStep?: Maybe<TourStep>;
  /** Enabled transitions */
  enabledTransitions: Array<Scalars['ID']['output']>;
  /** Number steps finished */
  finishedSteps: Scalars['Int']['output'];
  /** Get the last error if any */
  lastError?: Maybe<Scalars['String']['output']>;
  /** Tour name */
  name: TourNameEnum;
  /** Get reject reason, if status is "rejected", otherwise null */
  rejectReason?: Maybe<Scalars['String']['output']>;
  /** Tour status, represents the current status summary of all steps */
  status: ProfileStatusEnum;
  /** All tour steps  */
  steps: Array<TourStep>;
  /** Total steps */
  totalSteps: Scalars['Int']['output'];
  /** Validate input data, null if no input given, e.g. in query context */
  validate?: Maybe<TourValidation>;
  /** Tour current values */
  values: TourPayoutV1Values;
};

export type TourPayoutV2Mutation = {
  __typename?: 'TourPayoutV2Mutation';
  /** Tour values */
  update: TourPayoutV2;
};


export type TourPayoutV2MutationUpdateArgs = {
  data: InputTourPayoutV2;
  step: Scalars['ID']['input'];
  transition?: InputMaybe<Scalars['ID']['input']>;
};

export type TourPayoutV2Values = {
  __typename?: 'TourPayoutV2Values';
  /** Originator Model Release Form Birthdate [YYYY-MM-DD] */
  mrfOriginatorBirthdate?: Maybe<Scalars['Date']['output']>;
  /** Originator Model Release Form birthplace */
  mrfOriginatorBirthplace?: Maybe<Scalars['String']['output']>;
  /** Model Release Form for Signage */
  mrfOriginatorForm?: Maybe<FormManagerForm>;
  /** Originator IDproof back side */
  originatorIdentityProofBack?: Maybe<UploadDocument>;
  /** Originator IDproof front side */
  originatorIdentityProofFront?: Maybe<UploadDocument>;
  /** @deprecated use PaymentBillingAddressCity instead Payout Proof of Addresse - City */
  payoutAddressCity?: Maybe<Scalars['String']['output']>;
  /** @deprecated use PaymentBillingAddressCompanyname instead Payout Proof of Addresse - Company Name */
  payoutAddressCompanyname?: Maybe<Scalars['String']['output']>;
  /** @deprecated use PaymentBillingAddressCountry instead Payout Proof of Address - Country */
  payoutAddressCountry?: Maybe<CountryEnum>;
  /** @deprecated use PaymentBillingAddressDocument instead Payout Tax Document */
  payoutAddressDocument?: Maybe<UploadDocument>;
  /** @deprecated use  PaymentBillingAddressDocument Payout Address Document ID */
  payoutAddressDocumentId?: Maybe<Scalars['Int']['output']>;
  /** @deprecated use PaymentBillingAddressFirstname instead Payout Proof of Addresse - City */
  payoutAddressFirstname?: Maybe<Scalars['String']['output']>;
  /** @deprecated use PaymentBillingAddressIsCompany instead Payout Proof of Adress - is Company */
  payoutAddressIsCompany?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated use PaymentBillingAddressLastname instead Payout Proof of Addresse - City */
  payoutAddressLastname?: Maybe<Scalars['String']['output']>;
  /** @deprecated use PaymentBillingAddressPostalCode instead Payout Proof of Address - PostalCode */
  payoutAddressPostalCode?: Maybe<Scalars['String']['output']>;
  /** @deprecated use PaymentBillingAddressStreet instead Payout Proof of Address - street */
  payoutAddressStreet?: Maybe<Scalars['String']['output']>;
  /** @deprecated use PaymentBillingAddressStreetNumber instead Payout Proof of Address - street number */
  payoutAddressStreetNumber?: Maybe<Scalars['String']['output']>;
  /** @deprecated use  PaymentPayoutDataBa Payout Bankaccountowner */
  payoutBankaccountOwner?: Maybe<Scalars['String']['output']>;
  /** @deprecated use PaymentPayoutDataBankBic instead Payout BIC */
  payoutBic?: Maybe<Scalars['String']['output']>;
  /** @deprecated use PaymentPayoutDataBankIban instead Payout IBAN */
  payoutIban?: Maybe<Scalars['String']['output']>;
  /** Is model originator */
  payoutIsModelOriginator?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated use PaymentPayoutDataIsTaxable Payout Is Model Taxable */
  payoutIsTaxable?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated use PaymentPayoutDataPaxumEmailAccount instead Payout Paxum Email Account */
  payoutPaxumEmailAccount?: Maybe<Scalars['String']['output']>;
  /** @deprecated use PaymentTaxDataDocument Payout Tax Document */
  payoutTaxDocument?: Maybe<UploadDocument>;
  /** @deprecated use PaymentTaxDataDocument Payout Tax Document ID */
  payoutTaxDocumentId?: Maybe<Scalars['Int']['output']>;
  /** @deprecated use PaymentTaxDataTaxNumber Payout Tax Number */
  payoutTaxId?: Maybe<Scalars['String']['output']>;
  /** @deprecated use PaymentTaxDataTin Payout Tax TIN */
  payoutTaxTin?: Maybe<Scalars['String']['output']>;
  /** @deprecated use PaymentTaxDataTinCountry Payout Tax TIN Country */
  payoutTaxTinCountry?: Maybe<TaxCountryEnum>;
  /** @deprecated use PaymentPayoutDataPayoutMethod instead Payout Type of Transaction (paxum, bank, cheque) */
  payoutTransactionType?: Maybe<FinancesPayoutMethodEnum>;
};

export type TourStep = {
  __typename?: 'TourStep';
  /** Step description */
  description: Scalars['String']['output'];
  /** Tour step fields */
  fields: Array<Maybe<ProfileField>>;
  /** Step unique ID */
  id: Scalars['ID']['output'];
  /** Step position in tour */
  pos: Scalars['Int']['output'];
  /** Step status in tour */
  status: ProfileStatusEnum;
};

export type TourValidation = {
  __typename?: 'TourValidation';
  /** Step unique ID */
  data?: Maybe<Array<Maybe<ProfileFieldValidation>>>;
};

/** Translate Root */
export type Translate = {
  __typename?: 'Translate';
  /** Text result from DeepL */
  deeplTranslate: Array<Maybe<DeeplTranslateText>>;
};


/** Translate Root */
export type TranslateDeeplTranslateArgs = {
  sourceLang?: InputMaybe<Scalars['String']['input']>;
  targetLang?: InputMaybe<DeeplLangEnum>;
  text: Scalars['String']['input'];
};

export type UploadDocument = {
  __typename?: 'UploadDocument';
  /** Reason */
  comment: Scalars['String']['output'];
  /** Doc ID */
  docId: Scalars['Int']['output'];
  /** Expire Datetime */
  expireDate?: Maybe<Scalars['DateTime']['output']>;
  /** Original file name */
  filename: Scalars['String']['output'];
  /** File Status */
  status: DocumentStatusEnum;
  /** File Type */
  type: Scalars['String']['output'];
  /** Document type name */
  typeName: Scalars['String']['output'];
  /** URL to file */
  url: Scalars['String']['output'];
};

export type UploadInfo = {
  __typename?: 'UploadInfo';
  /** Required form data fields with type */
  errorCodes?: Maybe<Scalars['Dict']['output']>;
  /** Required form data fields with type */
  requiredFormData?: Maybe<Scalars['Dict']['output']>;
  /** Upload endpoint URL with all required params */
  url?: Maybe<Scalars['String']['output']>;
};

export type UploadInfoTus = {
  __typename?: 'UploadInfoTus';
  /** Metadata for TUS-Upload as JSON string */
  metaData: Scalars['Dict']['output'];
  /** Upload endpoint URL */
  url: Scalars['String']['output'];
};

export type VxCashMutation = {
  __typename?: 'VXCashMutation';
  /** Creates a webmaster in VXCash and returns Webmaster-ID if successfull. Otherwise returns 0 */
  createWebmaster: Scalars['Int']['output'];
};

export type VxLive = {
  __typename?: 'VXLive';
  /** Get deep link url for VXLive, if guestUserId is provided, then deep link url will be generated with link to channel, null if VXLive is not enabled for user */
  deepLinkUrl?: Maybe<Scalars['String']['output']>;
  /** Check if VXLive is enabled for user */
  isEnabled: Scalars['Boolean']['output'];
};


export type VxLiveDeepLinkUrlArgs = {
  guestUserId?: InputMaybe<Scalars['String']['input']>;
};

export type Video = {
  __typename?: 'Video';
  /** Album-Id (UMA_ID) */
  albumId: Scalars['Int']['output'];
  /** Returns true if all necessary ID-Cards are presents */
  allIDCardsUploaded: Scalars['Boolean']['output'];
  /** Returns true if all necessary MRFs are presents */
  allModelReleaseFormsUploaded: Scalars['Boolean']['output'];
  /** Contest id */
  contestId?: Maybe<Scalars['Int']['output']>;
  /** discount end */
  discountEnd?: Maybe<Scalars['DateTime']['output']>;
  /** discount Percent */
  discountPercent?: Maybe<Scalars['Int']['output']>;
  /** discount start */
  discountStart?: Maybe<Scalars['DateTime']['output']>;
  /** Feedbacks count */
  feedbacksCount?: Maybe<Scalars['Int']['output']>;
  /** Returns true if video flagged as Calendar-365 */
  isCalendar365Video: Scalars['Boolean']['output'];
  /** Returns true if discount can be displayed */
  isDiscountVisible?: Maybe<Scalars['Boolean']['output']>;
  /** Returns true if video can be edited */
  isEditable: Scalars['Boolean']['output'];
  /** Returns true if planned release date is editable */
  isPlannedReleaseDateEditable?: Maybe<Scalars['Boolean']['output']>;
  /** Returns true if price can be displayed */
  isPriceVisible?: Maybe<Scalars['Boolean']['output']>;
  /** Returns true if video is shared */
  isSharedVideo: Scalars['Boolean']['output'];
  /** Returns true if video flagged as VIP-30 */
  isVip30Video: Scalars['Boolean']['output'];
  /** length */
  length?: Maybe<Scalars['Int']['output']>;
  /** likes count */
  likesCount?: Maybe<Scalars['Int']['output']>;
  /** has sound */
  pictures?: Maybe<Array<Maybe<MediaPicture>>>;
  /** planned release date */
  plannedReleaseDate?: Maybe<Scalars['DateTime']['output']>;
  /** Preview picture FSK-16 */
  previewPicture16?: Maybe<MediaPicture>;
  /** Preview picture FSK-18 */
  previewPicture18?: Maybe<MediaPicture>;
  /** Price */
  price?: Maybe<Scalars['Float']['output']>;
  /** Price max */
  priceMax?: Maybe<Scalars['Float']['output']>;
  /** Rejection reason */
  rejectionReason?: Maybe<Scalars['String']['output']>;
  /** Released status */
  releasedStatus?: Maybe<VideoReleasedStatusEnum>;
  /** Sales count */
  salesCount?: Maybe<Scalars['Int']['output']>;
  /** Status */
  status?: Maybe<VideoStatusEnum>;
  /** tag collection */
  tagCollection?: Maybe<Array<Maybe<MediaTag>>>;
  /** text collection */
  textCollection?: Maybe<MediaTextCollection>;
  /** Video type */
  type?: Maybe<VideoTypeEnum>;
  /** Upload request id */
  uploadRequestId?: Maybe<Scalars['String']['output']>;
  /** Uploaded At */
  uploadedAt: Scalars['DateTime']['output'];
  /** Video URL */
  url: Scalars['String']['output'];
  /** User-Id */
  userId: Scalars['Int']['output'];
  /** Video-Id (UMV_ID) */
  videoId: Scalars['Int']['output'];
};

/** Video groups */
export enum VideoGroupEnum {
  Marketing = 'marketing',
  Released = 'released',
  Unused = 'unused'
}

export type VideoList = {
  __typename?: 'VideoList';
  /** Edges */
  edges: Array<Maybe<VideoPaginationEdge>>;
  /** Page info */
  pageInfo?: Maybe<PaginationPageInfo>;
  /** Total edges */
  totalCount: Scalars['Int']['output'];
};

export type VideoPaginationEdge = {
  __typename?: 'VideoPaginationEdge';
  /** Cursor for cursor-based pagination */
  cursor?: Maybe<Scalars['String']['output']>;
  /** Video item */
  node: Video;
};

/** Video released status */
export enum VideoReleasedStatusEnum {
  Offline = 'offline',
  Online = 'online',
  Planned = 'planned'
}

/** Released status */
export enum VideoSortFieldsEnum {
  AlbumType = 'albumType',
  Discount = 'discount',
  GuestRating = 'guestRating',
  Id = 'id',
  Name = 'name',
  Price = 'price',
  Sales = 'sales',
  Status = 'status',
  UploadDate = 'uploadDate'
}

/** Video status */
export enum VideoStatusEnum {
  Broken = 'broken',
  New = 'new',
  Offline = 'offline',
  Online = 'online',
  Plannend = 'plannend',
  Rating = 'rating',
  Rejected = 'rejected',
  Transcoding = 'transcoding'
}

/** Video types */
export enum VideoTypeEnum {
  VideoContest = 'videoContest',
  VideoCultbabes = 'videoCultbabes',
  VideoFeed = 'videoFeed',
  VideoHotclip = 'videoHotclip',
  VideoMessengerOffer = 'videoMessengerOffer',
  VideoPool = 'videoPool',
  VideoShop = 'videoShop',
  VideoWelcomeclip = 'videoWelcomeclip'
}

export type Videos = {
  __typename?: 'Videos';
  /** Picture upload URL */
  pictureUploadUrl: Scalars['String']['output'];
  /** Data for TUS-Upload */
  tusUploadData?: Maybe<UploadInfoTus>;
  /** Video upload URL */
  uploadUrl: Scalars['String']['output'];
  /** Video */
  videoById?: Maybe<Video>;
  /** Video list */
  videosList: VideoList;
};


export type VideosPictureUploadUrlArgs = {
  albumId: Scalars['Int']['input'];
};


export type VideosTusUploadDataArgs = {
  albumId?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<VideoTypeEnum>;
};


export type VideosUploadUrlArgs = {
  type?: InputMaybe<VideoTypeEnum>;
};


export type VideosVideoByIdArgs = {
  albumId?: InputMaybe<Scalars['Int']['input']>;
  uploadRequestId?: InputMaybe<Scalars['String']['input']>;
};


export type VideosVideosListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  group?: InputMaybe<VideoGroupEnum>;
  sortDescending?: InputMaybe<Scalars['Boolean']['input']>;
  sortField?: InputMaybe<VideoSortFieldsEnum>;
  status?: InputMaybe<Array<InputMaybe<VideoStatusEnum>>>;
  types?: InputMaybe<Array<InputMaybe<VideoTypeEnum>>>;
};

export type VideosMutation = {
  __typename?: 'VideosMutation';
  /** Update video */
  saveVideo?: Maybe<Video>;
};


export type VideosMutationSaveVideoArgs = {
  data: InputVideo;
};

export type GetPayoutConditionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPayoutConditionsQuery = { __typename?: 'Query', finances: { __typename?: 'Finances', payoutConditions: { __typename?: 'FinancesPayoutConditions', minAmountBankDE: number, feeBankDE: number, feeBankEU: number, feeBank3L: number, feePaxum: number, feeUnderMinAmount: number } } };

export type TagAutoCompleteQueryVariables = Exact<{
  fragment: Scalars['String']['input'];
}>;


export type TagAutoCompleteQuery = { __typename?: 'Query', media: { __typename?: 'Media', tags: Array<{ __typename?: 'MediaTag', id?: number | null, value?: string | null } | null> } };

export type GetProfileHeaderStatisticsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProfileHeaderStatisticsQuery = { __typename?: 'Query', statistics: { __typename?: 'Statistics', entries: Array<{ __typename: 'StatisticsEntrySingleCurrency', unit: string, id: StatisticsEntryNameEnum, label: string, icon: string, category: StatisticsEntryCategoryEnum, values: Array<{ __typename?: 'StatisticsEntryValue', value: string, dateTime: any, ts: number } | null>, trend?: { __typename?: 'StatisticsTrend', percent: number } | null } | { __typename: 'StatisticsEntrySingleDuration', unit: string, id: StatisticsEntryNameEnum, label: string, icon: string, category: StatisticsEntryCategoryEnum, values: Array<{ __typename?: 'StatisticsEntryValue', value: string, dateTime: any, ts: number } | null>, trend?: { __typename?: 'StatisticsTrend', percent: number } | null } | { __typename: 'StatisticsEntrySingleNumber', unit: string, id: StatisticsEntryNameEnum, label: string, icon: string, category: StatisticsEntryCategoryEnum, values: Array<{ __typename?: 'StatisticsEntryValue', value: string, dateTime: any, ts: number } | null>, trend?: { __typename?: 'StatisticsTrend', percent: number } | null }> } };

export type AuthUserFragment = { __typename?: 'AuthUser', permissions: Array<AuthUserPermissionEnum>, userId: string, username: string, scope: ScopeEnum, roles: Array<SecurityRoleEnum>, lang: ApiLangEnum };

export type IncomeSourceEntryFragment = { __typename?: 'IncomeSourcesEntry', id: string, title: string, teaserText: string, isLabeledNew: boolean, activatedAt?: any | null, readAt?: any | null, headerImage: { __typename?: 'Image', alt: string, src: string }, experienceTags?: Array<{ __typename?: 'TipsTag', id: string, value?: string | null } | null> | null, intentionTags?: Array<{ __typename?: 'TipsTag', id: string, value?: string | null } | null> | null };

export type IncomeSourceWithBodyEntryFragment = { __typename?: 'IncomeSourcesEntry', id: string, title: string, teaserText: string, body: any, isLabeledNew: boolean, activatedAt?: any | null, readAt?: any | null, headerImage: { __typename?: 'Image', alt: string, src: string }, experienceTags?: Array<{ __typename?: 'TipsTag', id: string, value?: string | null } | null> | null, intentionTags?: Array<{ __typename?: 'TipsTag', id: string, value?: string | null } | null> | null };

export type TagEntryFragment = { __typename?: 'TipsTag', id: string, value?: string | null };

export type MediaPictureFieldFragment = { __typename?: 'ProfileFieldTypePicture', status: ProfileStatusEnum, rejectReason?: string | null, upload: { __typename?: 'UploadInfo', url?: string | null, requiredFormData?: any | null, errorCodes?: any | null } };

export type MediaPictureValueFragment = { __typename?: 'MediaPicture', image: { __typename?: 'Image', src: string, alt: string, srcset: string } };

export type MutationResultFragment = { __typename?: 'MutationResult', message?: string | null, success?: boolean | null };

export type PrefillProfileStringFieldFragment = { __typename?: 'ProfileFieldTypeString', name: string, minLength?: number | null, maxLength?: number | null, value?: string | null };

export type PrefillProfileDateFieldFragment = { __typename?: 'ProfileFieldTypeDate', name: string, value?: any | null, minDate?: any | null, maxDate?: any | null };

export type QuickpickValueFragment = { __typename?: 'OptionEntry', value: string, label: string };

export type ValidValueFragment = { __typename?: 'OptionEntry', value: string, label: string };

export type PrefillProfileEnumFieldFragment = { __typename?: 'ProfileFieldTypeEnum', name: string, value?: string | null, quickpickValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }>, validValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }> };

export type ProfileFieldTypeEnumFragment = { __typename: 'ProfileFieldTypeEnum', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, quickpickValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }>, validValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }> };

export type ProfileFieldTypeDateFragment = { __typename: 'ProfileFieldTypeDate', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: any | null, minDate?: any | null, maxDate?: any | null };

export type ProfileFieldTypeEnumListFragment = { __typename: 'ProfileFieldTypeEnumList', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: Array<string | null> | null, validValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }> };

export type ProfileFieldTypeIntFragment = { __typename: 'ProfileFieldTypeInt', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: number | null, minValue?: number | null, maxValue?: number | null };

export type ProfileFieldTypeStringFragment = { __typename: 'ProfileFieldTypeString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, minLength?: number | null, maxLength?: number | null };

export type MultiLangTextFragment = { __typename?: 'MultiLangText', status: string, langs: Array<LanguagesEnum>, origText: string, texts: Array<{ __typename?: 'LangText', status: string, text: string, lang: LanguagesEnum }> };

export type ProfileFieldTypeMultilangStringFragment = { __typename: 'ProfileFieldTypeMultiLangString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, minLength: number, maxLength: number, requiredLangs: Array<ApiLangEnum | null>, value?: { __typename?: 'MultiLangText', status: string, langs: Array<LanguagesEnum>, origText: string, texts: Array<{ __typename?: 'LangText', status: string, text: string, lang: LanguagesEnum }> } | null, langs: Array<{ __typename?: 'OptionEntry', name: string, label: string }> };

export type ProfileFieldTypePictureFragment = { __typename: 'ProfileFieldTypePicture', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: { __typename?: 'MediaPicture', umaId: number, umpId: number, type: string, rejectReason?: string | null, status: MediaPictureStatusEnum, image: { __typename?: 'Image', src: string, alt: string, srcset: string } } | null };

export type ProfileFieldTypePictureListFragment = { __typename: 'ProfileFieldTypePictureList', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value: Array<{ __typename?: 'MediaPicture', type: string, fsk: number, rejectReason?: string | null, position: number, status: MediaPictureStatusEnum, umaId: number, umpId: number, image: { __typename?: 'Image', src: string, alt: string, srcset: string } }> };

export type ModelProfileCompletenessFragment = { __typename?: 'ProfileCollectionCompleteness', total: number, missing: number, complete: number, missingFields: Array<ProfileFieldsEnum> };

export type ProfileCollectionFieldStringFragment = { __typename?: 'ProfileFieldTypeString', disabled: boolean, minLength?: number | null, maxLength?: number | null, readOnly: boolean, value?: string | null };

export type ProfileCollectionFieldEnumFragment = { __typename?: 'ProfileFieldTypeEnum', disabled: boolean, readOnly: boolean, value?: string | null, quickpickValues: Array<{ __typename?: 'OptionEntry', label: string, value: string }>, validValues: Array<{ __typename?: 'OptionEntry', label: string, value: string }> };

export type ProfileCollectionFieldDateFragment = { __typename?: 'ProfileFieldTypeDate', disabled: boolean, readOnly: boolean, value?: any | null };

export type ProfileCollectionMobileAboutMeV1FieldsFragment = { __typename?: 'ProfileCollectionMobileAboutMeV1Fields', modelUsername?: { __typename: 'ProfileFieldTypeString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, minLength?: number | null, maxLength?: number | null } | null, modelGender?: { __typename: 'ProfileFieldTypeEnum', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, quickpickValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }>, validValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }> } | null, modelSexuality?: { __typename: 'ProfileFieldTypeEnum', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, quickpickValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }>, validValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }> } | null, modelBirthdate?: { __typename: 'ProfileFieldTypeDate', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: any | null, minDate?: any | null, maxDate?: any | null } | null, modelMotto?: { __typename: 'ProfileFieldTypeMultiLangString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, minLength: number, maxLength: number, requiredLangs: Array<ApiLangEnum | null>, value?: { __typename?: 'MultiLangText', status: string, langs: Array<LanguagesEnum>, origText: string, texts: Array<{ __typename?: 'LangText', status: string, text: string, lang: LanguagesEnum }> } | null, langs: Array<{ __typename?: 'OptionEntry', name: string, label: string }> } | null, modelAboutMe?: { __typename: 'ProfileFieldTypeMultiLangString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, minLength: number, maxLength: number, requiredLangs: Array<ApiLangEnum | null>, value?: { __typename?: 'MultiLangText', status: string, langs: Array<LanguagesEnum>, origText: string, texts: Array<{ __typename?: 'LangText', status: string, text: string, lang: LanguagesEnum }> } | null, langs: Array<{ __typename?: 'OptionEntry', name: string, label: string }> } | null, modelRelationshipState?: { __typename: 'ProfileFieldTypeEnum', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, quickpickValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }>, validValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }> } | null, modelCountry?: { __typename: 'ProfileFieldTypeEnum', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, quickpickValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }>, validValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }> } | null, modelPostalCode?: { __typename: 'ProfileFieldTypeString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, minLength?: number | null, maxLength?: number | null } | null, modelCity?: { __typename: 'ProfileFieldTypeString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, minLength?: number | null, maxLength?: number | null } | null, modelLanguage?: { __typename: 'ProfileFieldTypeEnumList', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: Array<string | null> | null, validValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }> } | null, modelChatPractices?: { __typename: 'ProfileFieldTypeEnumList', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: Array<string | null> | null, validValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }> } | null };

export type ProfileCollectionMobileAboutMeV1Fragment = { __typename?: 'ProfileCollectionMobileAboutMeV1', completeness: { __typename?: 'ProfileCollectionCompleteness', total: number, missing: number, complete: number, missingFields: Array<ProfileFieldsEnum> }, fields: { __typename?: 'ProfileCollectionMobileAboutMeV1Fields', modelUsername?: { __typename: 'ProfileFieldTypeString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, minLength?: number | null, maxLength?: number | null } | null, modelGender?: { __typename: 'ProfileFieldTypeEnum', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, quickpickValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }>, validValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }> } | null, modelSexuality?: { __typename: 'ProfileFieldTypeEnum', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, quickpickValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }>, validValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }> } | null, modelBirthdate?: { __typename: 'ProfileFieldTypeDate', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: any | null, minDate?: any | null, maxDate?: any | null } | null, modelMotto?: { __typename: 'ProfileFieldTypeMultiLangString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, minLength: number, maxLength: number, requiredLangs: Array<ApiLangEnum | null>, value?: { __typename?: 'MultiLangText', status: string, langs: Array<LanguagesEnum>, origText: string, texts: Array<{ __typename?: 'LangText', status: string, text: string, lang: LanguagesEnum }> } | null, langs: Array<{ __typename?: 'OptionEntry', name: string, label: string }> } | null, modelAboutMe?: { __typename: 'ProfileFieldTypeMultiLangString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, minLength: number, maxLength: number, requiredLangs: Array<ApiLangEnum | null>, value?: { __typename?: 'MultiLangText', status: string, langs: Array<LanguagesEnum>, origText: string, texts: Array<{ __typename?: 'LangText', status: string, text: string, lang: LanguagesEnum }> } | null, langs: Array<{ __typename?: 'OptionEntry', name: string, label: string }> } | null, modelRelationshipState?: { __typename: 'ProfileFieldTypeEnum', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, quickpickValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }>, validValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }> } | null, modelCountry?: { __typename: 'ProfileFieldTypeEnum', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, quickpickValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }>, validValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }> } | null, modelPostalCode?: { __typename: 'ProfileFieldTypeString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, minLength?: number | null, maxLength?: number | null } | null, modelCity?: { __typename: 'ProfileFieldTypeString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, minLength?: number | null, maxLength?: number | null } | null, modelLanguage?: { __typename: 'ProfileFieldTypeEnumList', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: Array<string | null> | null, validValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }> } | null, modelChatPractices?: { __typename: 'ProfileFieldTypeEnumList', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: Array<string | null> | null, validValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }> } | null } };

export type ProfileCollectionMobileAppearanceV1FieldsFragment = { __typename?: 'ProfileCollectionMobileAppearanceV1Fields', modelBodyHeight?: { __typename: 'ProfileFieldTypeInt', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: number | null, minValue?: number | null, maxValue?: number | null } | null, modelBodyWeight?: { __typename: 'ProfileFieldTypeInt', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: number | null, minValue?: number | null, maxValue?: number | null } | null, modelBodyFigure?: { __typename: 'ProfileFieldTypeEnum', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, quickpickValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }>, validValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }> } | null, modelBreastSize?: { __typename: 'ProfileFieldTypeEnum', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, quickpickValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }>, validValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }> } | null, modelPenisSize?: { __typename: 'ProfileFieldTypeEnum', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, quickpickValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }>, validValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }> } | null, modelSkinType?: { __typename: 'ProfileFieldTypeEnum', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, quickpickValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }>, validValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }> } | null, modelHairColor?: { __typename: 'ProfileFieldTypeEnum', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, quickpickValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }>, validValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }> } | null, modelEyeColor?: { __typename: 'ProfileFieldTypeEnum', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, quickpickValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }>, validValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }> } | null, modelPubicHair?: { __typename: 'ProfileFieldTypeEnum', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, quickpickValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }>, validValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }> } | null, modelBodyModifications?: { __typename: 'ProfileFieldTypeEnumList', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: Array<string | null> | null, validValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }> } | null };

export type ProfileCollectionMobileAppearanceV1Fragment = { __typename?: 'ProfileCollectionMobileAppearanceV1', completeness: { __typename?: 'ProfileCollectionCompleteness', total: number, missing: number, complete: number, missingFields: Array<ProfileFieldsEnum> }, fields: { __typename?: 'ProfileCollectionMobileAppearanceV1Fields', modelBodyHeight?: { __typename: 'ProfileFieldTypeInt', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: number | null, minValue?: number | null, maxValue?: number | null } | null, modelBodyWeight?: { __typename: 'ProfileFieldTypeInt', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: number | null, minValue?: number | null, maxValue?: number | null } | null, modelBodyFigure?: { __typename: 'ProfileFieldTypeEnum', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, quickpickValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }>, validValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }> } | null, modelBreastSize?: { __typename: 'ProfileFieldTypeEnum', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, quickpickValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }>, validValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }> } | null, modelPenisSize?: { __typename: 'ProfileFieldTypeEnum', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, quickpickValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }>, validValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }> } | null, modelSkinType?: { __typename: 'ProfileFieldTypeEnum', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, quickpickValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }>, validValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }> } | null, modelHairColor?: { __typename: 'ProfileFieldTypeEnum', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, quickpickValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }>, validValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }> } | null, modelEyeColor?: { __typename: 'ProfileFieldTypeEnum', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, quickpickValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }>, validValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }> } | null, modelPubicHair?: { __typename: 'ProfileFieldTypeEnum', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, quickpickValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }>, validValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }> } | null, modelBodyModifications?: { __typename: 'ProfileFieldTypeEnumList', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: Array<string | null> | null, validValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }> } | null } };

export type ProfileCollectionMobileInterviewV1FieldsFragment = { __typename?: 'ProfileCollectionMobileInterviewV1Fields', modelInterviewPartner?: { __typename: 'ProfileFieldTypeMultiLangString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, minLength: number, maxLength: number, requiredLangs: Array<ApiLangEnum | null>, value?: { __typename?: 'MultiLangText', status: string, langs: Array<LanguagesEnum>, origText: string, texts: Array<{ __typename?: 'LangText', status: string, text: string, lang: LanguagesEnum }> } | null, langs: Array<{ __typename?: 'OptionEntry', name: string, label: string }> } | null, modelInterviewIsland?: { __typename: 'ProfileFieldTypeMultiLangString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, minLength: number, maxLength: number, requiredLangs: Array<ApiLangEnum | null>, value?: { __typename?: 'MultiLangText', status: string, langs: Array<LanguagesEnum>, origText: string, texts: Array<{ __typename?: 'LangText', status: string, text: string, lang: LanguagesEnum }> } | null, langs: Array<{ __typename?: 'OptionEntry', name: string, label: string }> } | null, modelInterviewEnterprise?: { __typename: 'ProfileFieldTypeMultiLangString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, minLength: number, maxLength: number, requiredLangs: Array<ApiLangEnum | null>, value?: { __typename?: 'MultiLangText', status: string, langs: Array<LanguagesEnum>, origText: string, texts: Array<{ __typename?: 'LangText', status: string, text: string, lang: LanguagesEnum }> } | null, langs: Array<{ __typename?: 'OptionEntry', name: string, label: string }> } | null, modelInterviewHobbies?: { __typename: 'ProfileFieldTypeMultiLangString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, minLength: number, maxLength: number, requiredLangs: Array<ApiLangEnum | null>, value?: { __typename?: 'MultiLangText', status: string, langs: Array<LanguagesEnum>, origText: string, texts: Array<{ __typename?: 'LangText', status: string, text: string, lang: LanguagesEnum }> } | null, langs: Array<{ __typename?: 'OptionEntry', name: string, label: string }> } | null, modelInterviewSexualPosition?: { __typename: 'ProfileFieldTypeMultiLangString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, minLength: number, maxLength: number, requiredLangs: Array<ApiLangEnum | null>, value?: { __typename?: 'MultiLangText', status: string, langs: Array<LanguagesEnum>, origText: string, texts: Array<{ __typename?: 'LangText', status: string, text: string, lang: LanguagesEnum }> } | null, langs: Array<{ __typename?: 'OptionEntry', name: string, label: string }> } | null, modelInterviewSexualFantasies?: { __typename: 'ProfileFieldTypeMultiLangString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, minLength: number, maxLength: number, requiredLangs: Array<ApiLangEnum | null>, value?: { __typename?: 'MultiLangText', status: string, langs: Array<LanguagesEnum>, origText: string, texts: Array<{ __typename?: 'LangText', status: string, text: string, lang: LanguagesEnum }> } | null, langs: Array<{ __typename?: 'OptionEntry', name: string, label: string }> } | null, modelInterviewSexNotOk?: { __typename: 'ProfileFieldTypeMultiLangString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, minLength: number, maxLength: number, requiredLangs: Array<ApiLangEnum | null>, value?: { __typename?: 'MultiLangText', status: string, langs: Array<LanguagesEnum>, origText: string, texts: Array<{ __typename?: 'LangText', status: string, text: string, lang: LanguagesEnum }> } | null, langs: Array<{ __typename?: 'OptionEntry', name: string, label: string }> } | null, modelInterviewSexOk?: { __typename: 'ProfileFieldTypeMultiLangString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, minLength: number, maxLength: number, requiredLangs: Array<ApiLangEnum | null>, value?: { __typename?: 'MultiLangText', status: string, langs: Array<LanguagesEnum>, origText: string, texts: Array<{ __typename?: 'LangText', status: string, text: string, lang: LanguagesEnum }> } | null, langs: Array<{ __typename?: 'OptionEntry', name: string, label: string }> } | null, modelInterviewEroticExperience?: { __typename: 'ProfileFieldTypeMultiLangString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, minLength: number, maxLength: number, requiredLangs: Array<ApiLangEnum | null>, value?: { __typename?: 'MultiLangText', status: string, langs: Array<LanguagesEnum>, origText: string, texts: Array<{ __typename?: 'LangText', status: string, text: string, lang: LanguagesEnum }> } | null, langs: Array<{ __typename?: 'OptionEntry', name: string, label: string }> } | null };

export type ProfileCollectionMobileInterviewV1Fragment = { __typename?: 'ProfileCollectionMobileInterviewV1', completeness: { __typename?: 'ProfileCollectionCompleteness', total: number, missing: number, complete: number, missingFields: Array<ProfileFieldsEnum> }, fields: { __typename?: 'ProfileCollectionMobileInterviewV1Fields', modelInterviewPartner?: { __typename: 'ProfileFieldTypeMultiLangString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, minLength: number, maxLength: number, requiredLangs: Array<ApiLangEnum | null>, value?: { __typename?: 'MultiLangText', status: string, langs: Array<LanguagesEnum>, origText: string, texts: Array<{ __typename?: 'LangText', status: string, text: string, lang: LanguagesEnum }> } | null, langs: Array<{ __typename?: 'OptionEntry', name: string, label: string }> } | null, modelInterviewIsland?: { __typename: 'ProfileFieldTypeMultiLangString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, minLength: number, maxLength: number, requiredLangs: Array<ApiLangEnum | null>, value?: { __typename?: 'MultiLangText', status: string, langs: Array<LanguagesEnum>, origText: string, texts: Array<{ __typename?: 'LangText', status: string, text: string, lang: LanguagesEnum }> } | null, langs: Array<{ __typename?: 'OptionEntry', name: string, label: string }> } | null, modelInterviewEnterprise?: { __typename: 'ProfileFieldTypeMultiLangString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, minLength: number, maxLength: number, requiredLangs: Array<ApiLangEnum | null>, value?: { __typename?: 'MultiLangText', status: string, langs: Array<LanguagesEnum>, origText: string, texts: Array<{ __typename?: 'LangText', status: string, text: string, lang: LanguagesEnum }> } | null, langs: Array<{ __typename?: 'OptionEntry', name: string, label: string }> } | null, modelInterviewHobbies?: { __typename: 'ProfileFieldTypeMultiLangString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, minLength: number, maxLength: number, requiredLangs: Array<ApiLangEnum | null>, value?: { __typename?: 'MultiLangText', status: string, langs: Array<LanguagesEnum>, origText: string, texts: Array<{ __typename?: 'LangText', status: string, text: string, lang: LanguagesEnum }> } | null, langs: Array<{ __typename?: 'OptionEntry', name: string, label: string }> } | null, modelInterviewSexualPosition?: { __typename: 'ProfileFieldTypeMultiLangString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, minLength: number, maxLength: number, requiredLangs: Array<ApiLangEnum | null>, value?: { __typename?: 'MultiLangText', status: string, langs: Array<LanguagesEnum>, origText: string, texts: Array<{ __typename?: 'LangText', status: string, text: string, lang: LanguagesEnum }> } | null, langs: Array<{ __typename?: 'OptionEntry', name: string, label: string }> } | null, modelInterviewSexualFantasies?: { __typename: 'ProfileFieldTypeMultiLangString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, minLength: number, maxLength: number, requiredLangs: Array<ApiLangEnum | null>, value?: { __typename?: 'MultiLangText', status: string, langs: Array<LanguagesEnum>, origText: string, texts: Array<{ __typename?: 'LangText', status: string, text: string, lang: LanguagesEnum }> } | null, langs: Array<{ __typename?: 'OptionEntry', name: string, label: string }> } | null, modelInterviewSexNotOk?: { __typename: 'ProfileFieldTypeMultiLangString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, minLength: number, maxLength: number, requiredLangs: Array<ApiLangEnum | null>, value?: { __typename?: 'MultiLangText', status: string, langs: Array<LanguagesEnum>, origText: string, texts: Array<{ __typename?: 'LangText', status: string, text: string, lang: LanguagesEnum }> } | null, langs: Array<{ __typename?: 'OptionEntry', name: string, label: string }> } | null, modelInterviewSexOk?: { __typename: 'ProfileFieldTypeMultiLangString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, minLength: number, maxLength: number, requiredLangs: Array<ApiLangEnum | null>, value?: { __typename?: 'MultiLangText', status: string, langs: Array<LanguagesEnum>, origText: string, texts: Array<{ __typename?: 'LangText', status: string, text: string, lang: LanguagesEnum }> } | null, langs: Array<{ __typename?: 'OptionEntry', name: string, label: string }> } | null, modelInterviewEroticExperience?: { __typename: 'ProfileFieldTypeMultiLangString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, minLength: number, maxLength: number, requiredLangs: Array<ApiLangEnum | null>, value?: { __typename?: 'MultiLangText', status: string, langs: Array<LanguagesEnum>, origText: string, texts: Array<{ __typename?: 'LangText', status: string, text: string, lang: LanguagesEnum }> } | null, langs: Array<{ __typename?: 'OptionEntry', name: string, label: string }> } | null } };

export type ProfileCollectionMobileMediaV1FieldsFragment = { __typename?: 'ProfileCollectionMobileMediaV1Fields', modelPictureTitleLandscape?: { __typename: 'ProfileFieldTypePicture', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: { __typename?: 'MediaPicture', umaId: number, umpId: number, type: string, rejectReason?: string | null, status: MediaPictureStatusEnum, image: { __typename?: 'Image', src: string, alt: string, srcset: string } } | null } | null, modelPictureFSK16Avatar?: { __typename: 'ProfileFieldTypePicture', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: { __typename?: 'MediaPicture', umaId: number, umpId: number, type: string, rejectReason?: string | null, status: MediaPictureStatusEnum, image: { __typename?: 'Image', src: string, alt: string, srcset: string } } | null } | null, modelPictureFSK12Sedcard?: { __typename: 'ProfileFieldTypePictureList', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value: Array<{ __typename?: 'MediaPicture', type: string, fsk: number, rejectReason?: string | null, position: number, status: MediaPictureStatusEnum, umaId: number, umpId: number, image: { __typename?: 'Image', src: string, alt: string, srcset: string } }> } | null, modelPictureFSK16Sedcard?: { __typename: 'ProfileFieldTypePictureList', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value: Array<{ __typename?: 'MediaPicture', type: string, fsk: number, rejectReason?: string | null, position: number, status: MediaPictureStatusEnum, umaId: number, umpId: number, image: { __typename?: 'Image', src: string, alt: string, srcset: string } }> } | null, modelPictureFSK18Sedcard?: { __typename: 'ProfileFieldTypePictureList', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value: Array<{ __typename?: 'MediaPicture', type: string, fsk: number, rejectReason?: string | null, position: number, status: MediaPictureStatusEnum, umaId: number, umpId: number, image: { __typename?: 'Image', src: string, alt: string, srcset: string } }> } | null };

export type ProfileCollectionMobileMediaV1Fragment = { __typename?: 'ProfileCollectionMobileMediaV1', completeness: { __typename?: 'ProfileCollectionCompleteness', total: number, missing: number, complete: number, missingFields: Array<ProfileFieldsEnum> }, fields: { __typename?: 'ProfileCollectionMobileMediaV1Fields', modelPictureTitleLandscape?: { __typename: 'ProfileFieldTypePicture', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: { __typename?: 'MediaPicture', umaId: number, umpId: number, type: string, rejectReason?: string | null, status: MediaPictureStatusEnum, image: { __typename?: 'Image', src: string, alt: string, srcset: string } } | null } | null, modelPictureFSK16Avatar?: { __typename: 'ProfileFieldTypePicture', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: { __typename?: 'MediaPicture', umaId: number, umpId: number, type: string, rejectReason?: string | null, status: MediaPictureStatusEnum, image: { __typename?: 'Image', src: string, alt: string, srcset: string } } | null } | null, modelPictureFSK12Sedcard?: { __typename: 'ProfileFieldTypePictureList', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value: Array<{ __typename?: 'MediaPicture', type: string, fsk: number, rejectReason?: string | null, position: number, status: MediaPictureStatusEnum, umaId: number, umpId: number, image: { __typename?: 'Image', src: string, alt: string, srcset: string } }> } | null, modelPictureFSK16Sedcard?: { __typename: 'ProfileFieldTypePictureList', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value: Array<{ __typename?: 'MediaPicture', type: string, fsk: number, rejectReason?: string | null, position: number, status: MediaPictureStatusEnum, umaId: number, umpId: number, image: { __typename?: 'Image', src: string, alt: string, srcset: string } }> } | null, modelPictureFSK18Sedcard?: { __typename: 'ProfileFieldTypePictureList', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value: Array<{ __typename?: 'MediaPicture', type: string, fsk: number, rejectReason?: string | null, position: number, status: MediaPictureStatusEnum, umaId: number, umpId: number, image: { __typename?: 'Image', src: string, alt: string, srcset: string } }> } | null } };

export type TipEntryFragment = { __typename?: 'TipsEntry', id: string, title: string, teaserText: string, isLabeledNew: boolean, readAt?: any | null, headerImage: { __typename?: 'Image', alt: string, src: string }, experienceTags?: Array<{ __typename?: 'TipsTag', id: string, value?: string | null } | null> | null, intentionTags?: Array<{ __typename?: 'TipsTag', id: string, value?: string | null } | null> | null };

export type TipWithBodyEntryFragment = { __typename?: 'TipsEntry', id: string, title: string, teaserText: string, body: any, isLabeledNew: boolean, readAt?: any | null, headerImage: { __typename?: 'Image', alt: string, src: string }, experienceTags?: Array<{ __typename?: 'TipsTag', id: string, value?: string | null } | null> | null, intentionTags?: Array<{ __typename?: 'TipsTag', id: string, value?: string | null } | null> | null };

export type GetEmailVerificationStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEmailVerificationStatusQuery = { __typename?: 'Query', account: { __typename?: 'Account', isRegistrationComplete: boolean, contact: { __typename?: 'Contact', isCurrentEmailAddressVerified: boolean } } };

export type GetCmsMarkdownQueryVariables = Exact<{
  lang: ApiLangEnum;
  id: Scalars['ID']['input'];
}>;


export type GetCmsMarkdownQuery = { __typename?: 'Query', cms: { __typename?: 'Cms', article?: { __typename?: 'CmsArticle', id: string, lang: ApiLangEnum, title?: string | null, content: string, revision: { __typename?: 'CmsArticleRevision', rev: number, published: any } } | null } };

export type CmsArticleFragment = { __typename?: 'CmsArticle', id: string, lang: ApiLangEnum, title?: string | null, content: string, revision: { __typename?: 'CmsArticleRevision', rev: number, published: any } };

export type GetLegalTermMarkdownQueryVariables = Exact<{
  type: TermsAcceptanceTypeEnum;
}>;


export type GetLegalTermMarkdownQuery = { __typename?: 'Query', terms: { __typename?: 'Terms', acceptance?: { __typename?: 'TermAcceptance', type: TermsAcceptanceTypeEnum, cmsArticle: { __typename?: 'CmsArticle', id: string, lang: ApiLangEnum, type: ContentTypeEnum, content: string, title?: string | null, revision: { __typename?: 'CmsArticleRevision', pdfUrl?: string | null, published: any, modified: any } } } | null } };

export type LegalTermsArticleFragment = { __typename?: 'CmsArticle', id: string, lang: ApiLangEnum, type: ContentTypeEnum, content: string, title?: string | null, revision: { __typename?: 'CmsArticleRevision', pdfUrl?: string | null, published: any, modified: any } };

export type EmailSectionQueryVariables = Exact<{ [key: string]: never; }>;


export type EmailSectionQuery = { __typename?: 'Query', account: { __typename?: 'Account', isRegistrationComplete: boolean, contact: { __typename?: 'Contact', currentEmailAddress: string, isCurrentEmailAddressVerified: boolean } }, profile: { __typename?: 'Profile', collection?: { __typename?: 'ProfileCollectionAccountV1', fields: { __typename?: 'ProfileCollectionAccountV1Fields', accountContactEmailAdress?: { __typename?: 'ProfileFieldTypeString', disabled: boolean, minLength?: number | null, maxLength?: number | null, readOnly: boolean, value?: string | null } | null } } | { __typename?: 'ProfileCollectionMobileAboutMeV1' } | { __typename?: 'ProfileCollectionMobileAppearanceV1' } | { __typename?: 'ProfileCollectionMobileInterviewV1' } | { __typename?: 'ProfileCollectionMobileMediaV1' } | { __typename?: 'ProfileCollectionMobileProfileV1' } | { __typename?: 'ProfileCollectionModelReleaseFormV1' } | { __typename?: 'ProfileCollectionOnboardingV1' } | { __typename?: 'ProfileCollectionPayoutV1' } | null } };

export type EmailSectionFragment = { __typename?: 'ProfileCollectionAccountV1', fields: { __typename?: 'ProfileCollectionAccountV1Fields', accountContactEmailAdress?: { __typename?: 'ProfileFieldTypeString', disabled: boolean, minLength?: number | null, maxLength?: number | null, readOnly: boolean, value?: string | null } | null } };

export type EmailSectionFieldsFragment = { __typename?: 'ProfileCollectionAccountV1Fields', accountContactEmailAdress?: { __typename?: 'ProfileFieldTypeString', disabled: boolean, minLength?: number | null, maxLength?: number | null, readOnly: boolean, value?: string | null } | null };

export type EmailSectionRegistrationUpdateMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type EmailSectionRegistrationUpdateMutation = { __typename?: 'Mutation', account?: { __typename?: 'AccountMutation', changeEmailAddressAndSendRegistrationMail?: { __typename?: 'MutationResult', message?: string | null, success?: boolean | null } | null } | null };

export type EmailSectionResendRegistrationMailMutationVariables = Exact<{ [key: string]: never; }>;


export type EmailSectionResendRegistrationMailMutation = { __typename?: 'Mutation', account?: { __typename?: 'AccountMutation', resendRegistrationMail?: { __typename?: 'MutationResult', message?: string | null, success?: boolean | null } | null } | null };

export type EmailSectionEmailUpdateMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type EmailSectionEmailUpdateMutation = { __typename?: 'Mutation', account?: { __typename?: 'AccountMutation', changeEmailAddressAndSendVerificationMail?: { __typename?: 'MutationResult', message?: string | null, success?: boolean | null } | null } | null };

export type EmailSectionResendVerificationMailMutationVariables = Exact<{ [key: string]: never; }>;


export type EmailSectionResendVerificationMailMutation = { __typename?: 'Mutation', account?: { __typename?: 'AccountMutation', resendVerificationMail?: { __typename?: 'MutationResult', message?: string | null, success?: boolean | null } | null } | null };

export type LanguageSectionQueryVariables = Exact<{ [key: string]: never; }>;


export type LanguageSectionQuery = { __typename?: 'Query', account: { __typename?: 'Account', language: string } };

export type LanguageUpdateMutationVariables = Exact<{
  language: ApiLangEnum;
}>;


export type LanguageUpdateMutation = { __typename?: 'Mutation', account?: { __typename?: 'AccountMutation', saveLanguage?: { __typename?: 'MutationResult', success?: boolean | null, message?: string | null } | null } | null };

export type MobileNumberSectionQueryVariables = Exact<{ [key: string]: never; }>;


export type MobileNumberSectionQuery = { __typename?: 'Query', account: { __typename?: 'Account', contact: { __typename?: 'Contact', isCurrentMobileNumberVerified: boolean, currentMobileNumber?: { __typename?: 'PhoneNumber', fullPhoneNumber: string } | null } }, profile: { __typename?: 'Profile', collection?: { __typename?: 'ProfileCollectionAccountV1', fields: { __typename?: 'ProfileCollectionAccountV1Fields', accountContactMobilePhone?: { __typename?: 'ProfileFieldTypeString', disabled: boolean, minLength?: number | null, maxLength?: number | null, readOnly: boolean, value?: string | null } | null } } | { __typename?: 'ProfileCollectionMobileAboutMeV1' } | { __typename?: 'ProfileCollectionMobileAppearanceV1' } | { __typename?: 'ProfileCollectionMobileInterviewV1' } | { __typename?: 'ProfileCollectionMobileMediaV1' } | { __typename?: 'ProfileCollectionMobileProfileV1' } | { __typename?: 'ProfileCollectionModelReleaseFormV1' } | { __typename?: 'ProfileCollectionOnboardingV1' } | { __typename?: 'ProfileCollectionPayoutV1' } | null } };

export type MobileNumberSectionNumberUpdateMutationVariables = Exact<{
  mobileNumber: Scalars['String']['input'];
}>;


export type MobileNumberSectionNumberUpdateMutation = { __typename?: 'Mutation', account?: { __typename?: 'AccountMutation', changePhoneNumberAndSendVerificationCode?: { __typename?: 'MutationResult', message?: string | null, success?: boolean | null } | null } | null };

export type MobileNumberSectionNumberResendVerificationCodeMutationVariables = Exact<{
  mobileNumber: Scalars['String']['input'];
}>;


export type MobileNumberSectionNumberResendVerificationCodeMutation = { __typename?: 'Mutation', account?: { __typename?: 'AccountMutation', resendVerificationCodeToPhoneNumber?: { __typename?: 'MutationResult', message?: string | null, success?: boolean | null } | null } | null };

export type MobileNumberSectionNumberVerifyMutationVariables = Exact<{
  mobileNumber: Scalars['String']['input'];
  verificationCode: Scalars['String']['input'];
}>;


export type MobileNumberSectionNumberVerifyMutation = { __typename?: 'Mutation', account?: { __typename?: 'AccountMutation', verifyPhoneNumber?: { __typename?: 'MutationResult', message?: string | null, success?: boolean | null } | null } | null };

export type PasswordSectionQueryVariables = Exact<{ [key: string]: never; }>;


export type PasswordSectionQuery = { __typename?: 'Query', account: { __typename?: 'Account', isRegistrationComplete: boolean } };

export type PasswordUpdateMutationVariables = Exact<{
  currentPW: Scalars['String']['input'];
  newPW: Scalars['String']['input'];
}>;


export type PasswordUpdateMutation = { __typename?: 'Mutation', auth?: { __typename?: 'AuthMutation', changePassword?: { __typename: 'PasswordSetResultFail', message: string } | { __typename: 'PasswordSetResultSuccessful', message: string } | null } | null };

export type AccountPersonalSectionQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountPersonalSectionQuery = { __typename?: 'Query', profile: { __typename?: 'Profile', collection?: { __typename?: 'ProfileCollectionAccountV1', fields: { __typename?: 'ProfileCollectionAccountV1Fields', accountBirthdate?: { __typename?: 'ProfileFieldTypeDate', disabled: boolean, readOnly: boolean, value?: any | null } | null, accountFirstname?: { __typename?: 'ProfileFieldTypeString', disabled: boolean, minLength?: number | null, maxLength?: number | null, readOnly: boolean, value?: string | null } | null, accountLastname?: { __typename?: 'ProfileFieldTypeString', disabled: boolean, minLength?: number | null, maxLength?: number | null, readOnly: boolean, value?: string | null } | null } } | { __typename?: 'ProfileCollectionMobileAboutMeV1' } | { __typename?: 'ProfileCollectionMobileAppearanceV1' } | { __typename?: 'ProfileCollectionMobileInterviewV1' } | { __typename?: 'ProfileCollectionMobileMediaV1' } | { __typename?: 'ProfileCollectionMobileProfileV1' } | { __typename?: 'ProfileCollectionModelReleaseFormV1' } | { __typename?: 'ProfileCollectionOnboardingV1' } | { __typename?: 'ProfileCollectionPayoutV1' } | null } };

export type AccountEditPersonalSectionUpdateMutationVariables = Exact<{
  firstname: Scalars['String']['input'];
  lastname: Scalars['String']['input'];
  birthdate: Scalars['Date']['input'];
}>;


export type AccountEditPersonalSectionUpdateMutation = { __typename?: 'Mutation', account?: { __typename?: 'AccountMutation', saveBirthday?: { __typename?: 'MutationResult', message?: string | null, success?: boolean | null } | null, saveName?: { __typename?: 'MutationResult', message?: string | null, success?: boolean | null } | null } | null };

export type GetActorsDocumentsPageQueryVariables = Exact<{ [key: string]: never; }>;


export type GetActorsDocumentsPageQuery = { __typename?: 'Query', account: { __typename?: 'Account', isAllowedToAddNewActor: boolean, hostUserId: number, personalDocuments: { __typename?: 'DocumentsOfHostAccount', identityProofFront?: { __typename?: 'Document', id: number, filename: string, url: string, status: DocumentStatusEnum, rejectionReason?: string | null, side: DocumentSideEnum, isImage: boolean, type: DocumentTypeEnum, typeName: string, uploadDate: any, userId: number } | null, identityProofBack?: { __typename?: 'Document', id: number, filename: string, url: string, status: DocumentStatusEnum, rejectionReason?: string | null, side: DocumentSideEnum, isImage: boolean, type: DocumentTypeEnum, typeName: string, uploadDate: any, userId: number } | null, idShot?: { __typename?: 'Document', id: number, filename: string, url: string, status: DocumentStatusEnum, rejectionReason?: string | null, side: DocumentSideEnum, isImage: boolean, type: DocumentTypeEnum, typeName: string, uploadDate: any, userId: number } | null, modelReleaseForm?: { __typename?: 'Document', id: number, filename: string, url: string, status: DocumentStatusEnum, rejectionReason?: string | null, side: DocumentSideEnum, isImage: boolean, type: DocumentTypeEnum, typeName: string, uploadDate: any, userId: number } | null }, originator?: { __typename?: 'Originator', userId: number, isVerified: boolean, isActor: boolean, isNew: boolean, personalDocumentsStatus: ProfileStatusEnum, financialDocumentsStatus: ProfileStatusEnum, birthday?: any | null, personalDocuments: { __typename?: 'DocumentsPersonalRealPerson', isModelReleaseFormRequired: boolean, isIdShotRequired: boolean, identityProofFront?: { __typename?: 'Document', id: number, filename: string, url: string, status: DocumentStatusEnum, rejectionReason?: string | null, side: DocumentSideEnum, isImage: boolean, type: DocumentTypeEnum, typeName: string, uploadDate: any, userId: number } | null, identityProofBack?: { __typename?: 'Document', id: number, filename: string, url: string, status: DocumentStatusEnum, rejectionReason?: string | null, side: DocumentSideEnum, isImage: boolean, type: DocumentTypeEnum, typeName: string, uploadDate: any, userId: number } | null, idShot?: { __typename?: 'Document', id: number, filename: string, url: string, status: DocumentStatusEnum, rejectionReason?: string | null, side: DocumentSideEnum, isImage: boolean, type: DocumentTypeEnum, typeName: string, uploadDate: any, userId: number } | null, modelReleaseForm?: { __typename?: 'Document', id: number, filename: string, url: string, status: DocumentStatusEnum, rejectionReason?: string | null, side: DocumentSideEnum, isImage: boolean, type: DocumentTypeEnum, typeName: string, uploadDate: any, userId: number } | null }, address?: { __typename?: 'Address', isEditable: boolean, isCompany: boolean, companyName?: string | null, firstname?: string | null, lastname?: string | null, street?: string | null, streetNumber?: string | null, city?: string | null, zipCode?: string | null, countryCode?: string | null } | null } | null, actors: Array<{ __typename?: 'Actor', userId: number, isVerified: boolean, isLeadActor: boolean, isNew: boolean, personalDocumentsStatus: ProfileStatusEnum, birthday?: any | null, personalDocuments: { __typename?: 'DocumentsPersonalRealPerson', isModelReleaseFormRequired: boolean, isIdShotRequired: boolean, identityProofFront?: { __typename?: 'Document', id: number, filename: string, url: string, status: DocumentStatusEnum, rejectionReason?: string | null, side: DocumentSideEnum, isImage: boolean, type: DocumentTypeEnum, typeName: string, uploadDate: any, userId: number } | null, identityProofBack?: { __typename?: 'Document', id: number, filename: string, url: string, status: DocumentStatusEnum, rejectionReason?: string | null, side: DocumentSideEnum, isImage: boolean, type: DocumentTypeEnum, typeName: string, uploadDate: any, userId: number } | null, idShot?: { __typename?: 'Document', id: number, filename: string, url: string, status: DocumentStatusEnum, rejectionReason?: string | null, side: DocumentSideEnum, isImage: boolean, type: DocumentTypeEnum, typeName: string, uploadDate: any, userId: number } | null, modelReleaseForm?: { __typename?: 'Document', id: number, filename: string, url: string, status: DocumentStatusEnum, rejectionReason?: string | null, side: DocumentSideEnum, isImage: boolean, type: DocumentTypeEnum, typeName: string, uploadDate: any, userId: number } | null }, address?: { __typename?: 'Address', isEditable: boolean, isCompany: boolean, companyName?: string | null, firstname?: string | null, lastname?: string | null, street?: string | null, streetNumber?: string | null, city?: string | null, zipCode?: string | null, countryCode?: string | null } | null } | null> } };

export type OriginatorFragment = { __typename?: 'Originator', userId: number, isVerified: boolean, isActor: boolean, isNew: boolean, personalDocumentsStatus: ProfileStatusEnum, financialDocumentsStatus: ProfileStatusEnum, birthday?: any | null, personalDocuments: { __typename?: 'DocumentsPersonalRealPerson', isModelReleaseFormRequired: boolean, isIdShotRequired: boolean, identityProofFront?: { __typename?: 'Document', id: number, filename: string, url: string, status: DocumentStatusEnum, rejectionReason?: string | null, side: DocumentSideEnum, isImage: boolean, type: DocumentTypeEnum, typeName: string, uploadDate: any, userId: number } | null, identityProofBack?: { __typename?: 'Document', id: number, filename: string, url: string, status: DocumentStatusEnum, rejectionReason?: string | null, side: DocumentSideEnum, isImage: boolean, type: DocumentTypeEnum, typeName: string, uploadDate: any, userId: number } | null, idShot?: { __typename?: 'Document', id: number, filename: string, url: string, status: DocumentStatusEnum, rejectionReason?: string | null, side: DocumentSideEnum, isImage: boolean, type: DocumentTypeEnum, typeName: string, uploadDate: any, userId: number } | null, modelReleaseForm?: { __typename?: 'Document', id: number, filename: string, url: string, status: DocumentStatusEnum, rejectionReason?: string | null, side: DocumentSideEnum, isImage: boolean, type: DocumentTypeEnum, typeName: string, uploadDate: any, userId: number } | null }, address?: { __typename?: 'Address', isEditable: boolean, isCompany: boolean, companyName?: string | null, firstname?: string | null, lastname?: string | null, street?: string | null, streetNumber?: string | null, city?: string | null, zipCode?: string | null, countryCode?: string | null } | null };

export type ActorFragment = { __typename?: 'Actor', userId: number, isVerified: boolean, isLeadActor: boolean, isNew: boolean, personalDocumentsStatus: ProfileStatusEnum, birthday?: any | null, personalDocuments: { __typename?: 'DocumentsPersonalRealPerson', isModelReleaseFormRequired: boolean, isIdShotRequired: boolean, identityProofFront?: { __typename?: 'Document', id: number, filename: string, url: string, status: DocumentStatusEnum, rejectionReason?: string | null, side: DocumentSideEnum, isImage: boolean, type: DocumentTypeEnum, typeName: string, uploadDate: any, userId: number } | null, identityProofBack?: { __typename?: 'Document', id: number, filename: string, url: string, status: DocumentStatusEnum, rejectionReason?: string | null, side: DocumentSideEnum, isImage: boolean, type: DocumentTypeEnum, typeName: string, uploadDate: any, userId: number } | null, idShot?: { __typename?: 'Document', id: number, filename: string, url: string, status: DocumentStatusEnum, rejectionReason?: string | null, side: DocumentSideEnum, isImage: boolean, type: DocumentTypeEnum, typeName: string, uploadDate: any, userId: number } | null, modelReleaseForm?: { __typename?: 'Document', id: number, filename: string, url: string, status: DocumentStatusEnum, rejectionReason?: string | null, side: DocumentSideEnum, isImage: boolean, type: DocumentTypeEnum, typeName: string, uploadDate: any, userId: number } | null }, address?: { __typename?: 'Address', isEditable: boolean, isCompany: boolean, companyName?: string | null, firstname?: string | null, lastname?: string | null, street?: string | null, streetNumber?: string | null, city?: string | null, zipCode?: string | null, countryCode?: string | null } | null };

export type AddressFragment = { __typename?: 'Address', isEditable: boolean, isCompany: boolean, companyName?: string | null, firstname?: string | null, lastname?: string | null, street?: string | null, streetNumber?: string | null, city?: string | null, zipCode?: string | null, countryCode?: string | null };

export type DocumentsOfHostAccountFragment = { __typename?: 'DocumentsOfHostAccount', identityProofFront?: { __typename?: 'Document', id: number, filename: string, url: string, status: DocumentStatusEnum, rejectionReason?: string | null, side: DocumentSideEnum, isImage: boolean, type: DocumentTypeEnum, typeName: string, uploadDate: any, userId: number } | null, identityProofBack?: { __typename?: 'Document', id: number, filename: string, url: string, status: DocumentStatusEnum, rejectionReason?: string | null, side: DocumentSideEnum, isImage: boolean, type: DocumentTypeEnum, typeName: string, uploadDate: any, userId: number } | null, idShot?: { __typename?: 'Document', id: number, filename: string, url: string, status: DocumentStatusEnum, rejectionReason?: string | null, side: DocumentSideEnum, isImage: boolean, type: DocumentTypeEnum, typeName: string, uploadDate: any, userId: number } | null, modelReleaseForm?: { __typename?: 'Document', id: number, filename: string, url: string, status: DocumentStatusEnum, rejectionReason?: string | null, side: DocumentSideEnum, isImage: boolean, type: DocumentTypeEnum, typeName: string, uploadDate: any, userId: number } | null };

export type DocumentsPersonalRealPersonFragment = { __typename?: 'DocumentsPersonalRealPerson', isModelReleaseFormRequired: boolean, isIdShotRequired: boolean, identityProofFront?: { __typename?: 'Document', id: number, filename: string, url: string, status: DocumentStatusEnum, rejectionReason?: string | null, side: DocumentSideEnum, isImage: boolean, type: DocumentTypeEnum, typeName: string, uploadDate: any, userId: number } | null, identityProofBack?: { __typename?: 'Document', id: number, filename: string, url: string, status: DocumentStatusEnum, rejectionReason?: string | null, side: DocumentSideEnum, isImage: boolean, type: DocumentTypeEnum, typeName: string, uploadDate: any, userId: number } | null, idShot?: { __typename?: 'Document', id: number, filename: string, url: string, status: DocumentStatusEnum, rejectionReason?: string | null, side: DocumentSideEnum, isImage: boolean, type: DocumentTypeEnum, typeName: string, uploadDate: any, userId: number } | null, modelReleaseForm?: { __typename?: 'Document', id: number, filename: string, url: string, status: DocumentStatusEnum, rejectionReason?: string | null, side: DocumentSideEnum, isImage: boolean, type: DocumentTypeEnum, typeName: string, uploadDate: any, userId: number } | null };

export type DocumentsFinancialRealPersonFragment = { __typename?: 'DocumentsFinancialRealPerson', isProofOfAddressRequired: boolean, isTaxDocumentRequired: boolean, proofOfAddress?: { __typename?: 'Document', id: number, filename: string, url: string, status: DocumentStatusEnum, rejectionReason?: string | null, side: DocumentSideEnum, isImage: boolean, type: DocumentTypeEnum, typeName: string, uploadDate: any, userId: number } | null, taxDocument?: { __typename?: 'Document', id: number, filename: string, url: string, status: DocumentStatusEnum, rejectionReason?: string | null, side: DocumentSideEnum, isImage: boolean, type: DocumentTypeEnum, typeName: string, uploadDate: any, userId: number } | null };

export type DocumentFragment = { __typename?: 'Document', id: number, filename: string, url: string, status: DocumentStatusEnum, rejectionReason?: string | null, side: DocumentSideEnum, isImage: boolean, type: DocumentTypeEnum, typeName: string, uploadDate: any, userId: number };

export type GetDocumentUploadUrlQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
  documentType: DocumentTypeEnum;
  side?: InputMaybe<DocumentSideEnum>;
}>;


export type GetDocumentUploadUrlQuery = { __typename?: 'Query', documents: { __typename?: 'Documents', uploadUrl: string } };

export type GetCreateActorPageQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCreateActorPageQuery = { __typename?: 'Query', account: { __typename?: 'Account', isAllowedToAddNewActor: boolean, originator?: { __typename?: 'Originator', userId: number } | null, actors: Array<{ __typename?: 'Actor', userId: number } | null> } };

export type SaveActorMutationVariables = Exact<{
  data: InputSaveRealPersonData;
}>;


export type SaveActorMutation = { __typename?: 'Mutation', account?: { __typename?: 'AccountMutation', saveActor?: { __typename?: 'SaveRealPersonMutationResult', success: boolean, errorMessage?: string | null, savedActor?: { __typename?: 'Actor', userId: number, isVerified: boolean, isLeadActor: boolean, isNew: boolean, personalDocumentsStatus: ProfileStatusEnum, birthday?: any | null, personalDocuments: { __typename?: 'DocumentsPersonalRealPerson', isModelReleaseFormRequired: boolean, isIdShotRequired: boolean, identityProofFront?: { __typename?: 'Document', id: number, filename: string, url: string, status: DocumentStatusEnum, rejectionReason?: string | null, side: DocumentSideEnum, isImage: boolean, type: DocumentTypeEnum, typeName: string, uploadDate: any, userId: number } | null, identityProofBack?: { __typename?: 'Document', id: number, filename: string, url: string, status: DocumentStatusEnum, rejectionReason?: string | null, side: DocumentSideEnum, isImage: boolean, type: DocumentTypeEnum, typeName: string, uploadDate: any, userId: number } | null, idShot?: { __typename?: 'Document', id: number, filename: string, url: string, status: DocumentStatusEnum, rejectionReason?: string | null, side: DocumentSideEnum, isImage: boolean, type: DocumentTypeEnum, typeName: string, uploadDate: any, userId: number } | null, modelReleaseForm?: { __typename?: 'Document', id: number, filename: string, url: string, status: DocumentStatusEnum, rejectionReason?: string | null, side: DocumentSideEnum, isImage: boolean, type: DocumentTypeEnum, typeName: string, uploadDate: any, userId: number } | null }, address?: { __typename?: 'Address', isEditable: boolean, isCompany: boolean, companyName?: string | null, firstname?: string | null, lastname?: string | null, street?: string | null, streetNumber?: string | null, city?: string | null, zipCode?: string | null, countryCode?: string | null } | null } | null } | null } | null };

export type InitModelReleaseFormMutationVariables = Exact<{
  userId?: InputMaybe<Scalars['Int']['input']>;
  lang?: InputMaybe<ModelReleaseFormLanguageEnum>;
  redirectUrl: Scalars['String']['input'];
}>;


export type InitModelReleaseFormMutation = { __typename?: 'Mutation', documents?: { __typename?: 'DocumentsMutation', initModelReleaseForm: { __typename?: 'FormManagerPaperlessForm', id?: string | null, status: FormStatusEnum, formdata?: any | null, formUrl?: string | null, metadata?: any | null } } | null };

export type DocumentDetailPageQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
}>;


export type DocumentDetailPageQuery = { __typename?: 'Query', account: { __typename?: 'Account', modelVerificationStatus: ModelVerificationStatusEnum, hostUserId: number, personalDocuments: { __typename?: 'DocumentsOfHostAccount', identityProofFront?: { __typename?: 'Document', id: number, filename: string, url: string, status: DocumentStatusEnum, rejectionReason?: string | null, side: DocumentSideEnum, isImage: boolean, type: DocumentTypeEnum, typeName: string, uploadDate: any, userId: number } | null, identityProofBack?: { __typename?: 'Document', id: number, filename: string, url: string, status: DocumentStatusEnum, rejectionReason?: string | null, side: DocumentSideEnum, isImage: boolean, type: DocumentTypeEnum, typeName: string, uploadDate: any, userId: number } | null, idShot?: { __typename?: 'Document', id: number, filename: string, url: string, status: DocumentStatusEnum, rejectionReason?: string | null, side: DocumentSideEnum, isImage: boolean, type: DocumentTypeEnum, typeName: string, uploadDate: any, userId: number } | null, modelReleaseForm?: { __typename?: 'Document', id: number, filename: string, url: string, status: DocumentStatusEnum, rejectionReason?: string | null, side: DocumentSideEnum, isImage: boolean, type: DocumentTypeEnum, typeName: string, uploadDate: any, userId: number } | null }, actor?: { __typename?: 'Actor', userId: number, isVerified: boolean, isLeadActor: boolean, isNew: boolean, personalDocumentsStatus: ProfileStatusEnum, birthday?: any | null, personalDocuments: { __typename?: 'DocumentsPersonalRealPerson', isModelReleaseFormRequired: boolean, isIdShotRequired: boolean, identityProofFront?: { __typename?: 'Document', id: number, filename: string, url: string, status: DocumentStatusEnum, rejectionReason?: string | null, side: DocumentSideEnum, isImage: boolean, type: DocumentTypeEnum, typeName: string, uploadDate: any, userId: number } | null, identityProofBack?: { __typename?: 'Document', id: number, filename: string, url: string, status: DocumentStatusEnum, rejectionReason?: string | null, side: DocumentSideEnum, isImage: boolean, type: DocumentTypeEnum, typeName: string, uploadDate: any, userId: number } | null, idShot?: { __typename?: 'Document', id: number, filename: string, url: string, status: DocumentStatusEnum, rejectionReason?: string | null, side: DocumentSideEnum, isImage: boolean, type: DocumentTypeEnum, typeName: string, uploadDate: any, userId: number } | null, modelReleaseForm?: { __typename?: 'Document', id: number, filename: string, url: string, status: DocumentStatusEnum, rejectionReason?: string | null, side: DocumentSideEnum, isImage: boolean, type: DocumentTypeEnum, typeName: string, uploadDate: any, userId: number } | null }, address?: { __typename?: 'Address', isEditable: boolean, isCompany: boolean, companyName?: string | null, firstname?: string | null, lastname?: string | null, street?: string | null, streetNumber?: string | null, city?: string | null, zipCode?: string | null, countryCode?: string | null } | null } | null, actors: Array<{ __typename?: 'Actor', userId: number, isVerified: boolean, isLeadActor: boolean, isNew: boolean, personalDocumentsStatus: ProfileStatusEnum, birthday?: any | null, personalDocuments: { __typename?: 'DocumentsPersonalRealPerson', isModelReleaseFormRequired: boolean, isIdShotRequired: boolean, identityProofFront?: { __typename?: 'Document', id: number, filename: string, url: string, status: DocumentStatusEnum, rejectionReason?: string | null, side: DocumentSideEnum, isImage: boolean, type: DocumentTypeEnum, typeName: string, uploadDate: any, userId: number } | null, identityProofBack?: { __typename?: 'Document', id: number, filename: string, url: string, status: DocumentStatusEnum, rejectionReason?: string | null, side: DocumentSideEnum, isImage: boolean, type: DocumentTypeEnum, typeName: string, uploadDate: any, userId: number } | null, idShot?: { __typename?: 'Document', id: number, filename: string, url: string, status: DocumentStatusEnum, rejectionReason?: string | null, side: DocumentSideEnum, isImage: boolean, type: DocumentTypeEnum, typeName: string, uploadDate: any, userId: number } | null, modelReleaseForm?: { __typename?: 'Document', id: number, filename: string, url: string, status: DocumentStatusEnum, rejectionReason?: string | null, side: DocumentSideEnum, isImage: boolean, type: DocumentTypeEnum, typeName: string, uploadDate: any, userId: number } | null }, address?: { __typename?: 'Address', isEditable: boolean, isCompany: boolean, companyName?: string | null, firstname?: string | null, lastname?: string | null, street?: string | null, streetNumber?: string | null, city?: string | null, zipCode?: string | null, countryCode?: string | null } | null } | null>, originator?: { __typename?: 'Originator', userId: number, isVerified: boolean, isActor: boolean, isNew: boolean, personalDocumentsStatus: ProfileStatusEnum, financialDocumentsStatus: ProfileStatusEnum, birthday?: any | null, personalDocuments: { __typename?: 'DocumentsPersonalRealPerson', isModelReleaseFormRequired: boolean, isIdShotRequired: boolean, identityProofFront?: { __typename?: 'Document', id: number, filename: string, url: string, status: DocumentStatusEnum, rejectionReason?: string | null, side: DocumentSideEnum, isImage: boolean, type: DocumentTypeEnum, typeName: string, uploadDate: any, userId: number } | null, identityProofBack?: { __typename?: 'Document', id: number, filename: string, url: string, status: DocumentStatusEnum, rejectionReason?: string | null, side: DocumentSideEnum, isImage: boolean, type: DocumentTypeEnum, typeName: string, uploadDate: any, userId: number } | null, idShot?: { __typename?: 'Document', id: number, filename: string, url: string, status: DocumentStatusEnum, rejectionReason?: string | null, side: DocumentSideEnum, isImage: boolean, type: DocumentTypeEnum, typeName: string, uploadDate: any, userId: number } | null, modelReleaseForm?: { __typename?: 'Document', id: number, filename: string, url: string, status: DocumentStatusEnum, rejectionReason?: string | null, side: DocumentSideEnum, isImage: boolean, type: DocumentTypeEnum, typeName: string, uploadDate: any, userId: number } | null }, address?: { __typename?: 'Address', isEditable: boolean, isCompany: boolean, companyName?: string | null, firstname?: string | null, lastname?: string | null, street?: string | null, streetNumber?: string | null, city?: string | null, zipCode?: string | null, countryCode?: string | null } | null } | null }, documents: { __typename?: 'Documents', ageVerificationTour: { __typename?: 'DocumentUploadAssistant', completenessPercent: number } }, mrfTour: { __typename?: 'TourModelReleaseFormV1', status: ProfileStatusEnum, lastVerified?: any | null, completeness: { __typename?: 'ProfileCollectionCompleteness', percent: number } } | { __typename?: 'TourOnboardingV1' } | { __typename?: 'TourPayoutV1' } | { __typename?: 'TourPayoutV2' } };

export type DocumentDetailPageMrfQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
  lang: ModelReleaseFormLanguageEnum;
  requestContext: ModelReleaseFormRequestContextEnum;
}>;


export type DocumentDetailPageMrfQuery = { __typename?: 'Query', documents: { __typename?: 'Documents', modelReleaseForm?: { __typename: 'FormManagerPaperlessForm', id?: string | null, class: string, userId: number, status: FormStatusEnum, formdata?: any | null, formUrl?: string | null, metadata?: any | null, userDocument?: { __typename?: 'Document', id: number, filename: string, url: string, status: DocumentStatusEnum, rejectionReason?: string | null, side: DocumentSideEnum, isImage: boolean, type: DocumentTypeEnum, typeName: string, uploadDate: any, userId: number } | null, paperlessDocument?: { __typename?: 'PaperlessDocument', id: string, name: string, state: string } | null, paperlessSubmission?: { __typename?: 'PaperlessSubmission', name: string } | null } | null } };

export type GetDocumentsPageSubRouterQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
}>;


export type GetDocumentsPageSubRouterQuery = { __typename?: 'Query', account: { __typename?: 'Account', userId: number, originator?: { __typename?: 'Originator', userId: number } | null, actor?: { __typename?: 'Actor', isLeadActor: boolean, userId: number } | null, actors: Array<{ __typename?: 'Actor', userId: number, isLeadActor: boolean } | null> } };

export type GetPayoutDocumentsAddressSectionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPayoutDocumentsAddressSectionQuery = { __typename?: 'Query', payment: { __typename?: 'Payment', billingAddress: { __typename?: 'PaymentBillingAddress', status?: PaymentBillingAddressStatusEnum | null, rejectReasonTitle?: string | null, rejectReason?: string | null, isCompany?: { __typename: 'ProfileFieldTypeBoolean', name: string, status: ProfileStatusEnum, rejectReason?: string | null, value?: boolean | null } | null, companyname?: { __typename: 'ProfileFieldTypeString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, minLength?: number | null, maxLength?: number | null } | null, firstname?: { __typename: 'ProfileFieldTypeString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, minLength?: number | null, maxLength?: number | null } | null, lastname?: { __typename: 'ProfileFieldTypeString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, minLength?: number | null, maxLength?: number | null } | null, street?: { __typename: 'ProfileFieldTypeString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, minLength?: number | null, maxLength?: number | null } | null, streetNumber?: { __typename: 'ProfileFieldTypeString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, minLength?: number | null, maxLength?: number | null } | null, city?: { __typename: 'ProfileFieldTypeString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, minLength?: number | null, maxLength?: number | null } | null, postalCode?: { __typename: 'ProfileFieldTypeString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, minLength?: number | null, maxLength?: number | null } | null, country?: { __typename: 'ProfileFieldTypeEnum', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, quickpickValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }>, validValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }> } | null, document?: { __typename: 'ProfileFieldTypeUploadDocument', name: string, status: ProfileStatusEnum, rejectReason?: string | null, value?: { __typename?: 'UploadDocument', docId: number, expireDate?: any | null, filename: string, url: string, status: DocumentStatusEnum } | null } | null } } };

export type BillingAddressFragment = { __typename?: 'PaymentBillingAddress', status?: PaymentBillingAddressStatusEnum | null, rejectReasonTitle?: string | null, rejectReason?: string | null, isCompany?: { __typename: 'ProfileFieldTypeBoolean', name: string, status: ProfileStatusEnum, rejectReason?: string | null, value?: boolean | null } | null, companyname?: { __typename: 'ProfileFieldTypeString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, minLength?: number | null, maxLength?: number | null } | null, firstname?: { __typename: 'ProfileFieldTypeString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, minLength?: number | null, maxLength?: number | null } | null, lastname?: { __typename: 'ProfileFieldTypeString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, minLength?: number | null, maxLength?: number | null } | null, street?: { __typename: 'ProfileFieldTypeString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, minLength?: number | null, maxLength?: number | null } | null, streetNumber?: { __typename: 'ProfileFieldTypeString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, minLength?: number | null, maxLength?: number | null } | null, city?: { __typename: 'ProfileFieldTypeString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, minLength?: number | null, maxLength?: number | null } | null, postalCode?: { __typename: 'ProfileFieldTypeString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, minLength?: number | null, maxLength?: number | null } | null, country?: { __typename: 'ProfileFieldTypeEnum', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, quickpickValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }>, validValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }> } | null, document?: { __typename: 'ProfileFieldTypeUploadDocument', name: string, status: ProfileStatusEnum, rejectReason?: string | null, value?: { __typename?: 'UploadDocument', docId: number, expireDate?: any | null, filename: string, url: string, status: DocumentStatusEnum } | null } | null };

export type UpdatePayoutDocumentsAddressSectionMutationVariables = Exact<{
  data: InputPaymentBillingAddress;
}>;


export type UpdatePayoutDocumentsAddressSectionMutation = { __typename?: 'Mutation', payment: { __typename?: 'PaymentMutation', billingAddress: { __typename?: 'PaymentBillingAddressMutation', updateBillingAddress?: { __typename?: 'PaymentBillingAddress' } | { __typename: 'ProfileFieldValidationSet', hasErrors: boolean, field: Array<{ __typename: 'ProfileFieldTypeValidationBoolean', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationDate', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationEnum', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationEnumList', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationInt', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationMultiLangString', name: ProfileFieldsEnum, isValid: boolean, multiLangErrors?: Array<{ __typename?: 'ProfileFieldValidationErrorMultiLang', lang: string, message: string }> | null } | { __typename: 'ProfileFieldTypeValidationPicture', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationPictureList', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationString', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationUploadDocument', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null }> } | null } } };

export type GetPayoutDocumentsPayoutSectionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPayoutDocumentsPayoutSectionQuery = { __typename?: 'Query', payment: { __typename?: 'Payment', payoutData: { __typename?: 'PaymentPayoutData', status: string, rejectReasonTitle?: string | null, rejectReason?: string | null, showPaxum: boolean, showBankAccount: boolean, payoutMethod?: { __typename: 'ProfileFieldTypeEnum', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, quickpickValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }>, validValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }> } | null, bankAccountOwner?: { __typename: 'ProfileFieldTypeString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, minLength?: number | null, maxLength?: number | null } | null, bankIban?: { __typename: 'ProfileFieldTypeString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, minLength?: number | null, maxLength?: number | null } | null, bankBic?: { __typename: 'ProfileFieldTypeString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, minLength?: number | null, maxLength?: number | null } | null, paxumEmailAccount?: { __typename: 'ProfileFieldTypeString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, minLength?: number | null, maxLength?: number | null } | null } } };

export type PayoutDataFragment = { __typename?: 'PaymentPayoutData', status: string, rejectReasonTitle?: string | null, rejectReason?: string | null, showPaxum: boolean, showBankAccount: boolean, payoutMethod?: { __typename: 'ProfileFieldTypeEnum', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, quickpickValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }>, validValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }> } | null, bankAccountOwner?: { __typename: 'ProfileFieldTypeString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, minLength?: number | null, maxLength?: number | null } | null, bankIban?: { __typename: 'ProfileFieldTypeString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, minLength?: number | null, maxLength?: number | null } | null, bankBic?: { __typename: 'ProfileFieldTypeString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, minLength?: number | null, maxLength?: number | null } | null, paxumEmailAccount?: { __typename: 'ProfileFieldTypeString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, minLength?: number | null, maxLength?: number | null } | null };

export type UpdatePayoutDocumentsPayoutSectionMutationVariables = Exact<{
  data: InputPaymentPayoutData;
}>;


export type UpdatePayoutDocumentsPayoutSectionMutation = { __typename?: 'Mutation', payment: { __typename?: 'PaymentMutation', payoutData: { __typename?: 'PaymentPayoutDataMutation', updatePayoutData?: { __typename?: 'PaymentPayoutData' } | { __typename: 'ProfileFieldValidationSet', hasErrors: boolean, field: Array<{ __typename: 'ProfileFieldTypeValidationBoolean', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationDate', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationEnum', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationEnumList', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationInt', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationMultiLangString', name: ProfileFieldsEnum, isValid: boolean, multiLangErrors?: Array<{ __typename?: 'ProfileFieldValidationErrorMultiLang', lang: string, message: string }> | null } | { __typename: 'ProfileFieldTypeValidationPicture', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationPictureList', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationString', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationUploadDocument', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null }> } | null } } };

export type GetPayoutDocumentsTaxSectionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPayoutDocumentsTaxSectionQuery = { __typename?: 'Query', payment: { __typename?: 'Payment', taxData: { __typename?: 'PaymentTaxData', status: string, rejectReasonTitle?: string | null, rejectReason?: string | null, showTin: boolean, isDocumentRequired: boolean, isRequired: boolean, isTaxable?: { __typename: 'ProfileFieldTypeBoolean', name: string, status: ProfileStatusEnum, rejectReason?: string | null, value?: boolean | null } | null, taxNumber?: { __typename: 'ProfileFieldTypeString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, minLength?: number | null, maxLength?: number | null } | null, tin?: { __typename: 'ProfileFieldTypeString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, minLength?: number | null, maxLength?: number | null } | null, tinCountry?: { __typename: 'ProfileFieldTypeEnum', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, quickpickValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }>, validValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }> } | null, document?: { __typename: 'ProfileFieldTypeUploadDocument', name: string, status: ProfileStatusEnum, rejectReason?: string | null, value?: { __typename?: 'UploadDocument', docId: number, expireDate?: any | null, filename: string, url: string, status: DocumentStatusEnum } | null } | null } } };

export type TaxDataFragment = { __typename?: 'PaymentTaxData', status: string, rejectReasonTitle?: string | null, rejectReason?: string | null, showTin: boolean, isDocumentRequired: boolean, isRequired: boolean, isTaxable?: { __typename: 'ProfileFieldTypeBoolean', name: string, status: ProfileStatusEnum, rejectReason?: string | null, value?: boolean | null } | null, taxNumber?: { __typename: 'ProfileFieldTypeString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, minLength?: number | null, maxLength?: number | null } | null, tin?: { __typename: 'ProfileFieldTypeString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, minLength?: number | null, maxLength?: number | null } | null, tinCountry?: { __typename: 'ProfileFieldTypeEnum', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, quickpickValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }>, validValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }> } | null, document?: { __typename: 'ProfileFieldTypeUploadDocument', name: string, status: ProfileStatusEnum, rejectReason?: string | null, value?: { __typename?: 'UploadDocument', docId: number, expireDate?: any | null, filename: string, url: string, status: DocumentStatusEnum } | null } | null };

export type UpdatePayoutDocumentsTaxSectionMutationVariables = Exact<{
  data: InputPaymentTaxData;
}>;


export type UpdatePayoutDocumentsTaxSectionMutation = { __typename?: 'Mutation', payment: { __typename?: 'PaymentMutation', taxData: { __typename?: 'PaymentTaxDataMutation', updateTaxData?: { __typename?: 'PaymentTaxData' } | { __typename: 'ProfileFieldValidationSet', hasErrors: boolean, field: Array<{ __typename: 'ProfileFieldTypeValidationBoolean', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationDate', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationEnum', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationEnumList', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationInt', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationMultiLangString', name: ProfileFieldsEnum, isValid: boolean, multiLangErrors?: Array<{ __typename?: 'ProfileFieldValidationErrorMultiLang', lang: string, message: string }> | null } | { __typename: 'ProfileFieldTypeValidationPicture', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationPictureList', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationString', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationUploadDocument', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null }> } | null } } };

export type FeedPageQueryVariables = Exact<{ [key: string]: never; }>;


export type FeedPageQuery = { __typename?: 'Query', profile: { __typename?: 'Profile', mediaCollection?: { __typename?: 'ProfileCollectionAccountV1' } | { __typename?: 'ProfileCollectionMobileAboutMeV1' } | { __typename?: 'ProfileCollectionMobileAppearanceV1' } | { __typename?: 'ProfileCollectionMobileInterviewV1' } | { __typename?: 'ProfileCollectionMobileMediaV1', fields: { __typename?: 'ProfileCollectionMobileMediaV1Fields', modelPictureFSK16Avatar?: { __typename: 'ProfileFieldTypePicture', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: { __typename?: 'MediaPicture', umaId: number, umpId: number, type: string, rejectReason?: string | null, status: MediaPictureStatusEnum, image: { __typename?: 'Image', src: string, alt: string, srcset: string } } | null } | null, modelPictureTitleLandscape?: { __typename: 'ProfileFieldTypePicture', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: { __typename?: 'MediaPicture', umaId: number, umpId: number, type: string, rejectReason?: string | null, status: MediaPictureStatusEnum, image: { __typename?: 'Image', src: string, alt: string, srcset: string } } | null } | null } } | { __typename?: 'ProfileCollectionMobileProfileV1' } | { __typename?: 'ProfileCollectionModelReleaseFormV1' } | { __typename?: 'ProfileCollectionOnboardingV1' } | { __typename?: 'ProfileCollectionPayoutV1' } | null, aboutMeCollection?: { __typename?: 'ProfileCollectionAccountV1' } | { __typename?: 'ProfileCollectionMobileAboutMeV1', fields: { __typename?: 'ProfileCollectionMobileAboutMeV1Fields', modelUsername?: { __typename?: 'ProfileFieldTypeString', value?: string | null } | null } } | { __typename?: 'ProfileCollectionMobileAppearanceV1' } | { __typename?: 'ProfileCollectionMobileInterviewV1' } | { __typename?: 'ProfileCollectionMobileMediaV1' } | { __typename?: 'ProfileCollectionMobileProfileV1' } | { __typename?: 'ProfileCollectionModelReleaseFormV1' } | { __typename?: 'ProfileCollectionOnboardingV1' } | { __typename?: 'ProfileCollectionPayoutV1' } | null } };

export type GetFinancesForFinancePageQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFinancesForFinancePageQuery = { __typename?: 'Query', account: { __typename?: 'Account', userName: string, isAccountFromGermany: boolean, isAccountFromEU: boolean, signupDate: any }, tour: { __typename?: 'TourModelReleaseFormV1' } | { __typename?: 'TourOnboardingV1' } | { __typename?: 'TourPayoutV1', status: ProfileStatusEnum, active: boolean } | { __typename?: 'TourPayoutV2' }, finances: { __typename?: 'Finances', payoutStatus: { __typename?: 'FinancesPayoutStatus', isFirstPayout: boolean, payoutDate?: any | null, status: FinancesPayoutStatusEnum, minimalPayableAmount: number, payableAmount: number } } };

export type GetPayoutTourStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPayoutTourStatusQuery = { __typename?: 'Query', tour: { __typename?: 'TourModelReleaseFormV1' } | { __typename?: 'TourOnboardingV1' } | { __typename?: 'TourPayoutV1', status: ProfileStatusEnum } | { __typename?: 'TourPayoutV2' } };

export type RequestManualPayoutMutationVariables = Exact<{ [key: string]: never; }>;


export type RequestManualPayoutMutation = { __typename?: 'Mutation', finances?: { __typename?: 'FinancesMutation', payoutStatus: { __typename?: 'FinancesPayoutStatus', status: FinancesPayoutStatusEnum } } | null };

export type CancelManualPayoutMutationVariables = Exact<{ [key: string]: never; }>;


export type CancelManualPayoutMutation = { __typename?: 'Mutation', finances?: { __typename?: 'FinancesMutation', payoutStatus: { __typename?: 'FinancesPayoutStatus', status: FinancesPayoutStatusEnum } } | null };

export type GetPayoutTimeTableQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPayoutTimeTableQuery = { __typename?: 'Query', finances: { __typename?: 'Finances', payoutTimeTable: Array<{ __typename?: 'FinancesPayoutTimeTable', billingFromDate: any, billingEndDate: any, payoutDate: any } | null> } };

export type GetPayoutAssistantSectionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPayoutAssistantSectionQuery = { __typename?: 'Query', finances: { __typename?: 'Finances', payoutAssistant: { __typename?: 'FinancesPayoutAssistant', isAssistantAllowed: boolean, currentMinAmount: number, allowedAmounts: Array<number | null>, currentRhythm: { __typename?: 'FinancesPayoutAssistantRhythmItem', id: FinancesPayoutAssistantRhythmEnum, label: string, nextPossiblePayoutDate?: any | null }, allowedRhythms: Array<{ __typename?: 'FinancesPayoutAssistantRhythmItem', id: FinancesPayoutAssistantRhythmEnum, label: string, nextPossiblePayoutDate?: any | null } | null> }, payoutStatus: { __typename?: 'FinancesPayoutStatus', status: FinancesPayoutStatusEnum } } };

export type SetPayoutAssistantSettingsMutationVariables = Exact<{
  targetRhythm: FinancesPayoutAssistantRhythmEnum;
  targetAmount: Scalars['Float']['input'];
}>;


export type SetPayoutAssistantSettingsMutation = { __typename?: 'Mutation', finances?: { __typename?: 'FinancesMutation', savePayoutAssistant: { __typename?: 'MutationResult', success?: boolean | null, message?: string | null } } | null };

export type GetPayoutBillingsSectionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPayoutBillingsSectionQuery = { __typename?: 'Query', account: { __typename?: 'Account', signupDate: any } };

export type GetBillingsListQueryVariables = Exact<{
  year: Scalars['Int']['input'];
}>;


export type GetBillingsListQuery = { __typename?: 'Query', finances: { __typename?: 'Finances', billings: Array<{ __typename?: 'FinancesBilling', amount: number, billNumber: string, billingStartDate: any, billingEndDate: any, company: FinancesBillingCompanyEnum, companyName: string, id: number, issueDate: any, status?: FinancesBillingStatusEnum | null, type: FinancesBillingTypeEnum } | null> } };

export type FinancesBillingFragment = { __typename?: 'FinancesBilling', amount: number, billNumber: string, billingStartDate: any, billingEndDate: any, company: FinancesBillingCompanyEnum, companyName: string, id: number, issueDate: any, status?: FinancesBillingStatusEnum | null, type: FinancesBillingTypeEnum };

export type GetPayoutWithdrawalsSectionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPayoutWithdrawalsSectionQuery = { __typename?: 'Query', account: { __typename?: 'Account', signupDate: any }, finances: { __typename?: 'Finances', invoices: { __typename?: 'FinancesInvoices', maxDate?: any | null, minDate?: any | null } } };

export type GetInvoicesListQueryVariables = Exact<{
  year: Scalars['Int']['input'];
}>;


export type GetInvoicesListQuery = { __typename?: 'Query', finances: { __typename?: 'Finances', invoices: { __typename?: 'FinancesInvoices', invoices?: Array<{ __typename?: 'FinancesInvoice', amount: number, payoutDate: any, status: FinancesInvoiceStatusEnum, message: string, billingStartDate: any, billingEndDate: any } | null> | null } } };

export type FinancesInvoicesFragment = { __typename?: 'FinancesInvoices', invoices?: Array<{ __typename?: 'FinancesInvoice', amount: number, payoutDate: any, status: FinancesInvoiceStatusEnum, message: string, billingStartDate: any, billingEndDate: any } | null> | null };

export type FinancesInvoiceFragment = { __typename?: 'FinancesInvoice', amount: number, payoutDate: any, status: FinancesInvoiceStatusEnum, message: string, billingStartDate: any, billingEndDate: any };

export type GetUnauthorizedHelpCenterPageDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUnauthorizedHelpCenterPageDataQuery = { __typename?: 'Query', support: { __typename?: 'Support', available: Array<SupportAgentTypeEnum>, mailto: string, tel: string } };

export type GetHelpCenterPageDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetHelpCenterPageDataQuery = { __typename?: 'Query', app: { __typename?: 'App', hotlineCode?: string | null }, helpcenter: { __typename?: 'Helpcenter', url?: string | null }, support: { __typename?: 'Support', available: Array<SupportAgentTypeEnum>, mailto: string, tel: string }, account: { __typename?: 'Account', keyAccounter?: { __typename?: 'KeyAccounter', name: string, email?: string | null, phoneNumber?: string | null } | null }, profile: { __typename?: 'Profile', mediaCollection?: { __typename?: 'ProfileCollectionAccountV1' } | { __typename?: 'ProfileCollectionMobileAboutMeV1' } | { __typename?: 'ProfileCollectionMobileAppearanceV1' } | { __typename?: 'ProfileCollectionMobileInterviewV1' } | { __typename?: 'ProfileCollectionMobileMediaV1', values: { __typename?: 'ProfileCollectionMobileMediaV1Values', modelPictureFSK16Avatar?: { __typename?: 'MediaPicture', image: { __typename?: 'Image', src: string } } | null } } | { __typename?: 'ProfileCollectionMobileProfileV1' } | { __typename?: 'ProfileCollectionModelReleaseFormV1' } | { __typename?: 'ProfileCollectionOnboardingV1' } | { __typename?: 'ProfileCollectionPayoutV1' } | null, collection?: { __typename?: 'ProfileCollectionAccountV1', values: { __typename?: 'ProfileCollectionAccountV1Values', accountContactEmailAdress?: string | null } } | { __typename?: 'ProfileCollectionMobileAboutMeV1' } | { __typename?: 'ProfileCollectionMobileAppearanceV1' } | { __typename?: 'ProfileCollectionMobileInterviewV1' } | { __typename?: 'ProfileCollectionMobileMediaV1' } | { __typename?: 'ProfileCollectionMobileProfileV1' } | { __typename?: 'ProfileCollectionModelReleaseFormV1' } | { __typename?: 'ProfileCollectionOnboardingV1' } | { __typename?: 'ProfileCollectionPayoutV1' } | null } };

export type GetHomeDataQueryVariables = Exact<{
  actorId: Scalars['Int']['input'];
}>;


export type GetHomeDataQuery = { __typename?: 'Query', account: { __typename?: 'Account', wasOnlineOnVXLive: boolean, isModelVerified: boolean, contact: { __typename?: 'Contact', currentEmailAddress: string, isCurrentEmailAddressVerified: boolean }, actor?: { __typename?: 'Actor', userId: number, isVerified: boolean, isLeadActor: boolean, isNew: boolean, personalDocumentsStatus: ProfileStatusEnum, birthday?: any | null, personalDocuments: { __typename?: 'DocumentsPersonalRealPerson', isModelReleaseFormRequired: boolean, isIdShotRequired: boolean, identityProofFront?: { __typename?: 'Document', id: number, filename: string, url: string, status: DocumentStatusEnum, rejectionReason?: string | null, side: DocumentSideEnum, isImage: boolean, type: DocumentTypeEnum, typeName: string, uploadDate: any, userId: number } | null, identityProofBack?: { __typename?: 'Document', id: number, filename: string, url: string, status: DocumentStatusEnum, rejectionReason?: string | null, side: DocumentSideEnum, isImage: boolean, type: DocumentTypeEnum, typeName: string, uploadDate: any, userId: number } | null, idShot?: { __typename?: 'Document', id: number, filename: string, url: string, status: DocumentStatusEnum, rejectionReason?: string | null, side: DocumentSideEnum, isImage: boolean, type: DocumentTypeEnum, typeName: string, uploadDate: any, userId: number } | null, modelReleaseForm?: { __typename?: 'Document', id: number, filename: string, url: string, status: DocumentStatusEnum, rejectionReason?: string | null, side: DocumentSideEnum, isImage: boolean, type: DocumentTypeEnum, typeName: string, uploadDate: any, userId: number } | null }, address?: { __typename?: 'Address', isEditable: boolean, isCompany: boolean, companyName?: string | null, firstname?: string | null, lastname?: string | null, street?: string | null, streetNumber?: string | null, city?: string | null, zipCode?: string | null, countryCode?: string | null } | null } | null, actors: Array<{ __typename?: 'Actor', userId: number, isVerified: boolean, isLeadActor: boolean, isNew: boolean, personalDocumentsStatus: ProfileStatusEnum, birthday?: any | null, personalDocuments: { __typename?: 'DocumentsPersonalRealPerson', isModelReleaseFormRequired: boolean, isIdShotRequired: boolean, identityProofFront?: { __typename?: 'Document', id: number, filename: string, url: string, status: DocumentStatusEnum, rejectionReason?: string | null, side: DocumentSideEnum, isImage: boolean, type: DocumentTypeEnum, typeName: string, uploadDate: any, userId: number } | null, identityProofBack?: { __typename?: 'Document', id: number, filename: string, url: string, status: DocumentStatusEnum, rejectionReason?: string | null, side: DocumentSideEnum, isImage: boolean, type: DocumentTypeEnum, typeName: string, uploadDate: any, userId: number } | null, idShot?: { __typename?: 'Document', id: number, filename: string, url: string, status: DocumentStatusEnum, rejectionReason?: string | null, side: DocumentSideEnum, isImage: boolean, type: DocumentTypeEnum, typeName: string, uploadDate: any, userId: number } | null, modelReleaseForm?: { __typename?: 'Document', id: number, filename: string, url: string, status: DocumentStatusEnum, rejectionReason?: string | null, side: DocumentSideEnum, isImage: boolean, type: DocumentTypeEnum, typeName: string, uploadDate: any, userId: number } | null }, address?: { __typename?: 'Address', isEditable: boolean, isCompany: boolean, companyName?: string | null, firstname?: string | null, lastname?: string | null, street?: string | null, streetNumber?: string | null, city?: string | null, zipCode?: string | null, countryCode?: string | null } | null } | null>, originator?: { __typename?: 'Originator', userId: number, isVerified: boolean, isActor: boolean, isNew: boolean, personalDocumentsStatus: ProfileStatusEnum, financialDocumentsStatus: ProfileStatusEnum, birthday?: any | null, personalDocuments: { __typename?: 'DocumentsPersonalRealPerson', isModelReleaseFormRequired: boolean, isIdShotRequired: boolean, identityProofFront?: { __typename?: 'Document', id: number, filename: string, url: string, status: DocumentStatusEnum, rejectionReason?: string | null, side: DocumentSideEnum, isImage: boolean, type: DocumentTypeEnum, typeName: string, uploadDate: any, userId: number } | null, identityProofBack?: { __typename?: 'Document', id: number, filename: string, url: string, status: DocumentStatusEnum, rejectionReason?: string | null, side: DocumentSideEnum, isImage: boolean, type: DocumentTypeEnum, typeName: string, uploadDate: any, userId: number } | null, idShot?: { __typename?: 'Document', id: number, filename: string, url: string, status: DocumentStatusEnum, rejectionReason?: string | null, side: DocumentSideEnum, isImage: boolean, type: DocumentTypeEnum, typeName: string, uploadDate: any, userId: number } | null, modelReleaseForm?: { __typename?: 'Document', id: number, filename: string, url: string, status: DocumentStatusEnum, rejectionReason?: string | null, side: DocumentSideEnum, isImage: boolean, type: DocumentTypeEnum, typeName: string, uploadDate: any, userId: number } | null }, address?: { __typename?: 'Address', isEditable: boolean, isCompany: boolean, companyName?: string | null, firstname?: string | null, lastname?: string | null, street?: string | null, streetNumber?: string | null, city?: string | null, zipCode?: string | null, countryCode?: string | null } | null } | null }, helpcenter: { __typename?: 'Helpcenter', faq?: { __typename?: 'HelpcenterFaq', entries: Array<{ __typename?: 'HelpcenterFaqEntry', answer: any, question: any } | null> } | null }, finances: { __typename?: 'Finances', payoutStatus: { __typename?: 'FinancesPayoutStatus', isFirstPayout: boolean, payableAmount: number, status: FinancesPayoutStatusEnum } }, profile: { __typename?: 'Profile', collection?: { __typename?: 'ProfileCollectionAccountV1' } | { __typename?: 'ProfileCollectionMobileAboutMeV1', fields: { __typename?: 'ProfileCollectionMobileAboutMeV1Fields', modelGender?: { __typename?: 'ProfileFieldTypeEnum', value?: string | null } | null } } | { __typename?: 'ProfileCollectionMobileAppearanceV1' } | { __typename?: 'ProfileCollectionMobileInterviewV1' } | { __typename?: 'ProfileCollectionMobileMediaV1' } | { __typename?: 'ProfileCollectionMobileProfileV1' } | { __typename?: 'ProfileCollectionModelReleaseFormV1' } | { __typename?: 'ProfileCollectionOnboardingV1' } | { __typename?: 'ProfileCollectionPayoutV1' } | null } };

export type HelpCenterHomeFragment = { __typename?: 'Helpcenter', faq?: { __typename?: 'HelpcenterFaq', entries: Array<{ __typename?: 'HelpcenterFaqEntry', answer: any, question: any } | null> } | null };

export type HelpCenterFaqEntryHomeFragment = { __typename?: 'HelpcenterFaqEntry', answer: any, question: any };

export type GetVerifyEmailModalDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetVerifyEmailModalDataQuery = { __typename?: 'Query', account: { __typename?: 'Account', isRegistrationComplete: boolean, contact: { __typename?: 'Contact', currentEmailAddress: string, isCurrentEmailAddressVerified: boolean } } };

export type EmailVerificationModalResendEmailMutationVariables = Exact<{ [key: string]: never; }>;


export type EmailVerificationModalResendEmailMutation = { __typename?: 'Mutation', account?: { __typename?: 'AccountMutation', resendRegistrationMail?: { __typename?: 'MutationResult', success?: boolean | null, message?: string | null } | null } | null };

export type GetIncomeSourceSectionDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetIncomeSourceSectionDataQuery = { __typename?: 'Query', helpcenter: { __typename?: 'Helpcenter', incomeSources?: { __typename?: 'IncomeSources', entries: Array<{ __typename?: 'IncomeSourcesEntry', id: string, title: string, teaserText: string, isLabeledNew: boolean, activatedAt?: any | null, readAt?: any | null, headerImage: { __typename?: 'Image', alt: string, src: string }, experienceTags?: Array<{ __typename?: 'TipsTag', id: string, value?: string | null } | null> | null, intentionTags?: Array<{ __typename?: 'TipsTag', id: string, value?: string | null } | null> | null } | null> } | null } };

export type GetStatisticSectionQueryVariables = Exact<{
  startDate: Scalars['Date']['input'];
  endDate: Scalars['Date']['input'];
  prevStartDate: Scalars['Date']['input'];
  prevEndDate: Scalars['Date']['input'];
}>;


export type GetStatisticSectionQuery = { __typename?: 'Query', previous: { __typename?: 'Finances', turnoverForPeriodTotal: number }, current: { __typename?: 'Finances', turnoverForPeriodTotal: number, turnoverForPeriodGroupedByDay?: Array<{ __typename?: 'StatisticDaily', date: any, value: number } | null> | null } };

export type GetTipSectionDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTipSectionDataQuery = { __typename?: 'Query', helpcenter: { __typename?: 'Helpcenter', tips?: { __typename?: 'Tips', entries: Array<{ __typename?: 'TipsEntry', id: string, title: string, teaserText: string, isLabeledNew: boolean, readAt?: any | null, headerImage: { __typename?: 'Image', alt: string, src: string }, experienceTags?: Array<{ __typename?: 'TipsTag', id: string, value?: string | null } | null> | null, intentionTags?: Array<{ __typename?: 'TipsTag', id: string, value?: string | null } | null> | null } | null> } | null } };

export type ModelProfilePageQueryVariables = Exact<{ [key: string]: never; }>;


export type ModelProfilePageQuery = { __typename?: 'Query', account: { __typename?: 'Account', userName: string }, profile: { __typename?: 'Profile', mediaCollection?: { __typename?: 'ProfileCollectionAccountV1' } | { __typename?: 'ProfileCollectionMobileAboutMeV1' } | { __typename?: 'ProfileCollectionMobileAppearanceV1' } | { __typename?: 'ProfileCollectionMobileInterviewV1' } | { __typename?: 'ProfileCollectionMobileMediaV1', fields: { __typename?: 'ProfileCollectionMobileMediaV1Fields', modelPictureFSK16Avatar?: { __typename: 'ProfileFieldTypePicture', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: { __typename?: 'MediaPicture', umaId: number, umpId: number, type: string, rejectReason?: string | null, status: MediaPictureStatusEnum, image: { __typename?: 'Image', src: string, alt: string, srcset: string } } | null } | null, modelPictureTitleLandscape?: { __typename: 'ProfileFieldTypePicture', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: { __typename?: 'MediaPicture', umaId: number, umpId: number, type: string, rejectReason?: string | null, status: MediaPictureStatusEnum, image: { __typename?: 'Image', src: string, alt: string, srcset: string } } | null } | null }, values: { __typename?: 'ProfileCollectionMobileMediaV1Values', modelPictureFSK16Avatar?: { __typename?: 'MediaPicture', umaId: number, umpId: number, type: string, rejectReason?: string | null, status: MediaPictureStatusEnum, image: { __typename?: 'Image', src: string, alt: string, srcset: string } } | null, modelPictureTitleLandscape?: { __typename?: 'MediaPicture', umaId: number, umpId: number, type: string, rejectReason?: string | null, status: MediaPictureStatusEnum, image: { __typename?: 'Image', src: string, alt: string, srcset: string } } | null } } | { __typename?: 'ProfileCollectionMobileProfileV1' } | { __typename?: 'ProfileCollectionModelReleaseFormV1' } | { __typename?: 'ProfileCollectionOnboardingV1' } | { __typename?: 'ProfileCollectionPayoutV1' } | null } };

export type ModelProfileParentQueryVariables = Exact<{ [key: string]: never; }>;


export type ModelProfileParentQuery = { __typename?: 'Query', profile: { __typename?: 'Profile', collection?: { __typename?: 'ProfileCollectionAccountV1' } | { __typename?: 'ProfileCollectionMobileAboutMeV1' } | { __typename?: 'ProfileCollectionMobileAppearanceV1' } | { __typename?: 'ProfileCollectionMobileInterviewV1' } | { __typename?: 'ProfileCollectionMobileMediaV1' } | { __typename?: 'ProfileCollectionMobileProfileV1', fields: { __typename?: 'ProfileCollectionMobileProfileV1Fields', modelPictureAvatar?: { __typename?: 'ProfileFieldTypePicture', status: ProfileStatusEnum } | null } } | { __typename?: 'ProfileCollectionModelReleaseFormV1' } | { __typename?: 'ProfileCollectionOnboardingV1' } | { __typename?: 'ProfileCollectionPayoutV1' } | null }, tour: { __typename?: 'TourModelReleaseFormV1' } | { __typename?: 'TourOnboardingV1', lastVerified?: any | null, completeness: { __typename?: 'ProfileCollectionCompleteness', percent: number } } | { __typename?: 'TourPayoutV1' } | { __typename?: 'TourPayoutV2' } };

export type ModelProfileParentMobileProfileFragment = { __typename?: 'ProfileCollectionMobileProfileV1', fields: { __typename?: 'ProfileCollectionMobileProfileV1Fields', modelPictureAvatar?: { __typename?: 'ProfileFieldTypePicture', status: ProfileStatusEnum } | null } };

export type ModelProfileParentWizardFragment = { __typename?: 'TourOnboardingV1', lastVerified?: any | null, completeness: { __typename?: 'ProfileCollectionCompleteness', percent: number } };

export type MediaPictureFragment = { __typename?: 'MediaPicture', umaId: number, umpId: number, type: string, rejectReason?: string | null, status: MediaPictureStatusEnum, image: { __typename?: 'Image', src: string, alt: string, srcset: string } };

export type MediaPictureInListFragment = { __typename?: 'MediaPicture', type: string, fsk: number, rejectReason?: string | null, position: number, status: MediaPictureStatusEnum, umaId: number, umpId: number, image: { __typename?: 'Image', src: string, alt: string, srcset: string } };

export type ImageFragment = { __typename?: 'Image', src: string, alt: string, srcset: string };

export type UploadInfoFragment = { __typename?: 'UploadInfo', errorCodes?: any | null, requiredFormData?: any | null, url?: string | null };

export type SaveProfileDataMutationVariables = Exact<{
  aboutMeData: InputProfileCollectionMobileAboutMeV1;
  mediaData: InputProfileCollectionMobileMediaV1;
  appearanceData: InputProfileCollectionMobileAppearanceV1;
  interviewData: InputProfileCollectionMobileInterviewV1;
}>;


export type SaveProfileDataMutation = { __typename?: 'Mutation', profile?: { __typename?: 'ProfileMutation', aboutMeCollection?: { __typename?: 'ProfileCollectionAccountV1Mutation' } | { __typename?: 'ProfileCollectionMobileAboutMeV1Mutation', update: { __typename?: 'ProfileCollectionMobileAboutMeV1' } | { __typename: 'ProfileFieldValidationSet', hasErrors: boolean, field: Array<{ __typename: 'ProfileFieldTypeValidationBoolean', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationDate', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationEnum', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationEnumList', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationInt', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationMultiLangString', name: ProfileFieldsEnum, isValid: boolean, multiLangErrors?: Array<{ __typename?: 'ProfileFieldValidationErrorMultiLang', lang: string, message: string }> | null } | { __typename: 'ProfileFieldTypeValidationPicture', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationPictureList', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationString', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationUploadDocument', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null }> } } | { __typename?: 'ProfileCollectionMobileAppearanceV1Mutation' } | { __typename?: 'ProfileCollectionMobileInterviewV1Mutation' } | { __typename?: 'ProfileCollectionMobileMediaV1Mutation' } | { __typename?: 'ProfileCollectionMobileProfileV1Mutation' } | { __typename?: 'ProfileCollectionModelReleaseFormV1Mutation' } | { __typename?: 'ProfileCollectionOnboardingV1Mutation' } | { __typename?: 'ProfileCollectionPayoutV1Mutation' } | null, appearanceCollection?: { __typename?: 'ProfileCollectionAccountV1Mutation' } | { __typename?: 'ProfileCollectionMobileAboutMeV1Mutation' } | { __typename?: 'ProfileCollectionMobileAppearanceV1Mutation', update: { __typename?: 'ProfileCollectionMobileAppearanceV1' } | { __typename: 'ProfileFieldValidationSet', hasErrors: boolean, field: Array<{ __typename: 'ProfileFieldTypeValidationBoolean', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationDate', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationEnum', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationEnumList', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationInt', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationMultiLangString', name: ProfileFieldsEnum, isValid: boolean, multiLangErrors?: Array<{ __typename?: 'ProfileFieldValidationErrorMultiLang', lang: string, message: string }> | null } | { __typename: 'ProfileFieldTypeValidationPicture', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationPictureList', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationString', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationUploadDocument', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null }> } } | { __typename?: 'ProfileCollectionMobileInterviewV1Mutation' } | { __typename?: 'ProfileCollectionMobileMediaV1Mutation' } | { __typename?: 'ProfileCollectionMobileProfileV1Mutation' } | { __typename?: 'ProfileCollectionModelReleaseFormV1Mutation' } | { __typename?: 'ProfileCollectionOnboardingV1Mutation' } | { __typename?: 'ProfileCollectionPayoutV1Mutation' } | null, interviewCollection?: { __typename?: 'ProfileCollectionAccountV1Mutation' } | { __typename?: 'ProfileCollectionMobileAboutMeV1Mutation' } | { __typename?: 'ProfileCollectionMobileAppearanceV1Mutation' } | { __typename?: 'ProfileCollectionMobileInterviewV1Mutation', update: { __typename?: 'ProfileCollectionMobileInterviewV1' } | { __typename: 'ProfileFieldValidationSet', hasErrors: boolean, field: Array<{ __typename: 'ProfileFieldTypeValidationBoolean', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationDate', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationEnum', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationEnumList', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationInt', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationMultiLangString', name: ProfileFieldsEnum, isValid: boolean, multiLangErrors?: Array<{ __typename?: 'ProfileFieldValidationErrorMultiLang', lang: string, message: string }> | null } | { __typename: 'ProfileFieldTypeValidationPicture', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationPictureList', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationString', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationUploadDocument', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null }> } } | { __typename?: 'ProfileCollectionMobileMediaV1Mutation' } | { __typename?: 'ProfileCollectionMobileProfileV1Mutation' } | { __typename?: 'ProfileCollectionModelReleaseFormV1Mutation' } | { __typename?: 'ProfileCollectionOnboardingV1Mutation' } | { __typename?: 'ProfileCollectionPayoutV1Mutation' } | null, mediaCollection?: { __typename?: 'ProfileCollectionAccountV1Mutation' } | { __typename?: 'ProfileCollectionMobileAboutMeV1Mutation' } | { __typename?: 'ProfileCollectionMobileAppearanceV1Mutation' } | { __typename?: 'ProfileCollectionMobileInterviewV1Mutation' } | { __typename?: 'ProfileCollectionMobileMediaV1Mutation', update: { __typename?: 'ProfileCollectionMobileMediaV1' } | { __typename: 'ProfileFieldValidationSet', hasErrors: boolean, field: Array<{ __typename: 'ProfileFieldTypeValidationBoolean', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationDate', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationEnum', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationEnumList', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationInt', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationMultiLangString', name: ProfileFieldsEnum, isValid: boolean, multiLangErrors?: Array<{ __typename?: 'ProfileFieldValidationErrorMultiLang', lang: string, message: string }> | null } | { __typename: 'ProfileFieldTypeValidationPicture', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationPictureList', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationString', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationUploadDocument', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null }> } } | { __typename?: 'ProfileCollectionMobileProfileV1Mutation' } | { __typename?: 'ProfileCollectionModelReleaseFormV1Mutation' } | { __typename?: 'ProfileCollectionOnboardingV1Mutation' } | { __typename?: 'ProfileCollectionPayoutV1Mutation' } | null } | null };

type ProfileFieldValidation_ProfileFieldTypeValidationBoolean_Fragment = { __typename: 'ProfileFieldTypeValidationBoolean', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null };

type ProfileFieldValidation_ProfileFieldTypeValidationDate_Fragment = { __typename: 'ProfileFieldTypeValidationDate', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null };

type ProfileFieldValidation_ProfileFieldTypeValidationEnum_Fragment = { __typename: 'ProfileFieldTypeValidationEnum', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null };

type ProfileFieldValidation_ProfileFieldTypeValidationEnumList_Fragment = { __typename: 'ProfileFieldTypeValidationEnumList', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null };

type ProfileFieldValidation_ProfileFieldTypeValidationInt_Fragment = { __typename: 'ProfileFieldTypeValidationInt', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null };

type ProfileFieldValidation_ProfileFieldTypeValidationMultiLangString_Fragment = { __typename: 'ProfileFieldTypeValidationMultiLangString', name: ProfileFieldsEnum, isValid: boolean, multiLangErrors?: Array<{ __typename?: 'ProfileFieldValidationErrorMultiLang', lang: string, message: string }> | null };

type ProfileFieldValidation_ProfileFieldTypeValidationPicture_Fragment = { __typename: 'ProfileFieldTypeValidationPicture', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null };

type ProfileFieldValidation_ProfileFieldTypeValidationPictureList_Fragment = { __typename: 'ProfileFieldTypeValidationPictureList', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null };

type ProfileFieldValidation_ProfileFieldTypeValidationString_Fragment = { __typename: 'ProfileFieldTypeValidationString', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null };

type ProfileFieldValidation_ProfileFieldTypeValidationUploadDocument_Fragment = { __typename: 'ProfileFieldTypeValidationUploadDocument', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null };

export type ProfileFieldValidationFragment = ProfileFieldValidation_ProfileFieldTypeValidationBoolean_Fragment | ProfileFieldValidation_ProfileFieldTypeValidationDate_Fragment | ProfileFieldValidation_ProfileFieldTypeValidationEnum_Fragment | ProfileFieldValidation_ProfileFieldTypeValidationEnumList_Fragment | ProfileFieldValidation_ProfileFieldTypeValidationInt_Fragment | ProfileFieldValidation_ProfileFieldTypeValidationMultiLangString_Fragment | ProfileFieldValidation_ProfileFieldTypeValidationPicture_Fragment | ProfileFieldValidation_ProfileFieldTypeValidationPictureList_Fragment | ProfileFieldValidation_ProfileFieldTypeValidationString_Fragment | ProfileFieldValidation_ProfileFieldTypeValidationUploadDocument_Fragment;

export type ProfileFieldValidationSetFragment = { __typename: 'ProfileFieldValidationSet', hasErrors: boolean, field: Array<{ __typename: 'ProfileFieldTypeValidationBoolean', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationDate', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationEnum', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationEnumList', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationInt', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationMultiLangString', name: ProfileFieldsEnum, isValid: boolean, multiLangErrors?: Array<{ __typename?: 'ProfileFieldValidationErrorMultiLang', lang: string, message: string }> | null } | { __typename: 'ProfileFieldTypeValidationPicture', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationPictureList', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationString', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationUploadDocument', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null }> };

export type GetUploadInfoForFieldQueryVariables = Exact<{
  name: ProfileFieldsEnum;
  position?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetUploadInfoForFieldQuery = { __typename?: 'Query', profile: { __typename?: 'Profile', field?: { __typename?: 'ProfileFieldTypeBoolean' } | { __typename?: 'ProfileFieldTypeDate' } | { __typename?: 'ProfileFieldTypeEnum' } | { __typename?: 'ProfileFieldTypeEnumList' } | { __typename?: 'ProfileFieldTypeFormManagerGenericForm' } | { __typename?: 'ProfileFieldTypeFormManagerPaperlessForm' } | { __typename?: 'ProfileFieldTypeInt' } | { __typename?: 'ProfileFieldTypeMultiLangString' } | { __typename?: 'ProfileFieldTypePicture', upload: { __typename?: 'UploadInfo', errorCodes?: any | null, requiredFormData?: any | null, url?: string | null } } | { __typename?: 'ProfileFieldTypePictureList', upload: { __typename?: 'UploadInfo', errorCodes?: any | null, requiredFormData?: any | null, url?: string | null } } | { __typename?: 'ProfileFieldTypeString' } | { __typename?: 'ProfileFieldTypeUploadDocument', upload: { __typename?: 'UploadInfo', errorCodes?: any | null, requiredFormData?: any | null, url?: string | null } } | null } };

export type ModelProfileProviderQueryVariables = Exact<{ [key: string]: never; }>;


export type ModelProfileProviderQuery = { __typename?: 'Query', account: { __typename?: 'Account', isModelVerified: boolean }, profile: { __typename?: 'Profile', aboutMeCollection?: { __typename?: 'ProfileCollectionAccountV1' } | { __typename?: 'ProfileCollectionMobileAboutMeV1', completeness: { __typename?: 'ProfileCollectionCompleteness', total: number, missing: number, complete: number, missingFields: Array<ProfileFieldsEnum> }, fields: { __typename?: 'ProfileCollectionMobileAboutMeV1Fields', modelUsername?: { __typename: 'ProfileFieldTypeString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, minLength?: number | null, maxLength?: number | null } | null, modelGender?: { __typename: 'ProfileFieldTypeEnum', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, quickpickValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }>, validValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }> } | null, modelSexuality?: { __typename: 'ProfileFieldTypeEnum', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, quickpickValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }>, validValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }> } | null, modelBirthdate?: { __typename: 'ProfileFieldTypeDate', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: any | null, minDate?: any | null, maxDate?: any | null } | null, modelMotto?: { __typename: 'ProfileFieldTypeMultiLangString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, minLength: number, maxLength: number, requiredLangs: Array<ApiLangEnum | null>, value?: { __typename?: 'MultiLangText', status: string, langs: Array<LanguagesEnum>, origText: string, texts: Array<{ __typename?: 'LangText', status: string, text: string, lang: LanguagesEnum }> } | null, langs: Array<{ __typename?: 'OptionEntry', name: string, label: string }> } | null, modelAboutMe?: { __typename: 'ProfileFieldTypeMultiLangString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, minLength: number, maxLength: number, requiredLangs: Array<ApiLangEnum | null>, value?: { __typename?: 'MultiLangText', status: string, langs: Array<LanguagesEnum>, origText: string, texts: Array<{ __typename?: 'LangText', status: string, text: string, lang: LanguagesEnum }> } | null, langs: Array<{ __typename?: 'OptionEntry', name: string, label: string }> } | null, modelRelationshipState?: { __typename: 'ProfileFieldTypeEnum', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, quickpickValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }>, validValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }> } | null, modelCountry?: { __typename: 'ProfileFieldTypeEnum', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, quickpickValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }>, validValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }> } | null, modelPostalCode?: { __typename: 'ProfileFieldTypeString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, minLength?: number | null, maxLength?: number | null } | null, modelCity?: { __typename: 'ProfileFieldTypeString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, minLength?: number | null, maxLength?: number | null } | null, modelLanguage?: { __typename: 'ProfileFieldTypeEnumList', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: Array<string | null> | null, validValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }> } | null, modelChatPractices?: { __typename: 'ProfileFieldTypeEnumList', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: Array<string | null> | null, validValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }> } | null } } | { __typename?: 'ProfileCollectionMobileAppearanceV1' } | { __typename?: 'ProfileCollectionMobileInterviewV1' } | { __typename?: 'ProfileCollectionMobileMediaV1' } | { __typename?: 'ProfileCollectionMobileProfileV1' } | { __typename?: 'ProfileCollectionModelReleaseFormV1' } | { __typename?: 'ProfileCollectionOnboardingV1' } | { __typename?: 'ProfileCollectionPayoutV1' } | null, appearanceCollection?: { __typename?: 'ProfileCollectionAccountV1' } | { __typename?: 'ProfileCollectionMobileAboutMeV1' } | { __typename?: 'ProfileCollectionMobileAppearanceV1', completeness: { __typename?: 'ProfileCollectionCompleteness', total: number, missing: number, complete: number, missingFields: Array<ProfileFieldsEnum> }, fields: { __typename?: 'ProfileCollectionMobileAppearanceV1Fields', modelBodyHeight?: { __typename: 'ProfileFieldTypeInt', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: number | null, minValue?: number | null, maxValue?: number | null } | null, modelBodyWeight?: { __typename: 'ProfileFieldTypeInt', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: number | null, minValue?: number | null, maxValue?: number | null } | null, modelBodyFigure?: { __typename: 'ProfileFieldTypeEnum', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, quickpickValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }>, validValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }> } | null, modelBreastSize?: { __typename: 'ProfileFieldTypeEnum', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, quickpickValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }>, validValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }> } | null, modelPenisSize?: { __typename: 'ProfileFieldTypeEnum', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, quickpickValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }>, validValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }> } | null, modelSkinType?: { __typename: 'ProfileFieldTypeEnum', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, quickpickValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }>, validValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }> } | null, modelHairColor?: { __typename: 'ProfileFieldTypeEnum', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, quickpickValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }>, validValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }> } | null, modelEyeColor?: { __typename: 'ProfileFieldTypeEnum', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, quickpickValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }>, validValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }> } | null, modelPubicHair?: { __typename: 'ProfileFieldTypeEnum', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, quickpickValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }>, validValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }> } | null, modelBodyModifications?: { __typename: 'ProfileFieldTypeEnumList', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: Array<string | null> | null, validValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }> } | null } } | { __typename?: 'ProfileCollectionMobileInterviewV1' } | { __typename?: 'ProfileCollectionMobileMediaV1' } | { __typename?: 'ProfileCollectionMobileProfileV1' } | { __typename?: 'ProfileCollectionModelReleaseFormV1' } | { __typename?: 'ProfileCollectionOnboardingV1' } | { __typename?: 'ProfileCollectionPayoutV1' } | null, interviewCollection?: { __typename?: 'ProfileCollectionAccountV1' } | { __typename?: 'ProfileCollectionMobileAboutMeV1' } | { __typename?: 'ProfileCollectionMobileAppearanceV1' } | { __typename?: 'ProfileCollectionMobileInterviewV1', completeness: { __typename?: 'ProfileCollectionCompleteness', total: number, missing: number, complete: number, missingFields: Array<ProfileFieldsEnum> }, fields: { __typename?: 'ProfileCollectionMobileInterviewV1Fields', modelInterviewPartner?: { __typename: 'ProfileFieldTypeMultiLangString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, minLength: number, maxLength: number, requiredLangs: Array<ApiLangEnum | null>, value?: { __typename?: 'MultiLangText', status: string, langs: Array<LanguagesEnum>, origText: string, texts: Array<{ __typename?: 'LangText', status: string, text: string, lang: LanguagesEnum }> } | null, langs: Array<{ __typename?: 'OptionEntry', name: string, label: string }> } | null, modelInterviewIsland?: { __typename: 'ProfileFieldTypeMultiLangString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, minLength: number, maxLength: number, requiredLangs: Array<ApiLangEnum | null>, value?: { __typename?: 'MultiLangText', status: string, langs: Array<LanguagesEnum>, origText: string, texts: Array<{ __typename?: 'LangText', status: string, text: string, lang: LanguagesEnum }> } | null, langs: Array<{ __typename?: 'OptionEntry', name: string, label: string }> } | null, modelInterviewEnterprise?: { __typename: 'ProfileFieldTypeMultiLangString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, minLength: number, maxLength: number, requiredLangs: Array<ApiLangEnum | null>, value?: { __typename?: 'MultiLangText', status: string, langs: Array<LanguagesEnum>, origText: string, texts: Array<{ __typename?: 'LangText', status: string, text: string, lang: LanguagesEnum }> } | null, langs: Array<{ __typename?: 'OptionEntry', name: string, label: string }> } | null, modelInterviewHobbies?: { __typename: 'ProfileFieldTypeMultiLangString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, minLength: number, maxLength: number, requiredLangs: Array<ApiLangEnum | null>, value?: { __typename?: 'MultiLangText', status: string, langs: Array<LanguagesEnum>, origText: string, texts: Array<{ __typename?: 'LangText', status: string, text: string, lang: LanguagesEnum }> } | null, langs: Array<{ __typename?: 'OptionEntry', name: string, label: string }> } | null, modelInterviewSexualPosition?: { __typename: 'ProfileFieldTypeMultiLangString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, minLength: number, maxLength: number, requiredLangs: Array<ApiLangEnum | null>, value?: { __typename?: 'MultiLangText', status: string, langs: Array<LanguagesEnum>, origText: string, texts: Array<{ __typename?: 'LangText', status: string, text: string, lang: LanguagesEnum }> } | null, langs: Array<{ __typename?: 'OptionEntry', name: string, label: string }> } | null, modelInterviewSexualFantasies?: { __typename: 'ProfileFieldTypeMultiLangString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, minLength: number, maxLength: number, requiredLangs: Array<ApiLangEnum | null>, value?: { __typename?: 'MultiLangText', status: string, langs: Array<LanguagesEnum>, origText: string, texts: Array<{ __typename?: 'LangText', status: string, text: string, lang: LanguagesEnum }> } | null, langs: Array<{ __typename?: 'OptionEntry', name: string, label: string }> } | null, modelInterviewSexNotOk?: { __typename: 'ProfileFieldTypeMultiLangString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, minLength: number, maxLength: number, requiredLangs: Array<ApiLangEnum | null>, value?: { __typename?: 'MultiLangText', status: string, langs: Array<LanguagesEnum>, origText: string, texts: Array<{ __typename?: 'LangText', status: string, text: string, lang: LanguagesEnum }> } | null, langs: Array<{ __typename?: 'OptionEntry', name: string, label: string }> } | null, modelInterviewSexOk?: { __typename: 'ProfileFieldTypeMultiLangString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, minLength: number, maxLength: number, requiredLangs: Array<ApiLangEnum | null>, value?: { __typename?: 'MultiLangText', status: string, langs: Array<LanguagesEnum>, origText: string, texts: Array<{ __typename?: 'LangText', status: string, text: string, lang: LanguagesEnum }> } | null, langs: Array<{ __typename?: 'OptionEntry', name: string, label: string }> } | null, modelInterviewEroticExperience?: { __typename: 'ProfileFieldTypeMultiLangString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, minLength: number, maxLength: number, requiredLangs: Array<ApiLangEnum | null>, value?: { __typename?: 'MultiLangText', status: string, langs: Array<LanguagesEnum>, origText: string, texts: Array<{ __typename?: 'LangText', status: string, text: string, lang: LanguagesEnum }> } | null, langs: Array<{ __typename?: 'OptionEntry', name: string, label: string }> } | null } } | { __typename?: 'ProfileCollectionMobileMediaV1' } | { __typename?: 'ProfileCollectionMobileProfileV1' } | { __typename?: 'ProfileCollectionModelReleaseFormV1' } | { __typename?: 'ProfileCollectionOnboardingV1' } | { __typename?: 'ProfileCollectionPayoutV1' } | null, mediaCollection?: { __typename?: 'ProfileCollectionAccountV1' } | { __typename?: 'ProfileCollectionMobileAboutMeV1' } | { __typename?: 'ProfileCollectionMobileAppearanceV1' } | { __typename?: 'ProfileCollectionMobileInterviewV1' } | { __typename?: 'ProfileCollectionMobileMediaV1', completeness: { __typename?: 'ProfileCollectionCompleteness', total: number, missing: number, complete: number, missingFields: Array<ProfileFieldsEnum> }, fields: { __typename?: 'ProfileCollectionMobileMediaV1Fields', modelPictureTitleLandscape?: { __typename: 'ProfileFieldTypePicture', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: { __typename?: 'MediaPicture', umaId: number, umpId: number, type: string, rejectReason?: string | null, status: MediaPictureStatusEnum, image: { __typename?: 'Image', src: string, alt: string, srcset: string } } | null } | null, modelPictureFSK16Avatar?: { __typename: 'ProfileFieldTypePicture', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: { __typename?: 'MediaPicture', umaId: number, umpId: number, type: string, rejectReason?: string | null, status: MediaPictureStatusEnum, image: { __typename?: 'Image', src: string, alt: string, srcset: string } } | null } | null, modelPictureFSK12Sedcard?: { __typename: 'ProfileFieldTypePictureList', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value: Array<{ __typename?: 'MediaPicture', type: string, fsk: number, rejectReason?: string | null, position: number, status: MediaPictureStatusEnum, umaId: number, umpId: number, image: { __typename?: 'Image', src: string, alt: string, srcset: string } }> } | null, modelPictureFSK16Sedcard?: { __typename: 'ProfileFieldTypePictureList', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value: Array<{ __typename?: 'MediaPicture', type: string, fsk: number, rejectReason?: string | null, position: number, status: MediaPictureStatusEnum, umaId: number, umpId: number, image: { __typename?: 'Image', src: string, alt: string, srcset: string } }> } | null, modelPictureFSK18Sedcard?: { __typename: 'ProfileFieldTypePictureList', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value: Array<{ __typename?: 'MediaPicture', type: string, fsk: number, rejectReason?: string | null, position: number, status: MediaPictureStatusEnum, umaId: number, umpId: number, image: { __typename?: 'Image', src: string, alt: string, srcset: string } }> } | null } } | { __typename?: 'ProfileCollectionMobileProfileV1' } | { __typename?: 'ProfileCollectionModelReleaseFormV1' } | { __typename?: 'ProfileCollectionOnboardingV1' } | { __typename?: 'ProfileCollectionPayoutV1' } | null } };

export type PasswordResetMutationVariables = Exact<{
  email: Scalars['String']['input'];
  modelname?: InputMaybe<Scalars['String']['input']>;
}>;


export type PasswordResetMutation = { __typename?: 'Mutation', auth?: { __typename?: 'AuthMutation', resetPassword?: { __typename: 'PasswordResetResultFail', message: string } | { __typename: 'PasswordResetResultSuccessful', message: string } | null } | null };

export type ResetPasswordMutationVariables = Exact<{
  hash: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', auth?: { __typename?: 'AuthMutation', setPassword?: { __typename: 'PasswordSetResultFail', message: string } | { __typename: 'PasswordSetResultSuccessful', message: string } | null } | null };

export type GetRedirectPageDataQueryVariables = Exact<{
  redirectUrl: Scalars['String']['input'];
}>;


export type GetRedirectPageDataQuery = { __typename?: 'Query', app: { __typename?: 'App', autologinLinkVXModels?: string | null } };

export type SignUpMutationVariables = Exact<{
  email: Scalars['EmailAddress']['input'];
  password: Scalars['String']['input'];
  userReferer?: InputMaybe<Scalars['String']['input']>;
  studioHash?: InputMaybe<Scalars['String']['input']>;
}>;


export type SignUpMutation = { __typename?: 'Mutation', auth?: { __typename?: 'AuthMutation', signup?: { __typename: 'AuthResultAccountLocked' } | { __typename: 'AuthResultInsufficientRights' } | { __typename: 'AuthResultInvalidCredentials' } | { __typename: 'AuthResultSuccessful', accessToken: any, refreshToken: any } | { __typename: 'SignupResultFail', topic: string, message: string, invalidFields: Array<{ __typename?: 'SignupDataField', name: string, errorMessages: Array<string | null> } | null> } | null } | null };

export type GetAllStatisticsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllStatisticsQuery = { __typename?: 'Query', statistics: { __typename?: 'Statistics', entries: Array<{ __typename?: 'StatisticsEntrySingleCurrency', id: StatisticsEntryNameEnum, label: string } | { __typename?: 'StatisticsEntrySingleDuration', id: StatisticsEntryNameEnum, label: string } | { __typename?: 'StatisticsEntrySingleNumber', id: StatisticsEntryNameEnum, label: string }>, availableEntries: Array<{ __typename?: 'StatisticsEntrySingleCurrency', id: StatisticsEntryNameEnum, label: string } | { __typename?: 'StatisticsEntrySingleDuration', id: StatisticsEntryNameEnum, label: string } | { __typename?: 'StatisticsEntrySingleNumber', id: StatisticsEntryNameEnum, label: string }> } };

type StatisticEditEntry_StatisticsEntrySingleCurrency_Fragment = { __typename?: 'StatisticsEntrySingleCurrency', id: StatisticsEntryNameEnum, label: string };

type StatisticEditEntry_StatisticsEntrySingleDuration_Fragment = { __typename?: 'StatisticsEntrySingleDuration', id: StatisticsEntryNameEnum, label: string };

type StatisticEditEntry_StatisticsEntrySingleNumber_Fragment = { __typename?: 'StatisticsEntrySingleNumber', id: StatisticsEntryNameEnum, label: string };

export type StatisticEditEntryFragment = StatisticEditEntry_StatisticsEntrySingleCurrency_Fragment | StatisticEditEntry_StatisticsEntrySingleDuration_Fragment | StatisticEditEntry_StatisticsEntrySingleNumber_Fragment;

export type UpdateStatisticsListMutationVariables = Exact<{
  statisticEntries: Array<StatisticsEntryNameEnum> | StatisticsEntryNameEnum;
}>;


export type UpdateStatisticsListMutation = { __typename?: 'Mutation', statistics?: { __typename?: 'StatisticsMutation', setSelectedEntries: Array<{ __typename?: 'StatisticsEntrySingleCurrency', id: StatisticsEntryNameEnum, label: string } | { __typename?: 'StatisticsEntrySingleDuration', id: StatisticsEntryNameEnum, label: string } | { __typename?: 'StatisticsEntrySingleNumber', id: StatisticsEntryNameEnum, label: string }> } | null };

export type GetVxLiveChatPageDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetVxLiveChatPageDataQuery = { __typename?: 'Query', app: { __typename?: 'App', autologinLinkVXLive?: string | null }, account: { __typename?: 'Account', userName: string } };

export type GetVxLiveGoLivePageDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetVxLiveGoLivePageDataQuery = { __typename?: 'Query', helpcenter: { __typename?: 'Helpcenter', tips?: { __typename?: 'Tips', entries: Array<{ __typename?: 'TipsEntry', id: string, title: string, teaserText: string, isLabeledNew: boolean, readAt?: any | null, headerImage: { __typename?: 'Image', alt: string, src: string }, experienceTags?: Array<{ __typename?: 'TipsTag', id: string, value?: string | null } | null> | null, intentionTags?: Array<{ __typename?: 'TipsTag', id: string, value?: string | null } | null> | null } | null> } | null } };

export type GetVxLivePageDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetVxLivePageDataQuery = { __typename?: 'Query', account: { __typename?: 'Account', userName: string } };

export type GetVxLiveAccountDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetVxLiveAccountDataQuery = { __typename?: 'Query', account: { __typename?: 'Account', userName: string } };

export type GetWizardMrfDataQueryVariables = Exact<{
  redirectUrl: Scalars['String']['input'];
}>;


export type GetWizardMrfDataQuery = { __typename?: 'Query', tour: { __typename: 'TourModelReleaseFormV1', totalSteps: number, currentStep?: { __typename?: 'TourStep', pos: number, id: string, fields: Array<{ __typename?: 'ProfileFieldTypeBoolean', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename?: 'ProfileFieldTypeDate', minDate?: any | null, maxDate?: any | null, name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, date?: any | null } | { __typename?: 'ProfileFieldTypeEnum', value?: string | null, name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, quickpickValues: Array<{ __typename?: 'OptionEntry', label: string, value: string }>, validValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }> } | { __typename?: 'ProfileFieldTypeEnumList', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename?: 'ProfileFieldTypeFormManagerGenericForm', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename?: 'ProfileFieldTypeFormManagerPaperlessForm', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, form?: { __typename?: 'FormManagerPaperlessForm', formUrl?: string | null } | null } | { __typename?: 'ProfileFieldTypeInt', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename?: 'ProfileFieldTypeMultiLangString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename?: 'ProfileFieldTypePicture', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename?: 'ProfileFieldTypePictureList', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename?: 'ProfileFieldTypeString', value?: string | null, minLength?: number | null, maxLength?: number | null, name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename?: 'ProfileFieldTypeUploadDocument', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, document?: { __typename?: 'UploadDocument', docId: number, status: DocumentStatusEnum, comment: string } | null, upload: { __typename?: 'UploadInfo', url?: string | null, errorCodes?: any | null, requiredFormData?: any | null } } | null> } | null, validate?: { __typename?: 'TourValidation', data?: Array<{ __typename: 'ProfileFieldTypeValidationBoolean', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationDate', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationEnum', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationEnumList', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationInt', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationMultiLangString', name: ProfileFieldsEnum, isValid: boolean, multiLangErrors?: Array<{ __typename?: 'ProfileFieldValidationErrorMultiLang', lang: string, message: string }> | null } | { __typename: 'ProfileFieldTypeValidationPicture', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationPictureList', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationString', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationUploadDocument', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | null> | null } | null } | { __typename: 'TourOnboardingV1' } | { __typename: 'TourPayoutV1' } | { __typename: 'TourPayoutV2' } };

export type UpdateWizardMrfDataMutationVariables = Exact<{
  step: Scalars['ID']['input'];
  data: InputTourModelReleaseFormV1;
  redirectUrl: Scalars['String']['input'];
}>;


export type UpdateWizardMrfDataMutation = { __typename?: 'Mutation', tour?: { __typename: 'TourModelReleaseFormV1Mutation', update: { __typename?: 'TourModelReleaseFormV1', totalSteps: number, currentStep?: { __typename?: 'TourStep', pos: number, id: string, fields: Array<{ __typename?: 'ProfileFieldTypeBoolean', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename?: 'ProfileFieldTypeDate', minDate?: any | null, maxDate?: any | null, name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, date?: any | null } | { __typename?: 'ProfileFieldTypeEnum', value?: string | null, name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, quickpickValues: Array<{ __typename?: 'OptionEntry', label: string, value: string }>, validValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }> } | { __typename?: 'ProfileFieldTypeEnumList', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename?: 'ProfileFieldTypeFormManagerGenericForm', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename?: 'ProfileFieldTypeFormManagerPaperlessForm', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, form?: { __typename?: 'FormManagerPaperlessForm', formUrl?: string | null } | null } | { __typename?: 'ProfileFieldTypeInt', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename?: 'ProfileFieldTypeMultiLangString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename?: 'ProfileFieldTypePicture', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename?: 'ProfileFieldTypePictureList', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename?: 'ProfileFieldTypeString', value?: string | null, minLength?: number | null, maxLength?: number | null, name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename?: 'ProfileFieldTypeUploadDocument', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, document?: { __typename?: 'UploadDocument', docId: number, status: DocumentStatusEnum, comment: string } | null, upload: { __typename?: 'UploadInfo', url?: string | null, errorCodes?: any | null, requiredFormData?: any | null } } | null> } | null, validate?: { __typename?: 'TourValidation', data?: Array<{ __typename: 'ProfileFieldTypeValidationBoolean', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationDate', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationEnum', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationEnumList', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationInt', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationMultiLangString', name: ProfileFieldsEnum, isValid: boolean, multiLangErrors?: Array<{ __typename?: 'ProfileFieldValidationErrorMultiLang', lang: string, message: string }> | null } | { __typename: 'ProfileFieldTypeValidationPicture', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationPictureList', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationString', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationUploadDocument', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | null> | null } | null } } | { __typename: 'TourOnboardingV1Mutation' } | { __typename: 'TourPayoutV1Mutation' } | { __typename: 'TourPayoutV2Mutation' } | null };

export type WizardMrfAccountPrefillFieldsFragment = { __typename?: 'ProfileCollectionAccountV1Fields', accountFirstname?: { __typename?: 'ProfileFieldTypeString', value?: string | null } | null, accountLastname?: { __typename?: 'ProfileFieldTypeString', value?: string | null } | null, accountBirthdate?: { __typename?: 'ProfileFieldTypeDate', value?: any | null } | null, accountAddressStreet?: { __typename?: 'ProfileFieldTypeString', value?: string | null } | null, accountAddressStreetNumber?: { __typename?: 'ProfileFieldTypeString', value?: string | null } | null, accountAddressCity?: { __typename?: 'ProfileFieldTypeString', value?: string | null } | null, accountAddressPostalCode?: { __typename?: 'ProfileFieldTypeString', value?: string | null } | null, accountAddressCountry?: { __typename?: 'ProfileFieldTypeEnum', value?: string | null, quickpickValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }>, validValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }> } | null };

export type CurrentStepWizardMrfFragment = { __typename?: 'TourStep', pos: number, id: string, fields: Array<{ __typename?: 'ProfileFieldTypeBoolean', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename?: 'ProfileFieldTypeDate', minDate?: any | null, maxDate?: any | null, name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, date?: any | null } | { __typename?: 'ProfileFieldTypeEnum', value?: string | null, name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, quickpickValues: Array<{ __typename?: 'OptionEntry', label: string, value: string }>, validValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }> } | { __typename?: 'ProfileFieldTypeEnumList', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename?: 'ProfileFieldTypeFormManagerGenericForm', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename?: 'ProfileFieldTypeFormManagerPaperlessForm', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, form?: { __typename?: 'FormManagerPaperlessForm', formUrl?: string | null } | null } | { __typename?: 'ProfileFieldTypeInt', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename?: 'ProfileFieldTypeMultiLangString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename?: 'ProfileFieldTypePicture', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename?: 'ProfileFieldTypePictureList', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename?: 'ProfileFieldTypeString', value?: string | null, minLength?: number | null, maxLength?: number | null, name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename?: 'ProfileFieldTypeUploadDocument', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, document?: { __typename?: 'UploadDocument', docId: number, status: DocumentStatusEnum, comment: string } | null, upload: { __typename?: 'UploadInfo', url?: string | null, errorCodes?: any | null, requiredFormData?: any | null } } | null> };

export type TourDataWizardMrfFragment = { __typename?: 'TourModelReleaseFormV1', totalSteps: number, currentStep?: { __typename?: 'TourStep', pos: number, id: string, fields: Array<{ __typename?: 'ProfileFieldTypeBoolean', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename?: 'ProfileFieldTypeDate', minDate?: any | null, maxDate?: any | null, name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, date?: any | null } | { __typename?: 'ProfileFieldTypeEnum', value?: string | null, name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, quickpickValues: Array<{ __typename?: 'OptionEntry', label: string, value: string }>, validValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }> } | { __typename?: 'ProfileFieldTypeEnumList', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename?: 'ProfileFieldTypeFormManagerGenericForm', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename?: 'ProfileFieldTypeFormManagerPaperlessForm', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, form?: { __typename?: 'FormManagerPaperlessForm', formUrl?: string | null } | null } | { __typename?: 'ProfileFieldTypeInt', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename?: 'ProfileFieldTypeMultiLangString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename?: 'ProfileFieldTypePicture', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename?: 'ProfileFieldTypePictureList', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename?: 'ProfileFieldTypeString', value?: string | null, minLength?: number | null, maxLength?: number | null, name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename?: 'ProfileFieldTypeUploadDocument', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, document?: { __typename?: 'UploadDocument', docId: number, status: DocumentStatusEnum, comment: string } | null, upload: { __typename?: 'UploadInfo', url?: string | null, errorCodes?: any | null, requiredFormData?: any | null } } | null> } | null, validate?: { __typename?: 'TourValidation', data?: Array<{ __typename: 'ProfileFieldTypeValidationBoolean', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationDate', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationEnum', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationEnumList', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationInt', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationMultiLangString', name: ProfileFieldsEnum, isValid: boolean, multiLangErrors?: Array<{ __typename?: 'ProfileFieldValidationErrorMultiLang', lang: string, message: string }> | null } | { __typename: 'ProfileFieldTypeValidationPicture', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationPictureList', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationString', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationUploadDocument', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | null> | null } | null };

type WizardStepField_ProfileFieldTypeBoolean_Fragment = { __typename: 'ProfileFieldTypeBoolean', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null };

type WizardStepField_ProfileFieldTypeDate_Fragment = { __typename: 'ProfileFieldTypeDate', minDate?: any | null, maxDate?: any | null, name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, date?: any | null };

type WizardStepField_ProfileFieldTypeEnum_Fragment = { __typename: 'ProfileFieldTypeEnum', value?: string | null, name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, quickpickValues: Array<{ __typename?: 'OptionEntry', label: string, value: string }>, validValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }> };

type WizardStepField_ProfileFieldTypeEnumList_Fragment = { __typename: 'ProfileFieldTypeEnumList', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null };

type WizardStepField_ProfileFieldTypeFormManagerGenericForm_Fragment = { __typename: 'ProfileFieldTypeFormManagerGenericForm', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null };

type WizardStepField_ProfileFieldTypeFormManagerPaperlessForm_Fragment = { __typename: 'ProfileFieldTypeFormManagerPaperlessForm', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null };

type WizardStepField_ProfileFieldTypeInt_Fragment = { __typename: 'ProfileFieldTypeInt', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null };

type WizardStepField_ProfileFieldTypeMultiLangString_Fragment = { __typename: 'ProfileFieldTypeMultiLangString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null };

type WizardStepField_ProfileFieldTypePicture_Fragment = { __typename: 'ProfileFieldTypePicture', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null };

type WizardStepField_ProfileFieldTypePictureList_Fragment = { __typename: 'ProfileFieldTypePictureList', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null };

type WizardStepField_ProfileFieldTypeString_Fragment = { __typename: 'ProfileFieldTypeString', value?: string | null, minLength?: number | null, maxLength?: number | null, name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null };

type WizardStepField_ProfileFieldTypeUploadDocument_Fragment = { __typename: 'ProfileFieldTypeUploadDocument', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, document?: { __typename?: 'UploadDocument', docId: number, status: DocumentStatusEnum, comment: string } | null, upload: { __typename?: 'UploadInfo', url?: string | null, errorCodes?: any | null, requiredFormData?: any | null } };

export type WizardStepFieldFragment = WizardStepField_ProfileFieldTypeBoolean_Fragment | WizardStepField_ProfileFieldTypeDate_Fragment | WizardStepField_ProfileFieldTypeEnum_Fragment | WizardStepField_ProfileFieldTypeEnumList_Fragment | WizardStepField_ProfileFieldTypeFormManagerGenericForm_Fragment | WizardStepField_ProfileFieldTypeFormManagerPaperlessForm_Fragment | WizardStepField_ProfileFieldTypeInt_Fragment | WizardStepField_ProfileFieldTypeMultiLangString_Fragment | WizardStepField_ProfileFieldTypePicture_Fragment | WizardStepField_ProfileFieldTypePictureList_Fragment | WizardStepField_ProfileFieldTypeString_Fragment | WizardStepField_ProfileFieldTypeUploadDocument_Fragment;

export type UpdateWizardMrfFinishedMutationVariables = Exact<{ [key: string]: never; }>;


export type UpdateWizardMrfFinishedMutation = { __typename?: 'Mutation', tour?: { __typename: 'TourModelReleaseFormV1Mutation', update: { __typename?: 'TourModelReleaseFormV1', status: ProfileStatusEnum, currentStep?: { __typename?: 'TourStep', id: string } | null } } | { __typename: 'TourOnboardingV1Mutation' } | { __typename: 'TourPayoutV1Mutation' } | { __typename: 'TourPayoutV2Mutation' } | null };

export type WizardPayoutBankDataBicByIbanQueryVariables = Exact<{
  iban: Scalars['String']['input'];
}>;


export type WizardPayoutBankDataBicByIbanQuery = { __typename?: 'Query', finances: { __typename?: 'Finances', bicByIban: string } };

export type WizardPayoutBankDataQueryVariables = Exact<{ [key: string]: never; }>;


export type WizardPayoutBankDataQuery = { __typename?: 'Query', account: { __typename?: 'Account', isAccountFromEU: boolean, isAccountFromGermany: boolean } };

export type GetWizardPayoutTaxTinExtrasQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWizardPayoutTaxTinExtrasQuery = { __typename?: 'Query', payment: { __typename?: 'Payment', taxData: { __typename?: 'PaymentTaxData', status: string, rejectReasonTitle?: string | null, rejectReason?: string | null, showTin: boolean, isDocumentRequired: boolean, isRequired: boolean, isTaxable?: { __typename: 'ProfileFieldTypeBoolean', name: string, status: ProfileStatusEnum, rejectReason?: string | null, value?: boolean | null } | null, taxNumber?: { __typename: 'ProfileFieldTypeString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, minLength?: number | null, maxLength?: number | null } | null, tin?: { __typename: 'ProfileFieldTypeString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, minLength?: number | null, maxLength?: number | null } | null, tinCountry?: { __typename: 'ProfileFieldTypeEnum', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, quickpickValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }>, validValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }> } | null, document?: { __typename: 'ProfileFieldTypeUploadDocument', name: string, status: ProfileStatusEnum, rejectReason?: string | null, value?: { __typename?: 'UploadDocument', docId: number, expireDate?: any | null, filename: string, url: string, status: DocumentStatusEnum } | null } | null } } };

export type GetWizardPayoutDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWizardPayoutDataQuery = { __typename?: 'Query', tour: { __typename: 'TourModelReleaseFormV1' } | { __typename: 'TourOnboardingV1' } | { __typename: 'TourPayoutV1', totalSteps: number, status: ProfileStatusEnum, currentStep?: { __typename?: 'TourStep', pos: number, id: string, fields: Array<{ __typename?: 'ProfileFieldTypeBoolean', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename?: 'ProfileFieldTypeDate', minDate?: any | null, maxDate?: any | null, name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, date?: any | null } | { __typename?: 'ProfileFieldTypeEnum', value?: string | null, name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, quickpickValues: Array<{ __typename?: 'OptionEntry', label: string, value: string }>, validValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }> } | { __typename?: 'ProfileFieldTypeEnumList', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename?: 'ProfileFieldTypeFormManagerGenericForm', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename?: 'ProfileFieldTypeFormManagerPaperlessForm', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename?: 'ProfileFieldTypeInt', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename?: 'ProfileFieldTypeMultiLangString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename?: 'ProfileFieldTypePicture', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename?: 'ProfileFieldTypePictureList', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename?: 'ProfileFieldTypeString', value?: string | null, minLength?: number | null, maxLength?: number | null, name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename?: 'ProfileFieldTypeUploadDocument', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, document?: { __typename?: 'UploadDocument', docId: number, status: DocumentStatusEnum, comment: string } | null, upload: { __typename?: 'UploadInfo', url?: string | null, errorCodes?: any | null, requiredFormData?: any | null } } | null> } | null, validate?: { __typename?: 'TourValidation', data?: Array<{ __typename: 'ProfileFieldTypeValidationBoolean', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationDate', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationEnum', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationEnumList', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationInt', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationMultiLangString', name: ProfileFieldsEnum, isValid: boolean, multiLangErrors?: Array<{ __typename?: 'ProfileFieldValidationErrorMultiLang', lang: string, message: string }> | null } | { __typename: 'ProfileFieldTypeValidationPicture', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationPictureList', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationString', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationUploadDocument', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | null> | null } | null } | { __typename: 'TourPayoutV2' }, account: { __typename?: 'Account', isAccountFromGermany: boolean, isAccountFromEU: boolean }, profile: { __typename?: 'Profile', collection?: { __typename?: 'ProfileCollectionAccountV1', fields: { __typename?: 'ProfileCollectionAccountV1Fields', accountFirstname?: { __typename?: 'ProfileFieldTypeString', value?: string | null } | null, accountLastname?: { __typename?: 'ProfileFieldTypeString', value?: string | null } | null, accountAddressStreet?: { __typename?: 'ProfileFieldTypeString', value?: string | null } | null, accountAddressStreetNumber?: { __typename?: 'ProfileFieldTypeString', value?: string | null } | null, accountAddressCity?: { __typename?: 'ProfileFieldTypeString', value?: string | null } | null, accountAddressPostalCode?: { __typename?: 'ProfileFieldTypeString', value?: string | null } | null, accountAddressCountry?: { __typename?: 'ProfileFieldTypeEnum', value?: string | null, quickpickValues: Array<{ __typename?: 'OptionEntry', label: string, value: string }>, validValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }> } | null } } | { __typename?: 'ProfileCollectionMobileAboutMeV1' } | { __typename?: 'ProfileCollectionMobileAppearanceV1' } | { __typename?: 'ProfileCollectionMobileInterviewV1' } | { __typename?: 'ProfileCollectionMobileMediaV1' } | { __typename?: 'ProfileCollectionMobileProfileV1' } | { __typename?: 'ProfileCollectionModelReleaseFormV1' } | { __typename?: 'ProfileCollectionOnboardingV1' } | { __typename?: 'ProfileCollectionPayoutV1' } | null } };

export type WizardPayoutAccountPrefillFieldsFragment = { __typename?: 'ProfileCollectionAccountV1Fields', accountFirstname?: { __typename?: 'ProfileFieldTypeString', value?: string | null } | null, accountLastname?: { __typename?: 'ProfileFieldTypeString', value?: string | null } | null, accountAddressStreet?: { __typename?: 'ProfileFieldTypeString', value?: string | null } | null, accountAddressStreetNumber?: { __typename?: 'ProfileFieldTypeString', value?: string | null } | null, accountAddressCity?: { __typename?: 'ProfileFieldTypeString', value?: string | null } | null, accountAddressPostalCode?: { __typename?: 'ProfileFieldTypeString', value?: string | null } | null, accountAddressCountry?: { __typename?: 'ProfileFieldTypeEnum', value?: string | null, quickpickValues: Array<{ __typename?: 'OptionEntry', label: string, value: string }>, validValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }> } | null };

export type UpdateWizardPayoutDataMutationVariables = Exact<{
  step: Scalars['ID']['input'];
  data: InputTourPayoutV1;
}>;


export type UpdateWizardPayoutDataMutation = { __typename?: 'Mutation', tour?: { __typename: 'TourModelReleaseFormV1Mutation' } | { __typename: 'TourOnboardingV1Mutation' } | { __typename: 'TourPayoutV1Mutation', update: { __typename?: 'TourPayoutV1', totalSteps: number, status: ProfileStatusEnum, currentStep?: { __typename?: 'TourStep', pos: number, id: string, fields: Array<{ __typename?: 'ProfileFieldTypeBoolean', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename?: 'ProfileFieldTypeDate', minDate?: any | null, maxDate?: any | null, name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, date?: any | null } | { __typename?: 'ProfileFieldTypeEnum', value?: string | null, name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, quickpickValues: Array<{ __typename?: 'OptionEntry', label: string, value: string }>, validValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }> } | { __typename?: 'ProfileFieldTypeEnumList', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename?: 'ProfileFieldTypeFormManagerGenericForm', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename?: 'ProfileFieldTypeFormManagerPaperlessForm', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename?: 'ProfileFieldTypeInt', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename?: 'ProfileFieldTypeMultiLangString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename?: 'ProfileFieldTypePicture', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename?: 'ProfileFieldTypePictureList', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename?: 'ProfileFieldTypeString', value?: string | null, minLength?: number | null, maxLength?: number | null, name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename?: 'ProfileFieldTypeUploadDocument', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, document?: { __typename?: 'UploadDocument', docId: number, status: DocumentStatusEnum, comment: string } | null, upload: { __typename?: 'UploadInfo', url?: string | null, errorCodes?: any | null, requiredFormData?: any | null } } | null> } | null, validate?: { __typename?: 'TourValidation', data?: Array<{ __typename: 'ProfileFieldTypeValidationBoolean', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationDate', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationEnum', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationEnumList', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationInt', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationMultiLangString', name: ProfileFieldsEnum, isValid: boolean, multiLangErrors?: Array<{ __typename?: 'ProfileFieldValidationErrorMultiLang', lang: string, message: string }> | null } | { __typename: 'ProfileFieldTypeValidationPicture', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationPictureList', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationString', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationUploadDocument', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | null> | null } | null } } | { __typename: 'TourPayoutV2Mutation' } | null };

export type TourDataWizardPayoutFragment = { __typename?: 'TourPayoutV1', totalSteps: number, status: ProfileStatusEnum, currentStep?: { __typename?: 'TourStep', pos: number, id: string, fields: Array<{ __typename?: 'ProfileFieldTypeBoolean', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename?: 'ProfileFieldTypeDate', minDate?: any | null, maxDate?: any | null, name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, date?: any | null } | { __typename?: 'ProfileFieldTypeEnum', value?: string | null, name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, quickpickValues: Array<{ __typename?: 'OptionEntry', label: string, value: string }>, validValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }> } | { __typename?: 'ProfileFieldTypeEnumList', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename?: 'ProfileFieldTypeFormManagerGenericForm', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename?: 'ProfileFieldTypeFormManagerPaperlessForm', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename?: 'ProfileFieldTypeInt', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename?: 'ProfileFieldTypeMultiLangString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename?: 'ProfileFieldTypePicture', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename?: 'ProfileFieldTypePictureList', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename?: 'ProfileFieldTypeString', value?: string | null, minLength?: number | null, maxLength?: number | null, name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename?: 'ProfileFieldTypeUploadDocument', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, document?: { __typename?: 'UploadDocument', docId: number, status: DocumentStatusEnum, comment: string } | null, upload: { __typename?: 'UploadInfo', url?: string | null, errorCodes?: any | null, requiredFormData?: any | null } } | null> } | null, validate?: { __typename?: 'TourValidation', data?: Array<{ __typename: 'ProfileFieldTypeValidationBoolean', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationDate', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationEnum', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationEnumList', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationInt', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationMultiLangString', name: ProfileFieldsEnum, isValid: boolean, multiLangErrors?: Array<{ __typename?: 'ProfileFieldValidationErrorMultiLang', lang: string, message: string }> | null } | { __typename: 'ProfileFieldTypeValidationPicture', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationPictureList', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationString', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationUploadDocument', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | null> | null } | null };

export type CurrentStepWizardPayoutFragment = { __typename?: 'TourStep', pos: number, id: string, fields: Array<{ __typename?: 'ProfileFieldTypeBoolean', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename?: 'ProfileFieldTypeDate', minDate?: any | null, maxDate?: any | null, name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, date?: any | null } | { __typename?: 'ProfileFieldTypeEnum', value?: string | null, name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, quickpickValues: Array<{ __typename?: 'OptionEntry', label: string, value: string }>, validValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }> } | { __typename?: 'ProfileFieldTypeEnumList', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename?: 'ProfileFieldTypeFormManagerGenericForm', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename?: 'ProfileFieldTypeFormManagerPaperlessForm', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename?: 'ProfileFieldTypeInt', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename?: 'ProfileFieldTypeMultiLangString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename?: 'ProfileFieldTypePicture', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename?: 'ProfileFieldTypePictureList', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename?: 'ProfileFieldTypeString', value?: string | null, minLength?: number | null, maxLength?: number | null, name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename?: 'ProfileFieldTypeUploadDocument', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, document?: { __typename?: 'UploadDocument', docId: number, status: DocumentStatusEnum, comment: string } | null, upload: { __typename?: 'UploadInfo', url?: string | null, errorCodes?: any | null, requiredFormData?: any | null } } | null> };

export type GetWizardPayoutDataV2QueryVariables = Exact<{
  redirectUrl: Scalars['String']['input'];
}>;


export type GetWizardPayoutDataV2Query = { __typename?: 'Query', tour: { __typename: 'TourModelReleaseFormV1' } | { __typename: 'TourOnboardingV1' } | { __typename: 'TourPayoutV1' } | { __typename: 'TourPayoutV2', totalSteps: number, status: ProfileStatusEnum, currentStep?: { __typename?: 'TourStep', pos: number, id: string, fields: Array<{ __typename: 'ProfileFieldTypeBoolean', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename: 'ProfileFieldTypeDate', minDate?: any | null, maxDate?: any | null, name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, date?: any | null } | { __typename: 'ProfileFieldTypeEnum', value?: string | null, name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, quickpickValues: Array<{ __typename?: 'OptionEntry', label: string, value: string }>, validValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }> } | { __typename: 'ProfileFieldTypeEnumList', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename: 'ProfileFieldTypeFormManagerGenericForm', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename: 'ProfileFieldTypeFormManagerPaperlessForm', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, form?: { __typename?: 'FormManagerPaperlessForm', formUrl?: string | null } | null } | { __typename: 'ProfileFieldTypeInt', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename: 'ProfileFieldTypeMultiLangString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename: 'ProfileFieldTypePicture', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename: 'ProfileFieldTypePictureList', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename: 'ProfileFieldTypeString', value?: string | null, minLength?: number | null, maxLength?: number | null, name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename: 'ProfileFieldTypeUploadDocument', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, document?: { __typename?: 'UploadDocument', docId: number, status: DocumentStatusEnum, comment: string } | null, upload: { __typename?: 'UploadInfo', url?: string | null, errorCodes?: any | null, requiredFormData?: any | null } } | null> } | null, validate?: { __typename?: 'TourValidation', data?: Array<{ __typename: 'ProfileFieldTypeValidationBoolean', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationDate', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationEnum', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationEnumList', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationInt', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationMultiLangString', name: ProfileFieldsEnum, isValid: boolean, multiLangErrors?: Array<{ __typename?: 'ProfileFieldValidationErrorMultiLang', lang: string, message: string }> | null } | { __typename: 'ProfileFieldTypeValidationPicture', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationPictureList', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationString', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationUploadDocument', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | null> | null } | null }, account: { __typename?: 'Account', isAccountFromGermany: boolean, isAccountFromEU: boolean }, profile: { __typename?: 'Profile', collection?: { __typename?: 'ProfileCollectionAccountV1', fields: { __typename?: 'ProfileCollectionAccountV1Fields', accountFirstname?: { __typename?: 'ProfileFieldTypeString', value?: string | null } | null, accountLastname?: { __typename?: 'ProfileFieldTypeString', value?: string | null } | null, accountAddressStreet?: { __typename?: 'ProfileFieldTypeString', value?: string | null } | null, accountAddressStreetNumber?: { __typename?: 'ProfileFieldTypeString', value?: string | null } | null, accountAddressCity?: { __typename?: 'ProfileFieldTypeString', value?: string | null } | null, accountAddressPostalCode?: { __typename?: 'ProfileFieldTypeString', value?: string | null } | null, accountAddressCountry?: { __typename?: 'ProfileFieldTypeEnum', value?: string | null, quickpickValues: Array<{ __typename?: 'OptionEntry', label: string, value: string }>, validValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }> } | null } } | { __typename?: 'ProfileCollectionMobileAboutMeV1' } | { __typename?: 'ProfileCollectionMobileAppearanceV1' } | { __typename?: 'ProfileCollectionMobileInterviewV1' } | { __typename?: 'ProfileCollectionMobileMediaV1' } | { __typename?: 'ProfileCollectionMobileProfileV1' } | { __typename?: 'ProfileCollectionModelReleaseFormV1' } | { __typename?: 'ProfileCollectionOnboardingV1' } | { __typename?: 'ProfileCollectionPayoutV1' } | null } };

export type WizardPayoutAccountPrefillFieldsV2Fragment = { __typename?: 'ProfileCollectionAccountV1Fields', accountFirstname?: { __typename?: 'ProfileFieldTypeString', value?: string | null } | null, accountLastname?: { __typename?: 'ProfileFieldTypeString', value?: string | null } | null, accountAddressStreet?: { __typename?: 'ProfileFieldTypeString', value?: string | null } | null, accountAddressStreetNumber?: { __typename?: 'ProfileFieldTypeString', value?: string | null } | null, accountAddressCity?: { __typename?: 'ProfileFieldTypeString', value?: string | null } | null, accountAddressPostalCode?: { __typename?: 'ProfileFieldTypeString', value?: string | null } | null, accountAddressCountry?: { __typename?: 'ProfileFieldTypeEnum', value?: string | null, quickpickValues: Array<{ __typename?: 'OptionEntry', label: string, value: string }>, validValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }> } | null };

export type UpdateWizardPayoutDataV2MutationVariables = Exact<{
  step: Scalars['ID']['input'];
  data: InputTourPayoutV2;
  redirectUrl: Scalars['String']['input'];
}>;


export type UpdateWizardPayoutDataV2Mutation = { __typename?: 'Mutation', tour?: { __typename: 'TourModelReleaseFormV1Mutation' } | { __typename: 'TourOnboardingV1Mutation' } | { __typename: 'TourPayoutV1Mutation' } | { __typename: 'TourPayoutV2Mutation', update: { __typename?: 'TourPayoutV2', totalSteps: number, status: ProfileStatusEnum, currentStep?: { __typename?: 'TourStep', pos: number, id: string, fields: Array<{ __typename: 'ProfileFieldTypeBoolean', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename: 'ProfileFieldTypeDate', minDate?: any | null, maxDate?: any | null, name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, date?: any | null } | { __typename: 'ProfileFieldTypeEnum', value?: string | null, name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, quickpickValues: Array<{ __typename?: 'OptionEntry', label: string, value: string }>, validValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }> } | { __typename: 'ProfileFieldTypeEnumList', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename: 'ProfileFieldTypeFormManagerGenericForm', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename: 'ProfileFieldTypeFormManagerPaperlessForm', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, form?: { __typename?: 'FormManagerPaperlessForm', formUrl?: string | null } | null } | { __typename: 'ProfileFieldTypeInt', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename: 'ProfileFieldTypeMultiLangString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename: 'ProfileFieldTypePicture', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename: 'ProfileFieldTypePictureList', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename: 'ProfileFieldTypeString', value?: string | null, minLength?: number | null, maxLength?: number | null, name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename: 'ProfileFieldTypeUploadDocument', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, document?: { __typename?: 'UploadDocument', docId: number, status: DocumentStatusEnum, comment: string } | null, upload: { __typename?: 'UploadInfo', url?: string | null, errorCodes?: any | null, requiredFormData?: any | null } } | null> } | null, validate?: { __typename?: 'TourValidation', data?: Array<{ __typename: 'ProfileFieldTypeValidationBoolean', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationDate', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationEnum', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationEnumList', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationInt', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationMultiLangString', name: ProfileFieldsEnum, isValid: boolean, multiLangErrors?: Array<{ __typename?: 'ProfileFieldValidationErrorMultiLang', lang: string, message: string }> | null } | { __typename: 'ProfileFieldTypeValidationPicture', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationPictureList', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationString', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationUploadDocument', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | null> | null } | null } } | null };

export type TourDataWizardPayoutV2Fragment = { __typename?: 'TourPayoutV2', totalSteps: number, status: ProfileStatusEnum, currentStep?: { __typename?: 'TourStep', pos: number, id: string, fields: Array<{ __typename: 'ProfileFieldTypeBoolean', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename: 'ProfileFieldTypeDate', minDate?: any | null, maxDate?: any | null, name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, date?: any | null } | { __typename: 'ProfileFieldTypeEnum', value?: string | null, name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, quickpickValues: Array<{ __typename?: 'OptionEntry', label: string, value: string }>, validValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }> } | { __typename: 'ProfileFieldTypeEnumList', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename: 'ProfileFieldTypeFormManagerGenericForm', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename: 'ProfileFieldTypeFormManagerPaperlessForm', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, form?: { __typename?: 'FormManagerPaperlessForm', formUrl?: string | null } | null } | { __typename: 'ProfileFieldTypeInt', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename: 'ProfileFieldTypeMultiLangString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename: 'ProfileFieldTypePicture', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename: 'ProfileFieldTypePictureList', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename: 'ProfileFieldTypeString', value?: string | null, minLength?: number | null, maxLength?: number | null, name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename: 'ProfileFieldTypeUploadDocument', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, document?: { __typename?: 'UploadDocument', docId: number, status: DocumentStatusEnum, comment: string } | null, upload: { __typename?: 'UploadInfo', url?: string | null, errorCodes?: any | null, requiredFormData?: any | null } } | null> } | null, validate?: { __typename?: 'TourValidation', data?: Array<{ __typename: 'ProfileFieldTypeValidationBoolean', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationDate', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationEnum', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationEnumList', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationInt', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationMultiLangString', name: ProfileFieldsEnum, isValid: boolean, multiLangErrors?: Array<{ __typename?: 'ProfileFieldValidationErrorMultiLang', lang: string, message: string }> | null } | { __typename: 'ProfileFieldTypeValidationPicture', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationPictureList', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationString', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationUploadDocument', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | null> | null } | null };

export type CurrentStepWizardPayoutV2Fragment = { __typename?: 'TourStep', pos: number, id: string, fields: Array<{ __typename: 'ProfileFieldTypeBoolean', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename: 'ProfileFieldTypeDate', minDate?: any | null, maxDate?: any | null, name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, date?: any | null } | { __typename: 'ProfileFieldTypeEnum', value?: string | null, name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, quickpickValues: Array<{ __typename?: 'OptionEntry', label: string, value: string }>, validValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }> } | { __typename: 'ProfileFieldTypeEnumList', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename: 'ProfileFieldTypeFormManagerGenericForm', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename: 'ProfileFieldTypeFormManagerPaperlessForm', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, form?: { __typename?: 'FormManagerPaperlessForm', formUrl?: string | null } | null } | { __typename: 'ProfileFieldTypeInt', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename: 'ProfileFieldTypeMultiLangString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename: 'ProfileFieldTypePicture', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename: 'ProfileFieldTypePictureList', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename: 'ProfileFieldTypeString', value?: string | null, minLength?: number | null, maxLength?: number | null, name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename: 'ProfileFieldTypeUploadDocument', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, document?: { __typename?: 'UploadDocument', docId: number, status: DocumentStatusEnum, comment: string } | null, upload: { __typename?: 'UploadInfo', url?: string | null, errorCodes?: any | null, requiredFormData?: any | null } } | null> };

export type WizardPayoutAddressV2QueryVariables = Exact<{ [key: string]: never; }>;


export type WizardPayoutAddressV2Query = { __typename?: 'Query', profile: { __typename?: 'Profile', collection?: { __typename?: 'ProfileCollectionAccountV1', fields: { __typename?: 'ProfileCollectionAccountV1Fields', accountFirstname?: { __typename?: 'ProfileFieldTypeString', value?: string | null } | null, accountLastname?: { __typename?: 'ProfileFieldTypeString', value?: string | null } | null, accountAddressStreet?: { __typename?: 'ProfileFieldTypeString', value?: string | null } | null, accountAddressStreetNumber?: { __typename?: 'ProfileFieldTypeString', value?: string | null } | null, accountAddressCity?: { __typename?: 'ProfileFieldTypeString', value?: string | null } | null, accountAddressPostalCode?: { __typename?: 'ProfileFieldTypeString', value?: string | null } | null, accountAddressCountry?: { __typename?: 'ProfileFieldTypeEnum', name: string, value?: string | null, quickpickValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }>, validValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }> } | null } } | { __typename?: 'ProfileCollectionMobileAboutMeV1' } | { __typename?: 'ProfileCollectionMobileAppearanceV1' } | { __typename?: 'ProfileCollectionMobileInterviewV1' } | { __typename?: 'ProfileCollectionMobileMediaV1' } | { __typename?: 'ProfileCollectionMobileProfileV1' } | { __typename?: 'ProfileCollectionModelReleaseFormV1' } | { __typename?: 'ProfileCollectionOnboardingV1' } | { __typename?: 'ProfileCollectionPayoutV1' } | null } };

export type GetWizardProfileDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWizardProfileDataQuery = { __typename: 'Query', tour: { __typename?: 'TourModelReleaseFormV1' } | { __typename?: 'TourOnboardingV1', totalSteps: number, currentStep?: { __typename?: 'TourStep', pos: number, id: string, fields: Array<{ __typename: 'ProfileFieldTypeBoolean', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename: 'ProfileFieldTypeDate', minDate?: any | null, maxDate?: any | null, name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, date?: any | null } | { __typename: 'ProfileFieldTypeEnum', value?: string | null, name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, quickpickValues: Array<{ __typename?: 'OptionEntry', label: string, value: string }>, validValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }> } | { __typename: 'ProfileFieldTypeEnumList', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename: 'ProfileFieldTypeFormManagerGenericForm', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename: 'ProfileFieldTypeFormManagerPaperlessForm', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename: 'ProfileFieldTypeInt', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename: 'ProfileFieldTypeMultiLangString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, multiLangMinLength: number, multiLangMaxLength: number, multiLangValue?: { __typename?: 'MultiLangText', langs: Array<LanguagesEnum>, texts: Array<{ __typename?: 'LangText', lang: LanguagesEnum, text: string }> } | null } | { __typename: 'ProfileFieldTypePicture', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, image?: { __typename?: 'MediaPicture', umaId: number, umpId: number, type: string, rejectReason?: string | null, status: MediaPictureStatusEnum, image: { __typename?: 'Image', src: string, alt: string, srcset: string } } | null, upload: { __typename?: 'UploadInfo', errorCodes?: any | null, requiredFormData?: any | null, url?: string | null } } | { __typename: 'ProfileFieldTypePictureList', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename: 'ProfileFieldTypeString', value?: string | null, minLength?: number | null, maxLength?: number | null, name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename: 'ProfileFieldTypeUploadDocument', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | null> } | null, validate?: { __typename?: 'TourValidation', data?: Array<{ __typename: 'ProfileFieldTypeValidationBoolean', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationDate', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationEnum', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationEnumList', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationInt', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationMultiLangString', name: ProfileFieldsEnum, isValid: boolean, multiLangErrors?: Array<{ __typename?: 'ProfileFieldValidationErrorMultiLang', lang: string, message: string }> | null } | { __typename: 'ProfileFieldTypeValidationPicture', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationPictureList', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationString', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationUploadDocument', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | null> | null } | null } | { __typename?: 'TourPayoutV1' } | { __typename?: 'TourPayoutV2' } };

export type GetWizardProfileCurrentStepQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWizardProfileCurrentStepQuery = { __typename: 'Query', tour: { __typename?: 'TourModelReleaseFormV1' } | { __typename?: 'TourOnboardingV1', totalSteps: number, currentStep?: { __typename?: 'TourStep', pos: number, id: string, fields: Array<{ __typename: 'ProfileFieldTypeBoolean', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename: 'ProfileFieldTypeDate', minDate?: any | null, maxDate?: any | null, name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, date?: any | null } | { __typename: 'ProfileFieldTypeEnum', value?: string | null, name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, quickpickValues: Array<{ __typename?: 'OptionEntry', label: string, value: string }>, validValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }> } | { __typename: 'ProfileFieldTypeEnumList', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename: 'ProfileFieldTypeFormManagerGenericForm', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename: 'ProfileFieldTypeFormManagerPaperlessForm', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename: 'ProfileFieldTypeInt', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename: 'ProfileFieldTypeMultiLangString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, multiLangMinLength: number, multiLangMaxLength: number, multiLangValue?: { __typename?: 'MultiLangText', langs: Array<LanguagesEnum>, texts: Array<{ __typename?: 'LangText', lang: LanguagesEnum, text: string }> } | null } | { __typename: 'ProfileFieldTypePicture', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, image?: { __typename?: 'MediaPicture', umaId: number, umpId: number, type: string, rejectReason?: string | null, status: MediaPictureStatusEnum, image: { __typename?: 'Image', src: string, alt: string, srcset: string } } | null, upload: { __typename?: 'UploadInfo', errorCodes?: any | null, requiredFormData?: any | null, url?: string | null } } | { __typename: 'ProfileFieldTypePictureList', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename: 'ProfileFieldTypeString', value?: string | null, minLength?: number | null, maxLength?: number | null, name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename: 'ProfileFieldTypeUploadDocument', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | null> } | null, validate?: { __typename?: 'TourValidation', data?: Array<{ __typename: 'ProfileFieldTypeValidationBoolean', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationDate', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationEnum', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationEnumList', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationInt', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationMultiLangString', name: ProfileFieldsEnum, isValid: boolean, multiLangErrors?: Array<{ __typename?: 'ProfileFieldValidationErrorMultiLang', lang: string, message: string }> | null } | { __typename: 'ProfileFieldTypeValidationPicture', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationPictureList', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationString', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationUploadDocument', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | null> | null } | null } | { __typename?: 'TourPayoutV1' } | { __typename?: 'TourPayoutV2' } };

export type UpdateWizardProfileDataMutationVariables = Exact<{
  step: Scalars['ID']['input'];
  data: InputTourOnboardingV1;
}>;


export type UpdateWizardProfileDataMutation = { __typename?: 'Mutation', tour?: { __typename?: 'TourModelReleaseFormV1Mutation' } | { __typename?: 'TourOnboardingV1Mutation', update: { __typename?: 'TourOnboardingV1', totalSteps: number, currentStep?: { __typename?: 'TourStep', pos: number, id: string, fields: Array<{ __typename: 'ProfileFieldTypeBoolean', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename: 'ProfileFieldTypeDate', minDate?: any | null, maxDate?: any | null, name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, date?: any | null } | { __typename: 'ProfileFieldTypeEnum', value?: string | null, name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, quickpickValues: Array<{ __typename?: 'OptionEntry', label: string, value: string }>, validValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }> } | { __typename: 'ProfileFieldTypeEnumList', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename: 'ProfileFieldTypeFormManagerGenericForm', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename: 'ProfileFieldTypeFormManagerPaperlessForm', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename: 'ProfileFieldTypeInt', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename: 'ProfileFieldTypeMultiLangString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, multiLangMinLength: number, multiLangMaxLength: number, multiLangValue?: { __typename?: 'MultiLangText', langs: Array<LanguagesEnum>, texts: Array<{ __typename?: 'LangText', lang: LanguagesEnum, text: string }> } | null } | { __typename: 'ProfileFieldTypePicture', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, image?: { __typename?: 'MediaPicture', umaId: number, umpId: number, type: string, rejectReason?: string | null, status: MediaPictureStatusEnum, image: { __typename?: 'Image', src: string, alt: string, srcset: string } } | null, upload: { __typename?: 'UploadInfo', errorCodes?: any | null, requiredFormData?: any | null, url?: string | null } } | { __typename: 'ProfileFieldTypePictureList', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename: 'ProfileFieldTypeString', value?: string | null, minLength?: number | null, maxLength?: number | null, name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename: 'ProfileFieldTypeUploadDocument', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | null> } | null, validate?: { __typename?: 'TourValidation', data?: Array<{ __typename: 'ProfileFieldTypeValidationBoolean', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationDate', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationEnum', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationEnumList', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationInt', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationMultiLangString', name: ProfileFieldsEnum, isValid: boolean, multiLangErrors?: Array<{ __typename?: 'ProfileFieldValidationErrorMultiLang', lang: string, message: string }> | null } | { __typename: 'ProfileFieldTypeValidationPicture', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationPictureList', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationString', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationUploadDocument', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | null> | null } | null } } | { __typename?: 'TourPayoutV1Mutation' } | { __typename?: 'TourPayoutV2Mutation' } | null };

export type MarkWizardProfileStepCompleteMutationVariables = Exact<{ [key: string]: never; }>;


export type MarkWizardProfileStepCompleteMutation = { __typename?: 'Mutation', tour?: { __typename?: 'TourModelReleaseFormV1Mutation' } | { __typename?: 'TourOnboardingV1Mutation', update: { __typename?: 'TourOnboardingV1', status: ProfileStatusEnum } } | { __typename?: 'TourPayoutV1Mutation' } | { __typename?: 'TourPayoutV2Mutation' } | null };

export type TourDataWizardProfileFragment = { __typename?: 'TourOnboardingV1', totalSteps: number, currentStep?: { __typename?: 'TourStep', pos: number, id: string, fields: Array<{ __typename: 'ProfileFieldTypeBoolean', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename: 'ProfileFieldTypeDate', minDate?: any | null, maxDate?: any | null, name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, date?: any | null } | { __typename: 'ProfileFieldTypeEnum', value?: string | null, name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, quickpickValues: Array<{ __typename?: 'OptionEntry', label: string, value: string }>, validValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }> } | { __typename: 'ProfileFieldTypeEnumList', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename: 'ProfileFieldTypeFormManagerGenericForm', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename: 'ProfileFieldTypeFormManagerPaperlessForm', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename: 'ProfileFieldTypeInt', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename: 'ProfileFieldTypeMultiLangString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, multiLangMinLength: number, multiLangMaxLength: number, multiLangValue?: { __typename?: 'MultiLangText', langs: Array<LanguagesEnum>, texts: Array<{ __typename?: 'LangText', lang: LanguagesEnum, text: string }> } | null } | { __typename: 'ProfileFieldTypePicture', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, image?: { __typename?: 'MediaPicture', umaId: number, umpId: number, type: string, rejectReason?: string | null, status: MediaPictureStatusEnum, image: { __typename?: 'Image', src: string, alt: string, srcset: string } } | null, upload: { __typename?: 'UploadInfo', errorCodes?: any | null, requiredFormData?: any | null, url?: string | null } } | { __typename: 'ProfileFieldTypePictureList', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename: 'ProfileFieldTypeString', value?: string | null, minLength?: number | null, maxLength?: number | null, name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename: 'ProfileFieldTypeUploadDocument', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | null> } | null, validate?: { __typename?: 'TourValidation', data?: Array<{ __typename: 'ProfileFieldTypeValidationBoolean', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationDate', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationEnum', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationEnumList', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationInt', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationMultiLangString', name: ProfileFieldsEnum, isValid: boolean, multiLangErrors?: Array<{ __typename?: 'ProfileFieldValidationErrorMultiLang', lang: string, message: string }> | null } | { __typename: 'ProfileFieldTypeValidationPicture', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationPictureList', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationString', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationUploadDocument', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | null> | null } | null };

export type CurrentStepWizardProfileFragment = { __typename?: 'TourStep', pos: number, id: string, fields: Array<{ __typename: 'ProfileFieldTypeBoolean', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename: 'ProfileFieldTypeDate', minDate?: any | null, maxDate?: any | null, name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, date?: any | null } | { __typename: 'ProfileFieldTypeEnum', value?: string | null, name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, quickpickValues: Array<{ __typename?: 'OptionEntry', label: string, value: string }>, validValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }> } | { __typename: 'ProfileFieldTypeEnumList', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename: 'ProfileFieldTypeFormManagerGenericForm', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename: 'ProfileFieldTypeFormManagerPaperlessForm', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename: 'ProfileFieldTypeInt', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename: 'ProfileFieldTypeMultiLangString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, multiLangMinLength: number, multiLangMaxLength: number, multiLangValue?: { __typename?: 'MultiLangText', langs: Array<LanguagesEnum>, texts: Array<{ __typename?: 'LangText', lang: LanguagesEnum, text: string }> } | null } | { __typename: 'ProfileFieldTypePicture', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, image?: { __typename?: 'MediaPicture', umaId: number, umpId: number, type: string, rejectReason?: string | null, status: MediaPictureStatusEnum, image: { __typename?: 'Image', src: string, alt: string, srcset: string } } | null, upload: { __typename?: 'UploadInfo', errorCodes?: any | null, requiredFormData?: any | null, url?: string | null } } | { __typename: 'ProfileFieldTypePictureList', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename: 'ProfileFieldTypeString', value?: string | null, minLength?: number | null, maxLength?: number | null, name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | { __typename: 'ProfileFieldTypeUploadDocument', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null } | null> };

export type ProfileWizardMultiLangStringFragment = { __typename?: 'ProfileFieldTypeMultiLangString', multiLangMinLength: number, multiLangMaxLength: number, multiLangValue?: { __typename?: 'MultiLangText', langs: Array<LanguagesEnum>, texts: Array<{ __typename?: 'LangText', lang: LanguagesEnum, text: string }> } | null };

export type CheckUserNameValidityMutationVariables = Exact<{
  userName: Scalars['String']['input'];
}>;


export type CheckUserNameValidityMutation = { __typename?: 'Mutation', profile?: { __typename?: 'ProfileMutation', validate?: { __typename: 'ProfileFieldTypeValidationBoolean', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationDate', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationEnum', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationEnumList', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationInt', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationMultiLangString', name: ProfileFieldsEnum, isValid: boolean, multiLangErrors?: Array<{ __typename?: 'ProfileFieldValidationErrorMultiLang', lang: string, message: string }> | null } | { __typename: 'ProfileFieldTypeValidationPicture', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationPictureList', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationString', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationUploadDocument', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | null } | null };

export type WizardVerificationQueryVariables = Exact<{ [key: string]: never; }>;


export type WizardVerificationQuery = { __typename?: 'Query', account: { __typename?: 'Account', userId: number, isStudio: boolean, actors: Array<{ __typename?: 'Actor', userId: number, personalDocumentsStatus: ProfileStatusEnum, birthday?: any | null, address?: { __typename?: 'Address', firstname?: string | null, lastname?: string | null } | null } | null>, originator?: { __typename?: 'Originator', isActor: boolean } | null } };

export type WizardVerificationCreateTourQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type WizardVerificationCreateTourQuery = { __typename?: 'Query', documents: { __typename?: 'Documents', tour: { __typename?: 'DocumentUploadAssistant', currentStep?: { __typename?: 'DocumentUploadAssistantStep', name: DocumentUploadAssistantStepEnum, status: DocumentUploadAssistantStepStatusEnum, documentType: DocumentTypeEnum, uploadUrl: string, position: number, lastUploadedDocument?: { __typename?: 'Document', id: number, type: DocumentTypeEnum, status: DocumentStatusEnum, side: DocumentSideEnum, userId: number, uploadDate: any, isImage: boolean, url: string, rejectionReason?: string | null } | null } | null, steps: Array<{ __typename?: 'DocumentUploadAssistantStep', name: DocumentUploadAssistantStepEnum } | null> } } };

export type VerificationTourCurrentStepFragment = { __typename?: 'DocumentUploadAssistantStep', name: DocumentUploadAssistantStepEnum, status: DocumentUploadAssistantStepStatusEnum, documentType: DocumentTypeEnum, uploadUrl: string, position: number, lastUploadedDocument?: { __typename?: 'Document', id: number, type: DocumentTypeEnum, status: DocumentStatusEnum, side: DocumentSideEnum, userId: number, uploadDate: any, isImage: boolean, url: string, rejectionReason?: string | null } | null };

export type VerificationTourStepFragment = { __typename?: 'DocumentUploadAssistantStep', name: DocumentUploadAssistantStepEnum };

export type SkipVerificationBacksideMutationVariables = Exact<{
  userId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SkipVerificationBacksideMutation = { __typename?: 'Mutation', documents?: { __typename?: 'DocumentsMutation', skipBacksideUpload?: boolean | null } | null };

export type VerificationSaveActorMutationVariables = Exact<{
  data: InputSaveRealPersonData;
}>;


export type VerificationSaveActorMutation = { __typename?: 'Mutation', account?: { __typename?: 'AccountMutation', saveActor?: { __typename?: 'SaveRealPersonMutationResult', success: boolean, errorMessage?: string | null, savedActor?: { __typename?: 'Actor', userId: number, isVerified: boolean, isLeadActor: boolean, isNew: boolean, personalDocumentsStatus: ProfileStatusEnum, birthday?: any | null, personalDocuments: { __typename?: 'DocumentsPersonalRealPerson', isModelReleaseFormRequired: boolean, isIdShotRequired: boolean, identityProofFront?: { __typename?: 'Document', id: number, filename: string, url: string, status: DocumentStatusEnum, rejectionReason?: string | null, side: DocumentSideEnum, isImage: boolean, type: DocumentTypeEnum, typeName: string, uploadDate: any, userId: number } | null, identityProofBack?: { __typename?: 'Document', id: number, filename: string, url: string, status: DocumentStatusEnum, rejectionReason?: string | null, side: DocumentSideEnum, isImage: boolean, type: DocumentTypeEnum, typeName: string, uploadDate: any, userId: number } | null, idShot?: { __typename?: 'Document', id: number, filename: string, url: string, status: DocumentStatusEnum, rejectionReason?: string | null, side: DocumentSideEnum, isImage: boolean, type: DocumentTypeEnum, typeName: string, uploadDate: any, userId: number } | null, modelReleaseForm?: { __typename?: 'Document', id: number, filename: string, url: string, status: DocumentStatusEnum, rejectionReason?: string | null, side: DocumentSideEnum, isImage: boolean, type: DocumentTypeEnum, typeName: string, uploadDate: any, userId: number } | null }, address?: { __typename?: 'Address', isEditable: boolean, isCompany: boolean, companyName?: string | null, firstname?: string | null, lastname?: string | null, street?: string | null, streetNumber?: string | null, city?: string | null, zipCode?: string | null, countryCode?: string | null } | null } | null } | null } | null };

export type TourValidationFragment = { __typename?: 'TourValidation', data?: Array<{ __typename: 'ProfileFieldTypeValidationBoolean', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationDate', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationEnum', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationEnumList', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationInt', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationMultiLangString', name: ProfileFieldsEnum, isValid: boolean, multiLangErrors?: Array<{ __typename?: 'ProfileFieldValidationErrorMultiLang', lang: string, message: string }> | null } | { __typename: 'ProfileFieldTypeValidationPicture', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationPictureList', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationString', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationUploadDocument', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | null> | null };

export type AccountStatusProviderQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountStatusProviderQuery = { __typename?: 'Query', account: { __typename?: 'Account', isModelVerified: boolean, wasOnlineOnVXLive: boolean }, profileTour: { __typename?: 'TourModelReleaseFormV1' } | { __typename?: 'TourOnboardingV1', status: ProfileStatusEnum, lastVerified?: any | null } | { __typename?: 'TourPayoutV1' } | { __typename?: 'TourPayoutV2' }, verificationTour: { __typename?: 'Account', modelVerificationStatus: ModelVerificationStatusEnum }, mrfTour: { __typename?: 'TourModelReleaseFormV1', status: ProfileStatusEnum, lastVerified?: any | null } | { __typename?: 'TourOnboardingV1' } | { __typename?: 'TourPayoutV1' } | { __typename?: 'TourPayoutV2' } };

export type LoginMutationVariables = Exact<{
  username: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type LoginMutation = { __typename?: 'Mutation', auth?: { __typename?: 'AuthMutation', login?: { __typename: 'AuthResultAccountLocked' } | { __typename: 'AuthResultInsufficientRights' } | { __typename: 'AuthResultInvalidCredentials' } | { __typename: 'AuthResultSuccessful', accessToken: any, refreshToken: any, redirectUrl?: string | null } | { __typename: 'SignupResultFail' } | null } | null };

export type LoginWithTokenMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type LoginWithTokenMutation = { __typename?: 'Mutation', auth?: { __typename?: 'AuthMutation', loginWithToken?: { __typename?: 'AuthResultAccountLocked' } | { __typename?: 'AuthResultInsufficientRights' } | { __typename?: 'AuthResultInvalidCredentials' } | { __typename?: 'AuthResultSuccessful', accessToken: any, refreshToken: any, redirectUrl?: string | null } | { __typename?: 'SignupResultFail' } | null } | null };

export type GetUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserQuery = { __typename?: 'Query', auth?: { __typename?: 'Auth', accessToken?: string | null, user?: { __typename?: 'AuthUser', permissions: Array<AuthUserPermissionEnum>, userId: string, username: string, scope: ScopeEnum, roles: Array<SecurityRoleEnum>, lang: ApiLangEnum } | null } | null, account: { __typename?: 'Account', language: string } };

export type GetContestDataQueryVariables = Exact<{
  contestId?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<MediaContestTypeEnum>;
}>;


export type GetContestDataQuery = { __typename?: 'Query', media: { __typename?: 'Media', contest?: { __typename?: 'MediaContest', id: number, type: MediaContestTypeEnum, title: string, description: string, uploadStart: any, uploadEnd: any, votingStart: any, votingEnd: any, userPlace?: number | null, uploadLimit: number, images: { __typename?: 'MediaContestImages', titleImage?: string | null, comingSoonImage?: string | null, payturSignupImage?: string | null }, prizes: Array<{ __typename?: 'MediaContestPrize', place: number, amount: number } | null>, video?: { __typename: 'Video', albumId: number, contestId?: number | null, type?: VideoTypeEnum | null, uploadRequestId?: string | null, releasedStatus?: VideoReleasedStatusEnum | null, plannedReleaseDate?: any | null, isPlannedReleaseDateEditable?: boolean | null, allIDCardsUploaded: boolean, allModelReleaseFormsUploaded: boolean, price?: number | null, likesCount?: number | null, salesCount?: number | null, feedbacksCount?: number | null, isDiscountVisible?: boolean | null, discountPercent?: number | null, discountStart?: any | null, discountEnd?: any | null, userId: number, videoId: number, status?: VideoStatusEnum | null, rejectionReason?: string | null, url: string, length?: number | null, isVip30Video: boolean, isEditable: boolean, isSharedVideo: boolean, tagCollection?: Array<{ __typename?: 'MediaTag', flags?: number | null, id?: number | null, isChecked?: boolean | null, value?: string | null } | null> | null, pictures?: Array<{ __typename?: 'MediaPicture', umaId: number, umpId: number, type: string, rejectReason?: string | null, status: MediaPictureStatusEnum, image: { __typename?: 'Image', src: string, alt: string, srcset: string } } | null> | null, textCollection?: { __typename?: 'MediaTextCollection', visitxTitles?: Array<{ __typename?: 'MediaText', lang?: string | null, text?: string | null } | null> | null, visitxDescriptions?: Array<{ __typename?: 'MediaText', lang?: string | null, text?: string | null } | null> | null } | null, previewPicture16?: { __typename?: 'MediaPicture', fsk: number, position: number, rejectReason?: string | null, status: MediaPictureStatusEnum, type: string, umaId: number, umpId: number, image: { __typename?: 'Image', alt: string, src: string, srcset: string } } | null, previewPicture18?: { __typename?: 'MediaPicture', fsk: number, position: number, rejectReason?: string | null, status: MediaPictureStatusEnum, type: string, umaId: number, umpId: number, image: { __typename?: 'Image', alt: string, src: string, srcset: string } } | null } | null, photoalbum?: { __typename?: 'Photoalbum', userId: number, albumId: number, status?: PhotoalbumStatusEnum | null, type?: PhotoalbumTypeEnum | null, isPriceVisible?: boolean | null, price?: number | null, priceMax?: number | null, releasedDate?: any | null, salesCount?: number | null, likesCount?: number | null, feedbacksCount?: number | null, pictureCountTotal?: number | null, pictureCountRejected?: number | null, pictureCountReleased?: number | null, contestId?: number | null, releasedStatus: PhotoalbumReleasedStatusEnum, previewPicture16?: { __typename?: 'MediaPicture', umpId: number, umaId: number, position: number, type: string, status: MediaPictureStatusEnum, rejectReason?: string | null, image: { __typename?: 'Image', alt: string, src: string, srcset: string } } | null, previewPicture18?: { __typename?: 'MediaPicture', umpId: number, umaId: number, position: number, type: string, status: MediaPictureStatusEnum, rejectReason?: string | null, image: { __typename?: 'Image', alt: string, src: string, srcset: string } } | null, textCollection?: { __typename?: 'MediaTextCollection', visitxTitles?: Array<{ __typename?: 'MediaText', lang?: string | null, text?: string | null } | null> | null, visitxDescriptions?: Array<{ __typename?: 'MediaText', lang?: string | null, text?: string | null } | null> | null } | null, tagCollection?: Array<{ __typename?: 'MediaTag', id?: number | null, value?: string | null, flags?: number | null, isChecked?: boolean | null } | null> | null } | null } | null } };

export type GetPictureUploadUrlQueryVariables = Exact<{
  umaId: Scalars['Int']['input'];
  pictureType: Scalars['Int']['input'];
}>;


export type GetPictureUploadUrlQuery = { __typename?: 'Query', media: { __typename?: 'Media', photoalbums: { __typename?: 'Photoalbums', pictureUploadUrl?: string | null } } };

export type ContestFragment = { __typename?: 'MediaContest', id: number, type: MediaContestTypeEnum, title: string, description: string, uploadStart: any, uploadEnd: any, votingStart: any, votingEnd: any, userPlace?: number | null, uploadLimit: number, images: { __typename?: 'MediaContestImages', titleImage?: string | null, comingSoonImage?: string | null, payturSignupImage?: string | null }, prizes: Array<{ __typename?: 'MediaContestPrize', place: number, amount: number } | null>, video?: { __typename: 'Video', albumId: number, contestId?: number | null, type?: VideoTypeEnum | null, uploadRequestId?: string | null, releasedStatus?: VideoReleasedStatusEnum | null, plannedReleaseDate?: any | null, isPlannedReleaseDateEditable?: boolean | null, allIDCardsUploaded: boolean, allModelReleaseFormsUploaded: boolean, price?: number | null, likesCount?: number | null, salesCount?: number | null, feedbacksCount?: number | null, isDiscountVisible?: boolean | null, discountPercent?: number | null, discountStart?: any | null, discountEnd?: any | null, userId: number, videoId: number, status?: VideoStatusEnum | null, rejectionReason?: string | null, url: string, length?: number | null, isVip30Video: boolean, isEditable: boolean, isSharedVideo: boolean, tagCollection?: Array<{ __typename?: 'MediaTag', flags?: number | null, id?: number | null, isChecked?: boolean | null, value?: string | null } | null> | null, pictures?: Array<{ __typename?: 'MediaPicture', umaId: number, umpId: number, type: string, rejectReason?: string | null, status: MediaPictureStatusEnum, image: { __typename?: 'Image', src: string, alt: string, srcset: string } } | null> | null, textCollection?: { __typename?: 'MediaTextCollection', visitxTitles?: Array<{ __typename?: 'MediaText', lang?: string | null, text?: string | null } | null> | null, visitxDescriptions?: Array<{ __typename?: 'MediaText', lang?: string | null, text?: string | null } | null> | null } | null, previewPicture16?: { __typename?: 'MediaPicture', fsk: number, position: number, rejectReason?: string | null, status: MediaPictureStatusEnum, type: string, umaId: number, umpId: number, image: { __typename?: 'Image', alt: string, src: string, srcset: string } } | null, previewPicture18?: { __typename?: 'MediaPicture', fsk: number, position: number, rejectReason?: string | null, status: MediaPictureStatusEnum, type: string, umaId: number, umpId: number, image: { __typename?: 'Image', alt: string, src: string, srcset: string } } | null } | null, photoalbum?: { __typename?: 'Photoalbum', userId: number, albumId: number, status?: PhotoalbumStatusEnum | null, type?: PhotoalbumTypeEnum | null, isPriceVisible?: boolean | null, price?: number | null, priceMax?: number | null, releasedDate?: any | null, salesCount?: number | null, likesCount?: number | null, feedbacksCount?: number | null, pictureCountTotal?: number | null, pictureCountRejected?: number | null, pictureCountReleased?: number | null, contestId?: number | null, releasedStatus: PhotoalbumReleasedStatusEnum, previewPicture16?: { __typename?: 'MediaPicture', umpId: number, umaId: number, position: number, type: string, status: MediaPictureStatusEnum, rejectReason?: string | null, image: { __typename?: 'Image', alt: string, src: string, srcset: string } } | null, previewPicture18?: { __typename?: 'MediaPicture', umpId: number, umaId: number, position: number, type: string, status: MediaPictureStatusEnum, rejectReason?: string | null, image: { __typename?: 'Image', alt: string, src: string, srcset: string } } | null, textCollection?: { __typename?: 'MediaTextCollection', visitxTitles?: Array<{ __typename?: 'MediaText', lang?: string | null, text?: string | null } | null> | null, visitxDescriptions?: Array<{ __typename?: 'MediaText', lang?: string | null, text?: string | null } | null> | null } | null, tagCollection?: Array<{ __typename?: 'MediaTag', id?: number | null, value?: string | null, flags?: number | null, isChecked?: boolean | null } | null> | null } | null };

export type GetVxLiveChannelDeeplinkQueryVariables = Exact<{
  guestUserId: Scalars['String']['input'];
}>;


export type GetVxLiveChannelDeeplinkQuery = { __typename?: 'Query', vxlive: { __typename?: 'VXLive', deepLinkUrl?: string | null } };

export type GetFinanceServiceQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFinanceServiceQuery = { __typename?: 'Query', account: { __typename?: 'Account', isAccountFromGermany: boolean, isAccountFromEU: boolean, expirationDateOfLastAcceptedTaxDocument?: any | null, originator?: { __typename?: 'Originator', userId: number, financialDocuments: { __typename?: 'DocumentsFinancialRealPerson', isProofOfAddressRequired: boolean, isTaxDocumentRequired: boolean, proofOfAddress?: { __typename?: 'Document', id: number, filename: string, url: string, status: DocumentStatusEnum, rejectionReason?: string | null, side: DocumentSideEnum, isImage: boolean, type: DocumentTypeEnum, typeName: string, uploadDate: any, userId: number } | null, taxDocument?: { __typename?: 'Document', id: number, filename: string, url: string, status: DocumentStatusEnum, rejectionReason?: string | null, side: DocumentSideEnum, isImage: boolean, type: DocumentTypeEnum, typeName: string, uploadDate: any, userId: number } | null } } | null }, payoutWizardV1: { __typename?: 'TourModelReleaseFormV1' } | { __typename?: 'TourOnboardingV1' } | { __typename?: 'TourPayoutV1', active: boolean, status: ProfileStatusEnum, lastVerified?: any | null } | { __typename?: 'TourPayoutV2' }, payoutWizardV2: { __typename?: 'TourModelReleaseFormV1' } | { __typename?: 'TourOnboardingV1' } | { __typename?: 'TourPayoutV1' } | { __typename?: 'TourPayoutV2', active: boolean, status: ProfileStatusEnum }, finances: { __typename?: 'Finances', payoutStatus: { __typename?: 'FinancesPayoutStatus', isFirstPayout: boolean, payoutDate?: any | null, status: FinancesPayoutStatusEnum, minimalPayableAmount: number, payableAmount: number } }, profile: { __typename?: 'Profile', collection?: { __typename?: 'ProfileCollectionAccountV1' } | { __typename?: 'ProfileCollectionMobileAboutMeV1' } | { __typename?: 'ProfileCollectionMobileAppearanceV1' } | { __typename?: 'ProfileCollectionMobileInterviewV1' } | { __typename?: 'ProfileCollectionMobileMediaV1' } | { __typename?: 'ProfileCollectionMobileProfileV1' } | { __typename?: 'ProfileCollectionModelReleaseFormV1' } | { __typename?: 'ProfileCollectionOnboardingV1' } | { __typename?: 'ProfileCollectionPayoutV1', fields: { __typename?: 'ProfileCollectionPayoutV1Fields', payoutIsTaxable?: { __typename: 'ProfileFieldTypeBoolean', name: string, status: ProfileStatusEnum, rejectReason?: string | null, value?: boolean | null } | null, payoutTaxId?: { __typename: 'ProfileFieldTypeString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, minLength?: number | null, maxLength?: number | null } | null, payoutTaxDocument?: { __typename: 'ProfileFieldTypeUploadDocument', name: string, status: ProfileStatusEnum, rejectReason?: string | null, value?: { __typename?: 'UploadDocument', docId: number } | null } | null, payoutTransactionType?: { __typename: 'ProfileFieldTypeEnum', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, quickpickValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }>, validValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }> } | null, payoutBankaccountOwner?: { __typename: 'ProfileFieldTypeString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, minLength?: number | null, maxLength?: number | null } | null, payoutIban?: { __typename: 'ProfileFieldTypeString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, minLength?: number | null, maxLength?: number | null } | null, payoutBic?: { __typename: 'ProfileFieldTypeString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, minLength?: number | null, maxLength?: number | null } | null, payoutPaxumEmailAccount?: { __typename: 'ProfileFieldTypeString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, minLength?: number | null, maxLength?: number | null } | null, payoutAddressDocument?: { __typename: 'ProfileFieldTypeUploadDocument', name: string, status: ProfileStatusEnum, rejectReason?: string | null, value?: { __typename?: 'UploadDocument', docId: number } | null } | null }, values: { __typename?: 'ProfileCollectionPayoutV1Values', payoutIsTaxable?: boolean | null, payoutTaxId?: string | null, payoutTransactionType?: FinancesPayoutMethodEnum | null, payoutBankaccountOwner?: string | null, payoutIban?: string | null, payoutBic?: string | null, payoutPaxumEmailAccount?: string | null, payoutAddressCity?: string | null, payoutAddressCountry?: CountryEnum | null, payoutAddressPostalCode?: string | null, payoutAddressStreet?: string | null, payoutAddressStreetNumber?: string | null, payoutAddressFirstname?: string | null, payoutAddressLastname?: string | null, payoutAddressCompanyname?: string | null, payoutAddressIsCompany?: boolean | null, payoutTaxDocument?: { __typename?: 'UploadDocument', docId: number } | null, payoutAddressDocument?: { __typename?: 'UploadDocument', docId: number } | null } } | null } };

export type FinanceServiceCollectionFragment = { __typename?: 'ProfileCollectionPayoutV1', fields: { __typename?: 'ProfileCollectionPayoutV1Fields', payoutIsTaxable?: { __typename: 'ProfileFieldTypeBoolean', name: string, status: ProfileStatusEnum, rejectReason?: string | null, value?: boolean | null } | null, payoutTaxId?: { __typename: 'ProfileFieldTypeString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, minLength?: number | null, maxLength?: number | null } | null, payoutTaxDocument?: { __typename: 'ProfileFieldTypeUploadDocument', name: string, status: ProfileStatusEnum, rejectReason?: string | null, value?: { __typename?: 'UploadDocument', docId: number } | null } | null, payoutTransactionType?: { __typename: 'ProfileFieldTypeEnum', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, quickpickValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }>, validValues: Array<{ __typename?: 'OptionEntry', value: string, label: string }> } | null, payoutBankaccountOwner?: { __typename: 'ProfileFieldTypeString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, minLength?: number | null, maxLength?: number | null } | null, payoutIban?: { __typename: 'ProfileFieldTypeString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, minLength?: number | null, maxLength?: number | null } | null, payoutBic?: { __typename: 'ProfileFieldTypeString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, minLength?: number | null, maxLength?: number | null } | null, payoutPaxumEmailAccount?: { __typename: 'ProfileFieldTypeString', name: string, readOnly: boolean, status: ProfileStatusEnum, rejectReason?: string | null, disabled: boolean, value?: string | null, minLength?: number | null, maxLength?: number | null } | null, payoutAddressDocument?: { __typename: 'ProfileFieldTypeUploadDocument', name: string, status: ProfileStatusEnum, rejectReason?: string | null, value?: { __typename?: 'UploadDocument', docId: number } | null } | null }, values: { __typename?: 'ProfileCollectionPayoutV1Values', payoutIsTaxable?: boolean | null, payoutTaxId?: string | null, payoutTransactionType?: FinancesPayoutMethodEnum | null, payoutBankaccountOwner?: string | null, payoutIban?: string | null, payoutBic?: string | null, payoutPaxumEmailAccount?: string | null, payoutAddressCity?: string | null, payoutAddressCountry?: CountryEnum | null, payoutAddressPostalCode?: string | null, payoutAddressStreet?: string | null, payoutAddressStreetNumber?: string | null, payoutAddressFirstname?: string | null, payoutAddressLastname?: string | null, payoutAddressCompanyname?: string | null, payoutAddressIsCompany?: boolean | null, payoutTaxDocument?: { __typename?: 'UploadDocument', docId: number } | null, payoutAddressDocument?: { __typename?: 'UploadDocument', docId: number } | null } };

export type GetInvoicesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInvoicesQuery = { __typename?: 'Query', account: { __typename?: 'Account', signupDate: any }, finances: { __typename?: 'Finances', invoices: { __typename?: 'FinancesInvoices', count: number, maxDate?: any | null, minDate?: any | null, invoices?: Array<{ __typename?: 'FinancesInvoice', amount: number, payoutDate: any, status: FinancesInvoiceStatusEnum, message: string, billingStartDate: any, billingEndDate: any } | null> | null } } };

export type UpdatePayoutCollectionMutationVariables = Exact<{
  data: InputProfileCollectionPayoutV1;
}>;


export type UpdatePayoutCollectionMutation = { __typename?: 'Mutation', profile?: { __typename?: 'ProfileMutation', collection?: { __typename?: 'ProfileCollectionAccountV1Mutation' } | { __typename?: 'ProfileCollectionMobileAboutMeV1Mutation' } | { __typename?: 'ProfileCollectionMobileAppearanceV1Mutation' } | { __typename?: 'ProfileCollectionMobileInterviewV1Mutation' } | { __typename?: 'ProfileCollectionMobileMediaV1Mutation' } | { __typename?: 'ProfileCollectionMobileProfileV1Mutation' } | { __typename?: 'ProfileCollectionModelReleaseFormV1Mutation' } | { __typename?: 'ProfileCollectionOnboardingV1Mutation' } | { __typename?: 'ProfileCollectionPayoutV1Mutation', update: { __typename?: 'ProfileCollectionPayoutV1' } | { __typename: 'ProfileFieldValidationSet', hasErrors: boolean, field: Array<{ __typename: 'ProfileFieldTypeValidationBoolean', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationDate', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationEnum', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationEnumList', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationInt', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationMultiLangString', name: ProfileFieldsEnum, isValid: boolean, multiLangErrors?: Array<{ __typename?: 'ProfileFieldValidationErrorMultiLang', lang: string, message: string }> | null } | { __typename: 'ProfileFieldTypeValidationPicture', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationPictureList', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationString', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationUploadDocument', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null }> } } | null } | null };

export type ProfileFieldTypeBooleanFragment = { __typename: 'ProfileFieldTypeBoolean', name: string, status: ProfileStatusEnum, rejectReason?: string | null, value?: boolean | null };

export type ProfileFieldTypeUploadDocumentFragment = { __typename: 'ProfileFieldTypeUploadDocument', name: string, status: ProfileStatusEnum, rejectReason?: string | null, value?: { __typename?: 'UploadDocument', docId: number } | null };

export type ExtendedUploadDocumentFragment = { __typename?: 'UploadDocument', docId: number, expireDate?: any | null, filename: string, url: string, status: DocumentStatusEnum };

export type ExtendedProfileFieldTypeUploadDocumentFragment = { __typename: 'ProfileFieldTypeUploadDocument', name: string, status: ProfileStatusEnum, rejectReason?: string | null, value?: { __typename?: 'UploadDocument', docId: number, expireDate?: any | null, filename: string, url: string, status: DocumentStatusEnum } | null };

export type OldFinancesInvoicesFragment = { __typename?: 'FinancesInvoices', count: number, maxDate?: any | null, minDate?: any | null, invoices?: Array<{ __typename?: 'FinancesInvoice', amount: number, payoutDate: any, status: FinancesInvoiceStatusEnum, message: string, billingStartDate: any, billingEndDate: any } | null> | null };

export type OldFinancesInvoiceFragment = { __typename?: 'FinancesInvoice', amount: number, payoutDate: any, status: FinancesInvoiceStatusEnum, message: string, billingStartDate: any, billingEndDate: any };

export type CheckTaxIdValidityMutationVariables = Exact<{
  taxId: Scalars['String']['input'];
}>;


export type CheckTaxIdValidityMutation = { __typename?: 'Mutation', profile?: { __typename?: 'ProfileMutation', validate?: { __typename: 'ProfileFieldTypeValidationBoolean', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationDate', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationEnum', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationEnumList', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationInt', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationMultiLangString', name: ProfileFieldsEnum, isValid: boolean, multiLangErrors?: Array<{ __typename?: 'ProfileFieldValidationErrorMultiLang', lang: string, message: string }> | null } | { __typename: 'ProfileFieldTypeValidationPicture', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationPictureList', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationString', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | { __typename: 'ProfileFieldTypeValidationUploadDocument', name: ProfileFieldsEnum, isValid: boolean, errors?: Array<{ __typename?: 'ProfileFieldValidationError', message: string }> | null } | null } | null };

export type GetIncomeSourceDetailDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetIncomeSourceDetailDataQuery = { __typename?: 'Query', helpcenter: { __typename?: 'Helpcenter', incomeSources?: { __typename?: 'IncomeSources', incomeSourceById?: { __typename?: 'IncomeSourcesEntry', id: string, title: string, teaserText: string, body: any, isLabeledNew: boolean, activatedAt?: any | null, readAt?: any | null, headerImage: { __typename?: 'Image', alt: string, src: string }, experienceTags?: Array<{ __typename?: 'TipsTag', id: string, value?: string | null } | null> | null, intentionTags?: Array<{ __typename?: 'TipsTag', id: string, value?: string | null } | null> | null } | null } | null } };

export type ActivateIncomeSourceMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ActivateIncomeSourceMutation = { __typename?: 'Mutation', helpcenter?: { __typename?: 'HelpcenterMutation', incomeSources?: { __typename?: 'IncomeSourcesMutation', activate?: { __typename?: 'IncomeSourcesEntry', id: string, activatedAt?: any | null } | null } | null } | null };

export type DeactivateIncomeSourceMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeactivateIncomeSourceMutation = { __typename?: 'Mutation', helpcenter?: { __typename?: 'HelpcenterMutation', incomeSources?: { __typename?: 'IncomeSourcesMutation', deactivate?: { __typename?: 'IncomeSourcesEntry', id: string, activatedAt?: any | null } | null } | null } | null };

export type MarkIncomeSourceAsReadMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type MarkIncomeSourceAsReadMutation = { __typename?: 'Mutation', helpcenter?: { __typename?: 'HelpcenterMutation', incomeSources?: { __typename?: 'IncomeSourcesMutation', markAsRead?: { __typename?: 'IncomeSourcesEntry', id: string, readAt?: any | null } | null } | null } | null };

export type GetIncomeSourcesDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetIncomeSourcesDataQuery = { __typename?: 'Query', helpcenter: { __typename?: 'Helpcenter', incomeSources?: { __typename?: 'IncomeSources', entries: Array<{ __typename?: 'IncomeSourcesEntry', id: string, title: string, teaserText: string, isLabeledNew: boolean, activatedAt?: any | null, readAt?: any | null, headerImage: { __typename?: 'Image', alt: string, src: string }, experienceTags?: Array<{ __typename?: 'TipsTag', id: string, value?: string | null } | null> | null, intentionTags?: Array<{ __typename?: 'TipsTag', id: string, value?: string | null } | null> | null } | null>, experienceTags: Array<{ __typename?: 'TipsTag', id: string, value?: string | null } | null>, intentionTags: Array<{ __typename?: 'TipsTag', id: string, value?: string | null } | null> } | null } };

export type GetMandatoryEmaiLVerificationProviderDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMandatoryEmaiLVerificationProviderDataQuery = { __typename?: 'Query', account: { __typename?: 'Account', isRegistrationComplete: boolean, contact: { __typename?: 'Contact', emailAddress: string, currentEmailAddress: string } }, profile: { __typename?: 'Profile', collection?: { __typename?: 'ProfileCollectionAccountV1', fields: { __typename?: 'ProfileCollectionAccountV1Fields', accountContactEmailAdress?: { __typename?: 'ProfileFieldTypeString', maxLength?: number | null, minLength?: number | null } | null } } | { __typename?: 'ProfileCollectionMobileAboutMeV1' } | { __typename?: 'ProfileCollectionMobileAppearanceV1' } | { __typename?: 'ProfileCollectionMobileInterviewV1' } | { __typename?: 'ProfileCollectionMobileMediaV1' } | { __typename?: 'ProfileCollectionMobileProfileV1' } | { __typename?: 'ProfileCollectionModelReleaseFormV1' } | { __typename?: 'ProfileCollectionOnboardingV1' } | { __typename?: 'ProfileCollectionPayoutV1' } | null } };

export type MandatoryEmailVerificationSectionFragment = { __typename?: 'ProfileCollectionAccountV1', fields: { __typename?: 'ProfileCollectionAccountV1Fields', accountContactEmailAdress?: { __typename?: 'ProfileFieldTypeString', maxLength?: number | null, minLength?: number | null } | null } };

export type ResendEmailVerificationMutationVariables = Exact<{ [key: string]: never; }>;


export type ResendEmailVerificationMutation = { __typename?: 'Mutation', account?: { __typename?: 'AccountMutation', resendRegistrationMail?: { __typename?: 'MutationResult', success?: boolean | null, message?: string | null } | null } | null };

export type ChangeEmailAndResendRegistrationMailMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type ChangeEmailAndResendRegistrationMailMutation = { __typename?: 'Mutation', account?: { __typename?: 'AccountMutation', changeEmailAddressAndSendRegistrationMail?: { __typename?: 'MutationResult', success?: boolean | null, message?: string | null } | null } | null };

export type DeleteSedcardMutationVariables = Exact<{
  umaId: Scalars['Int']['input'];
  umpId: Scalars['Int']['input'];
}>;


export type DeleteSedcardMutation = { __typename?: 'Mutation', profile?: { __typename?: 'ProfileMutation', collection?: { __typename?: 'ProfileCollectionAccountV1Mutation' } | { __typename?: 'ProfileCollectionMobileAboutMeV1Mutation' } | { __typename?: 'ProfileCollectionMobileAppearanceV1Mutation' } | { __typename?: 'ProfileCollectionMobileInterviewV1Mutation' } | { __typename?: 'ProfileCollectionMobileMediaV1Mutation', deleteSedcardPicture: boolean } | { __typename?: 'ProfileCollectionMobileProfileV1Mutation' } | { __typename?: 'ProfileCollectionModelReleaseFormV1Mutation' } | { __typename?: 'ProfileCollectionOnboardingV1Mutation' } | { __typename?: 'ProfileCollectionPayoutV1Mutation' } | null } | null };

export type GetVxModelsClassicAutoLoginUrlWithPathQueryVariables = Exact<{
  path: Scalars['String']['input'];
}>;


export type GetVxModelsClassicAutoLoginUrlWithPathQuery = { __typename?: 'Query', app: { __typename?: 'App', autologinLinkVXModels?: string | null } };

export type GetOnboardingTaskStatusProviderQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOnboardingTaskStatusProviderQuery = { __typename?: 'Query', account: { __typename?: 'Account', modelVerificationStatus: ModelVerificationStatusEnum }, tour: { __typename?: 'TourModelReleaseFormV1' } | { __typename: 'TourOnboardingV1', status: ProfileStatusEnum, lastVerified?: any | null } | { __typename?: 'TourPayoutV1' } | { __typename?: 'TourPayoutV2' } };

export type GetStatisticProviderQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStatisticProviderQuery = { __typename?: 'Query', statistics: { __typename?: 'Statistics', entries: Array<{ __typename: 'StatisticsEntrySingleCurrency', unit: string, id: StatisticsEntryNameEnum, label: string, icon: string, category: StatisticsEntryCategoryEnum, values: Array<{ __typename?: 'StatisticsEntryValue', value: string, dateTime: any, ts: number } | null>, trend?: { __typename?: 'StatisticsTrend', percent: number } | null } | { __typename: 'StatisticsEntrySingleDuration', unit: string, id: StatisticsEntryNameEnum, label: string, icon: string, category: StatisticsEntryCategoryEnum, values: Array<{ __typename?: 'StatisticsEntryValue', value: string, dateTime: any, ts: number } | null>, trend?: { __typename?: 'StatisticsTrend', percent: number } | null } | { __typename: 'StatisticsEntrySingleNumber', unit: string, id: StatisticsEntryNameEnum, label: string, icon: string, category: StatisticsEntryCategoryEnum, values: Array<{ __typename?: 'StatisticsEntryValue', value: string, dateTime: any, ts: number } | null>, trend?: { __typename?: 'StatisticsTrend', percent: number } | null }> } };

type StatisticsEntry_StatisticsEntrySingleCurrency_Fragment = { __typename: 'StatisticsEntrySingleCurrency', unit: string, id: StatisticsEntryNameEnum, label: string, icon: string, category: StatisticsEntryCategoryEnum, values: Array<{ __typename?: 'StatisticsEntryValue', value: string, dateTime: any, ts: number } | null>, trend?: { __typename?: 'StatisticsTrend', percent: number } | null };

type StatisticsEntry_StatisticsEntrySingleDuration_Fragment = { __typename: 'StatisticsEntrySingleDuration', unit: string, id: StatisticsEntryNameEnum, label: string, icon: string, category: StatisticsEntryCategoryEnum, values: Array<{ __typename?: 'StatisticsEntryValue', value: string, dateTime: any, ts: number } | null>, trend?: { __typename?: 'StatisticsTrend', percent: number } | null };

type StatisticsEntry_StatisticsEntrySingleNumber_Fragment = { __typename: 'StatisticsEntrySingleNumber', unit: string, id: StatisticsEntryNameEnum, label: string, icon: string, category: StatisticsEntryCategoryEnum, values: Array<{ __typename?: 'StatisticsEntryValue', value: string, dateTime: any, ts: number } | null>, trend?: { __typename?: 'StatisticsTrend', percent: number } | null };

export type StatisticsEntryFragment = StatisticsEntry_StatisticsEntrySingleCurrency_Fragment | StatisticsEntry_StatisticsEntrySingleDuration_Fragment | StatisticsEntry_StatisticsEntrySingleNumber_Fragment;

export type GetTermsAcceptDatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTermsAcceptDatesQuery = { __typename?: 'Query', terms: { __typename?: 'Terms', termsAndConditions?: { __typename?: 'TermAcceptance', type: TermsAcceptanceTypeEnum, hasAccepted: boolean, hasAcceptedAnyVersion: boolean, acceptDate?: any | null, acceptedVersion?: any | null, consentRequired: boolean } | null, privacyPolicy?: { __typename?: 'TermAcceptance', type: TermsAcceptanceTypeEnum, hasAccepted: boolean, hasAcceptedAnyVersion: boolean, acceptDate?: any | null, acceptedVersion?: any | null, consentRequired: boolean } | null }, account: { __typename?: 'Account', isStudio: boolean, hasWebmasterId: boolean } };

export type TermAcceptanceStateFragment = { __typename?: 'TermAcceptance', type: TermsAcceptanceTypeEnum, hasAccepted: boolean, hasAcceptedAnyVersion: boolean, acceptDate?: any | null, acceptedVersion?: any | null, consentRequired: boolean };

export type AcceptTermsMutationVariables = Exact<{
  type: TermsAcceptanceTypeEnum;
}>;


export type AcceptTermsMutation = { __typename?: 'Mutation', terms?: { __typename?: 'TermsMutation', accept?: { __typename?: 'TermsAcceptResult', wasSuccsessful: boolean, isPasswordInvalid: boolean } | null } | null };

export type CreateWebmasterMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateWebmasterMutation = { __typename?: 'Mutation', vxcash: { __typename?: 'VXCashMutation', createWebmaster: number } };

export type GetTipDetailDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetTipDetailDataQuery = { __typename?: 'Query', helpcenter: { __typename?: 'Helpcenter', tips?: { __typename?: 'Tips', tipById?: { __typename?: 'TipsEntry', id: string, title: string, teaserText: string, body: any, isLabeledNew: boolean, readAt?: any | null, headerImage: { __typename?: 'Image', alt: string, src: string }, experienceTags?: Array<{ __typename?: 'TipsTag', id: string, value?: string | null } | null> | null, intentionTags?: Array<{ __typename?: 'TipsTag', id: string, value?: string | null } | null> | null } | null } | null } };

export type MarkTipAsReadMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type MarkTipAsReadMutation = { __typename?: 'Mutation', helpcenter?: { __typename?: 'HelpcenterMutation', tips?: { __typename?: 'TipsMutation', markAsRead?: { __typename?: 'TipsEntry', id: string, readAt?: any | null } | null } | null } | null };

export type GetTipsDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTipsDataQuery = { __typename?: 'Query', helpcenter: { __typename?: 'Helpcenter', tips?: { __typename?: 'Tips', entries: Array<{ __typename?: 'TipsEntry', id: string, title: string, teaserText: string, isLabeledNew: boolean, readAt?: any | null, headerImage: { __typename?: 'Image', alt: string, src: string }, experienceTags?: Array<{ __typename?: 'TipsTag', id: string, value?: string | null } | null> | null, intentionTags?: Array<{ __typename?: 'TipsTag', id: string, value?: string | null } | null> | null } | null>, experienceTags: Array<{ __typename?: 'TipsTag', id: string, value?: string | null } | null>, intentionTags: Array<{ __typename?: 'TipsTag', id: string, value?: string | null } | null> } | null } };

export type VxLiveLinkProviderQueryVariables = Exact<{ [key: string]: never; }>;


export type VxLiveLinkProviderQuery = { __typename?: 'Query', app: { __typename?: 'App', autologinLinkVXLive?: string | null } };

export type VideoLibraryDeleteMediaMutationVariables = Exact<{
  albumId: Scalars['Int']['input'];
}>;


export type VideoLibraryDeleteMediaMutation = { __typename?: 'Mutation', media?: { __typename?: 'MediaMutation', deleteMedia?: boolean | null } | null };

export type GetVideoCommentingProviderQueryVariables = Exact<{
  albumId: Scalars['Int']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
}>;


export type GetVideoCommentingProviderQuery = { __typename?: 'Query', media: { __typename?: 'Media', videos: { __typename?: 'Videos', videoById?: { __typename: 'Video', albumId: number, contestId?: number | null, type?: VideoTypeEnum | null, uploadRequestId?: string | null, releasedStatus?: VideoReleasedStatusEnum | null, plannedReleaseDate?: any | null, isPlannedReleaseDateEditable?: boolean | null, allIDCardsUploaded: boolean, allModelReleaseFormsUploaded: boolean, price?: number | null, likesCount?: number | null, salesCount?: number | null, feedbacksCount?: number | null, isDiscountVisible?: boolean | null, discountPercent?: number | null, discountStart?: any | null, discountEnd?: any | null, userId: number, videoId: number, status?: VideoStatusEnum | null, rejectionReason?: string | null, url: string, length?: number | null, isVip30Video: boolean, isEditable: boolean, isSharedVideo: boolean, tagCollection?: Array<{ __typename?: 'MediaTag', flags?: number | null, id?: number | null, isChecked?: boolean | null, value?: string | null } | null> | null, pictures?: Array<{ __typename?: 'MediaPicture', umaId: number, umpId: number, type: string, rejectReason?: string | null, status: MediaPictureStatusEnum, image: { __typename?: 'Image', src: string, alt: string, srcset: string } } | null> | null, textCollection?: { __typename?: 'MediaTextCollection', visitxTitles?: Array<{ __typename?: 'MediaText', lang?: string | null, text?: string | null } | null> | null, visitxDescriptions?: Array<{ __typename?: 'MediaText', lang?: string | null, text?: string | null } | null> | null } | null, previewPicture16?: { __typename?: 'MediaPicture', fsk: number, position: number, rejectReason?: string | null, status: MediaPictureStatusEnum, type: string, umaId: number, umpId: number, image: { __typename?: 'Image', alt: string, src: string, srcset: string } } | null, previewPicture18?: { __typename?: 'MediaPicture', fsk: number, position: number, rejectReason?: string | null, status: MediaPictureStatusEnum, type: string, umaId: number, umpId: number, image: { __typename?: 'Image', alt: string, src: string, srcset: string } } | null } | null }, comments: { __typename?: 'MediaCommentsList', totalCount: number, pageInfo?: { __typename?: 'PaginationPageInfo', hasNextPage: boolean } | null, edges: Array<{ __typename?: 'MediaCommentsPaginationEdge', cursor?: string | null, node: { __typename?: 'MediaComment', albumId: number, avatarUrl?: string | null, date: any, id: number, text: string, userId: number, userName: string, reply?: { __typename?: 'MediaCommentReply', date: any, id: number, text: string } | null } } | null> } } };

export type MediaCommentFragment = { __typename?: 'MediaComment', albumId: number, avatarUrl?: string | null, date: any, id: number, text: string, userId: number, userName: string, reply?: { __typename?: 'MediaCommentReply', date: any, id: number, text: string } | null };

export type CreateReplyCommentMutationVariables = Exact<{
  commentId: Scalars['Int']['input'];
  text: Scalars['String']['input'];
}>;


export type CreateReplyCommentMutation = { __typename?: 'Mutation', media?: { __typename?: 'MediaMutation', replyToComment: { __typename?: 'MediaComment', albumId: number, avatarUrl?: string | null, date: any, id: number, text: string, userId: number, userName: string, reply?: { __typename?: 'MediaCommentReply', date: any, id: number, text: string } | null } } | null };

export type GetPhotoCommentingProviderQueryVariables = Exact<{
  albumId: Scalars['Int']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
}>;


export type GetPhotoCommentingProviderQuery = { __typename?: 'Query', media: { __typename?: 'Media', comments: { __typename?: 'MediaCommentsList', totalCount: number, pageInfo?: { __typename?: 'PaginationPageInfo', hasNextPage: boolean } | null, edges: Array<{ __typename?: 'MediaCommentsPaginationEdge', cursor?: string | null, node: { __typename?: 'MediaComment', albumId: number, avatarUrl?: string | null, date: any, id: number, text: string, userId: number, userName: string, reply?: { __typename?: 'MediaCommentReply', date: any, id: number, text: string } | null } } | null> } } };

export type VideoLibraryUploadListEntryMutationVariables = Exact<{
  data: InputVideo;
}>;


export type VideoLibraryUploadListEntryMutation = { __typename?: 'Mutation', media?: { __typename?: 'MediaMutation', video: { __typename?: 'VideosMutation', saveVideo?: { __typename: 'Video', albumId: number, contestId?: number | null, type?: VideoTypeEnum | null, uploadRequestId?: string | null, releasedStatus?: VideoReleasedStatusEnum | null, plannedReleaseDate?: any | null, isPlannedReleaseDateEditable?: boolean | null, allIDCardsUploaded: boolean, allModelReleaseFormsUploaded: boolean, price?: number | null, likesCount?: number | null, salesCount?: number | null, feedbacksCount?: number | null, isDiscountVisible?: boolean | null, discountPercent?: number | null, discountStart?: any | null, discountEnd?: any | null, userId: number, videoId: number, status?: VideoStatusEnum | null, rejectionReason?: string | null, url: string, length?: number | null, isVip30Video: boolean, isEditable: boolean, isSharedVideo: boolean, tagCollection?: Array<{ __typename?: 'MediaTag', flags?: number | null, id?: number | null, isChecked?: boolean | null, value?: string | null } | null> | null, pictures?: Array<{ __typename?: 'MediaPicture', umaId: number, umpId: number, type: string, rejectReason?: string | null, status: MediaPictureStatusEnum, image: { __typename?: 'Image', src: string, alt: string, srcset: string } } | null> | null, textCollection?: { __typename?: 'MediaTextCollection', visitxTitles?: Array<{ __typename?: 'MediaText', lang?: string | null, text?: string | null } | null> | null, visitxDescriptions?: Array<{ __typename?: 'MediaText', lang?: string | null, text?: string | null } | null> | null } | null, previewPicture16?: { __typename?: 'MediaPicture', fsk: number, position: number, rejectReason?: string | null, status: MediaPictureStatusEnum, type: string, umaId: number, umpId: number, image: { __typename?: 'Image', alt: string, src: string, srcset: string } } | null, previewPicture18?: { __typename?: 'MediaPicture', fsk: number, position: number, rejectReason?: string | null, status: MediaPictureStatusEnum, type: string, umaId: number, umpId: number, image: { __typename?: 'Image', alt: string, src: string, srcset: string } } | null } | null } } | null };

export type GetVideoLibraryVideoUploadListEntryQueryVariables = Exact<{
  albumId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetVideoLibraryVideoUploadListEntryQuery = { __typename?: 'Query', media: { __typename?: 'Media', videos: { __typename?: 'Videos', videoById?: { __typename: 'Video', albumId: number, contestId?: number | null, type?: VideoTypeEnum | null, uploadRequestId?: string | null, releasedStatus?: VideoReleasedStatusEnum | null, plannedReleaseDate?: any | null, isPlannedReleaseDateEditable?: boolean | null, allIDCardsUploaded: boolean, allModelReleaseFormsUploaded: boolean, price?: number | null, likesCount?: number | null, salesCount?: number | null, feedbacksCount?: number | null, isDiscountVisible?: boolean | null, discountPercent?: number | null, discountStart?: any | null, discountEnd?: any | null, userId: number, videoId: number, status?: VideoStatusEnum | null, rejectionReason?: string | null, url: string, length?: number | null, isVip30Video: boolean, isEditable: boolean, isSharedVideo: boolean, tagCollection?: Array<{ __typename?: 'MediaTag', flags?: number | null, id?: number | null, isChecked?: boolean | null, value?: string | null } | null> | null, pictures?: Array<{ __typename?: 'MediaPicture', umaId: number, umpId: number, type: string, rejectReason?: string | null, status: MediaPictureStatusEnum, image: { __typename?: 'Image', src: string, alt: string, srcset: string } } | null> | null, textCollection?: { __typename?: 'MediaTextCollection', visitxTitles?: Array<{ __typename?: 'MediaText', lang?: string | null, text?: string | null } | null> | null, visitxDescriptions?: Array<{ __typename?: 'MediaText', lang?: string | null, text?: string | null } | null> | null } | null, previewPicture16?: { __typename?: 'MediaPicture', fsk: number, position: number, rejectReason?: string | null, status: MediaPictureStatusEnum, type: string, umaId: number, umpId: number, image: { __typename?: 'Image', alt: string, src: string, srcset: string } } | null, previewPicture18?: { __typename?: 'MediaPicture', fsk: number, position: number, rejectReason?: string | null, status: MediaPictureStatusEnum, type: string, umaId: number, umpId: number, image: { __typename?: 'Image', alt: string, src: string, srcset: string } } | null } | null } } };

export type GetVideoLibraryUploadListEntryPreviewPicturesQueryVariables = Exact<{
  albumId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetVideoLibraryUploadListEntryPreviewPicturesQuery = { __typename?: 'Query', media: { __typename?: 'Media', videos: { __typename?: 'Videos', videoById?: { __typename?: 'Video', pictures?: Array<{ __typename?: 'MediaPicture', umaId: number, umpId: number, type: string, rejectReason?: string | null, status: MediaPictureStatusEnum, image: { __typename?: 'Image', src: string, alt: string, srcset: string } } | null> | null } | null } } };

export type GetVideoLibraryPreviewPictureUploadUrlQueryVariables = Exact<{
  albumId: Scalars['Int']['input'];
}>;


export type GetVideoLibraryPreviewPictureUploadUrlQuery = { __typename?: 'Query', media: { __typename?: 'Media', videos: { __typename?: 'Videos', pictureUploadUrl: string } } };

export type GetVideoByRequestIdQueryVariables = Exact<{
  requestId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetVideoByRequestIdQuery = { __typename?: 'Query', media: { __typename?: 'Media', videos: { __typename?: 'Videos', videoById?: { __typename: 'Video', albumId: number, contestId?: number | null, type?: VideoTypeEnum | null, uploadRequestId?: string | null, releasedStatus?: VideoReleasedStatusEnum | null, plannedReleaseDate?: any | null, isPlannedReleaseDateEditable?: boolean | null, allIDCardsUploaded: boolean, allModelReleaseFormsUploaded: boolean, price?: number | null, likesCount?: number | null, salesCount?: number | null, feedbacksCount?: number | null, isDiscountVisible?: boolean | null, discountPercent?: number | null, discountStart?: any | null, discountEnd?: any | null, userId: number, videoId: number, status?: VideoStatusEnum | null, rejectionReason?: string | null, url: string, length?: number | null, isVip30Video: boolean, isEditable: boolean, isSharedVideo: boolean, tagCollection?: Array<{ __typename?: 'MediaTag', flags?: number | null, id?: number | null, isChecked?: boolean | null, value?: string | null } | null> | null, pictures?: Array<{ __typename?: 'MediaPicture', umaId: number, umpId: number, type: string, rejectReason?: string | null, status: MediaPictureStatusEnum, image: { __typename?: 'Image', src: string, alt: string, srcset: string } } | null> | null, textCollection?: { __typename?: 'MediaTextCollection', visitxTitles?: Array<{ __typename?: 'MediaText', lang?: string | null, text?: string | null } | null> | null, visitxDescriptions?: Array<{ __typename?: 'MediaText', lang?: string | null, text?: string | null } | null> | null } | null, previewPicture16?: { __typename?: 'MediaPicture', fsk: number, position: number, rejectReason?: string | null, status: MediaPictureStatusEnum, type: string, umaId: number, umpId: number, image: { __typename?: 'Image', alt: string, src: string, srcset: string } } | null, previewPicture18?: { __typename?: 'MediaPicture', fsk: number, position: number, rejectReason?: string | null, status: MediaPictureStatusEnum, type: string, umaId: number, umpId: number, image: { __typename?: 'Image', alt: string, src: string, srcset: string } } | null } | null } } };

export type GetVideoLibraryPhotoUploadListEntryQueryVariables = Exact<{
  albumId: Scalars['Int']['input'];
}>;


export type GetVideoLibraryPhotoUploadListEntryQuery = { __typename?: 'Query', media: { __typename?: 'Media', photoalbums: { __typename?: 'Photoalbums', photoalbum?: { __typename?: 'Photoalbum', userId: number, albumId: number, status?: PhotoalbumStatusEnum | null, type?: PhotoalbumTypeEnum | null, isPriceVisible?: boolean | null, price?: number | null, priceMax?: number | null, releasedDate?: any | null, salesCount?: number | null, likesCount?: number | null, feedbacksCount?: number | null, pictureCountTotal?: number | null, pictureCountRejected?: number | null, pictureCountReleased?: number | null, contestId?: number | null, releasedStatus: PhotoalbumReleasedStatusEnum, previewPicture16?: { __typename?: 'MediaPicture', umpId: number, umaId: number, position: number, type: string, status: MediaPictureStatusEnum, rejectReason?: string | null, image: { __typename?: 'Image', alt: string, src: string, srcset: string } } | null, previewPicture18?: { __typename?: 'MediaPicture', umpId: number, umaId: number, position: number, type: string, status: MediaPictureStatusEnum, rejectReason?: string | null, image: { __typename?: 'Image', alt: string, src: string, srcset: string } } | null, textCollection?: { __typename?: 'MediaTextCollection', visitxTitles?: Array<{ __typename?: 'MediaText', lang?: string | null, text?: string | null } | null> | null, visitxDescriptions?: Array<{ __typename?: 'MediaText', lang?: string | null, text?: string | null } | null> | null } | null, tagCollection?: Array<{ __typename?: 'MediaTag', id?: number | null, value?: string | null, flags?: number | null, isChecked?: boolean | null } | null> | null } | null } } };

export type GetPhotoLibraryUploadListEntryQueryVariables = Exact<{
  albumId: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
}>;


export type GetPhotoLibraryUploadListEntryQuery = { __typename?: 'Query', media: { __typename?: 'Media', photoalbums: { __typename?: 'Photoalbums', pictureList: { __typename?: 'PictureList', totalCount: number, edges: Array<{ __typename?: 'PicturePaginationEdge', cursor?: string | null, node: { __typename?: 'MediaPicture', type: string, fsk: number, rejectReason?: string | null, position: number, status: MediaPictureStatusEnum, umaId: number, umpId: number, image: { __typename?: 'Image', src: string, alt: string, srcset: string } } } | null>, pageInfo?: { __typename?: 'PaginationPageInfo', hasNextPage: boolean } | null } } } };

export type PictureListFragment = { __typename?: 'PictureList', totalCount: number, edges: Array<{ __typename?: 'PicturePaginationEdge', cursor?: string | null, node: { __typename?: 'MediaPicture', type: string, fsk: number, rejectReason?: string | null, position: number, status: MediaPictureStatusEnum, umaId: number, umpId: number, image: { __typename?: 'Image', src: string, alt: string, srcset: string } } } | null>, pageInfo?: { __typename?: 'PaginationPageInfo', hasNextPage: boolean } | null };

export type GetPhotoLibraryUploadListEntryDetailsQueryVariables = Exact<{
  albumId: Scalars['Int']['input'];
}>;


export type GetPhotoLibraryUploadListEntryDetailsQuery = { __typename?: 'Query', media: { __typename?: 'Media', photoalbums: { __typename?: 'Photoalbums', photoalbum?: { __typename?: 'Photoalbum', userId: number, albumId: number, status?: PhotoalbumStatusEnum | null, type?: PhotoalbumTypeEnum | null, isPriceVisible?: boolean | null, price?: number | null, priceMax?: number | null, releasedDate?: any | null, salesCount?: number | null, likesCount?: number | null, feedbacksCount?: number | null, pictureCountTotal?: number | null, pictureCountRejected?: number | null, pictureCountReleased?: number | null, contestId?: number | null, releasedStatus: PhotoalbumReleasedStatusEnum, previewPicture16?: { __typename?: 'MediaPicture', umpId: number, umaId: number, position: number, type: string, status: MediaPictureStatusEnum, rejectReason?: string | null, image: { __typename?: 'Image', alt: string, src: string, srcset: string } } | null, previewPicture18?: { __typename?: 'MediaPicture', umpId: number, umaId: number, position: number, type: string, status: MediaPictureStatusEnum, rejectReason?: string | null, image: { __typename?: 'Image', alt: string, src: string, srcset: string } } | null, textCollection?: { __typename?: 'MediaTextCollection', visitxTitles?: Array<{ __typename?: 'MediaText', lang?: string | null, text?: string | null } | null> | null, visitxDescriptions?: Array<{ __typename?: 'MediaText', lang?: string | null, text?: string | null } | null> | null } | null, tagCollection?: Array<{ __typename?: 'MediaTag', id?: number | null, value?: string | null, flags?: number | null, isChecked?: boolean | null } | null> | null } | null } } };

export type VideoLibraryDeletePhotoMutationVariables = Exact<{
  albumId: Scalars['Int']['input'];
  pictureId: Scalars['Int']['input'];
}>;


export type VideoLibraryDeletePhotoMutation = { __typename?: 'Mutation', media?: { __typename?: 'MediaMutation', photoalbum: { __typename?: 'PhotoalbumsMutation', deletePicture?: boolean | null } } | null };

export type VideoLibraryUpdatePhotoAlbumStatusMutationVariables = Exact<{
  albumId: Scalars['Int']['input'];
  status: PhotoalbumReleasedStatusEnum;
}>;


export type VideoLibraryUpdatePhotoAlbumStatusMutation = { __typename?: 'Mutation', media?: { __typename?: 'MediaMutation', photoalbum: { __typename?: 'PhotoalbumsMutation', updateReleasedStatus?: { __typename?: 'Photoalbum', albumId: number, type?: PhotoalbumTypeEnum | null, price?: number | null, releasedStatus: PhotoalbumReleasedStatusEnum } | null } } | null };

export type GetVideoLibraryPhotoUploadListQueryVariables = Exact<{
  count: Scalars['Int']['input'];
  cursor: Scalars['String']['input'];
  mediaTypes?: InputMaybe<Array<InputMaybe<PhotoalbumTypeEnum>> | InputMaybe<PhotoalbumTypeEnum>>;
  status?: InputMaybe<Array<InputMaybe<PhotoalbumStatusEnum>> | InputMaybe<PhotoalbumStatusEnum>>;
}>;


export type GetVideoLibraryPhotoUploadListQuery = { __typename?: 'Query', media: { __typename?: 'Media', photoalbums: { __typename?: 'Photoalbums', photoalbumList: { __typename?: 'PhotoalbumList', totalCount: number, pageInfo?: { __typename?: 'PaginationPageInfo', hasNextPage: boolean } | null, edges: Array<{ __typename?: 'PhotoalbumPaginationEdge', cursor?: string | null, node: { __typename?: 'Photoalbum', userId: number, albumId: number, status?: PhotoalbumStatusEnum | null, type?: PhotoalbumTypeEnum | null, isPriceVisible?: boolean | null, price?: number | null, priceMax?: number | null, releasedDate?: any | null, salesCount?: number | null, likesCount?: number | null, feedbacksCount?: number | null, pictureCountTotal?: number | null, pictureCountRejected?: number | null, pictureCountReleased?: number | null, contestId?: number | null, releasedStatus: PhotoalbumReleasedStatusEnum, previewPicture16?: { __typename?: 'MediaPicture', umpId: number, umaId: number, position: number, type: string, status: MediaPictureStatusEnum, rejectReason?: string | null, image: { __typename?: 'Image', alt: string, src: string, srcset: string } } | null, previewPicture18?: { __typename?: 'MediaPicture', umpId: number, umaId: number, position: number, type: string, status: MediaPictureStatusEnum, rejectReason?: string | null, image: { __typename?: 'Image', alt: string, src: string, srcset: string } } | null, textCollection?: { __typename?: 'MediaTextCollection', visitxTitles?: Array<{ __typename?: 'MediaText', lang?: string | null, text?: string | null } | null> | null, visitxDescriptions?: Array<{ __typename?: 'MediaText', lang?: string | null, text?: string | null } | null> | null } | null, tagCollection?: Array<{ __typename?: 'MediaTag', id?: number | null, value?: string | null, flags?: number | null, isChecked?: boolean | null } | null> | null } } | null> } } } };

export type PhotoalbumFragment = { __typename?: 'Photoalbum', userId: number, albumId: number, status?: PhotoalbumStatusEnum | null, type?: PhotoalbumTypeEnum | null, isPriceVisible?: boolean | null, price?: number | null, priceMax?: number | null, releasedDate?: any | null, salesCount?: number | null, likesCount?: number | null, feedbacksCount?: number | null, pictureCountTotal?: number | null, pictureCountRejected?: number | null, pictureCountReleased?: number | null, contestId?: number | null, releasedStatus: PhotoalbumReleasedStatusEnum, previewPicture16?: { __typename?: 'MediaPicture', umpId: number, umaId: number, position: number, type: string, status: MediaPictureStatusEnum, rejectReason?: string | null, image: { __typename?: 'Image', alt: string, src: string, srcset: string } } | null, previewPicture18?: { __typename?: 'MediaPicture', umpId: number, umaId: number, position: number, type: string, status: MediaPictureStatusEnum, rejectReason?: string | null, image: { __typename?: 'Image', alt: string, src: string, srcset: string } } | null, textCollection?: { __typename?: 'MediaTextCollection', visitxTitles?: Array<{ __typename?: 'MediaText', lang?: string | null, text?: string | null } | null> | null, visitxDescriptions?: Array<{ __typename?: 'MediaText', lang?: string | null, text?: string | null } | null> | null } | null, tagCollection?: Array<{ __typename?: 'MediaTag', id?: number | null, value?: string | null, flags?: number | null, isChecked?: boolean | null } | null> | null };

export type GetVideoLibraryUploadListEntryLikesQueryVariables = Exact<{
  albumId: Scalars['Int']['input'];
  count: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetVideoLibraryUploadListEntryLikesQuery = { __typename?: 'Query', media: { __typename?: 'Media', likes: { __typename?: 'MediaLikesList', pageInfo?: { __typename?: 'PaginationPageInfo', hasNextPage: boolean } | null, edges: Array<{ __typename?: 'MediaLikesPaginationEdge', cursor?: string | null, node: { __typename?: 'MediaLike', albumId: number, avatarUrl?: string | null, date: any, userId: number, userName: string } } | null> } } };

export type GetVideoLibraryUploadListEntrySalesQueryVariables = Exact<{
  albumId: Scalars['Int']['input'];
  count: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetVideoLibraryUploadListEntrySalesQuery = { __typename?: 'Query', media: { __typename?: 'Media', sales: { __typename?: 'MediaSalesList', pageInfo?: { __typename?: 'PaginationPageInfo', hasNextPage: boolean } | null, edges: Array<{ __typename?: 'MediaSalesPaginationEdge', cursor?: string | null, node: { __typename?: 'MediaSale', albumId: number, avatarUrl?: string | null, date: any, discountPercent?: number | null, guestPrice: number, modelSharing: number, userId: number, userName: string } } | null> } } };

export type MediaLikeFragment = { __typename?: 'MediaLike', albumId: number, avatarUrl?: string | null, date: any, userId: number, userName: string };

export type MediaSaleFragment = { __typename?: 'MediaSale', albumId: number, avatarUrl?: string | null, date: any, discountPercent?: number | null, guestPrice: number, modelSharing: number, userId: number, userName: string };

export type GetVideoLibraryTusUploadDataQueryVariables = Exact<{
  type?: InputMaybe<VideoTypeEnum>;
  albumId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetVideoLibraryTusUploadDataQuery = { __typename?: 'Query', media: { __typename?: 'Media', videos: { __typename?: 'Videos', tusUploadData?: { __typename?: 'UploadInfoTus', url: string, metaData: any } | null } } };

export type GetVideoLibraryVideoUploadListQueryVariables = Exact<{
  count: Scalars['Int']['input'];
  cursor: Scalars['String']['input'];
  types?: InputMaybe<Array<InputMaybe<VideoTypeEnum>> | InputMaybe<VideoTypeEnum>>;
  status?: InputMaybe<Array<InputMaybe<VideoStatusEnum>> | InputMaybe<VideoStatusEnum>>;
  group?: InputMaybe<VideoGroupEnum>;
}>;


export type GetVideoLibraryVideoUploadListQuery = { __typename?: 'Query', media: { __typename?: 'Media', videos: { __typename?: 'Videos', videosList: { __typename?: 'VideoList', totalCount: number, pageInfo?: { __typename?: 'PaginationPageInfo', hasNextPage: boolean } | null, edges: Array<{ __typename?: 'VideoPaginationEdge', cursor?: string | null, node: { __typename: 'Video', albumId: number, contestId?: number | null, type?: VideoTypeEnum | null, uploadRequestId?: string | null, releasedStatus?: VideoReleasedStatusEnum | null, plannedReleaseDate?: any | null, isPlannedReleaseDateEditable?: boolean | null, allIDCardsUploaded: boolean, allModelReleaseFormsUploaded: boolean, price?: number | null, likesCount?: number | null, salesCount?: number | null, feedbacksCount?: number | null, isDiscountVisible?: boolean | null, discountPercent?: number | null, discountStart?: any | null, discountEnd?: any | null, userId: number, videoId: number, status?: VideoStatusEnum | null, rejectionReason?: string | null, url: string, length?: number | null, isVip30Video: boolean, isEditable: boolean, isSharedVideo: boolean, tagCollection?: Array<{ __typename?: 'MediaTag', flags?: number | null, id?: number | null, isChecked?: boolean | null, value?: string | null } | null> | null, pictures?: Array<{ __typename?: 'MediaPicture', umaId: number, umpId: number, type: string, rejectReason?: string | null, status: MediaPictureStatusEnum, image: { __typename?: 'Image', src: string, alt: string, srcset: string } } | null> | null, textCollection?: { __typename?: 'MediaTextCollection', visitxTitles?: Array<{ __typename?: 'MediaText', lang?: string | null, text?: string | null } | null> | null, visitxDescriptions?: Array<{ __typename?: 'MediaText', lang?: string | null, text?: string | null } | null> | null } | null, previewPicture16?: { __typename?: 'MediaPicture', fsk: number, position: number, rejectReason?: string | null, status: MediaPictureStatusEnum, type: string, umaId: number, umpId: number, image: { __typename?: 'Image', alt: string, src: string, srcset: string } } | null, previewPicture18?: { __typename?: 'MediaPicture', fsk: number, position: number, rejectReason?: string | null, status: MediaPictureStatusEnum, type: string, umaId: number, umpId: number, image: { __typename?: 'Image', alt: string, src: string, srcset: string } } | null } } | null> } } } };

export type GetVideoLibraryTranscodingCountQueryVariables = Exact<{
  count: Scalars['Int']['input'];
  types?: InputMaybe<Array<InputMaybe<VideoTypeEnum>> | InputMaybe<VideoTypeEnum>>;
  status?: InputMaybe<Array<InputMaybe<VideoStatusEnum>> | InputMaybe<VideoStatusEnum>>;
}>;


export type GetVideoLibraryTranscodingCountQuery = { __typename?: 'Query', media: { __typename?: 'Media', videos: { __typename?: 'Videos', videosList: { __typename?: 'VideoList', totalCount: number } } } };

export type VideoFragment = { __typename: 'Video', albumId: number, contestId?: number | null, type?: VideoTypeEnum | null, uploadRequestId?: string | null, releasedStatus?: VideoReleasedStatusEnum | null, plannedReleaseDate?: any | null, isPlannedReleaseDateEditable?: boolean | null, allIDCardsUploaded: boolean, allModelReleaseFormsUploaded: boolean, price?: number | null, likesCount?: number | null, salesCount?: number | null, feedbacksCount?: number | null, isDiscountVisible?: boolean | null, discountPercent?: number | null, discountStart?: any | null, discountEnd?: any | null, userId: number, videoId: number, status?: VideoStatusEnum | null, rejectionReason?: string | null, url: string, length?: number | null, isVip30Video: boolean, isEditable: boolean, isSharedVideo: boolean, tagCollection?: Array<{ __typename?: 'MediaTag', flags?: number | null, id?: number | null, isChecked?: boolean | null, value?: string | null } | null> | null, pictures?: Array<{ __typename?: 'MediaPicture', umaId: number, umpId: number, type: string, rejectReason?: string | null, status: MediaPictureStatusEnum, image: { __typename?: 'Image', src: string, alt: string, srcset: string } } | null> | null, textCollection?: { __typename?: 'MediaTextCollection', visitxTitles?: Array<{ __typename?: 'MediaText', lang?: string | null, text?: string | null } | null> | null, visitxDescriptions?: Array<{ __typename?: 'MediaText', lang?: string | null, text?: string | null } | null> | null } | null, previewPicture16?: { __typename?: 'MediaPicture', fsk: number, position: number, rejectReason?: string | null, status: MediaPictureStatusEnum, type: string, umaId: number, umpId: number, image: { __typename?: 'Image', alt: string, src: string, srcset: string } } | null, previewPicture18?: { __typename?: 'MediaPicture', fsk: number, position: number, rejectReason?: string | null, status: MediaPictureStatusEnum, type: string, umaId: number, umpId: number, image: { __typename?: 'Image', alt: string, src: string, srcset: string } } | null };

export type GetVideoLibraryMarketingVideoDateQueryVariables = Exact<{
  contestId: Scalars['Int']['input'];
}>;


export type GetVideoLibraryMarketingVideoDateQuery = { __typename?: 'Query', media: { __typename?: 'Media', contest?: { __typename?: 'MediaContest', votingStart: any, votingEnd: any } | null } };

export type ContestVideoFragment = { __typename?: 'MediaContest', votingStart: any, votingEnd: any };

export const AuthUserFragmentDoc = gql`
    fragment AuthUser on AuthUser {
  permissions
  userId
  username
  scope
  roles
  lang
}
    `;
export const TagEntryFragmentDoc = gql`
    fragment TagEntry on TipsTag {
  id
  value
}
    `;
export const IncomeSourceEntryFragmentDoc = gql`
    fragment IncomeSourceEntry on IncomeSourcesEntry {
  id
  title
  teaserText
  headerImage {
    alt
    src
  }
  isLabeledNew
  activatedAt
  readAt
  experienceTags {
    ...TagEntry
  }
  intentionTags {
    ...TagEntry
  }
}
    ${TagEntryFragmentDoc}`;
export const IncomeSourceWithBodyEntryFragmentDoc = gql`
    fragment IncomeSourceWithBodyEntry on IncomeSourcesEntry {
  id
  title
  teaserText
  headerImage {
    alt
    src
  }
  body
  isLabeledNew
  activatedAt
  readAt
  experienceTags {
    ...TagEntry
  }
  intentionTags {
    ...TagEntry
  }
}
    ${TagEntryFragmentDoc}`;
export const MediaPictureFieldFragmentDoc = gql`
    fragment MediaPictureField on ProfileFieldTypePicture {
  status
  rejectReason
  upload {
    url
    requiredFormData
    errorCodes
  }
}
    `;
export const MediaPictureValueFragmentDoc = gql`
    fragment MediaPictureValue on MediaPicture {
  image {
    src
    alt
    srcset
  }
}
    `;
export const MutationResultFragmentDoc = gql`
    fragment MutationResult on MutationResult {
  message
  success
}
    `;
export const PrefillProfileStringFieldFragmentDoc = gql`
    fragment PrefillProfileStringField on ProfileFieldTypeString {
  name
  minLength
  maxLength
  value
}
    `;
export const PrefillProfileDateFieldFragmentDoc = gql`
    fragment PrefillProfileDateField on ProfileFieldTypeDate {
  name
  value
  minDate
  maxDate
}
    `;
export const QuickpickValueFragmentDoc = gql`
    fragment QuickpickValue on OptionEntry {
  value
  label
}
    `;
export const ValidValueFragmentDoc = gql`
    fragment ValidValue on OptionEntry {
  value
  label
}
    `;
export const PrefillProfileEnumFieldFragmentDoc = gql`
    fragment PrefillProfileEnumField on ProfileFieldTypeEnum {
  name
  value
  quickpickValues {
    ...QuickpickValue
  }
  validValues {
    ...ValidValue
  }
}
    ${QuickpickValueFragmentDoc}
${ValidValueFragmentDoc}`;
export const ProfileCollectionFieldEnumFragmentDoc = gql`
    fragment ProfileCollectionFieldEnum on ProfileFieldTypeEnum {
  disabled
  readOnly
  value
  quickpickValues {
    label
    value
  }
  validValues {
    label
    value
  }
}
    `;
export const ProfileCollectionFieldDateFragmentDoc = gql`
    fragment ProfileCollectionFieldDate on ProfileFieldTypeDate {
  disabled
  readOnly
  value
}
    `;
export const ModelProfileCompletenessFragmentDoc = gql`
    fragment ModelProfileCompleteness on ProfileCollectionCompleteness {
  total
  missing
  complete
  missingFields
}
    `;
export const ProfileFieldTypeStringFragmentDoc = gql`
    fragment ProfileFieldTypeString on ProfileFieldTypeString {
  __typename
  name
  readOnly
  status
  rejectReason
  disabled
  value
  minLength
  maxLength
}
    `;
export const ProfileFieldTypeEnumFragmentDoc = gql`
    fragment ProfileFieldTypeEnum on ProfileFieldTypeEnum {
  __typename
  name
  readOnly
  status
  rejectReason
  disabled
  value
  quickpickValues {
    ...QuickpickValue
  }
  validValues {
    ...ValidValue
  }
}
    ${QuickpickValueFragmentDoc}
${ValidValueFragmentDoc}`;
export const ProfileFieldTypeDateFragmentDoc = gql`
    fragment ProfileFieldTypeDate on ProfileFieldTypeDate {
  __typename
  name
  readOnly
  status
  rejectReason
  disabled
  value
  minDate
  maxDate
}
    `;
export const MultiLangTextFragmentDoc = gql`
    fragment MultiLangText on MultiLangText {
  status
  langs
  texts {
    status
    text
    lang
  }
  origText
}
    `;
export const ProfileFieldTypeMultilangStringFragmentDoc = gql`
    fragment ProfileFieldTypeMultilangString on ProfileFieldTypeMultiLangString {
  __typename
  name
  readOnly
  status
  rejectReason
  disabled
  value {
    ...MultiLangText
  }
  minLength
  maxLength
  langs {
    name
    label
  }
  requiredLangs
}
    ${MultiLangTextFragmentDoc}`;
export const ProfileFieldTypeEnumListFragmentDoc = gql`
    fragment ProfileFieldTypeEnumList on ProfileFieldTypeEnumList {
  __typename
  name
  readOnly
  status
  rejectReason
  disabled
  value
  validValues {
    ...ValidValue
  }
}
    ${ValidValueFragmentDoc}`;
export const ProfileCollectionMobileAboutMeV1FieldsFragmentDoc = gql`
    fragment ProfileCollectionMobileAboutMeV1Fields on ProfileCollectionMobileAboutMeV1Fields {
  modelUsername {
    ...ProfileFieldTypeString
  }
  modelGender {
    ...ProfileFieldTypeEnum
  }
  modelSexuality {
    ...ProfileFieldTypeEnum
  }
  modelBirthdate {
    ...ProfileFieldTypeDate
  }
  modelMotto {
    ...ProfileFieldTypeMultilangString
  }
  modelAboutMe {
    ...ProfileFieldTypeMultilangString
  }
  modelRelationshipState {
    ...ProfileFieldTypeEnum
  }
  modelCountry {
    ...ProfileFieldTypeEnum
  }
  modelPostalCode {
    ...ProfileFieldTypeString
  }
  modelCity {
    ...ProfileFieldTypeString
  }
  modelLanguage {
    ...ProfileFieldTypeEnumList
  }
  modelChatPractices {
    ...ProfileFieldTypeEnumList
  }
}
    ${ProfileFieldTypeStringFragmentDoc}
${ProfileFieldTypeEnumFragmentDoc}
${ProfileFieldTypeDateFragmentDoc}
${ProfileFieldTypeMultilangStringFragmentDoc}
${ProfileFieldTypeEnumListFragmentDoc}`;
export const ProfileCollectionMobileAboutMeV1FragmentDoc = gql`
    fragment ProfileCollectionMobileAboutMeV1 on ProfileCollectionMobileAboutMeV1 {
  completeness {
    ...ModelProfileCompleteness
  }
  fields {
    ...ProfileCollectionMobileAboutMeV1Fields
  }
}
    ${ModelProfileCompletenessFragmentDoc}
${ProfileCollectionMobileAboutMeV1FieldsFragmentDoc}`;
export const ProfileFieldTypeIntFragmentDoc = gql`
    fragment ProfileFieldTypeInt on ProfileFieldTypeInt {
  __typename
  name
  readOnly
  status
  rejectReason
  disabled
  value
  minValue
  maxValue
}
    `;
export const ProfileCollectionMobileAppearanceV1FieldsFragmentDoc = gql`
    fragment ProfileCollectionMobileAppearanceV1Fields on ProfileCollectionMobileAppearanceV1Fields {
  modelBodyHeight {
    ...ProfileFieldTypeInt
  }
  modelBodyWeight {
    ...ProfileFieldTypeInt
  }
  modelBodyFigure {
    ...ProfileFieldTypeEnum
  }
  modelBreastSize {
    ...ProfileFieldTypeEnum
  }
  modelPenisSize {
    ...ProfileFieldTypeEnum
  }
  modelSkinType {
    ...ProfileFieldTypeEnum
  }
  modelHairColor {
    ...ProfileFieldTypeEnum
  }
  modelEyeColor {
    ...ProfileFieldTypeEnum
  }
  modelPubicHair {
    ...ProfileFieldTypeEnum
  }
  modelBodyModifications {
    ...ProfileFieldTypeEnumList
  }
}
    ${ProfileFieldTypeIntFragmentDoc}
${ProfileFieldTypeEnumFragmentDoc}
${ProfileFieldTypeEnumListFragmentDoc}`;
export const ProfileCollectionMobileAppearanceV1FragmentDoc = gql`
    fragment ProfileCollectionMobileAppearanceV1 on ProfileCollectionMobileAppearanceV1 {
  completeness {
    ...ModelProfileCompleteness
  }
  fields {
    ...ProfileCollectionMobileAppearanceV1Fields
  }
}
    ${ModelProfileCompletenessFragmentDoc}
${ProfileCollectionMobileAppearanceV1FieldsFragmentDoc}`;
export const ProfileCollectionMobileInterviewV1FieldsFragmentDoc = gql`
    fragment ProfileCollectionMobileInterviewV1Fields on ProfileCollectionMobileInterviewV1Fields {
  modelInterviewPartner {
    ...ProfileFieldTypeMultilangString
  }
  modelInterviewIsland {
    ...ProfileFieldTypeMultilangString
  }
  modelInterviewEnterprise {
    ...ProfileFieldTypeMultilangString
  }
  modelInterviewHobbies {
    ...ProfileFieldTypeMultilangString
  }
  modelInterviewSexualPosition {
    ...ProfileFieldTypeMultilangString
  }
  modelInterviewSexualFantasies {
    ...ProfileFieldTypeMultilangString
  }
  modelInterviewSexNotOk {
    ...ProfileFieldTypeMultilangString
  }
  modelInterviewSexOk {
    ...ProfileFieldTypeMultilangString
  }
  modelInterviewEroticExperience {
    ...ProfileFieldTypeMultilangString
  }
}
    ${ProfileFieldTypeMultilangStringFragmentDoc}`;
export const ProfileCollectionMobileInterviewV1FragmentDoc = gql`
    fragment ProfileCollectionMobileInterviewV1 on ProfileCollectionMobileInterviewV1 {
  completeness {
    ...ModelProfileCompleteness
  }
  fields {
    ...ProfileCollectionMobileInterviewV1Fields
  }
}
    ${ModelProfileCompletenessFragmentDoc}
${ProfileCollectionMobileInterviewV1FieldsFragmentDoc}`;
export const ImageFragmentDoc = gql`
    fragment Image on Image {
  src(size: ORIG)
  alt
  srcset
}
    `;
export const MediaPictureFragmentDoc = gql`
    fragment MediaPicture on MediaPicture {
  umaId
  umpId
  type
  rejectReason
  status
  image {
    ...Image
  }
}
    ${ImageFragmentDoc}`;
export const ProfileFieldTypePictureFragmentDoc = gql`
    fragment ProfileFieldTypePicture on ProfileFieldTypePicture {
  __typename
  name
  readOnly
  status
  rejectReason
  disabled
  value {
    ...MediaPicture
  }
}
    ${MediaPictureFragmentDoc}`;
export const MediaPictureInListFragmentDoc = gql`
    fragment MediaPictureInList on MediaPicture {
  type
  fsk
  rejectReason
  position
  status
  image {
    ...Image
  }
  umaId
  umpId
}
    ${ImageFragmentDoc}`;
export const ProfileFieldTypePictureListFragmentDoc = gql`
    fragment ProfileFieldTypePictureList on ProfileFieldTypePictureList {
  __typename
  name
  readOnly
  status
  rejectReason
  disabled
  value {
    ...MediaPictureInList
  }
}
    ${MediaPictureInListFragmentDoc}`;
export const ProfileCollectionMobileMediaV1FieldsFragmentDoc = gql`
    fragment ProfileCollectionMobileMediaV1Fields on ProfileCollectionMobileMediaV1Fields {
  modelPictureTitleLandscape {
    ...ProfileFieldTypePicture
  }
  modelPictureFSK16Avatar {
    ...ProfileFieldTypePicture
  }
  modelPictureFSK12Sedcard {
    ...ProfileFieldTypePictureList
  }
  modelPictureFSK16Sedcard {
    ...ProfileFieldTypePictureList
  }
  modelPictureFSK18Sedcard {
    ...ProfileFieldTypePictureList
  }
}
    ${ProfileFieldTypePictureFragmentDoc}
${ProfileFieldTypePictureListFragmentDoc}`;
export const ProfileCollectionMobileMediaV1FragmentDoc = gql`
    fragment ProfileCollectionMobileMediaV1 on ProfileCollectionMobileMediaV1 {
  completeness {
    ...ModelProfileCompleteness
  }
  fields {
    ...ProfileCollectionMobileMediaV1Fields
  }
}
    ${ModelProfileCompletenessFragmentDoc}
${ProfileCollectionMobileMediaV1FieldsFragmentDoc}`;
export const TipEntryFragmentDoc = gql`
    fragment TipEntry on TipsEntry {
  id
  title
  teaserText
  headerImage {
    alt
    src
  }
  isLabeledNew
  readAt
  experienceTags {
    ...TagEntry
  }
  intentionTags {
    ...TagEntry
  }
}
    ${TagEntryFragmentDoc}`;
export const TipWithBodyEntryFragmentDoc = gql`
    fragment TipWithBodyEntry on TipsEntry {
  id
  title
  teaserText
  headerImage {
    alt
    src
  }
  body
  isLabeledNew
  readAt
  experienceTags {
    ...TagEntry
  }
  intentionTags {
    ...TagEntry
  }
}
    ${TagEntryFragmentDoc}`;
export const CmsArticleFragmentDoc = gql`
    fragment CmsArticle on CmsArticle {
  id
  lang
  title
  content
  revision {
    rev
    published
  }
}
    `;
export const LegalTermsArticleFragmentDoc = gql`
    fragment LegalTermsArticle on CmsArticle {
  id
  lang
  type
  content
  title
  revision {
    pdfUrl
    published
    modified
  }
}
    `;
export const ProfileCollectionFieldStringFragmentDoc = gql`
    fragment ProfileCollectionFieldString on ProfileFieldTypeString {
  disabled
  minLength
  maxLength
  readOnly
  value
}
    `;
export const EmailSectionFieldsFragmentDoc = gql`
    fragment EmailSectionFields on ProfileCollectionAccountV1Fields {
  accountContactEmailAdress {
    ...ProfileCollectionFieldString
  }
}
    ${ProfileCollectionFieldStringFragmentDoc}`;
export const EmailSectionFragmentDoc = gql`
    fragment EmailSection on ProfileCollectionAccountV1 {
  fields {
    ...EmailSectionFields
  }
}
    ${EmailSectionFieldsFragmentDoc}`;
export const DocumentFragmentDoc = gql`
    fragment Document on Document {
  id
  filename
  url
  status
  rejectionReason
  side
  isImage
  type
  typeName
  uploadDate
  userId
}
    `;
export const DocumentsPersonalRealPersonFragmentDoc = gql`
    fragment DocumentsPersonalRealPerson on DocumentsPersonalRealPerson {
  isModelReleaseFormRequired
  isIdShotRequired
  identityProofFront {
    ...Document
  }
  identityProofBack {
    ...Document
  }
  idShot {
    ...Document
  }
  modelReleaseForm {
    ...Document
  }
}
    ${DocumentFragmentDoc}`;
export const AddressFragmentDoc = gql`
    fragment Address on Address {
  isEditable
  isCompany
  companyName
  firstname
  lastname
  street
  streetNumber
  city
  zipCode
  countryCode
}
    `;
export const OriginatorFragmentDoc = gql`
    fragment Originator on Originator {
  userId
  isVerified
  isActor
  isNew
  personalDocumentsStatus
  financialDocumentsStatus
  personalDocuments {
    ...DocumentsPersonalRealPerson
  }
  address {
    ...Address
  }
  birthday
}
    ${DocumentsPersonalRealPersonFragmentDoc}
${AddressFragmentDoc}`;
export const ActorFragmentDoc = gql`
    fragment Actor on Actor {
  userId
  isVerified
  isLeadActor
  isNew
  personalDocumentsStatus
  personalDocuments {
    ...DocumentsPersonalRealPerson
  }
  address {
    ...Address
  }
  birthday
}
    ${DocumentsPersonalRealPersonFragmentDoc}
${AddressFragmentDoc}`;
export const DocumentsOfHostAccountFragmentDoc = gql`
    fragment DocumentsOfHostAccount on DocumentsOfHostAccount {
  identityProofFront {
    ...Document
  }
  identityProofBack {
    ...Document
  }
  idShot {
    ...Document
  }
  modelReleaseForm {
    ...Document
  }
}
    ${DocumentFragmentDoc}`;
export const DocumentsFinancialRealPersonFragmentDoc = gql`
    fragment DocumentsFinancialRealPerson on DocumentsFinancialRealPerson {
  isProofOfAddressRequired
  proofOfAddress {
    ...Document
  }
  isTaxDocumentRequired
  taxDocument {
    ...Document
  }
}
    ${DocumentFragmentDoc}`;
export const ProfileFieldTypeBooleanFragmentDoc = gql`
    fragment ProfileFieldTypeBoolean on ProfileFieldTypeBoolean {
  __typename
  name
  status
  rejectReason
  value
}
    `;
export const ExtendedUploadDocumentFragmentDoc = gql`
    fragment ExtendedUploadDocument on UploadDocument {
  docId
  expireDate
  filename
  url
  status
}
    `;
export const ExtendedProfileFieldTypeUploadDocumentFragmentDoc = gql`
    fragment ExtendedProfileFieldTypeUploadDocument on ProfileFieldTypeUploadDocument {
  __typename
  name
  status
  rejectReason
  value {
    ...ExtendedUploadDocument
  }
}
    ${ExtendedUploadDocumentFragmentDoc}`;
export const BillingAddressFragmentDoc = gql`
    fragment BillingAddress on PaymentBillingAddress {
  status
  rejectReasonTitle
  rejectReason
  isCompany {
    ...ProfileFieldTypeBoolean
  }
  companyname {
    ...ProfileFieldTypeString
  }
  firstname {
    ...ProfileFieldTypeString
  }
  lastname {
    ...ProfileFieldTypeString
  }
  street {
    ...ProfileFieldTypeString
  }
  streetNumber {
    ...ProfileFieldTypeString
  }
  city {
    ...ProfileFieldTypeString
  }
  postalCode {
    ...ProfileFieldTypeString
  }
  country {
    ...ProfileFieldTypeEnum
  }
  document {
    ...ExtendedProfileFieldTypeUploadDocument
  }
}
    ${ProfileFieldTypeBooleanFragmentDoc}
${ProfileFieldTypeStringFragmentDoc}
${ProfileFieldTypeEnumFragmentDoc}
${ExtendedProfileFieldTypeUploadDocumentFragmentDoc}`;
export const PayoutDataFragmentDoc = gql`
    fragment PayoutData on PaymentPayoutData {
  status
  rejectReasonTitle
  rejectReason
  showPaxum
  showBankAccount
  payoutMethod {
    ...ProfileFieldTypeEnum
  }
  bankAccountOwner {
    ...ProfileFieldTypeString
  }
  bankIban {
    ...ProfileFieldTypeString
  }
  bankBic {
    ...ProfileFieldTypeString
  }
  paxumEmailAccount {
    ...ProfileFieldTypeString
  }
}
    ${ProfileFieldTypeEnumFragmentDoc}
${ProfileFieldTypeStringFragmentDoc}`;
export const TaxDataFragmentDoc = gql`
    fragment TaxData on PaymentTaxData {
  status
  rejectReasonTitle
  rejectReason
  showTin
  isDocumentRequired
  isRequired
  isTaxable {
    ...ProfileFieldTypeBoolean
  }
  taxNumber {
    ...ProfileFieldTypeString
  }
  tin {
    ...ProfileFieldTypeString
  }
  tinCountry {
    ...ProfileFieldTypeEnum
  }
  document {
    ...ExtendedProfileFieldTypeUploadDocument
  }
}
    ${ProfileFieldTypeBooleanFragmentDoc}
${ProfileFieldTypeStringFragmentDoc}
${ProfileFieldTypeEnumFragmentDoc}
${ExtendedProfileFieldTypeUploadDocumentFragmentDoc}`;
export const FinancesBillingFragmentDoc = gql`
    fragment FinancesBilling on FinancesBilling {
  amount
  billNumber
  billingStartDate
  billingEndDate
  company
  companyName
  id
  issueDate
  status
  type
}
    `;
export const FinancesInvoiceFragmentDoc = gql`
    fragment FinancesInvoice on FinancesInvoice {
  amount
  payoutDate
  status
  message
  billingStartDate
  billingEndDate
}
    `;
export const FinancesInvoicesFragmentDoc = gql`
    fragment FinancesInvoices on FinancesInvoices {
  invoices {
    ...FinancesInvoice
  }
}
    ${FinancesInvoiceFragmentDoc}`;
export const HelpCenterFaqEntryHomeFragmentDoc = gql`
    fragment HelpCenterFaqEntryHome on HelpcenterFaqEntry {
  answer
  question
}
    `;
export const HelpCenterHomeFragmentDoc = gql`
    fragment HelpCenterHome on Helpcenter {
  faq {
    entries {
      ...HelpCenterFaqEntryHome
    }
  }
}
    ${HelpCenterFaqEntryHomeFragmentDoc}`;
export const ModelProfileParentMobileProfileFragmentDoc = gql`
    fragment ModelProfileParentMobileProfile on ProfileCollectionMobileProfileV1 {
  fields {
    modelPictureAvatar {
      status
    }
  }
}
    `;
export const ModelProfileParentWizardFragmentDoc = gql`
    fragment ModelProfileParentWizard on TourOnboardingV1 {
  completeness {
    percent
  }
  lastVerified
}
    `;
export const ProfileFieldValidationFragmentDoc = gql`
    fragment ProfileFieldValidation on ProfileFieldValidation {
  __typename
  name
  isValid
  ... on ProfileFieldTypeValidationBoolean {
    errors {
      message
    }
  }
  ... on ProfileFieldTypeValidationDate {
    errors {
      message
    }
  }
  ... on ProfileFieldTypeValidationEnum {
    errors {
      message
    }
  }
  ... on ProfileFieldTypeValidationEnumList {
    errors {
      message
    }
  }
  ... on ProfileFieldTypeValidationInt {
    errors {
      message
    }
  }
  ... on ProfileFieldTypeValidationMultiLangString {
    multiLangErrors: errors {
      lang
      message
    }
  }
  ... on ProfileFieldTypeValidationPicture {
    errors {
      message
    }
  }
  ... on ProfileFieldTypeValidationPictureList {
    errors {
      message
    }
  }
  ... on ProfileFieldTypeValidationString {
    errors {
      message
    }
  }
  ... on ProfileFieldTypeValidationUploadDocument {
    errors {
      message
    }
  }
}
    `;
export const ProfileFieldValidationSetFragmentDoc = gql`
    fragment ProfileFieldValidationSet on ProfileFieldValidationSet {
  __typename
  field {
    ...ProfileFieldValidation
  }
  hasErrors
}
    ${ProfileFieldValidationFragmentDoc}`;
export const StatisticEditEntryFragmentDoc = gql`
    fragment StatisticEditEntry on StatisticsEntry {
  id
  label
}
    `;
export const WizardMrfAccountPrefillFieldsFragmentDoc = gql`
    fragment WizardMrfAccountPrefillFields on ProfileCollectionAccountV1Fields {
  accountFirstname {
    value
  }
  accountLastname {
    value
  }
  accountBirthdate {
    value
  }
  accountAddressStreet {
    value
  }
  accountAddressStreetNumber {
    value
  }
  accountAddressCity {
    value
  }
  accountAddressPostalCode {
    value
  }
  accountAddressCountry {
    value
    quickpickValues {
      value
      label
    }
    validValues {
      value
      label
    }
  }
}
    `;
export const CurrentStepWizardMrfFragmentDoc = gql`
    fragment CurrentStepWizardMRF on TourStep {
  pos
  id
  fields {
    name
    readOnly
    status
    rejectReason
    ... on ProfileFieldTypeUploadDocument {
      document: value {
        docId
        status
        comment
      }
      upload {
        url
        errorCodes
        requiredFormData
      }
    }
    ... on ProfileFieldTypeString {
      value
      minLength
      maxLength
    }
    ... on ProfileFieldTypeEnum {
      value
      quickpickValues {
        label
        value
      }
      validValues {
        value
        label
      }
    }
    ... on ProfileFieldTypeDate {
      date: value
      minDate
      maxDate
    }
    ... on ProfileFieldTypeFormManagerPaperlessForm {
      name
      form: value {
        formUrl(redirUrl: $redirectUrl)
      }
    }
  }
}
    `;
export const TourValidationFragmentDoc = gql`
    fragment TourValidation on TourValidation {
  data {
    ...ProfileFieldValidation
  }
}
    ${ProfileFieldValidationFragmentDoc}`;
export const TourDataWizardMrfFragmentDoc = gql`
    fragment TourDataWizardMrf on TourModelReleaseFormV1 {
  totalSteps
  currentStep {
    ...CurrentStepWizardMRF
  }
  validate {
    ...TourValidation
  }
}
    ${CurrentStepWizardMrfFragmentDoc}
${TourValidationFragmentDoc}`;
export const WizardStepFieldFragmentDoc = gql`
    fragment WizardStepField on ProfileField {
  __typename
  name
  readOnly
  status
  rejectReason
  ... on ProfileFieldTypeUploadDocument {
    __typename
    document: value {
      docId
      status
      comment
    }
    upload {
      url
      errorCodes
      requiredFormData
    }
  }
  ... on ProfileFieldTypeString {
    __typename
    value
    minLength
    maxLength
  }
  ... on ProfileFieldTypeEnum {
    __typename
    value
    quickpickValues {
      label
      value
    }
    validValues {
      value
      label
    }
  }
  ... on ProfileFieldTypeDate {
    __typename
    date: value
    minDate
    maxDate
  }
}
    `;
export const WizardPayoutAccountPrefillFieldsFragmentDoc = gql`
    fragment WizardPayoutAccountPrefillFields on ProfileCollectionAccountV1Fields {
  accountFirstname {
    value
  }
  accountFirstname {
    value
  }
  accountLastname {
    value
  }
  accountAddressStreet {
    value
  }
  accountAddressStreetNumber {
    value
  }
  accountAddressCity {
    value
  }
  accountAddressPostalCode {
    value
  }
  accountAddressCountry {
    value
    quickpickValues {
      label
      value
    }
    validValues {
      value
      label
    }
  }
}
    `;
export const CurrentStepWizardPayoutFragmentDoc = gql`
    fragment CurrentStepWizardPayout on TourStep {
  pos
  id
  fields {
    name
    readOnly
    status
    rejectReason
    ... on ProfileFieldTypeUploadDocument {
      document: value {
        docId
        status
        comment
      }
      upload {
        url
        errorCodes
        requiredFormData
      }
    }
    ... on ProfileFieldTypeString {
      value
      minLength
      maxLength
    }
    ... on ProfileFieldTypeEnum {
      value
      quickpickValues {
        label
        value
      }
      validValues {
        value
        label
      }
    }
    ... on ProfileFieldTypeDate {
      date: value
      minDate
      maxDate
    }
  }
}
    `;
export const TourDataWizardPayoutFragmentDoc = gql`
    fragment TourDataWizardPayout on TourPayoutV1 {
  totalSteps
  status
  currentStep {
    ...CurrentStepWizardPayout
  }
  validate {
    ...TourValidation
  }
}
    ${CurrentStepWizardPayoutFragmentDoc}
${TourValidationFragmentDoc}`;
export const WizardPayoutAccountPrefillFieldsV2FragmentDoc = gql`
    fragment WizardPayoutAccountPrefillFieldsV2 on ProfileCollectionAccountV1Fields {
  accountFirstname {
    value
  }
  accountFirstname {
    value
  }
  accountLastname {
    value
  }
  accountAddressStreet {
    value
  }
  accountAddressStreetNumber {
    value
  }
  accountAddressCity {
    value
  }
  accountAddressPostalCode {
    value
  }
  accountAddressCountry {
    value
    quickpickValues {
      label
      value
    }
    validValues {
      value
      label
    }
  }
}
    `;
export const CurrentStepWizardPayoutV2FragmentDoc = gql`
    fragment CurrentStepWizardPayoutV2 on TourStep {
  pos
  id
  fields {
    __typename
    name
    readOnly
    status
    rejectReason
    ... on ProfileFieldTypeUploadDocument {
      document: value {
        docId
        status
        comment
      }
      upload {
        url
        errorCodes
        requiredFormData
      }
    }
    ... on ProfileFieldTypeString {
      value
      minLength
      maxLength
    }
    ... on ProfileFieldTypeEnum {
      value
      quickpickValues {
        label
        value
      }
      validValues {
        value
        label
      }
    }
    ... on ProfileFieldTypeDate {
      date: value
      minDate
      maxDate
    }
    ... on ProfileFieldTypeFormManagerPaperlessForm {
      name
      form: value {
        formUrl(redirUrl: $redirectUrl)
      }
    }
  }
}
    `;
export const TourDataWizardPayoutV2FragmentDoc = gql`
    fragment TourDataWizardPayoutV2 on TourPayoutV2 {
  totalSteps
  status
  currentStep {
    ...CurrentStepWizardPayoutV2
  }
  validate {
    ...TourValidation
  }
}
    ${CurrentStepWizardPayoutV2FragmentDoc}
${TourValidationFragmentDoc}`;
export const UploadInfoFragmentDoc = gql`
    fragment UploadInfo on UploadInfo {
  errorCodes
  requiredFormData
  url
}
    `;
export const ProfileWizardMultiLangStringFragmentDoc = gql`
    fragment ProfileWizardMultiLangString on ProfileFieldTypeMultiLangString {
  multiLangValue: value {
    langs
    texts {
      lang
      text
    }
  }
  multiLangMinLength: minLength
  multiLangMaxLength: maxLength
}
    `;
export const CurrentStepWizardProfileFragmentDoc = gql`
    fragment CurrentStepWizardProfile on TourStep {
  pos
  id
  fields {
    __typename
    name
    readOnly
    status
    rejectReason
    ... on ProfileFieldTypePicture {
      __typename
      image: value {
        ...MediaPicture
      }
      upload {
        ...UploadInfo
      }
    }
    ... on ProfileFieldTypeString {
      value
      minLength
      maxLength
    }
    ... on ProfileFieldTypeMultiLangString {
      ...ProfileWizardMultiLangString
    }
    ... on ProfileFieldTypeEnum {
      value
      quickpickValues {
        label
        value
      }
      validValues {
        value
        label
      }
    }
    ... on ProfileFieldTypeDate {
      date: value
      minDate
      maxDate
    }
  }
}
    ${MediaPictureFragmentDoc}
${UploadInfoFragmentDoc}
${ProfileWizardMultiLangStringFragmentDoc}`;
export const TourDataWizardProfileFragmentDoc = gql`
    fragment TourDataWizardProfile on TourOnboardingV1 {
  totalSteps
  currentStep {
    ...CurrentStepWizardProfile
  }
  validate {
    ...TourValidation
  }
}
    ${CurrentStepWizardProfileFragmentDoc}
${TourValidationFragmentDoc}`;
export const VerificationTourCurrentStepFragmentDoc = gql`
    fragment VerificationTourCurrentStep on DocumentUploadAssistantStep {
  name
  status
  documentType
  uploadUrl
  lastUploadedDocument {
    id
    type
    status
    side
    userId
    uploadDate
    isImage
    url
    rejectionReason
  }
  position
}
    `;
export const VerificationTourStepFragmentDoc = gql`
    fragment VerificationTourStep on DocumentUploadAssistantStep {
  name
}
    `;
export const VideoFragmentDoc = gql`
    fragment Video on Video {
  albumId
  contestId
  type
  uploadRequestId
  releasedStatus
  plannedReleaseDate
  isPlannedReleaseDateEditable
  allIDCardsUploaded
  allModelReleaseFormsUploaded
  price
  likesCount
  salesCount
  feedbacksCount
  tagCollection {
    flags
    id
    isChecked
    value
  }
  isDiscountVisible
  discountPercent
  discountStart
  discountEnd
  releasedStatus
  userId
  videoId
  status
  rejectionReason
  url
  length
  isVip30Video
  isEditable
  isSharedVideo
  pictures {
    ...MediaPicture
  }
  textCollection {
    visitxTitles {
      lang
      text
    }
    visitxDescriptions {
      lang
      text
    }
  }
  previewPicture16 {
    fsk
    image {
      alt
      src
      srcset
    }
    position
    rejectReason
    status
    type
    umaId
    umpId
  }
  previewPicture18 {
    fsk
    image {
      alt
      src
      srcset
    }
    position
    rejectReason
    status
    type
    umaId
    umpId
  }
  __typename
}
    ${MediaPictureFragmentDoc}`;
export const PhotoalbumFragmentDoc = gql`
    fragment Photoalbum on Photoalbum {
  userId
  albumId
  status
  type
  isPriceVisible
  price
  priceMax
  releasedDate
  salesCount
  likesCount
  feedbacksCount
  pictureCountTotal
  pictureCountRejected
  pictureCountReleased
  previewPicture16 {
    umpId
    umaId
    position
    type
    status
    rejectReason
    image {
      alt
      src
      srcset
    }
  }
  previewPicture18 {
    umpId
    umaId
    position
    type
    status
    rejectReason
    image {
      alt
      src
      srcset
    }
  }
  contestId
  releasedStatus
  textCollection {
    visitxTitles {
      lang
      text
    }
    visitxDescriptions {
      lang
      text
    }
  }
  tagCollection {
    id
    value
    flags
    isChecked
  }
}
    `;
export const ContestFragmentDoc = gql`
    fragment Contest on MediaContest {
  id
  type
  title
  description
  images {
    titleImage
    comingSoonImage
    payturSignupImage
  }
  uploadStart
  uploadEnd
  votingStart
  votingEnd
  prizes {
    place
    amount
  }
  userPlace
  video {
    ...Video
  }
  photoalbum {
    ...Photoalbum
  }
  uploadLimit
}
    ${VideoFragmentDoc}
${PhotoalbumFragmentDoc}`;
export const ProfileFieldTypeUploadDocumentFragmentDoc = gql`
    fragment ProfileFieldTypeUploadDocument on ProfileFieldTypeUploadDocument {
  __typename
  name
  status
  rejectReason
  value {
    docId
  }
}
    `;
export const FinanceServiceCollectionFragmentDoc = gql`
    fragment FinanceServiceCollection on ProfileCollectionPayoutV1 {
  fields {
    payoutIsTaxable {
      ...ProfileFieldTypeBoolean
    }
    payoutTaxId {
      ...ProfileFieldTypeString
    }
    payoutTaxDocument {
      ...ProfileFieldTypeUploadDocument
    }
    payoutTransactionType {
      ...ProfileFieldTypeEnum
    }
    payoutBankaccountOwner {
      ...ProfileFieldTypeString
    }
    payoutIban {
      ...ProfileFieldTypeString
    }
    payoutBic {
      ...ProfileFieldTypeString
    }
    payoutPaxumEmailAccount {
      ...ProfileFieldTypeString
    }
    payoutAddressDocument {
      ...ProfileFieldTypeUploadDocument
    }
  }
  values {
    payoutIsTaxable
    payoutTaxId
    payoutTaxDocument {
      docId
    }
    payoutTransactionType
    payoutBankaccountOwner
    payoutIban
    payoutBic
    payoutPaxumEmailAccount
    payoutAddressCity
    payoutAddressCountry
    payoutAddressDocument {
      docId
    }
    payoutAddressPostalCode
    payoutAddressStreet
    payoutAddressStreetNumber
    payoutAddressFirstname
    payoutAddressLastname
    payoutAddressCompanyname
    payoutAddressIsCompany
  }
}
    ${ProfileFieldTypeBooleanFragmentDoc}
${ProfileFieldTypeStringFragmentDoc}
${ProfileFieldTypeUploadDocumentFragmentDoc}
${ProfileFieldTypeEnumFragmentDoc}`;
export const OldFinancesInvoiceFragmentDoc = gql`
    fragment OldFinancesInvoice on FinancesInvoice {
  amount
  payoutDate
  status
  message
  billingStartDate
  billingEndDate
}
    `;
export const OldFinancesInvoicesFragmentDoc = gql`
    fragment OldFinancesInvoices on FinancesInvoices {
  count
  maxDate
  minDate
  invoices {
    ...OldFinancesInvoice
  }
}
    ${OldFinancesInvoiceFragmentDoc}`;
export const MandatoryEmailVerificationSectionFragmentDoc = gql`
    fragment MandatoryEmailVerificationSection on ProfileCollectionAccountV1 {
  fields {
    accountContactEmailAdress {
      maxLength
      minLength
    }
  }
}
    `;
export const StatisticsEntryFragmentDoc = gql`
    fragment StatisticsEntry on StatisticsEntry {
  __typename
  id
  label
  icon
  category
  values {
    value
    dateTime
    ts
  }
  trend {
    percent
  }
  ... on StatisticsEntrySingleCurrency {
    unit
  }
  ... on StatisticsEntrySingleDuration {
    unit
  }
  ... on StatisticsEntrySingleNumber {
    unit
  }
}
    `;
export const TermAcceptanceStateFragmentDoc = gql`
    fragment TermAcceptanceState on TermAcceptance {
  type
  hasAccepted
  hasAcceptedAnyVersion
  acceptDate
  acceptedVersion
  consentRequired
}
    `;
export const MediaCommentFragmentDoc = gql`
    fragment MediaComment on MediaComment {
  albumId
  avatarUrl
  date
  id
  reply {
    date
    id
    text
  }
  text
  userId
  userName
}
    `;
export const PictureListFragmentDoc = gql`
    fragment PictureList on PictureList {
  edges {
    node {
      ...MediaPictureInList
    }
    cursor
  }
  pageInfo {
    hasNextPage
  }
  totalCount
}
    ${MediaPictureInListFragmentDoc}`;
export const MediaLikeFragmentDoc = gql`
    fragment MediaLike on MediaLike {
  albumId
  avatarUrl
  date
  userId
  userName
}
    `;
export const MediaSaleFragmentDoc = gql`
    fragment MediaSale on MediaSale {
  albumId
  avatarUrl
  date
  discountPercent
  guestPrice
  modelSharing
  userId
  userName
}
    `;
export const ContestVideoFragmentDoc = gql`
    fragment ContestVideo on MediaContest {
  votingStart
  votingEnd
}
    `;
export const GetPayoutConditionsDocument = gql`
    query getPayoutConditions {
  finances {
    payoutConditions {
      minAmountBankDE
      feeBankDE
      feeBankEU
      feeBank3L
      feePaxum
      feeUnderMinAmount
    }
  }
}
    `;

/**
 * __useGetPayoutConditionsQuery__
 *
 * To run a query within a React component, call `useGetPayoutConditionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPayoutConditionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPayoutConditionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPayoutConditionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPayoutConditionsQuery, GetPayoutConditionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPayoutConditionsQuery, GetPayoutConditionsQueryVariables>(GetPayoutConditionsDocument, options);
      }
export function useGetPayoutConditionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPayoutConditionsQuery, GetPayoutConditionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPayoutConditionsQuery, GetPayoutConditionsQueryVariables>(GetPayoutConditionsDocument, options);
        }
export function useGetPayoutConditionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetPayoutConditionsQuery, GetPayoutConditionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetPayoutConditionsQuery, GetPayoutConditionsQueryVariables>(GetPayoutConditionsDocument, options);
        }
export type GetPayoutConditionsQueryHookResult = ReturnType<typeof useGetPayoutConditionsQuery>;
export type GetPayoutConditionsLazyQueryHookResult = ReturnType<typeof useGetPayoutConditionsLazyQuery>;
export type GetPayoutConditionsSuspenseQueryHookResult = ReturnType<typeof useGetPayoutConditionsSuspenseQuery>;
export type GetPayoutConditionsQueryResult = Apollo.QueryResult<GetPayoutConditionsQuery, GetPayoutConditionsQueryVariables>;
export const TagAutoCompleteDocument = gql`
    query TagAutoComplete($fragment: String!) {
  media {
    tags(fragment: $fragment) {
      id
      value
    }
  }
}
    `;

/**
 * __useTagAutoCompleteQuery__
 *
 * To run a query within a React component, call `useTagAutoCompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagAutoCompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagAutoCompleteQuery({
 *   variables: {
 *      fragment: // value for 'fragment'
 *   },
 * });
 */
export function useTagAutoCompleteQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TagAutoCompleteQuery, TagAutoCompleteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TagAutoCompleteQuery, TagAutoCompleteQueryVariables>(TagAutoCompleteDocument, options);
      }
export function useTagAutoCompleteLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TagAutoCompleteQuery, TagAutoCompleteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TagAutoCompleteQuery, TagAutoCompleteQueryVariables>(TagAutoCompleteDocument, options);
        }
export function useTagAutoCompleteSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TagAutoCompleteQuery, TagAutoCompleteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TagAutoCompleteQuery, TagAutoCompleteQueryVariables>(TagAutoCompleteDocument, options);
        }
export type TagAutoCompleteQueryHookResult = ReturnType<typeof useTagAutoCompleteQuery>;
export type TagAutoCompleteLazyQueryHookResult = ReturnType<typeof useTagAutoCompleteLazyQuery>;
export type TagAutoCompleteSuspenseQueryHookResult = ReturnType<typeof useTagAutoCompleteSuspenseQuery>;
export type TagAutoCompleteQueryResult = Apollo.QueryResult<TagAutoCompleteQuery, TagAutoCompleteQueryVariables>;
export const GetProfileHeaderStatisticsDocument = gql`
    query GetProfileHeaderStatistics {
  statistics {
    entries(name: modelProfile) {
      ...StatisticsEntry
    }
  }
}
    ${StatisticsEntryFragmentDoc}`;

/**
 * __useGetProfileHeaderStatisticsQuery__
 *
 * To run a query within a React component, call `useGetProfileHeaderStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfileHeaderStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfileHeaderStatisticsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProfileHeaderStatisticsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetProfileHeaderStatisticsQuery, GetProfileHeaderStatisticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetProfileHeaderStatisticsQuery, GetProfileHeaderStatisticsQueryVariables>(GetProfileHeaderStatisticsDocument, options);
      }
export function useGetProfileHeaderStatisticsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProfileHeaderStatisticsQuery, GetProfileHeaderStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetProfileHeaderStatisticsQuery, GetProfileHeaderStatisticsQueryVariables>(GetProfileHeaderStatisticsDocument, options);
        }
export function useGetProfileHeaderStatisticsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetProfileHeaderStatisticsQuery, GetProfileHeaderStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetProfileHeaderStatisticsQuery, GetProfileHeaderStatisticsQueryVariables>(GetProfileHeaderStatisticsDocument, options);
        }
export type GetProfileHeaderStatisticsQueryHookResult = ReturnType<typeof useGetProfileHeaderStatisticsQuery>;
export type GetProfileHeaderStatisticsLazyQueryHookResult = ReturnType<typeof useGetProfileHeaderStatisticsLazyQuery>;
export type GetProfileHeaderStatisticsSuspenseQueryHookResult = ReturnType<typeof useGetProfileHeaderStatisticsSuspenseQuery>;
export type GetProfileHeaderStatisticsQueryResult = Apollo.QueryResult<GetProfileHeaderStatisticsQuery, GetProfileHeaderStatisticsQueryVariables>;
export const GetEmailVerificationStatusDocument = gql`
    query GetEmailVerificationStatus {
  account {
    isRegistrationComplete
    contact {
      isCurrentEmailAddressVerified
    }
  }
}
    `;

/**
 * __useGetEmailVerificationStatusQuery__
 *
 * To run a query within a React component, call `useGetEmailVerificationStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailVerificationStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailVerificationStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEmailVerificationStatusQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetEmailVerificationStatusQuery, GetEmailVerificationStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetEmailVerificationStatusQuery, GetEmailVerificationStatusQueryVariables>(GetEmailVerificationStatusDocument, options);
      }
export function useGetEmailVerificationStatusLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEmailVerificationStatusQuery, GetEmailVerificationStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetEmailVerificationStatusQuery, GetEmailVerificationStatusQueryVariables>(GetEmailVerificationStatusDocument, options);
        }
export function useGetEmailVerificationStatusSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetEmailVerificationStatusQuery, GetEmailVerificationStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetEmailVerificationStatusQuery, GetEmailVerificationStatusQueryVariables>(GetEmailVerificationStatusDocument, options);
        }
export type GetEmailVerificationStatusQueryHookResult = ReturnType<typeof useGetEmailVerificationStatusQuery>;
export type GetEmailVerificationStatusLazyQueryHookResult = ReturnType<typeof useGetEmailVerificationStatusLazyQuery>;
export type GetEmailVerificationStatusSuspenseQueryHookResult = ReturnType<typeof useGetEmailVerificationStatusSuspenseQuery>;
export type GetEmailVerificationStatusQueryResult = Apollo.QueryResult<GetEmailVerificationStatusQuery, GetEmailVerificationStatusQueryVariables>;
export const GetCmsMarkdownDocument = gql`
    query GetCmsMarkdown($lang: ApiLangEnum!, $id: ID!) {
  cms(lang: $lang) {
    article(id: $id) {
      ...CmsArticle
    }
  }
}
    ${CmsArticleFragmentDoc}`;

/**
 * __useGetCmsMarkdownQuery__
 *
 * To run a query within a React component, call `useGetCmsMarkdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCmsMarkdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCmsMarkdownQuery({
 *   variables: {
 *      lang: // value for 'lang'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCmsMarkdownQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetCmsMarkdownQuery, GetCmsMarkdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCmsMarkdownQuery, GetCmsMarkdownQueryVariables>(GetCmsMarkdownDocument, options);
      }
export function useGetCmsMarkdownLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCmsMarkdownQuery, GetCmsMarkdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCmsMarkdownQuery, GetCmsMarkdownQueryVariables>(GetCmsMarkdownDocument, options);
        }
export function useGetCmsMarkdownSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetCmsMarkdownQuery, GetCmsMarkdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetCmsMarkdownQuery, GetCmsMarkdownQueryVariables>(GetCmsMarkdownDocument, options);
        }
export type GetCmsMarkdownQueryHookResult = ReturnType<typeof useGetCmsMarkdownQuery>;
export type GetCmsMarkdownLazyQueryHookResult = ReturnType<typeof useGetCmsMarkdownLazyQuery>;
export type GetCmsMarkdownSuspenseQueryHookResult = ReturnType<typeof useGetCmsMarkdownSuspenseQuery>;
export type GetCmsMarkdownQueryResult = Apollo.QueryResult<GetCmsMarkdownQuery, GetCmsMarkdownQueryVariables>;
export const GetLegalTermMarkdownDocument = gql`
    query GetLegalTermMarkdown($type: TermsAcceptanceTypeEnum!) {
  terms {
    acceptance(type: $type) {
      type
      cmsArticle {
        ...LegalTermsArticle
      }
    }
  }
}
    ${LegalTermsArticleFragmentDoc}`;

/**
 * __useGetLegalTermMarkdownQuery__
 *
 * To run a query within a React component, call `useGetLegalTermMarkdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLegalTermMarkdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLegalTermMarkdownQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetLegalTermMarkdownQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetLegalTermMarkdownQuery, GetLegalTermMarkdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetLegalTermMarkdownQuery, GetLegalTermMarkdownQueryVariables>(GetLegalTermMarkdownDocument, options);
      }
export function useGetLegalTermMarkdownLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetLegalTermMarkdownQuery, GetLegalTermMarkdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetLegalTermMarkdownQuery, GetLegalTermMarkdownQueryVariables>(GetLegalTermMarkdownDocument, options);
        }
export function useGetLegalTermMarkdownSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetLegalTermMarkdownQuery, GetLegalTermMarkdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetLegalTermMarkdownQuery, GetLegalTermMarkdownQueryVariables>(GetLegalTermMarkdownDocument, options);
        }
export type GetLegalTermMarkdownQueryHookResult = ReturnType<typeof useGetLegalTermMarkdownQuery>;
export type GetLegalTermMarkdownLazyQueryHookResult = ReturnType<typeof useGetLegalTermMarkdownLazyQuery>;
export type GetLegalTermMarkdownSuspenseQueryHookResult = ReturnType<typeof useGetLegalTermMarkdownSuspenseQuery>;
export type GetLegalTermMarkdownQueryResult = Apollo.QueryResult<GetLegalTermMarkdownQuery, GetLegalTermMarkdownQueryVariables>;
export const EmailSectionDocument = gql`
    query EmailSection {
  account {
    isRegistrationComplete
    contact {
      currentEmailAddress
      isCurrentEmailAddressVerified
    }
  }
  profile {
    collection(name: AccountV1) {
      ...EmailSection
    }
  }
}
    ${EmailSectionFragmentDoc}`;

/**
 * __useEmailSectionQuery__
 *
 * To run a query within a React component, call `useEmailSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailSectionQuery({
 *   variables: {
 *   },
 * });
 */
export function useEmailSectionQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EmailSectionQuery, EmailSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EmailSectionQuery, EmailSectionQueryVariables>(EmailSectionDocument, options);
      }
export function useEmailSectionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EmailSectionQuery, EmailSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EmailSectionQuery, EmailSectionQueryVariables>(EmailSectionDocument, options);
        }
export function useEmailSectionSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EmailSectionQuery, EmailSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EmailSectionQuery, EmailSectionQueryVariables>(EmailSectionDocument, options);
        }
export type EmailSectionQueryHookResult = ReturnType<typeof useEmailSectionQuery>;
export type EmailSectionLazyQueryHookResult = ReturnType<typeof useEmailSectionLazyQuery>;
export type EmailSectionSuspenseQueryHookResult = ReturnType<typeof useEmailSectionSuspenseQuery>;
export type EmailSectionQueryResult = Apollo.QueryResult<EmailSectionQuery, EmailSectionQueryVariables>;
export const EmailSectionRegistrationUpdateDocument = gql`
    mutation emailSectionRegistrationUpdate($email: String!) {
  account {
    changeEmailAddressAndSendRegistrationMail(email: $email) {
      ...MutationResult
    }
  }
}
    ${MutationResultFragmentDoc}`;
export type EmailSectionRegistrationUpdateMutationFn = Apollo.MutationFunction<EmailSectionRegistrationUpdateMutation, EmailSectionRegistrationUpdateMutationVariables>;

/**
 * __useEmailSectionRegistrationUpdateMutation__
 *
 * To run a mutation, you first call `useEmailSectionRegistrationUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmailSectionRegistrationUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [emailSectionRegistrationUpdateMutation, { data, loading, error }] = useEmailSectionRegistrationUpdateMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useEmailSectionRegistrationUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EmailSectionRegistrationUpdateMutation, EmailSectionRegistrationUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<EmailSectionRegistrationUpdateMutation, EmailSectionRegistrationUpdateMutationVariables>(EmailSectionRegistrationUpdateDocument, options);
      }
export type EmailSectionRegistrationUpdateMutationHookResult = ReturnType<typeof useEmailSectionRegistrationUpdateMutation>;
export type EmailSectionRegistrationUpdateMutationResult = Apollo.MutationResult<EmailSectionRegistrationUpdateMutation>;
export type EmailSectionRegistrationUpdateMutationOptions = Apollo.BaseMutationOptions<EmailSectionRegistrationUpdateMutation, EmailSectionRegistrationUpdateMutationVariables>;
export const EmailSectionResendRegistrationMailDocument = gql`
    mutation emailSectionResendRegistrationMail {
  account {
    resendRegistrationMail {
      ...MutationResult
    }
  }
}
    ${MutationResultFragmentDoc}`;
export type EmailSectionResendRegistrationMailMutationFn = Apollo.MutationFunction<EmailSectionResendRegistrationMailMutation, EmailSectionResendRegistrationMailMutationVariables>;

/**
 * __useEmailSectionResendRegistrationMailMutation__
 *
 * To run a mutation, you first call `useEmailSectionResendRegistrationMailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmailSectionResendRegistrationMailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [emailSectionResendRegistrationMailMutation, { data, loading, error }] = useEmailSectionResendRegistrationMailMutation({
 *   variables: {
 *   },
 * });
 */
export function useEmailSectionResendRegistrationMailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EmailSectionResendRegistrationMailMutation, EmailSectionResendRegistrationMailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<EmailSectionResendRegistrationMailMutation, EmailSectionResendRegistrationMailMutationVariables>(EmailSectionResendRegistrationMailDocument, options);
      }
export type EmailSectionResendRegistrationMailMutationHookResult = ReturnType<typeof useEmailSectionResendRegistrationMailMutation>;
export type EmailSectionResendRegistrationMailMutationResult = Apollo.MutationResult<EmailSectionResendRegistrationMailMutation>;
export type EmailSectionResendRegistrationMailMutationOptions = Apollo.BaseMutationOptions<EmailSectionResendRegistrationMailMutation, EmailSectionResendRegistrationMailMutationVariables>;
export const EmailSectionEmailUpdateDocument = gql`
    mutation emailSectionEmailUpdate($email: String!) {
  account {
    changeEmailAddressAndSendVerificationMail(email: $email) {
      ...MutationResult
    }
  }
}
    ${MutationResultFragmentDoc}`;
export type EmailSectionEmailUpdateMutationFn = Apollo.MutationFunction<EmailSectionEmailUpdateMutation, EmailSectionEmailUpdateMutationVariables>;

/**
 * __useEmailSectionEmailUpdateMutation__
 *
 * To run a mutation, you first call `useEmailSectionEmailUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmailSectionEmailUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [emailSectionEmailUpdateMutation, { data, loading, error }] = useEmailSectionEmailUpdateMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useEmailSectionEmailUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EmailSectionEmailUpdateMutation, EmailSectionEmailUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<EmailSectionEmailUpdateMutation, EmailSectionEmailUpdateMutationVariables>(EmailSectionEmailUpdateDocument, options);
      }
export type EmailSectionEmailUpdateMutationHookResult = ReturnType<typeof useEmailSectionEmailUpdateMutation>;
export type EmailSectionEmailUpdateMutationResult = Apollo.MutationResult<EmailSectionEmailUpdateMutation>;
export type EmailSectionEmailUpdateMutationOptions = Apollo.BaseMutationOptions<EmailSectionEmailUpdateMutation, EmailSectionEmailUpdateMutationVariables>;
export const EmailSectionResendVerificationMailDocument = gql`
    mutation emailSectionResendVerificationMail {
  account {
    resendVerificationMail {
      ...MutationResult
    }
  }
}
    ${MutationResultFragmentDoc}`;
export type EmailSectionResendVerificationMailMutationFn = Apollo.MutationFunction<EmailSectionResendVerificationMailMutation, EmailSectionResendVerificationMailMutationVariables>;

/**
 * __useEmailSectionResendVerificationMailMutation__
 *
 * To run a mutation, you first call `useEmailSectionResendVerificationMailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmailSectionResendVerificationMailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [emailSectionResendVerificationMailMutation, { data, loading, error }] = useEmailSectionResendVerificationMailMutation({
 *   variables: {
 *   },
 * });
 */
export function useEmailSectionResendVerificationMailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EmailSectionResendVerificationMailMutation, EmailSectionResendVerificationMailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<EmailSectionResendVerificationMailMutation, EmailSectionResendVerificationMailMutationVariables>(EmailSectionResendVerificationMailDocument, options);
      }
export type EmailSectionResendVerificationMailMutationHookResult = ReturnType<typeof useEmailSectionResendVerificationMailMutation>;
export type EmailSectionResendVerificationMailMutationResult = Apollo.MutationResult<EmailSectionResendVerificationMailMutation>;
export type EmailSectionResendVerificationMailMutationOptions = Apollo.BaseMutationOptions<EmailSectionResendVerificationMailMutation, EmailSectionResendVerificationMailMutationVariables>;
export const LanguageSectionDocument = gql`
    query LanguageSection {
  account {
    language
  }
}
    `;

/**
 * __useLanguageSectionQuery__
 *
 * To run a query within a React component, call `useLanguageSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useLanguageSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLanguageSectionQuery({
 *   variables: {
 *   },
 * });
 */
export function useLanguageSectionQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<LanguageSectionQuery, LanguageSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LanguageSectionQuery, LanguageSectionQueryVariables>(LanguageSectionDocument, options);
      }
export function useLanguageSectionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LanguageSectionQuery, LanguageSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LanguageSectionQuery, LanguageSectionQueryVariables>(LanguageSectionDocument, options);
        }
export function useLanguageSectionSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<LanguageSectionQuery, LanguageSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<LanguageSectionQuery, LanguageSectionQueryVariables>(LanguageSectionDocument, options);
        }
export type LanguageSectionQueryHookResult = ReturnType<typeof useLanguageSectionQuery>;
export type LanguageSectionLazyQueryHookResult = ReturnType<typeof useLanguageSectionLazyQuery>;
export type LanguageSectionSuspenseQueryHookResult = ReturnType<typeof useLanguageSectionSuspenseQuery>;
export type LanguageSectionQueryResult = Apollo.QueryResult<LanguageSectionQuery, LanguageSectionQueryVariables>;
export const LanguageUpdateDocument = gql`
    mutation languageUpdate($language: ApiLangEnum!) {
  account {
    saveLanguage(language: $language) {
      success
      message
    }
  }
}
    `;
export type LanguageUpdateMutationFn = Apollo.MutationFunction<LanguageUpdateMutation, LanguageUpdateMutationVariables>;

/**
 * __useLanguageUpdateMutation__
 *
 * To run a mutation, you first call `useLanguageUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLanguageUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [languageUpdateMutation, { data, loading, error }] = useLanguageUpdateMutation({
 *   variables: {
 *      language: // value for 'language'
 *   },
 * });
 */
export function useLanguageUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LanguageUpdateMutation, LanguageUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<LanguageUpdateMutation, LanguageUpdateMutationVariables>(LanguageUpdateDocument, options);
      }
export type LanguageUpdateMutationHookResult = ReturnType<typeof useLanguageUpdateMutation>;
export type LanguageUpdateMutationResult = Apollo.MutationResult<LanguageUpdateMutation>;
export type LanguageUpdateMutationOptions = Apollo.BaseMutationOptions<LanguageUpdateMutation, LanguageUpdateMutationVariables>;
export const MobileNumberSectionDocument = gql`
    query MobileNumberSection {
  account {
    contact {
      isCurrentMobileNumberVerified
      currentMobileNumber {
        fullPhoneNumber
      }
    }
  }
  profile {
    collection(name: AccountV1) {
      ... on ProfileCollectionAccountV1 {
        fields {
          accountContactMobilePhone {
            ...ProfileCollectionFieldString
          }
        }
      }
    }
  }
}
    ${ProfileCollectionFieldStringFragmentDoc}`;

/**
 * __useMobileNumberSectionQuery__
 *
 * To run a query within a React component, call `useMobileNumberSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useMobileNumberSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMobileNumberSectionQuery({
 *   variables: {
 *   },
 * });
 */
export function useMobileNumberSectionQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MobileNumberSectionQuery, MobileNumberSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MobileNumberSectionQuery, MobileNumberSectionQueryVariables>(MobileNumberSectionDocument, options);
      }
export function useMobileNumberSectionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MobileNumberSectionQuery, MobileNumberSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MobileNumberSectionQuery, MobileNumberSectionQueryVariables>(MobileNumberSectionDocument, options);
        }
export function useMobileNumberSectionSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MobileNumberSectionQuery, MobileNumberSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MobileNumberSectionQuery, MobileNumberSectionQueryVariables>(MobileNumberSectionDocument, options);
        }
export type MobileNumberSectionQueryHookResult = ReturnType<typeof useMobileNumberSectionQuery>;
export type MobileNumberSectionLazyQueryHookResult = ReturnType<typeof useMobileNumberSectionLazyQuery>;
export type MobileNumberSectionSuspenseQueryHookResult = ReturnType<typeof useMobileNumberSectionSuspenseQuery>;
export type MobileNumberSectionQueryResult = Apollo.QueryResult<MobileNumberSectionQuery, MobileNumberSectionQueryVariables>;
export const MobileNumberSectionNumberUpdateDocument = gql`
    mutation mobileNumberSectionNumberUpdate($mobileNumber: String!) {
  account {
    changePhoneNumberAndSendVerificationCode(phoneNumber: $mobileNumber) {
      ...MutationResult
    }
  }
}
    ${MutationResultFragmentDoc}`;
export type MobileNumberSectionNumberUpdateMutationFn = Apollo.MutationFunction<MobileNumberSectionNumberUpdateMutation, MobileNumberSectionNumberUpdateMutationVariables>;

/**
 * __useMobileNumberSectionNumberUpdateMutation__
 *
 * To run a mutation, you first call `useMobileNumberSectionNumberUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMobileNumberSectionNumberUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mobileNumberSectionNumberUpdateMutation, { data, loading, error }] = useMobileNumberSectionNumberUpdateMutation({
 *   variables: {
 *      mobileNumber: // value for 'mobileNumber'
 *   },
 * });
 */
export function useMobileNumberSectionNumberUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MobileNumberSectionNumberUpdateMutation, MobileNumberSectionNumberUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MobileNumberSectionNumberUpdateMutation, MobileNumberSectionNumberUpdateMutationVariables>(MobileNumberSectionNumberUpdateDocument, options);
      }
export type MobileNumberSectionNumberUpdateMutationHookResult = ReturnType<typeof useMobileNumberSectionNumberUpdateMutation>;
export type MobileNumberSectionNumberUpdateMutationResult = Apollo.MutationResult<MobileNumberSectionNumberUpdateMutation>;
export type MobileNumberSectionNumberUpdateMutationOptions = Apollo.BaseMutationOptions<MobileNumberSectionNumberUpdateMutation, MobileNumberSectionNumberUpdateMutationVariables>;
export const MobileNumberSectionNumberResendVerificationCodeDocument = gql`
    mutation mobileNumberSectionNumberResendVerificationCode($mobileNumber: String!) {
  account {
    resendVerificationCodeToPhoneNumber(phoneNumber: $mobileNumber) {
      ...MutationResult
    }
  }
}
    ${MutationResultFragmentDoc}`;
export type MobileNumberSectionNumberResendVerificationCodeMutationFn = Apollo.MutationFunction<MobileNumberSectionNumberResendVerificationCodeMutation, MobileNumberSectionNumberResendVerificationCodeMutationVariables>;

/**
 * __useMobileNumberSectionNumberResendVerificationCodeMutation__
 *
 * To run a mutation, you first call `useMobileNumberSectionNumberResendVerificationCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMobileNumberSectionNumberResendVerificationCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mobileNumberSectionNumberResendVerificationCodeMutation, { data, loading, error }] = useMobileNumberSectionNumberResendVerificationCodeMutation({
 *   variables: {
 *      mobileNumber: // value for 'mobileNumber'
 *   },
 * });
 */
export function useMobileNumberSectionNumberResendVerificationCodeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MobileNumberSectionNumberResendVerificationCodeMutation, MobileNumberSectionNumberResendVerificationCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MobileNumberSectionNumberResendVerificationCodeMutation, MobileNumberSectionNumberResendVerificationCodeMutationVariables>(MobileNumberSectionNumberResendVerificationCodeDocument, options);
      }
export type MobileNumberSectionNumberResendVerificationCodeMutationHookResult = ReturnType<typeof useMobileNumberSectionNumberResendVerificationCodeMutation>;
export type MobileNumberSectionNumberResendVerificationCodeMutationResult = Apollo.MutationResult<MobileNumberSectionNumberResendVerificationCodeMutation>;
export type MobileNumberSectionNumberResendVerificationCodeMutationOptions = Apollo.BaseMutationOptions<MobileNumberSectionNumberResendVerificationCodeMutation, MobileNumberSectionNumberResendVerificationCodeMutationVariables>;
export const MobileNumberSectionNumberVerifyDocument = gql`
    mutation mobileNumberSectionNumberVerify($mobileNumber: String!, $verificationCode: String!) {
  account {
    verifyPhoneNumber(phoneNumber: $mobileNumber, code: $verificationCode) {
      ...MutationResult
    }
  }
}
    ${MutationResultFragmentDoc}`;
export type MobileNumberSectionNumberVerifyMutationFn = Apollo.MutationFunction<MobileNumberSectionNumberVerifyMutation, MobileNumberSectionNumberVerifyMutationVariables>;

/**
 * __useMobileNumberSectionNumberVerifyMutation__
 *
 * To run a mutation, you first call `useMobileNumberSectionNumberVerifyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMobileNumberSectionNumberVerifyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mobileNumberSectionNumberVerifyMutation, { data, loading, error }] = useMobileNumberSectionNumberVerifyMutation({
 *   variables: {
 *      mobileNumber: // value for 'mobileNumber'
 *      verificationCode: // value for 'verificationCode'
 *   },
 * });
 */
export function useMobileNumberSectionNumberVerifyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MobileNumberSectionNumberVerifyMutation, MobileNumberSectionNumberVerifyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MobileNumberSectionNumberVerifyMutation, MobileNumberSectionNumberVerifyMutationVariables>(MobileNumberSectionNumberVerifyDocument, options);
      }
export type MobileNumberSectionNumberVerifyMutationHookResult = ReturnType<typeof useMobileNumberSectionNumberVerifyMutation>;
export type MobileNumberSectionNumberVerifyMutationResult = Apollo.MutationResult<MobileNumberSectionNumberVerifyMutation>;
export type MobileNumberSectionNumberVerifyMutationOptions = Apollo.BaseMutationOptions<MobileNumberSectionNumberVerifyMutation, MobileNumberSectionNumberVerifyMutationVariables>;
export const PasswordSectionDocument = gql`
    query PasswordSection {
  account {
    isRegistrationComplete
  }
}
    `;

/**
 * __usePasswordSectionQuery__
 *
 * To run a query within a React component, call `usePasswordSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePasswordSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePasswordSectionQuery({
 *   variables: {
 *   },
 * });
 */
export function usePasswordSectionQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PasswordSectionQuery, PasswordSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PasswordSectionQuery, PasswordSectionQueryVariables>(PasswordSectionDocument, options);
      }
export function usePasswordSectionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PasswordSectionQuery, PasswordSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PasswordSectionQuery, PasswordSectionQueryVariables>(PasswordSectionDocument, options);
        }
export function usePasswordSectionSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PasswordSectionQuery, PasswordSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PasswordSectionQuery, PasswordSectionQueryVariables>(PasswordSectionDocument, options);
        }
export type PasswordSectionQueryHookResult = ReturnType<typeof usePasswordSectionQuery>;
export type PasswordSectionLazyQueryHookResult = ReturnType<typeof usePasswordSectionLazyQuery>;
export type PasswordSectionSuspenseQueryHookResult = ReturnType<typeof usePasswordSectionSuspenseQuery>;
export type PasswordSectionQueryResult = Apollo.QueryResult<PasswordSectionQuery, PasswordSectionQueryVariables>;
export const PasswordUpdateDocument = gql`
    mutation passwordUpdate($currentPW: String!, $newPW: String!) {
  auth {
    changePassword(currentPassword: $currentPW, newPassword: $newPW) {
      __typename
      ... on PasswordSetResultFail {
        message
      }
      ... on PasswordSetResultSuccessful {
        message
      }
    }
  }
}
    `;
export type PasswordUpdateMutationFn = Apollo.MutationFunction<PasswordUpdateMutation, PasswordUpdateMutationVariables>;

/**
 * __usePasswordUpdateMutation__
 *
 * To run a mutation, you first call `usePasswordUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePasswordUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [passwordUpdateMutation, { data, loading, error }] = usePasswordUpdateMutation({
 *   variables: {
 *      currentPW: // value for 'currentPW'
 *      newPW: // value for 'newPW'
 *   },
 * });
 */
export function usePasswordUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PasswordUpdateMutation, PasswordUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PasswordUpdateMutation, PasswordUpdateMutationVariables>(PasswordUpdateDocument, options);
      }
export type PasswordUpdateMutationHookResult = ReturnType<typeof usePasswordUpdateMutation>;
export type PasswordUpdateMutationResult = Apollo.MutationResult<PasswordUpdateMutation>;
export type PasswordUpdateMutationOptions = Apollo.BaseMutationOptions<PasswordUpdateMutation, PasswordUpdateMutationVariables>;
export const AccountPersonalSectionDocument = gql`
    query AccountPersonalSection {
  profile {
    collection(name: AccountV1) {
      ... on ProfileCollectionAccountV1 {
        fields {
          accountBirthdate {
            ...ProfileCollectionFieldDate
          }
          accountFirstname {
            ...ProfileCollectionFieldString
          }
          accountLastname {
            ...ProfileCollectionFieldString
          }
        }
      }
    }
  }
}
    ${ProfileCollectionFieldDateFragmentDoc}
${ProfileCollectionFieldStringFragmentDoc}`;

/**
 * __useAccountPersonalSectionQuery__
 *
 * To run a query within a React component, call `useAccountPersonalSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountPersonalSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountPersonalSectionQuery({
 *   variables: {
 *   },
 * });
 */
export function useAccountPersonalSectionQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AccountPersonalSectionQuery, AccountPersonalSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AccountPersonalSectionQuery, AccountPersonalSectionQueryVariables>(AccountPersonalSectionDocument, options);
      }
export function useAccountPersonalSectionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccountPersonalSectionQuery, AccountPersonalSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AccountPersonalSectionQuery, AccountPersonalSectionQueryVariables>(AccountPersonalSectionDocument, options);
        }
export function useAccountPersonalSectionSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AccountPersonalSectionQuery, AccountPersonalSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AccountPersonalSectionQuery, AccountPersonalSectionQueryVariables>(AccountPersonalSectionDocument, options);
        }
export type AccountPersonalSectionQueryHookResult = ReturnType<typeof useAccountPersonalSectionQuery>;
export type AccountPersonalSectionLazyQueryHookResult = ReturnType<typeof useAccountPersonalSectionLazyQuery>;
export type AccountPersonalSectionSuspenseQueryHookResult = ReturnType<typeof useAccountPersonalSectionSuspenseQuery>;
export type AccountPersonalSectionQueryResult = Apollo.QueryResult<AccountPersonalSectionQuery, AccountPersonalSectionQueryVariables>;
export const AccountEditPersonalSectionUpdateDocument = gql`
    mutation accountEditPersonalSectionUpdate($firstname: String!, $lastname: String!, $birthdate: Date!) {
  account {
    saveBirthday(birthday: $birthdate) {
      ...MutationResult
    }
    saveName(firstname: $firstname, lastname: $lastname) {
      ...MutationResult
    }
  }
}
    ${MutationResultFragmentDoc}`;
export type AccountEditPersonalSectionUpdateMutationFn = Apollo.MutationFunction<AccountEditPersonalSectionUpdateMutation, AccountEditPersonalSectionUpdateMutationVariables>;

/**
 * __useAccountEditPersonalSectionUpdateMutation__
 *
 * To run a mutation, you first call `useAccountEditPersonalSectionUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountEditPersonalSectionUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountEditPersonalSectionUpdateMutation, { data, loading, error }] = useAccountEditPersonalSectionUpdateMutation({
 *   variables: {
 *      firstname: // value for 'firstname'
 *      lastname: // value for 'lastname'
 *      birthdate: // value for 'birthdate'
 *   },
 * });
 */
export function useAccountEditPersonalSectionUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AccountEditPersonalSectionUpdateMutation, AccountEditPersonalSectionUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AccountEditPersonalSectionUpdateMutation, AccountEditPersonalSectionUpdateMutationVariables>(AccountEditPersonalSectionUpdateDocument, options);
      }
export type AccountEditPersonalSectionUpdateMutationHookResult = ReturnType<typeof useAccountEditPersonalSectionUpdateMutation>;
export type AccountEditPersonalSectionUpdateMutationResult = Apollo.MutationResult<AccountEditPersonalSectionUpdateMutation>;
export type AccountEditPersonalSectionUpdateMutationOptions = Apollo.BaseMutationOptions<AccountEditPersonalSectionUpdateMutation, AccountEditPersonalSectionUpdateMutationVariables>;
export const GetActorsDocumentsPageDocument = gql`
    query getActorsDocumentsPage {
  account {
    hostUserId: userId
    isAllowedToAddNewActor
    personalDocuments {
      ...DocumentsOfHostAccount
    }
    originator {
      ...Originator
    }
    actors {
      ...Actor
    }
  }
}
    ${DocumentsOfHostAccountFragmentDoc}
${OriginatorFragmentDoc}
${ActorFragmentDoc}`;

/**
 * __useGetActorsDocumentsPageQuery__
 *
 * To run a query within a React component, call `useGetActorsDocumentsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActorsDocumentsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActorsDocumentsPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetActorsDocumentsPageQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetActorsDocumentsPageQuery, GetActorsDocumentsPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetActorsDocumentsPageQuery, GetActorsDocumentsPageQueryVariables>(GetActorsDocumentsPageDocument, options);
      }
export function useGetActorsDocumentsPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetActorsDocumentsPageQuery, GetActorsDocumentsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetActorsDocumentsPageQuery, GetActorsDocumentsPageQueryVariables>(GetActorsDocumentsPageDocument, options);
        }
export function useGetActorsDocumentsPageSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetActorsDocumentsPageQuery, GetActorsDocumentsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetActorsDocumentsPageQuery, GetActorsDocumentsPageQueryVariables>(GetActorsDocumentsPageDocument, options);
        }
export type GetActorsDocumentsPageQueryHookResult = ReturnType<typeof useGetActorsDocumentsPageQuery>;
export type GetActorsDocumentsPageLazyQueryHookResult = ReturnType<typeof useGetActorsDocumentsPageLazyQuery>;
export type GetActorsDocumentsPageSuspenseQueryHookResult = ReturnType<typeof useGetActorsDocumentsPageSuspenseQuery>;
export type GetActorsDocumentsPageQueryResult = Apollo.QueryResult<GetActorsDocumentsPageQuery, GetActorsDocumentsPageQueryVariables>;
export const GetDocumentUploadUrlDocument = gql`
    query getDocumentUploadUrl($userId: Int!, $documentType: DocumentTypeEnum!, $side: DocumentSideEnum) {
  documents {
    uploadUrl(userId: $userId, type: $documentType, side: $side)
  }
}
    `;

/**
 * __useGetDocumentUploadUrlQuery__
 *
 * To run a query within a React component, call `useGetDocumentUploadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentUploadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentUploadUrlQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      documentType: // value for 'documentType'
 *      side: // value for 'side'
 *   },
 * });
 */
export function useGetDocumentUploadUrlQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetDocumentUploadUrlQuery, GetDocumentUploadUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDocumentUploadUrlQuery, GetDocumentUploadUrlQueryVariables>(GetDocumentUploadUrlDocument, options);
      }
export function useGetDocumentUploadUrlLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDocumentUploadUrlQuery, GetDocumentUploadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDocumentUploadUrlQuery, GetDocumentUploadUrlQueryVariables>(GetDocumentUploadUrlDocument, options);
        }
export function useGetDocumentUploadUrlSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetDocumentUploadUrlQuery, GetDocumentUploadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetDocumentUploadUrlQuery, GetDocumentUploadUrlQueryVariables>(GetDocumentUploadUrlDocument, options);
        }
export type GetDocumentUploadUrlQueryHookResult = ReturnType<typeof useGetDocumentUploadUrlQuery>;
export type GetDocumentUploadUrlLazyQueryHookResult = ReturnType<typeof useGetDocumentUploadUrlLazyQuery>;
export type GetDocumentUploadUrlSuspenseQueryHookResult = ReturnType<typeof useGetDocumentUploadUrlSuspenseQuery>;
export type GetDocumentUploadUrlQueryResult = Apollo.QueryResult<GetDocumentUploadUrlQuery, GetDocumentUploadUrlQueryVariables>;
export const GetCreateActorPageDocument = gql`
    query GetCreateActorPage {
  account {
    isAllowedToAddNewActor
    originator {
      userId
    }
    actors {
      userId
    }
  }
}
    `;

/**
 * __useGetCreateActorPageQuery__
 *
 * To run a query within a React component, call `useGetCreateActorPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreateActorPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreateActorPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCreateActorPageQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCreateActorPageQuery, GetCreateActorPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCreateActorPageQuery, GetCreateActorPageQueryVariables>(GetCreateActorPageDocument, options);
      }
export function useGetCreateActorPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCreateActorPageQuery, GetCreateActorPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCreateActorPageQuery, GetCreateActorPageQueryVariables>(GetCreateActorPageDocument, options);
        }
export function useGetCreateActorPageSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetCreateActorPageQuery, GetCreateActorPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetCreateActorPageQuery, GetCreateActorPageQueryVariables>(GetCreateActorPageDocument, options);
        }
export type GetCreateActorPageQueryHookResult = ReturnType<typeof useGetCreateActorPageQuery>;
export type GetCreateActorPageLazyQueryHookResult = ReturnType<typeof useGetCreateActorPageLazyQuery>;
export type GetCreateActorPageSuspenseQueryHookResult = ReturnType<typeof useGetCreateActorPageSuspenseQuery>;
export type GetCreateActorPageQueryResult = Apollo.QueryResult<GetCreateActorPageQuery, GetCreateActorPageQueryVariables>;
export const SaveActorDocument = gql`
    mutation saveActor($data: InputSaveRealPersonData!) {
  account {
    saveActor(data: $data) {
      success
      errorMessage
      savedActor {
        ...Actor
      }
    }
  }
}
    ${ActorFragmentDoc}`;
export type SaveActorMutationFn = Apollo.MutationFunction<SaveActorMutation, SaveActorMutationVariables>;

/**
 * __useSaveActorMutation__
 *
 * To run a mutation, you first call `useSaveActorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveActorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveActorMutation, { data, loading, error }] = useSaveActorMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSaveActorMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveActorMutation, SaveActorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveActorMutation, SaveActorMutationVariables>(SaveActorDocument, options);
      }
export type SaveActorMutationHookResult = ReturnType<typeof useSaveActorMutation>;
export type SaveActorMutationResult = Apollo.MutationResult<SaveActorMutation>;
export type SaveActorMutationOptions = Apollo.BaseMutationOptions<SaveActorMutation, SaveActorMutationVariables>;
export const InitModelReleaseFormDocument = gql`
    mutation initModelReleaseForm($userId: Int, $lang: ModelReleaseFormLanguageEnum, $redirectUrl: String!) {
  documents {
    initModelReleaseForm(userId: $userId, lang: $lang) {
      id
      status
      formdata
      formUrl(redirUrl: $redirectUrl)
      metadata
    }
  }
}
    `;
export type InitModelReleaseFormMutationFn = Apollo.MutationFunction<InitModelReleaseFormMutation, InitModelReleaseFormMutationVariables>;

/**
 * __useInitModelReleaseFormMutation__
 *
 * To run a mutation, you first call `useInitModelReleaseFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitModelReleaseFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initModelReleaseFormMutation, { data, loading, error }] = useInitModelReleaseFormMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      lang: // value for 'lang'
 *      redirectUrl: // value for 'redirectUrl'
 *   },
 * });
 */
export function useInitModelReleaseFormMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<InitModelReleaseFormMutation, InitModelReleaseFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<InitModelReleaseFormMutation, InitModelReleaseFormMutationVariables>(InitModelReleaseFormDocument, options);
      }
export type InitModelReleaseFormMutationHookResult = ReturnType<typeof useInitModelReleaseFormMutation>;
export type InitModelReleaseFormMutationResult = Apollo.MutationResult<InitModelReleaseFormMutation>;
export type InitModelReleaseFormMutationOptions = Apollo.BaseMutationOptions<InitModelReleaseFormMutation, InitModelReleaseFormMutationVariables>;
export const DocumentDetailPageDocument = gql`
    query DocumentDetailPage($userId: Int!) {
  account {
    hostUserId: userId
    personalDocuments {
      ...DocumentsOfHostAccount
    }
    actor(actorId: $userId) {
      ...Actor
    }
    actors {
      ...Actor
    }
    originator {
      ...Originator
    }
    modelVerificationStatus
  }
  documents {
    ageVerificationTour: tour(name: actorVerification) {
      completenessPercent
    }
  }
  mrfTour: tour(type: ModelReleaseFormV1) {
    ... on TourModelReleaseFormV1 {
      status
      lastVerified
      completeness {
        percent
      }
    }
  }
}
    ${DocumentsOfHostAccountFragmentDoc}
${ActorFragmentDoc}
${OriginatorFragmentDoc}`;

/**
 * __useDocumentDetailPageQuery__
 *
 * To run a query within a React component, call `useDocumentDetailPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentDetailPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentDetailPageQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useDocumentDetailPageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DocumentDetailPageQuery, DocumentDetailPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DocumentDetailPageQuery, DocumentDetailPageQueryVariables>(DocumentDetailPageDocument, options);
      }
export function useDocumentDetailPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DocumentDetailPageQuery, DocumentDetailPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DocumentDetailPageQuery, DocumentDetailPageQueryVariables>(DocumentDetailPageDocument, options);
        }
export function useDocumentDetailPageSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DocumentDetailPageQuery, DocumentDetailPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DocumentDetailPageQuery, DocumentDetailPageQueryVariables>(DocumentDetailPageDocument, options);
        }
export type DocumentDetailPageQueryHookResult = ReturnType<typeof useDocumentDetailPageQuery>;
export type DocumentDetailPageLazyQueryHookResult = ReturnType<typeof useDocumentDetailPageLazyQuery>;
export type DocumentDetailPageSuspenseQueryHookResult = ReturnType<typeof useDocumentDetailPageSuspenseQuery>;
export type DocumentDetailPageQueryResult = Apollo.QueryResult<DocumentDetailPageQuery, DocumentDetailPageQueryVariables>;
export const DocumentDetailPageMrfDocument = gql`
    query DocumentDetailPageMRF($userId: Int!, $lang: ModelReleaseFormLanguageEnum!, $requestContext: ModelReleaseFormRequestContextEnum!) {
  documents {
    modelReleaseForm(lang: $lang, requestContext: $requestContext, userId: $userId) {
      __typename
      ... on FormManagerPaperlessForm {
        __typename
        id
        class
        userId
        status
        formdata
        formUrl(redirUrl: "")
        metadata
        userDocument {
          ...Document
        }
        paperlessDocument {
          id
          name
          state
        }
        paperlessSubmission {
          name
        }
      }
    }
  }
}
    ${DocumentFragmentDoc}`;

/**
 * __useDocumentDetailPageMrfQuery__
 *
 * To run a query within a React component, call `useDocumentDetailPageMrfQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentDetailPageMrfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentDetailPageMrfQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      lang: // value for 'lang'
 *      requestContext: // value for 'requestContext'
 *   },
 * });
 */
export function useDocumentDetailPageMrfQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DocumentDetailPageMrfQuery, DocumentDetailPageMrfQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DocumentDetailPageMrfQuery, DocumentDetailPageMrfQueryVariables>(DocumentDetailPageMrfDocument, options);
      }
export function useDocumentDetailPageMrfLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DocumentDetailPageMrfQuery, DocumentDetailPageMrfQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DocumentDetailPageMrfQuery, DocumentDetailPageMrfQueryVariables>(DocumentDetailPageMrfDocument, options);
        }
export function useDocumentDetailPageMrfSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DocumentDetailPageMrfQuery, DocumentDetailPageMrfQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DocumentDetailPageMrfQuery, DocumentDetailPageMrfQueryVariables>(DocumentDetailPageMrfDocument, options);
        }
export type DocumentDetailPageMrfQueryHookResult = ReturnType<typeof useDocumentDetailPageMrfQuery>;
export type DocumentDetailPageMrfLazyQueryHookResult = ReturnType<typeof useDocumentDetailPageMrfLazyQuery>;
export type DocumentDetailPageMrfSuspenseQueryHookResult = ReturnType<typeof useDocumentDetailPageMrfSuspenseQuery>;
export type DocumentDetailPageMrfQueryResult = Apollo.QueryResult<DocumentDetailPageMrfQuery, DocumentDetailPageMrfQueryVariables>;
export const GetDocumentsPageSubRouterDocument = gql`
    query GetDocumentsPageSubRouter($userId: Int!) {
  account {
    userId
    originator {
      userId
    }
    actor(actorId: $userId) {
      isLeadActor
      userId
    }
    actors {
      userId
      isLeadActor
    }
  }
}
    `;

/**
 * __useGetDocumentsPageSubRouterQuery__
 *
 * To run a query within a React component, call `useGetDocumentsPageSubRouterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentsPageSubRouterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentsPageSubRouterQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetDocumentsPageSubRouterQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetDocumentsPageSubRouterQuery, GetDocumentsPageSubRouterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDocumentsPageSubRouterQuery, GetDocumentsPageSubRouterQueryVariables>(GetDocumentsPageSubRouterDocument, options);
      }
export function useGetDocumentsPageSubRouterLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDocumentsPageSubRouterQuery, GetDocumentsPageSubRouterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDocumentsPageSubRouterQuery, GetDocumentsPageSubRouterQueryVariables>(GetDocumentsPageSubRouterDocument, options);
        }
export function useGetDocumentsPageSubRouterSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetDocumentsPageSubRouterQuery, GetDocumentsPageSubRouterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetDocumentsPageSubRouterQuery, GetDocumentsPageSubRouterQueryVariables>(GetDocumentsPageSubRouterDocument, options);
        }
export type GetDocumentsPageSubRouterQueryHookResult = ReturnType<typeof useGetDocumentsPageSubRouterQuery>;
export type GetDocumentsPageSubRouterLazyQueryHookResult = ReturnType<typeof useGetDocumentsPageSubRouterLazyQuery>;
export type GetDocumentsPageSubRouterSuspenseQueryHookResult = ReturnType<typeof useGetDocumentsPageSubRouterSuspenseQuery>;
export type GetDocumentsPageSubRouterQueryResult = Apollo.QueryResult<GetDocumentsPageSubRouterQuery, GetDocumentsPageSubRouterQueryVariables>;
export const GetPayoutDocumentsAddressSectionDocument = gql`
    query GetPayoutDocumentsAddressSection {
  payment {
    billingAddress {
      ...BillingAddress
    }
  }
}
    ${BillingAddressFragmentDoc}`;

/**
 * __useGetPayoutDocumentsAddressSectionQuery__
 *
 * To run a query within a React component, call `useGetPayoutDocumentsAddressSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPayoutDocumentsAddressSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPayoutDocumentsAddressSectionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPayoutDocumentsAddressSectionQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPayoutDocumentsAddressSectionQuery, GetPayoutDocumentsAddressSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPayoutDocumentsAddressSectionQuery, GetPayoutDocumentsAddressSectionQueryVariables>(GetPayoutDocumentsAddressSectionDocument, options);
      }
export function useGetPayoutDocumentsAddressSectionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPayoutDocumentsAddressSectionQuery, GetPayoutDocumentsAddressSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPayoutDocumentsAddressSectionQuery, GetPayoutDocumentsAddressSectionQueryVariables>(GetPayoutDocumentsAddressSectionDocument, options);
        }
export function useGetPayoutDocumentsAddressSectionSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetPayoutDocumentsAddressSectionQuery, GetPayoutDocumentsAddressSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetPayoutDocumentsAddressSectionQuery, GetPayoutDocumentsAddressSectionQueryVariables>(GetPayoutDocumentsAddressSectionDocument, options);
        }
export type GetPayoutDocumentsAddressSectionQueryHookResult = ReturnType<typeof useGetPayoutDocumentsAddressSectionQuery>;
export type GetPayoutDocumentsAddressSectionLazyQueryHookResult = ReturnType<typeof useGetPayoutDocumentsAddressSectionLazyQuery>;
export type GetPayoutDocumentsAddressSectionSuspenseQueryHookResult = ReturnType<typeof useGetPayoutDocumentsAddressSectionSuspenseQuery>;
export type GetPayoutDocumentsAddressSectionQueryResult = Apollo.QueryResult<GetPayoutDocumentsAddressSectionQuery, GetPayoutDocumentsAddressSectionQueryVariables>;
export const UpdatePayoutDocumentsAddressSectionDocument = gql`
    mutation UpdatePayoutDocumentsAddressSection($data: InputPaymentBillingAddress!) {
  payment {
    billingAddress {
      updateBillingAddress(data: $data) {
        ...ProfileFieldValidationSet
      }
    }
  }
}
    ${ProfileFieldValidationSetFragmentDoc}`;
export type UpdatePayoutDocumentsAddressSectionMutationFn = Apollo.MutationFunction<UpdatePayoutDocumentsAddressSectionMutation, UpdatePayoutDocumentsAddressSectionMutationVariables>;

/**
 * __useUpdatePayoutDocumentsAddressSectionMutation__
 *
 * To run a mutation, you first call `useUpdatePayoutDocumentsAddressSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePayoutDocumentsAddressSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePayoutDocumentsAddressSectionMutation, { data, loading, error }] = useUpdatePayoutDocumentsAddressSectionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdatePayoutDocumentsAddressSectionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdatePayoutDocumentsAddressSectionMutation, UpdatePayoutDocumentsAddressSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdatePayoutDocumentsAddressSectionMutation, UpdatePayoutDocumentsAddressSectionMutationVariables>(UpdatePayoutDocumentsAddressSectionDocument, options);
      }
export type UpdatePayoutDocumentsAddressSectionMutationHookResult = ReturnType<typeof useUpdatePayoutDocumentsAddressSectionMutation>;
export type UpdatePayoutDocumentsAddressSectionMutationResult = Apollo.MutationResult<UpdatePayoutDocumentsAddressSectionMutation>;
export type UpdatePayoutDocumentsAddressSectionMutationOptions = Apollo.BaseMutationOptions<UpdatePayoutDocumentsAddressSectionMutation, UpdatePayoutDocumentsAddressSectionMutationVariables>;
export const GetPayoutDocumentsPayoutSectionDocument = gql`
    query GetPayoutDocumentsPayoutSection {
  payment {
    payoutData {
      ...PayoutData
    }
  }
}
    ${PayoutDataFragmentDoc}`;

/**
 * __useGetPayoutDocumentsPayoutSectionQuery__
 *
 * To run a query within a React component, call `useGetPayoutDocumentsPayoutSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPayoutDocumentsPayoutSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPayoutDocumentsPayoutSectionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPayoutDocumentsPayoutSectionQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPayoutDocumentsPayoutSectionQuery, GetPayoutDocumentsPayoutSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPayoutDocumentsPayoutSectionQuery, GetPayoutDocumentsPayoutSectionQueryVariables>(GetPayoutDocumentsPayoutSectionDocument, options);
      }
export function useGetPayoutDocumentsPayoutSectionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPayoutDocumentsPayoutSectionQuery, GetPayoutDocumentsPayoutSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPayoutDocumentsPayoutSectionQuery, GetPayoutDocumentsPayoutSectionQueryVariables>(GetPayoutDocumentsPayoutSectionDocument, options);
        }
export function useGetPayoutDocumentsPayoutSectionSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetPayoutDocumentsPayoutSectionQuery, GetPayoutDocumentsPayoutSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetPayoutDocumentsPayoutSectionQuery, GetPayoutDocumentsPayoutSectionQueryVariables>(GetPayoutDocumentsPayoutSectionDocument, options);
        }
export type GetPayoutDocumentsPayoutSectionQueryHookResult = ReturnType<typeof useGetPayoutDocumentsPayoutSectionQuery>;
export type GetPayoutDocumentsPayoutSectionLazyQueryHookResult = ReturnType<typeof useGetPayoutDocumentsPayoutSectionLazyQuery>;
export type GetPayoutDocumentsPayoutSectionSuspenseQueryHookResult = ReturnType<typeof useGetPayoutDocumentsPayoutSectionSuspenseQuery>;
export type GetPayoutDocumentsPayoutSectionQueryResult = Apollo.QueryResult<GetPayoutDocumentsPayoutSectionQuery, GetPayoutDocumentsPayoutSectionQueryVariables>;
export const UpdatePayoutDocumentsPayoutSectionDocument = gql`
    mutation UpdatePayoutDocumentsPayoutSection($data: InputPaymentPayoutData!) {
  payment {
    payoutData {
      updatePayoutData(data: $data) {
        ...ProfileFieldValidationSet
      }
    }
  }
}
    ${ProfileFieldValidationSetFragmentDoc}`;
export type UpdatePayoutDocumentsPayoutSectionMutationFn = Apollo.MutationFunction<UpdatePayoutDocumentsPayoutSectionMutation, UpdatePayoutDocumentsPayoutSectionMutationVariables>;

/**
 * __useUpdatePayoutDocumentsPayoutSectionMutation__
 *
 * To run a mutation, you first call `useUpdatePayoutDocumentsPayoutSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePayoutDocumentsPayoutSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePayoutDocumentsPayoutSectionMutation, { data, loading, error }] = useUpdatePayoutDocumentsPayoutSectionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdatePayoutDocumentsPayoutSectionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdatePayoutDocumentsPayoutSectionMutation, UpdatePayoutDocumentsPayoutSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdatePayoutDocumentsPayoutSectionMutation, UpdatePayoutDocumentsPayoutSectionMutationVariables>(UpdatePayoutDocumentsPayoutSectionDocument, options);
      }
export type UpdatePayoutDocumentsPayoutSectionMutationHookResult = ReturnType<typeof useUpdatePayoutDocumentsPayoutSectionMutation>;
export type UpdatePayoutDocumentsPayoutSectionMutationResult = Apollo.MutationResult<UpdatePayoutDocumentsPayoutSectionMutation>;
export type UpdatePayoutDocumentsPayoutSectionMutationOptions = Apollo.BaseMutationOptions<UpdatePayoutDocumentsPayoutSectionMutation, UpdatePayoutDocumentsPayoutSectionMutationVariables>;
export const GetPayoutDocumentsTaxSectionDocument = gql`
    query GetPayoutDocumentsTaxSection {
  payment {
    taxData {
      ...TaxData
    }
  }
}
    ${TaxDataFragmentDoc}`;

/**
 * __useGetPayoutDocumentsTaxSectionQuery__
 *
 * To run a query within a React component, call `useGetPayoutDocumentsTaxSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPayoutDocumentsTaxSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPayoutDocumentsTaxSectionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPayoutDocumentsTaxSectionQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPayoutDocumentsTaxSectionQuery, GetPayoutDocumentsTaxSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPayoutDocumentsTaxSectionQuery, GetPayoutDocumentsTaxSectionQueryVariables>(GetPayoutDocumentsTaxSectionDocument, options);
      }
export function useGetPayoutDocumentsTaxSectionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPayoutDocumentsTaxSectionQuery, GetPayoutDocumentsTaxSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPayoutDocumentsTaxSectionQuery, GetPayoutDocumentsTaxSectionQueryVariables>(GetPayoutDocumentsTaxSectionDocument, options);
        }
export function useGetPayoutDocumentsTaxSectionSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetPayoutDocumentsTaxSectionQuery, GetPayoutDocumentsTaxSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetPayoutDocumentsTaxSectionQuery, GetPayoutDocumentsTaxSectionQueryVariables>(GetPayoutDocumentsTaxSectionDocument, options);
        }
export type GetPayoutDocumentsTaxSectionQueryHookResult = ReturnType<typeof useGetPayoutDocumentsTaxSectionQuery>;
export type GetPayoutDocumentsTaxSectionLazyQueryHookResult = ReturnType<typeof useGetPayoutDocumentsTaxSectionLazyQuery>;
export type GetPayoutDocumentsTaxSectionSuspenseQueryHookResult = ReturnType<typeof useGetPayoutDocumentsTaxSectionSuspenseQuery>;
export type GetPayoutDocumentsTaxSectionQueryResult = Apollo.QueryResult<GetPayoutDocumentsTaxSectionQuery, GetPayoutDocumentsTaxSectionQueryVariables>;
export const UpdatePayoutDocumentsTaxSectionDocument = gql`
    mutation UpdatePayoutDocumentsTaxSection($data: InputPaymentTaxData!) {
  payment {
    taxData {
      updateTaxData(data: $data) {
        ...ProfileFieldValidationSet
      }
    }
  }
}
    ${ProfileFieldValidationSetFragmentDoc}`;
export type UpdatePayoutDocumentsTaxSectionMutationFn = Apollo.MutationFunction<UpdatePayoutDocumentsTaxSectionMutation, UpdatePayoutDocumentsTaxSectionMutationVariables>;

/**
 * __useUpdatePayoutDocumentsTaxSectionMutation__
 *
 * To run a mutation, you first call `useUpdatePayoutDocumentsTaxSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePayoutDocumentsTaxSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePayoutDocumentsTaxSectionMutation, { data, loading, error }] = useUpdatePayoutDocumentsTaxSectionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdatePayoutDocumentsTaxSectionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdatePayoutDocumentsTaxSectionMutation, UpdatePayoutDocumentsTaxSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdatePayoutDocumentsTaxSectionMutation, UpdatePayoutDocumentsTaxSectionMutationVariables>(UpdatePayoutDocumentsTaxSectionDocument, options);
      }
export type UpdatePayoutDocumentsTaxSectionMutationHookResult = ReturnType<typeof useUpdatePayoutDocumentsTaxSectionMutation>;
export type UpdatePayoutDocumentsTaxSectionMutationResult = Apollo.MutationResult<UpdatePayoutDocumentsTaxSectionMutation>;
export type UpdatePayoutDocumentsTaxSectionMutationOptions = Apollo.BaseMutationOptions<UpdatePayoutDocumentsTaxSectionMutation, UpdatePayoutDocumentsTaxSectionMutationVariables>;
export const FeedPageDocument = gql`
    query FeedPage {
  profile {
    mediaCollection: collection(name: MobileMediaV1) {
      ... on ProfileCollectionMobileMediaV1 {
        fields {
          modelPictureFSK16Avatar {
            ...ProfileFieldTypePicture
          }
          modelPictureTitleLandscape {
            ...ProfileFieldTypePicture
          }
        }
      }
    }
    aboutMeCollection: collection(name: MobileAboutMeV1) {
      ... on ProfileCollectionMobileAboutMeV1 {
        fields {
          modelUsername {
            value
          }
        }
      }
    }
  }
}
    ${ProfileFieldTypePictureFragmentDoc}`;

/**
 * __useFeedPageQuery__
 *
 * To run a query within a React component, call `useFeedPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeedPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeedPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useFeedPageQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FeedPageQuery, FeedPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FeedPageQuery, FeedPageQueryVariables>(FeedPageDocument, options);
      }
export function useFeedPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FeedPageQuery, FeedPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FeedPageQuery, FeedPageQueryVariables>(FeedPageDocument, options);
        }
export function useFeedPageSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FeedPageQuery, FeedPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FeedPageQuery, FeedPageQueryVariables>(FeedPageDocument, options);
        }
export type FeedPageQueryHookResult = ReturnType<typeof useFeedPageQuery>;
export type FeedPageLazyQueryHookResult = ReturnType<typeof useFeedPageLazyQuery>;
export type FeedPageSuspenseQueryHookResult = ReturnType<typeof useFeedPageSuspenseQuery>;
export type FeedPageQueryResult = Apollo.QueryResult<FeedPageQuery, FeedPageQueryVariables>;
export const GetFinancesForFinancePageDocument = gql`
    query GetFinancesForFinancePage {
  account {
    userName
    isAccountFromGermany
    isAccountFromEU
    signupDate
  }
  tour(type: PayoutV1) {
    ... on TourPayoutV1 {
      status
      active
    }
  }
  finances {
    payoutStatus {
      isFirstPayout
      payoutDate
      status
      minimalPayableAmount
      payableAmount
    }
  }
}
    `;

/**
 * __useGetFinancesForFinancePageQuery__
 *
 * To run a query within a React component, call `useGetFinancesForFinancePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFinancesForFinancePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFinancesForFinancePageQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFinancesForFinancePageQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetFinancesForFinancePageQuery, GetFinancesForFinancePageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetFinancesForFinancePageQuery, GetFinancesForFinancePageQueryVariables>(GetFinancesForFinancePageDocument, options);
      }
export function useGetFinancesForFinancePageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFinancesForFinancePageQuery, GetFinancesForFinancePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetFinancesForFinancePageQuery, GetFinancesForFinancePageQueryVariables>(GetFinancesForFinancePageDocument, options);
        }
export function useGetFinancesForFinancePageSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetFinancesForFinancePageQuery, GetFinancesForFinancePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetFinancesForFinancePageQuery, GetFinancesForFinancePageQueryVariables>(GetFinancesForFinancePageDocument, options);
        }
export type GetFinancesForFinancePageQueryHookResult = ReturnType<typeof useGetFinancesForFinancePageQuery>;
export type GetFinancesForFinancePageLazyQueryHookResult = ReturnType<typeof useGetFinancesForFinancePageLazyQuery>;
export type GetFinancesForFinancePageSuspenseQueryHookResult = ReturnType<typeof useGetFinancesForFinancePageSuspenseQuery>;
export type GetFinancesForFinancePageQueryResult = Apollo.QueryResult<GetFinancesForFinancePageQuery, GetFinancesForFinancePageQueryVariables>;
export const GetPayoutTourStatusDocument = gql`
    query GetPayoutTourStatus {
  tour(type: PayoutV1) {
    ... on TourPayoutV1 {
      status
    }
  }
}
    `;

/**
 * __useGetPayoutTourStatusQuery__
 *
 * To run a query within a React component, call `useGetPayoutTourStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPayoutTourStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPayoutTourStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPayoutTourStatusQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPayoutTourStatusQuery, GetPayoutTourStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPayoutTourStatusQuery, GetPayoutTourStatusQueryVariables>(GetPayoutTourStatusDocument, options);
      }
export function useGetPayoutTourStatusLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPayoutTourStatusQuery, GetPayoutTourStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPayoutTourStatusQuery, GetPayoutTourStatusQueryVariables>(GetPayoutTourStatusDocument, options);
        }
export function useGetPayoutTourStatusSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetPayoutTourStatusQuery, GetPayoutTourStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetPayoutTourStatusQuery, GetPayoutTourStatusQueryVariables>(GetPayoutTourStatusDocument, options);
        }
export type GetPayoutTourStatusQueryHookResult = ReturnType<typeof useGetPayoutTourStatusQuery>;
export type GetPayoutTourStatusLazyQueryHookResult = ReturnType<typeof useGetPayoutTourStatusLazyQuery>;
export type GetPayoutTourStatusSuspenseQueryHookResult = ReturnType<typeof useGetPayoutTourStatusSuspenseQuery>;
export type GetPayoutTourStatusQueryResult = Apollo.QueryResult<GetPayoutTourStatusQuery, GetPayoutTourStatusQueryVariables>;
export const RequestManualPayoutDocument = gql`
    mutation RequestManualPayout {
  finances {
    payoutStatus: requestPayout {
      status
    }
  }
}
    `;
export type RequestManualPayoutMutationFn = Apollo.MutationFunction<RequestManualPayoutMutation, RequestManualPayoutMutationVariables>;

/**
 * __useRequestManualPayoutMutation__
 *
 * To run a mutation, you first call `useRequestManualPayoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestManualPayoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestManualPayoutMutation, { data, loading, error }] = useRequestManualPayoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useRequestManualPayoutMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RequestManualPayoutMutation, RequestManualPayoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RequestManualPayoutMutation, RequestManualPayoutMutationVariables>(RequestManualPayoutDocument, options);
      }
export type RequestManualPayoutMutationHookResult = ReturnType<typeof useRequestManualPayoutMutation>;
export type RequestManualPayoutMutationResult = Apollo.MutationResult<RequestManualPayoutMutation>;
export type RequestManualPayoutMutationOptions = Apollo.BaseMutationOptions<RequestManualPayoutMutation, RequestManualPayoutMutationVariables>;
export const CancelManualPayoutDocument = gql`
    mutation CancelManualPayout {
  finances {
    payoutStatus: cancelPayout {
      status
    }
  }
}
    `;
export type CancelManualPayoutMutationFn = Apollo.MutationFunction<CancelManualPayoutMutation, CancelManualPayoutMutationVariables>;

/**
 * __useCancelManualPayoutMutation__
 *
 * To run a mutation, you first call `useCancelManualPayoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelManualPayoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelManualPayoutMutation, { data, loading, error }] = useCancelManualPayoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useCancelManualPayoutMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CancelManualPayoutMutation, CancelManualPayoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CancelManualPayoutMutation, CancelManualPayoutMutationVariables>(CancelManualPayoutDocument, options);
      }
export type CancelManualPayoutMutationHookResult = ReturnType<typeof useCancelManualPayoutMutation>;
export type CancelManualPayoutMutationResult = Apollo.MutationResult<CancelManualPayoutMutation>;
export type CancelManualPayoutMutationOptions = Apollo.BaseMutationOptions<CancelManualPayoutMutation, CancelManualPayoutMutationVariables>;
export const GetPayoutTimeTableDocument = gql`
    query GetPayoutTimeTable {
  finances {
    payoutTimeTable {
      billingFromDate
      billingEndDate
      payoutDate
    }
  }
}
    `;

/**
 * __useGetPayoutTimeTableQuery__
 *
 * To run a query within a React component, call `useGetPayoutTimeTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPayoutTimeTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPayoutTimeTableQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPayoutTimeTableQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPayoutTimeTableQuery, GetPayoutTimeTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPayoutTimeTableQuery, GetPayoutTimeTableQueryVariables>(GetPayoutTimeTableDocument, options);
      }
export function useGetPayoutTimeTableLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPayoutTimeTableQuery, GetPayoutTimeTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPayoutTimeTableQuery, GetPayoutTimeTableQueryVariables>(GetPayoutTimeTableDocument, options);
        }
export function useGetPayoutTimeTableSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetPayoutTimeTableQuery, GetPayoutTimeTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetPayoutTimeTableQuery, GetPayoutTimeTableQueryVariables>(GetPayoutTimeTableDocument, options);
        }
export type GetPayoutTimeTableQueryHookResult = ReturnType<typeof useGetPayoutTimeTableQuery>;
export type GetPayoutTimeTableLazyQueryHookResult = ReturnType<typeof useGetPayoutTimeTableLazyQuery>;
export type GetPayoutTimeTableSuspenseQueryHookResult = ReturnType<typeof useGetPayoutTimeTableSuspenseQuery>;
export type GetPayoutTimeTableQueryResult = Apollo.QueryResult<GetPayoutTimeTableQuery, GetPayoutTimeTableQueryVariables>;
export const GetPayoutAssistantSectionDocument = gql`
    query GetPayoutAssistantSection {
  finances {
    payoutAssistant {
      isAssistantAllowed
      currentRhythm {
        id
        label
        nextPossiblePayoutDate
      }
      currentMinAmount
      allowedRhythms {
        id
        label
        nextPossiblePayoutDate
      }
      allowedAmounts
    }
    payoutStatus {
      status
    }
  }
}
    `;

/**
 * __useGetPayoutAssistantSectionQuery__
 *
 * To run a query within a React component, call `useGetPayoutAssistantSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPayoutAssistantSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPayoutAssistantSectionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPayoutAssistantSectionQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPayoutAssistantSectionQuery, GetPayoutAssistantSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPayoutAssistantSectionQuery, GetPayoutAssistantSectionQueryVariables>(GetPayoutAssistantSectionDocument, options);
      }
export function useGetPayoutAssistantSectionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPayoutAssistantSectionQuery, GetPayoutAssistantSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPayoutAssistantSectionQuery, GetPayoutAssistantSectionQueryVariables>(GetPayoutAssistantSectionDocument, options);
        }
export function useGetPayoutAssistantSectionSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetPayoutAssistantSectionQuery, GetPayoutAssistantSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetPayoutAssistantSectionQuery, GetPayoutAssistantSectionQueryVariables>(GetPayoutAssistantSectionDocument, options);
        }
export type GetPayoutAssistantSectionQueryHookResult = ReturnType<typeof useGetPayoutAssistantSectionQuery>;
export type GetPayoutAssistantSectionLazyQueryHookResult = ReturnType<typeof useGetPayoutAssistantSectionLazyQuery>;
export type GetPayoutAssistantSectionSuspenseQueryHookResult = ReturnType<typeof useGetPayoutAssistantSectionSuspenseQuery>;
export type GetPayoutAssistantSectionQueryResult = Apollo.QueryResult<GetPayoutAssistantSectionQuery, GetPayoutAssistantSectionQueryVariables>;
export const SetPayoutAssistantSettingsDocument = gql`
    mutation setPayoutAssistantSettings($targetRhythm: FinancesPayoutAssistantRhythmEnum!, $targetAmount: Float!) {
  finances {
    savePayoutAssistant(rhythm: $targetRhythm, amount: $targetAmount) {
      success
      message
    }
  }
}
    `;
export type SetPayoutAssistantSettingsMutationFn = Apollo.MutationFunction<SetPayoutAssistantSettingsMutation, SetPayoutAssistantSettingsMutationVariables>;

/**
 * __useSetPayoutAssistantSettingsMutation__
 *
 * To run a mutation, you first call `useSetPayoutAssistantSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPayoutAssistantSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPayoutAssistantSettingsMutation, { data, loading, error }] = useSetPayoutAssistantSettingsMutation({
 *   variables: {
 *      targetRhythm: // value for 'targetRhythm'
 *      targetAmount: // value for 'targetAmount'
 *   },
 * });
 */
export function useSetPayoutAssistantSettingsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetPayoutAssistantSettingsMutation, SetPayoutAssistantSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetPayoutAssistantSettingsMutation, SetPayoutAssistantSettingsMutationVariables>(SetPayoutAssistantSettingsDocument, options);
      }
export type SetPayoutAssistantSettingsMutationHookResult = ReturnType<typeof useSetPayoutAssistantSettingsMutation>;
export type SetPayoutAssistantSettingsMutationResult = Apollo.MutationResult<SetPayoutAssistantSettingsMutation>;
export type SetPayoutAssistantSettingsMutationOptions = Apollo.BaseMutationOptions<SetPayoutAssistantSettingsMutation, SetPayoutAssistantSettingsMutationVariables>;
export const GetPayoutBillingsSectionDocument = gql`
    query GetPayoutBillingsSection {
  account {
    signupDate
  }
}
    `;

/**
 * __useGetPayoutBillingsSectionQuery__
 *
 * To run a query within a React component, call `useGetPayoutBillingsSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPayoutBillingsSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPayoutBillingsSectionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPayoutBillingsSectionQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPayoutBillingsSectionQuery, GetPayoutBillingsSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPayoutBillingsSectionQuery, GetPayoutBillingsSectionQueryVariables>(GetPayoutBillingsSectionDocument, options);
      }
export function useGetPayoutBillingsSectionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPayoutBillingsSectionQuery, GetPayoutBillingsSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPayoutBillingsSectionQuery, GetPayoutBillingsSectionQueryVariables>(GetPayoutBillingsSectionDocument, options);
        }
export function useGetPayoutBillingsSectionSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetPayoutBillingsSectionQuery, GetPayoutBillingsSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetPayoutBillingsSectionQuery, GetPayoutBillingsSectionQueryVariables>(GetPayoutBillingsSectionDocument, options);
        }
export type GetPayoutBillingsSectionQueryHookResult = ReturnType<typeof useGetPayoutBillingsSectionQuery>;
export type GetPayoutBillingsSectionLazyQueryHookResult = ReturnType<typeof useGetPayoutBillingsSectionLazyQuery>;
export type GetPayoutBillingsSectionSuspenseQueryHookResult = ReturnType<typeof useGetPayoutBillingsSectionSuspenseQuery>;
export type GetPayoutBillingsSectionQueryResult = Apollo.QueryResult<GetPayoutBillingsSectionQuery, GetPayoutBillingsSectionQueryVariables>;
export const GetBillingsListDocument = gql`
    query GetBillingsList($year: Int!) {
  finances {
    billings(year: $year) {
      ...FinancesBilling
    }
  }
}
    ${FinancesBillingFragmentDoc}`;

/**
 * __useGetBillingsListQuery__
 *
 * To run a query within a React component, call `useGetBillingsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBillingsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBillingsListQuery({
 *   variables: {
 *      year: // value for 'year'
 *   },
 * });
 */
export function useGetBillingsListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetBillingsListQuery, GetBillingsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetBillingsListQuery, GetBillingsListQueryVariables>(GetBillingsListDocument, options);
      }
export function useGetBillingsListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBillingsListQuery, GetBillingsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetBillingsListQuery, GetBillingsListQueryVariables>(GetBillingsListDocument, options);
        }
export function useGetBillingsListSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetBillingsListQuery, GetBillingsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetBillingsListQuery, GetBillingsListQueryVariables>(GetBillingsListDocument, options);
        }
export type GetBillingsListQueryHookResult = ReturnType<typeof useGetBillingsListQuery>;
export type GetBillingsListLazyQueryHookResult = ReturnType<typeof useGetBillingsListLazyQuery>;
export type GetBillingsListSuspenseQueryHookResult = ReturnType<typeof useGetBillingsListSuspenseQuery>;
export type GetBillingsListQueryResult = Apollo.QueryResult<GetBillingsListQuery, GetBillingsListQueryVariables>;
export const GetPayoutWithdrawalsSectionDocument = gql`
    query GetPayoutWithdrawalsSection {
  account {
    signupDate
  }
  finances {
    invoices {
      maxDate
      minDate
    }
  }
}
    `;

/**
 * __useGetPayoutWithdrawalsSectionQuery__
 *
 * To run a query within a React component, call `useGetPayoutWithdrawalsSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPayoutWithdrawalsSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPayoutWithdrawalsSectionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPayoutWithdrawalsSectionQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPayoutWithdrawalsSectionQuery, GetPayoutWithdrawalsSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPayoutWithdrawalsSectionQuery, GetPayoutWithdrawalsSectionQueryVariables>(GetPayoutWithdrawalsSectionDocument, options);
      }
export function useGetPayoutWithdrawalsSectionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPayoutWithdrawalsSectionQuery, GetPayoutWithdrawalsSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPayoutWithdrawalsSectionQuery, GetPayoutWithdrawalsSectionQueryVariables>(GetPayoutWithdrawalsSectionDocument, options);
        }
export function useGetPayoutWithdrawalsSectionSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetPayoutWithdrawalsSectionQuery, GetPayoutWithdrawalsSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetPayoutWithdrawalsSectionQuery, GetPayoutWithdrawalsSectionQueryVariables>(GetPayoutWithdrawalsSectionDocument, options);
        }
export type GetPayoutWithdrawalsSectionQueryHookResult = ReturnType<typeof useGetPayoutWithdrawalsSectionQuery>;
export type GetPayoutWithdrawalsSectionLazyQueryHookResult = ReturnType<typeof useGetPayoutWithdrawalsSectionLazyQuery>;
export type GetPayoutWithdrawalsSectionSuspenseQueryHookResult = ReturnType<typeof useGetPayoutWithdrawalsSectionSuspenseQuery>;
export type GetPayoutWithdrawalsSectionQueryResult = Apollo.QueryResult<GetPayoutWithdrawalsSectionQuery, GetPayoutWithdrawalsSectionQueryVariables>;
export const GetInvoicesListDocument = gql`
    query GetInvoicesList($year: Int!) {
  finances {
    invoices(year: $year) {
      ...FinancesInvoices
    }
  }
}
    ${FinancesInvoicesFragmentDoc}`;

/**
 * __useGetInvoicesListQuery__
 *
 * To run a query within a React component, call `useGetInvoicesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoicesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoicesListQuery({
 *   variables: {
 *      year: // value for 'year'
 *   },
 * });
 */
export function useGetInvoicesListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetInvoicesListQuery, GetInvoicesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetInvoicesListQuery, GetInvoicesListQueryVariables>(GetInvoicesListDocument, options);
      }
export function useGetInvoicesListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetInvoicesListQuery, GetInvoicesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetInvoicesListQuery, GetInvoicesListQueryVariables>(GetInvoicesListDocument, options);
        }
export function useGetInvoicesListSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetInvoicesListQuery, GetInvoicesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetInvoicesListQuery, GetInvoicesListQueryVariables>(GetInvoicesListDocument, options);
        }
export type GetInvoicesListQueryHookResult = ReturnType<typeof useGetInvoicesListQuery>;
export type GetInvoicesListLazyQueryHookResult = ReturnType<typeof useGetInvoicesListLazyQuery>;
export type GetInvoicesListSuspenseQueryHookResult = ReturnType<typeof useGetInvoicesListSuspenseQuery>;
export type GetInvoicesListQueryResult = Apollo.QueryResult<GetInvoicesListQuery, GetInvoicesListQueryVariables>;
export const GetUnauthorizedHelpCenterPageDataDocument = gql`
    query GetUnauthorizedHelpCenterPageData {
  support {
    available
    mailto
    tel
  }
}
    `;

/**
 * __useGetUnauthorizedHelpCenterPageDataQuery__
 *
 * To run a query within a React component, call `useGetUnauthorizedHelpCenterPageDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnauthorizedHelpCenterPageDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnauthorizedHelpCenterPageDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUnauthorizedHelpCenterPageDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetUnauthorizedHelpCenterPageDataQuery, GetUnauthorizedHelpCenterPageDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUnauthorizedHelpCenterPageDataQuery, GetUnauthorizedHelpCenterPageDataQueryVariables>(GetUnauthorizedHelpCenterPageDataDocument, options);
      }
export function useGetUnauthorizedHelpCenterPageDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUnauthorizedHelpCenterPageDataQuery, GetUnauthorizedHelpCenterPageDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUnauthorizedHelpCenterPageDataQuery, GetUnauthorizedHelpCenterPageDataQueryVariables>(GetUnauthorizedHelpCenterPageDataDocument, options);
        }
export function useGetUnauthorizedHelpCenterPageDataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetUnauthorizedHelpCenterPageDataQuery, GetUnauthorizedHelpCenterPageDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetUnauthorizedHelpCenterPageDataQuery, GetUnauthorizedHelpCenterPageDataQueryVariables>(GetUnauthorizedHelpCenterPageDataDocument, options);
        }
export type GetUnauthorizedHelpCenterPageDataQueryHookResult = ReturnType<typeof useGetUnauthorizedHelpCenterPageDataQuery>;
export type GetUnauthorizedHelpCenterPageDataLazyQueryHookResult = ReturnType<typeof useGetUnauthorizedHelpCenterPageDataLazyQuery>;
export type GetUnauthorizedHelpCenterPageDataSuspenseQueryHookResult = ReturnType<typeof useGetUnauthorizedHelpCenterPageDataSuspenseQuery>;
export type GetUnauthorizedHelpCenterPageDataQueryResult = Apollo.QueryResult<GetUnauthorizedHelpCenterPageDataQuery, GetUnauthorizedHelpCenterPageDataQueryVariables>;
export const GetHelpCenterPageDataDocument = gql`
    query GetHelpCenterPageData {
  app {
    hotlineCode
  }
  helpcenter {
    url
  }
  support {
    available
    mailto
    tel
  }
  account {
    keyAccounter {
      name
      email
      phoneNumber
    }
  }
  profile {
    mediaCollection: collection(name: MobileMediaV1) {
      ... on ProfileCollectionMobileMediaV1 {
        values {
          modelPictureFSK16Avatar {
            image {
              src
            }
          }
        }
      }
    }
    collection(name: AccountV1) {
      ... on ProfileCollectionAccountV1 {
        values {
          accountContactEmailAdress
        }
      }
    }
  }
}
    `;

/**
 * __useGetHelpCenterPageDataQuery__
 *
 * To run a query within a React component, call `useGetHelpCenterPageDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHelpCenterPageDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHelpCenterPageDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetHelpCenterPageDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetHelpCenterPageDataQuery, GetHelpCenterPageDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetHelpCenterPageDataQuery, GetHelpCenterPageDataQueryVariables>(GetHelpCenterPageDataDocument, options);
      }
export function useGetHelpCenterPageDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetHelpCenterPageDataQuery, GetHelpCenterPageDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetHelpCenterPageDataQuery, GetHelpCenterPageDataQueryVariables>(GetHelpCenterPageDataDocument, options);
        }
export function useGetHelpCenterPageDataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetHelpCenterPageDataQuery, GetHelpCenterPageDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetHelpCenterPageDataQuery, GetHelpCenterPageDataQueryVariables>(GetHelpCenterPageDataDocument, options);
        }
export type GetHelpCenterPageDataQueryHookResult = ReturnType<typeof useGetHelpCenterPageDataQuery>;
export type GetHelpCenterPageDataLazyQueryHookResult = ReturnType<typeof useGetHelpCenterPageDataLazyQuery>;
export type GetHelpCenterPageDataSuspenseQueryHookResult = ReturnType<typeof useGetHelpCenterPageDataSuspenseQuery>;
export type GetHelpCenterPageDataQueryResult = Apollo.QueryResult<GetHelpCenterPageDataQuery, GetHelpCenterPageDataQueryVariables>;
export const GetHomeDataDocument = gql`
    query GetHomeData($actorId: Int!) {
  account {
    contact {
      currentEmailAddress
      isCurrentEmailAddressVerified
    }
    wasOnlineOnVXLive
    isModelVerified
    actor(actorId: $actorId) {
      ...Actor
    }
    actors {
      ...Actor
    }
    originator {
      ...Originator
    }
  }
  helpcenter {
    ...HelpCenterHome
  }
  finances {
    payoutStatus {
      isFirstPayout
      payableAmount
      status
    }
  }
  profile {
    collection(name: MobileAboutMeV1) {
      ... on ProfileCollectionMobileAboutMeV1 {
        fields {
          modelGender {
            value
          }
        }
      }
    }
  }
}
    ${ActorFragmentDoc}
${OriginatorFragmentDoc}
${HelpCenterHomeFragmentDoc}`;

/**
 * __useGetHomeDataQuery__
 *
 * To run a query within a React component, call `useGetHomeDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHomeDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHomeDataQuery({
 *   variables: {
 *      actorId: // value for 'actorId'
 *   },
 * });
 */
export function useGetHomeDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetHomeDataQuery, GetHomeDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetHomeDataQuery, GetHomeDataQueryVariables>(GetHomeDataDocument, options);
      }
export function useGetHomeDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetHomeDataQuery, GetHomeDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetHomeDataQuery, GetHomeDataQueryVariables>(GetHomeDataDocument, options);
        }
export function useGetHomeDataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetHomeDataQuery, GetHomeDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetHomeDataQuery, GetHomeDataQueryVariables>(GetHomeDataDocument, options);
        }
export type GetHomeDataQueryHookResult = ReturnType<typeof useGetHomeDataQuery>;
export type GetHomeDataLazyQueryHookResult = ReturnType<typeof useGetHomeDataLazyQuery>;
export type GetHomeDataSuspenseQueryHookResult = ReturnType<typeof useGetHomeDataSuspenseQuery>;
export type GetHomeDataQueryResult = Apollo.QueryResult<GetHomeDataQuery, GetHomeDataQueryVariables>;
export const GetVerifyEmailModalDataDocument = gql`
    query GetVerifyEmailModalData {
  account {
    isRegistrationComplete
    contact {
      currentEmailAddress
      isCurrentEmailAddressVerified
    }
  }
}
    `;

/**
 * __useGetVerifyEmailModalDataQuery__
 *
 * To run a query within a React component, call `useGetVerifyEmailModalDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVerifyEmailModalDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVerifyEmailModalDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetVerifyEmailModalDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetVerifyEmailModalDataQuery, GetVerifyEmailModalDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetVerifyEmailModalDataQuery, GetVerifyEmailModalDataQueryVariables>(GetVerifyEmailModalDataDocument, options);
      }
export function useGetVerifyEmailModalDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetVerifyEmailModalDataQuery, GetVerifyEmailModalDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetVerifyEmailModalDataQuery, GetVerifyEmailModalDataQueryVariables>(GetVerifyEmailModalDataDocument, options);
        }
export function useGetVerifyEmailModalDataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetVerifyEmailModalDataQuery, GetVerifyEmailModalDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetVerifyEmailModalDataQuery, GetVerifyEmailModalDataQueryVariables>(GetVerifyEmailModalDataDocument, options);
        }
export type GetVerifyEmailModalDataQueryHookResult = ReturnType<typeof useGetVerifyEmailModalDataQuery>;
export type GetVerifyEmailModalDataLazyQueryHookResult = ReturnType<typeof useGetVerifyEmailModalDataLazyQuery>;
export type GetVerifyEmailModalDataSuspenseQueryHookResult = ReturnType<typeof useGetVerifyEmailModalDataSuspenseQuery>;
export type GetVerifyEmailModalDataQueryResult = Apollo.QueryResult<GetVerifyEmailModalDataQuery, GetVerifyEmailModalDataQueryVariables>;
export const EmailVerificationModalResendEmailDocument = gql`
    mutation EmailVerificationModalResendEmail {
  account {
    resendRegistrationMail {
      success
      message
    }
  }
}
    `;
export type EmailVerificationModalResendEmailMutationFn = Apollo.MutationFunction<EmailVerificationModalResendEmailMutation, EmailVerificationModalResendEmailMutationVariables>;

/**
 * __useEmailVerificationModalResendEmailMutation__
 *
 * To run a mutation, you first call `useEmailVerificationModalResendEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmailVerificationModalResendEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [emailVerificationModalResendEmailMutation, { data, loading, error }] = useEmailVerificationModalResendEmailMutation({
 *   variables: {
 *   },
 * });
 */
export function useEmailVerificationModalResendEmailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EmailVerificationModalResendEmailMutation, EmailVerificationModalResendEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<EmailVerificationModalResendEmailMutation, EmailVerificationModalResendEmailMutationVariables>(EmailVerificationModalResendEmailDocument, options);
      }
export type EmailVerificationModalResendEmailMutationHookResult = ReturnType<typeof useEmailVerificationModalResendEmailMutation>;
export type EmailVerificationModalResendEmailMutationResult = Apollo.MutationResult<EmailVerificationModalResendEmailMutation>;
export type EmailVerificationModalResendEmailMutationOptions = Apollo.BaseMutationOptions<EmailVerificationModalResendEmailMutation, EmailVerificationModalResendEmailMutationVariables>;
export const GetIncomeSourceSectionDataDocument = gql`
    query GetIncomeSourceSectionData {
  helpcenter {
    incomeSources {
      entries(targets: [dashboard]) {
        ...IncomeSourceEntry
      }
    }
  }
}
    ${IncomeSourceEntryFragmentDoc}`;

/**
 * __useGetIncomeSourceSectionDataQuery__
 *
 * To run a query within a React component, call `useGetIncomeSourceSectionDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIncomeSourceSectionDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIncomeSourceSectionDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetIncomeSourceSectionDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetIncomeSourceSectionDataQuery, GetIncomeSourceSectionDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetIncomeSourceSectionDataQuery, GetIncomeSourceSectionDataQueryVariables>(GetIncomeSourceSectionDataDocument, options);
      }
export function useGetIncomeSourceSectionDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetIncomeSourceSectionDataQuery, GetIncomeSourceSectionDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetIncomeSourceSectionDataQuery, GetIncomeSourceSectionDataQueryVariables>(GetIncomeSourceSectionDataDocument, options);
        }
export function useGetIncomeSourceSectionDataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetIncomeSourceSectionDataQuery, GetIncomeSourceSectionDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetIncomeSourceSectionDataQuery, GetIncomeSourceSectionDataQueryVariables>(GetIncomeSourceSectionDataDocument, options);
        }
export type GetIncomeSourceSectionDataQueryHookResult = ReturnType<typeof useGetIncomeSourceSectionDataQuery>;
export type GetIncomeSourceSectionDataLazyQueryHookResult = ReturnType<typeof useGetIncomeSourceSectionDataLazyQuery>;
export type GetIncomeSourceSectionDataSuspenseQueryHookResult = ReturnType<typeof useGetIncomeSourceSectionDataSuspenseQuery>;
export type GetIncomeSourceSectionDataQueryResult = Apollo.QueryResult<GetIncomeSourceSectionDataQuery, GetIncomeSourceSectionDataQueryVariables>;
export const GetStatisticSectionDocument = gql`
    query GetStatisticSection($startDate: Date!, $endDate: Date!, $prevStartDate: Date!, $prevEndDate: Date!) {
  previous: finances {
    turnoverForPeriodTotal(startDate: $prevStartDate, endDate: $prevEndDate)
  }
  current: finances {
    turnoverForPeriodTotal(startDate: $startDate, endDate: $endDate)
    turnoverForPeriodGroupedByDay(startDate: $startDate, endDate: $endDate) {
      date
      value
    }
  }
}
    `;

/**
 * __useGetStatisticSectionQuery__
 *
 * To run a query within a React component, call `useGetStatisticSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStatisticSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStatisticSectionQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      prevStartDate: // value for 'prevStartDate'
 *      prevEndDate: // value for 'prevEndDate'
 *   },
 * });
 */
export function useGetStatisticSectionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetStatisticSectionQuery, GetStatisticSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetStatisticSectionQuery, GetStatisticSectionQueryVariables>(GetStatisticSectionDocument, options);
      }
export function useGetStatisticSectionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetStatisticSectionQuery, GetStatisticSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetStatisticSectionQuery, GetStatisticSectionQueryVariables>(GetStatisticSectionDocument, options);
        }
export function useGetStatisticSectionSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetStatisticSectionQuery, GetStatisticSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetStatisticSectionQuery, GetStatisticSectionQueryVariables>(GetStatisticSectionDocument, options);
        }
export type GetStatisticSectionQueryHookResult = ReturnType<typeof useGetStatisticSectionQuery>;
export type GetStatisticSectionLazyQueryHookResult = ReturnType<typeof useGetStatisticSectionLazyQuery>;
export type GetStatisticSectionSuspenseQueryHookResult = ReturnType<typeof useGetStatisticSectionSuspenseQuery>;
export type GetStatisticSectionQueryResult = Apollo.QueryResult<GetStatisticSectionQuery, GetStatisticSectionQueryVariables>;
export const GetTipSectionDataDocument = gql`
    query GetTipSectionData {
  helpcenter {
    tips {
      entries(targets: [dashboard]) {
        ...TipEntry
      }
    }
  }
}
    ${TipEntryFragmentDoc}`;

/**
 * __useGetTipSectionDataQuery__
 *
 * To run a query within a React component, call `useGetTipSectionDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTipSectionDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTipSectionDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTipSectionDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetTipSectionDataQuery, GetTipSectionDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetTipSectionDataQuery, GetTipSectionDataQueryVariables>(GetTipSectionDataDocument, options);
      }
export function useGetTipSectionDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTipSectionDataQuery, GetTipSectionDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetTipSectionDataQuery, GetTipSectionDataQueryVariables>(GetTipSectionDataDocument, options);
        }
export function useGetTipSectionDataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetTipSectionDataQuery, GetTipSectionDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetTipSectionDataQuery, GetTipSectionDataQueryVariables>(GetTipSectionDataDocument, options);
        }
export type GetTipSectionDataQueryHookResult = ReturnType<typeof useGetTipSectionDataQuery>;
export type GetTipSectionDataLazyQueryHookResult = ReturnType<typeof useGetTipSectionDataLazyQuery>;
export type GetTipSectionDataSuspenseQueryHookResult = ReturnType<typeof useGetTipSectionDataSuspenseQuery>;
export type GetTipSectionDataQueryResult = Apollo.QueryResult<GetTipSectionDataQuery, GetTipSectionDataQueryVariables>;
export const ModelProfilePageDocument = gql`
    query ModelProfilePage {
  account {
    userName
  }
  profile {
    mediaCollection: collection(name: MobileMediaV1) {
      ... on ProfileCollectionMobileMediaV1 {
        fields {
          modelPictureFSK16Avatar {
            ...ProfileFieldTypePicture
          }
          modelPictureTitleLandscape {
            ...ProfileFieldTypePicture
          }
        }
        values {
          modelPictureFSK16Avatar {
            ...MediaPicture
          }
          modelPictureTitleLandscape {
            ...MediaPicture
          }
        }
      }
    }
  }
}
    ${ProfileFieldTypePictureFragmentDoc}
${MediaPictureFragmentDoc}`;

/**
 * __useModelProfilePageQuery__
 *
 * To run a query within a React component, call `useModelProfilePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useModelProfilePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModelProfilePageQuery({
 *   variables: {
 *   },
 * });
 */
export function useModelProfilePageQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ModelProfilePageQuery, ModelProfilePageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ModelProfilePageQuery, ModelProfilePageQueryVariables>(ModelProfilePageDocument, options);
      }
export function useModelProfilePageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ModelProfilePageQuery, ModelProfilePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ModelProfilePageQuery, ModelProfilePageQueryVariables>(ModelProfilePageDocument, options);
        }
export function useModelProfilePageSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ModelProfilePageQuery, ModelProfilePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ModelProfilePageQuery, ModelProfilePageQueryVariables>(ModelProfilePageDocument, options);
        }
export type ModelProfilePageQueryHookResult = ReturnType<typeof useModelProfilePageQuery>;
export type ModelProfilePageLazyQueryHookResult = ReturnType<typeof useModelProfilePageLazyQuery>;
export type ModelProfilePageSuspenseQueryHookResult = ReturnType<typeof useModelProfilePageSuspenseQuery>;
export type ModelProfilePageQueryResult = Apollo.QueryResult<ModelProfilePageQuery, ModelProfilePageQueryVariables>;
export const ModelProfileParentDocument = gql`
    query ModelProfileParent {
  profile {
    collection(name: MobileProfileV1) {
      ...ModelProfileParentMobileProfile
    }
  }
  tour(type: OnboardingV1) {
    ...ModelProfileParentWizard
  }
}
    ${ModelProfileParentMobileProfileFragmentDoc}
${ModelProfileParentWizardFragmentDoc}`;

/**
 * __useModelProfileParentQuery__
 *
 * To run a query within a React component, call `useModelProfileParentQuery` and pass it any options that fit your needs.
 * When your component renders, `useModelProfileParentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModelProfileParentQuery({
 *   variables: {
 *   },
 * });
 */
export function useModelProfileParentQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ModelProfileParentQuery, ModelProfileParentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ModelProfileParentQuery, ModelProfileParentQueryVariables>(ModelProfileParentDocument, options);
      }
export function useModelProfileParentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ModelProfileParentQuery, ModelProfileParentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ModelProfileParentQuery, ModelProfileParentQueryVariables>(ModelProfileParentDocument, options);
        }
export function useModelProfileParentSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ModelProfileParentQuery, ModelProfileParentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ModelProfileParentQuery, ModelProfileParentQueryVariables>(ModelProfileParentDocument, options);
        }
export type ModelProfileParentQueryHookResult = ReturnType<typeof useModelProfileParentQuery>;
export type ModelProfileParentLazyQueryHookResult = ReturnType<typeof useModelProfileParentLazyQuery>;
export type ModelProfileParentSuspenseQueryHookResult = ReturnType<typeof useModelProfileParentSuspenseQuery>;
export type ModelProfileParentQueryResult = Apollo.QueryResult<ModelProfileParentQuery, ModelProfileParentQueryVariables>;
export const SaveProfileDataDocument = gql`
    mutation saveProfileData($aboutMeData: InputProfileCollectionMobileAboutMeV1!, $mediaData: InputProfileCollectionMobileMediaV1!, $appearanceData: InputProfileCollectionMobileAppearanceV1!, $interviewData: InputProfileCollectionMobileInterviewV1!) {
  profile {
    aboutMeCollection: collection(name: MobileAboutMeV1) {
      ... on ProfileCollectionMobileAboutMeV1Mutation {
        update(data: $aboutMeData) {
          ...ProfileFieldValidationSet
        }
      }
    }
    appearanceCollection: collection(name: MobileAppearanceV1) {
      ... on ProfileCollectionMobileAppearanceV1Mutation {
        update(data: $appearanceData) {
          ...ProfileFieldValidationSet
        }
      }
    }
    interviewCollection: collection(name: MobileInterviewV1) {
      ... on ProfileCollectionMobileInterviewV1Mutation {
        update(data: $interviewData) {
          ...ProfileFieldValidationSet
        }
      }
    }
    mediaCollection: collection(name: MobileMediaV1) {
      ... on ProfileCollectionMobileMediaV1Mutation {
        update(data: $mediaData) {
          ...ProfileFieldValidationSet
        }
      }
    }
  }
}
    ${ProfileFieldValidationSetFragmentDoc}`;
export type SaveProfileDataMutationFn = Apollo.MutationFunction<SaveProfileDataMutation, SaveProfileDataMutationVariables>;

/**
 * __useSaveProfileDataMutation__
 *
 * To run a mutation, you first call `useSaveProfileDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveProfileDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveProfileDataMutation, { data, loading, error }] = useSaveProfileDataMutation({
 *   variables: {
 *      aboutMeData: // value for 'aboutMeData'
 *      mediaData: // value for 'mediaData'
 *      appearanceData: // value for 'appearanceData'
 *      interviewData: // value for 'interviewData'
 *   },
 * });
 */
export function useSaveProfileDataMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveProfileDataMutation, SaveProfileDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveProfileDataMutation, SaveProfileDataMutationVariables>(SaveProfileDataDocument, options);
      }
export type SaveProfileDataMutationHookResult = ReturnType<typeof useSaveProfileDataMutation>;
export type SaveProfileDataMutationResult = Apollo.MutationResult<SaveProfileDataMutation>;
export type SaveProfileDataMutationOptions = Apollo.BaseMutationOptions<SaveProfileDataMutation, SaveProfileDataMutationVariables>;
export const GetUploadInfoForFieldDocument = gql`
    query GetUploadInfoForField($name: ProfileFieldsEnum!, $position: Int) {
  profile {
    field(name: $name) {
      ... on ProfileFieldTypePicture {
        upload {
          ...UploadInfo
        }
      }
      ... on ProfileFieldTypePictureList {
        upload(position: $position) {
          ...UploadInfo
        }
      }
      ... on ProfileFieldTypeUploadDocument {
        upload {
          ...UploadInfo
        }
      }
    }
  }
}
    ${UploadInfoFragmentDoc}`;

/**
 * __useGetUploadInfoForFieldQuery__
 *
 * To run a query within a React component, call `useGetUploadInfoForFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUploadInfoForFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUploadInfoForFieldQuery({
 *   variables: {
 *      name: // value for 'name'
 *      position: // value for 'position'
 *   },
 * });
 */
export function useGetUploadInfoForFieldQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetUploadInfoForFieldQuery, GetUploadInfoForFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUploadInfoForFieldQuery, GetUploadInfoForFieldQueryVariables>(GetUploadInfoForFieldDocument, options);
      }
export function useGetUploadInfoForFieldLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUploadInfoForFieldQuery, GetUploadInfoForFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUploadInfoForFieldQuery, GetUploadInfoForFieldQueryVariables>(GetUploadInfoForFieldDocument, options);
        }
export function useGetUploadInfoForFieldSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetUploadInfoForFieldQuery, GetUploadInfoForFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetUploadInfoForFieldQuery, GetUploadInfoForFieldQueryVariables>(GetUploadInfoForFieldDocument, options);
        }
export type GetUploadInfoForFieldQueryHookResult = ReturnType<typeof useGetUploadInfoForFieldQuery>;
export type GetUploadInfoForFieldLazyQueryHookResult = ReturnType<typeof useGetUploadInfoForFieldLazyQuery>;
export type GetUploadInfoForFieldSuspenseQueryHookResult = ReturnType<typeof useGetUploadInfoForFieldSuspenseQuery>;
export type GetUploadInfoForFieldQueryResult = Apollo.QueryResult<GetUploadInfoForFieldQuery, GetUploadInfoForFieldQueryVariables>;
export const ModelProfileProviderDocument = gql`
    query ModelProfileProvider {
  account {
    isModelVerified
  }
  profile {
    aboutMeCollection: collection(name: MobileAboutMeV1) {
      ... on ProfileCollectionMobileAboutMeV1 {
        ...ProfileCollectionMobileAboutMeV1
      }
    }
    appearanceCollection: collection(name: MobileAppearanceV1) {
      ... on ProfileCollectionMobileAppearanceV1 {
        ...ProfileCollectionMobileAppearanceV1
      }
    }
    interviewCollection: collection(name: MobileInterviewV1) {
      ... on ProfileCollectionMobileInterviewV1 {
        ...ProfileCollectionMobileInterviewV1
      }
    }
    mediaCollection: collection(name: MobileMediaV1) {
      ... on ProfileCollectionMobileMediaV1 {
        ...ProfileCollectionMobileMediaV1
      }
    }
  }
}
    ${ProfileCollectionMobileAboutMeV1FragmentDoc}
${ProfileCollectionMobileAppearanceV1FragmentDoc}
${ProfileCollectionMobileInterviewV1FragmentDoc}
${ProfileCollectionMobileMediaV1FragmentDoc}`;

/**
 * __useModelProfileProviderQuery__
 *
 * To run a query within a React component, call `useModelProfileProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useModelProfileProviderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModelProfileProviderQuery({
 *   variables: {
 *   },
 * });
 */
export function useModelProfileProviderQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ModelProfileProviderQuery, ModelProfileProviderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ModelProfileProviderQuery, ModelProfileProviderQueryVariables>(ModelProfileProviderDocument, options);
      }
export function useModelProfileProviderLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ModelProfileProviderQuery, ModelProfileProviderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ModelProfileProviderQuery, ModelProfileProviderQueryVariables>(ModelProfileProviderDocument, options);
        }
export function useModelProfileProviderSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ModelProfileProviderQuery, ModelProfileProviderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ModelProfileProviderQuery, ModelProfileProviderQueryVariables>(ModelProfileProviderDocument, options);
        }
export type ModelProfileProviderQueryHookResult = ReturnType<typeof useModelProfileProviderQuery>;
export type ModelProfileProviderLazyQueryHookResult = ReturnType<typeof useModelProfileProviderLazyQuery>;
export type ModelProfileProviderSuspenseQueryHookResult = ReturnType<typeof useModelProfileProviderSuspenseQuery>;
export type ModelProfileProviderQueryResult = Apollo.QueryResult<ModelProfileProviderQuery, ModelProfileProviderQueryVariables>;
export const PasswordResetDocument = gql`
    mutation passwordReset($email: String!, $modelname: String) {
  auth {
    resetPassword(email: $email, username: $modelname) {
      __typename
      ... on PasswordResetResultFail {
        message
      }
      ... on PasswordResetResultSuccessful {
        message
      }
    }
  }
}
    `;
export type PasswordResetMutationFn = Apollo.MutationFunction<PasswordResetMutation, PasswordResetMutationVariables>;

/**
 * __usePasswordResetMutation__
 *
 * To run a mutation, you first call `usePasswordResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePasswordResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [passwordResetMutation, { data, loading, error }] = usePasswordResetMutation({
 *   variables: {
 *      email: // value for 'email'
 *      modelname: // value for 'modelname'
 *   },
 * });
 */
export function usePasswordResetMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PasswordResetMutation, PasswordResetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PasswordResetMutation, PasswordResetMutationVariables>(PasswordResetDocument, options);
      }
export type PasswordResetMutationHookResult = ReturnType<typeof usePasswordResetMutation>;
export type PasswordResetMutationResult = Apollo.MutationResult<PasswordResetMutation>;
export type PasswordResetMutationOptions = Apollo.BaseMutationOptions<PasswordResetMutation, PasswordResetMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation ResetPassword($hash: String!, $password: String!) {
  auth {
    setPassword(hash: $hash, password: $password) {
      __typename
      ... on PasswordSetResultSuccessful {
        message
      }
      ... on PasswordSetResultFail {
        message
      }
    }
  }
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      hash: // value for 'hash'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const GetRedirectPageDataDocument = gql`
    query GetRedirectPageData($redirectUrl: String!) {
  app {
    autologinLinkVXModels(redirect: $redirectUrl)
  }
}
    `;

/**
 * __useGetRedirectPageDataQuery__
 *
 * To run a query within a React component, call `useGetRedirectPageDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRedirectPageDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRedirectPageDataQuery({
 *   variables: {
 *      redirectUrl: // value for 'redirectUrl'
 *   },
 * });
 */
export function useGetRedirectPageDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetRedirectPageDataQuery, GetRedirectPageDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetRedirectPageDataQuery, GetRedirectPageDataQueryVariables>(GetRedirectPageDataDocument, options);
      }
export function useGetRedirectPageDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRedirectPageDataQuery, GetRedirectPageDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetRedirectPageDataQuery, GetRedirectPageDataQueryVariables>(GetRedirectPageDataDocument, options);
        }
export function useGetRedirectPageDataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetRedirectPageDataQuery, GetRedirectPageDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetRedirectPageDataQuery, GetRedirectPageDataQueryVariables>(GetRedirectPageDataDocument, options);
        }
export type GetRedirectPageDataQueryHookResult = ReturnType<typeof useGetRedirectPageDataQuery>;
export type GetRedirectPageDataLazyQueryHookResult = ReturnType<typeof useGetRedirectPageDataLazyQuery>;
export type GetRedirectPageDataSuspenseQueryHookResult = ReturnType<typeof useGetRedirectPageDataSuspenseQuery>;
export type GetRedirectPageDataQueryResult = Apollo.QueryResult<GetRedirectPageDataQuery, GetRedirectPageDataQueryVariables>;
export const SignUpDocument = gql`
    mutation signUp($email: EmailAddress!, $password: String!, $userReferer: String, $studioHash: String) {
  auth {
    signup(
      signupData: {email: $email, password: $password, userReferer: $userReferer, studioHash: $studioHash}
    ) {
      __typename
      ... on AuthResultSuccessful {
        accessToken
        refreshToken
      }
      ... on SignupResultFail {
        topic
        message
        invalidFields {
          name
          errorMessages
        }
      }
    }
  }
}
    `;
export type SignUpMutationFn = Apollo.MutationFunction<SignUpMutation, SignUpMutationVariables>;

/**
 * __useSignUpMutation__
 *
 * To run a mutation, you first call `useSignUpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignUpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signUpMutation, { data, loading, error }] = useSignUpMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      userReferer: // value for 'userReferer'
 *      studioHash: // value for 'studioHash'
 *   },
 * });
 */
export function useSignUpMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SignUpMutation, SignUpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SignUpMutation, SignUpMutationVariables>(SignUpDocument, options);
      }
export type SignUpMutationHookResult = ReturnType<typeof useSignUpMutation>;
export type SignUpMutationResult = Apollo.MutationResult<SignUpMutation>;
export type SignUpMutationOptions = Apollo.BaseMutationOptions<SignUpMutation, SignUpMutationVariables>;
export const GetAllStatisticsDocument = gql`
    query GetAllStatistics {
  statistics {
    entries {
      id
      label
    }
    availableEntries {
      id
      label
    }
  }
}
    `;

/**
 * __useGetAllStatisticsQuery__
 *
 * To run a query within a React component, call `useGetAllStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllStatisticsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllStatisticsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAllStatisticsQuery, GetAllStatisticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAllStatisticsQuery, GetAllStatisticsQueryVariables>(GetAllStatisticsDocument, options);
      }
export function useGetAllStatisticsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAllStatisticsQuery, GetAllStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAllStatisticsQuery, GetAllStatisticsQueryVariables>(GetAllStatisticsDocument, options);
        }
export function useGetAllStatisticsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetAllStatisticsQuery, GetAllStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAllStatisticsQuery, GetAllStatisticsQueryVariables>(GetAllStatisticsDocument, options);
        }
export type GetAllStatisticsQueryHookResult = ReturnType<typeof useGetAllStatisticsQuery>;
export type GetAllStatisticsLazyQueryHookResult = ReturnType<typeof useGetAllStatisticsLazyQuery>;
export type GetAllStatisticsSuspenseQueryHookResult = ReturnType<typeof useGetAllStatisticsSuspenseQuery>;
export type GetAllStatisticsQueryResult = Apollo.QueryResult<GetAllStatisticsQuery, GetAllStatisticsQueryVariables>;
export const UpdateStatisticsListDocument = gql`
    mutation UpdateStatisticsList($statisticEntries: [StatisticsEntryNameEnum!]!) {
  statistics {
    setSelectedEntries(entryNames: $statisticEntries) {
      id
      label
    }
  }
}
    `;
export type UpdateStatisticsListMutationFn = Apollo.MutationFunction<UpdateStatisticsListMutation, UpdateStatisticsListMutationVariables>;

/**
 * __useUpdateStatisticsListMutation__
 *
 * To run a mutation, you first call `useUpdateStatisticsListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStatisticsListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStatisticsListMutation, { data, loading, error }] = useUpdateStatisticsListMutation({
 *   variables: {
 *      statisticEntries: // value for 'statisticEntries'
 *   },
 * });
 */
export function useUpdateStatisticsListMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateStatisticsListMutation, UpdateStatisticsListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateStatisticsListMutation, UpdateStatisticsListMutationVariables>(UpdateStatisticsListDocument, options);
      }
export type UpdateStatisticsListMutationHookResult = ReturnType<typeof useUpdateStatisticsListMutation>;
export type UpdateStatisticsListMutationResult = Apollo.MutationResult<UpdateStatisticsListMutation>;
export type UpdateStatisticsListMutationOptions = Apollo.BaseMutationOptions<UpdateStatisticsListMutation, UpdateStatisticsListMutationVariables>;
export const GetVxLiveChatPageDataDocument = gql`
    query GetVxLiveChatPageData {
  app {
    autologinLinkVXLive
  }
  account {
    userName
  }
}
    `;

/**
 * __useGetVxLiveChatPageDataQuery__
 *
 * To run a query within a React component, call `useGetVxLiveChatPageDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVxLiveChatPageDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVxLiveChatPageDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetVxLiveChatPageDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetVxLiveChatPageDataQuery, GetVxLiveChatPageDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetVxLiveChatPageDataQuery, GetVxLiveChatPageDataQueryVariables>(GetVxLiveChatPageDataDocument, options);
      }
export function useGetVxLiveChatPageDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetVxLiveChatPageDataQuery, GetVxLiveChatPageDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetVxLiveChatPageDataQuery, GetVxLiveChatPageDataQueryVariables>(GetVxLiveChatPageDataDocument, options);
        }
export function useGetVxLiveChatPageDataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetVxLiveChatPageDataQuery, GetVxLiveChatPageDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetVxLiveChatPageDataQuery, GetVxLiveChatPageDataQueryVariables>(GetVxLiveChatPageDataDocument, options);
        }
export type GetVxLiveChatPageDataQueryHookResult = ReturnType<typeof useGetVxLiveChatPageDataQuery>;
export type GetVxLiveChatPageDataLazyQueryHookResult = ReturnType<typeof useGetVxLiveChatPageDataLazyQuery>;
export type GetVxLiveChatPageDataSuspenseQueryHookResult = ReturnType<typeof useGetVxLiveChatPageDataSuspenseQuery>;
export type GetVxLiveChatPageDataQueryResult = Apollo.QueryResult<GetVxLiveChatPageDataQuery, GetVxLiveChatPageDataQueryVariables>;
export const GetVxLiveGoLivePageDataDocument = gql`
    query GetVXLiveGoLivePageData {
  helpcenter {
    tips {
      entries(targets: [goonline]) {
        ...TipEntry
      }
    }
  }
}
    ${TipEntryFragmentDoc}`;

/**
 * __useGetVxLiveGoLivePageDataQuery__
 *
 * To run a query within a React component, call `useGetVxLiveGoLivePageDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVxLiveGoLivePageDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVxLiveGoLivePageDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetVxLiveGoLivePageDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetVxLiveGoLivePageDataQuery, GetVxLiveGoLivePageDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetVxLiveGoLivePageDataQuery, GetVxLiveGoLivePageDataQueryVariables>(GetVxLiveGoLivePageDataDocument, options);
      }
export function useGetVxLiveGoLivePageDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetVxLiveGoLivePageDataQuery, GetVxLiveGoLivePageDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetVxLiveGoLivePageDataQuery, GetVxLiveGoLivePageDataQueryVariables>(GetVxLiveGoLivePageDataDocument, options);
        }
export function useGetVxLiveGoLivePageDataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetVxLiveGoLivePageDataQuery, GetVxLiveGoLivePageDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetVxLiveGoLivePageDataQuery, GetVxLiveGoLivePageDataQueryVariables>(GetVxLiveGoLivePageDataDocument, options);
        }
export type GetVxLiveGoLivePageDataQueryHookResult = ReturnType<typeof useGetVxLiveGoLivePageDataQuery>;
export type GetVxLiveGoLivePageDataLazyQueryHookResult = ReturnType<typeof useGetVxLiveGoLivePageDataLazyQuery>;
export type GetVxLiveGoLivePageDataSuspenseQueryHookResult = ReturnType<typeof useGetVxLiveGoLivePageDataSuspenseQuery>;
export type GetVxLiveGoLivePageDataQueryResult = Apollo.QueryResult<GetVxLiveGoLivePageDataQuery, GetVxLiveGoLivePageDataQueryVariables>;
export const GetVxLivePageDataDocument = gql`
    query GetVxLivePageData {
  account {
    userName
  }
}
    `;

/**
 * __useGetVxLivePageDataQuery__
 *
 * To run a query within a React component, call `useGetVxLivePageDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVxLivePageDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVxLivePageDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetVxLivePageDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetVxLivePageDataQuery, GetVxLivePageDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetVxLivePageDataQuery, GetVxLivePageDataQueryVariables>(GetVxLivePageDataDocument, options);
      }
export function useGetVxLivePageDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetVxLivePageDataQuery, GetVxLivePageDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetVxLivePageDataQuery, GetVxLivePageDataQueryVariables>(GetVxLivePageDataDocument, options);
        }
export function useGetVxLivePageDataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetVxLivePageDataQuery, GetVxLivePageDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetVxLivePageDataQuery, GetVxLivePageDataQueryVariables>(GetVxLivePageDataDocument, options);
        }
export type GetVxLivePageDataQueryHookResult = ReturnType<typeof useGetVxLivePageDataQuery>;
export type GetVxLivePageDataLazyQueryHookResult = ReturnType<typeof useGetVxLivePageDataLazyQuery>;
export type GetVxLivePageDataSuspenseQueryHookResult = ReturnType<typeof useGetVxLivePageDataSuspenseQuery>;
export type GetVxLivePageDataQueryResult = Apollo.QueryResult<GetVxLivePageDataQuery, GetVxLivePageDataQueryVariables>;
export const GetVxLiveAccountDataDocument = gql`
    query GetVxLiveAccountData {
  account {
    userName
  }
}
    `;

/**
 * __useGetVxLiveAccountDataQuery__
 *
 * To run a query within a React component, call `useGetVxLiveAccountDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVxLiveAccountDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVxLiveAccountDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetVxLiveAccountDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetVxLiveAccountDataQuery, GetVxLiveAccountDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetVxLiveAccountDataQuery, GetVxLiveAccountDataQueryVariables>(GetVxLiveAccountDataDocument, options);
      }
export function useGetVxLiveAccountDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetVxLiveAccountDataQuery, GetVxLiveAccountDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetVxLiveAccountDataQuery, GetVxLiveAccountDataQueryVariables>(GetVxLiveAccountDataDocument, options);
        }
export function useGetVxLiveAccountDataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetVxLiveAccountDataQuery, GetVxLiveAccountDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetVxLiveAccountDataQuery, GetVxLiveAccountDataQueryVariables>(GetVxLiveAccountDataDocument, options);
        }
export type GetVxLiveAccountDataQueryHookResult = ReturnType<typeof useGetVxLiveAccountDataQuery>;
export type GetVxLiveAccountDataLazyQueryHookResult = ReturnType<typeof useGetVxLiveAccountDataLazyQuery>;
export type GetVxLiveAccountDataSuspenseQueryHookResult = ReturnType<typeof useGetVxLiveAccountDataSuspenseQuery>;
export type GetVxLiveAccountDataQueryResult = Apollo.QueryResult<GetVxLiveAccountDataQuery, GetVxLiveAccountDataQueryVariables>;
export const GetWizardMrfDataDocument = gql`
    query GetWizardMRFData($redirectUrl: String!) {
  tour(type: ModelReleaseFormV1) {
    __typename
    ... on TourModelReleaseFormV1 {
      ...TourDataWizardMrf
    }
  }
}
    ${TourDataWizardMrfFragmentDoc}`;

/**
 * __useGetWizardMrfDataQuery__
 *
 * To run a query within a React component, call `useGetWizardMrfDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWizardMrfDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWizardMrfDataQuery({
 *   variables: {
 *      redirectUrl: // value for 'redirectUrl'
 *   },
 * });
 */
export function useGetWizardMrfDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetWizardMrfDataQuery, GetWizardMrfDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWizardMrfDataQuery, GetWizardMrfDataQueryVariables>(GetWizardMrfDataDocument, options);
      }
export function useGetWizardMrfDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetWizardMrfDataQuery, GetWizardMrfDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWizardMrfDataQuery, GetWizardMrfDataQueryVariables>(GetWizardMrfDataDocument, options);
        }
export function useGetWizardMrfDataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetWizardMrfDataQuery, GetWizardMrfDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetWizardMrfDataQuery, GetWizardMrfDataQueryVariables>(GetWizardMrfDataDocument, options);
        }
export type GetWizardMrfDataQueryHookResult = ReturnType<typeof useGetWizardMrfDataQuery>;
export type GetWizardMrfDataLazyQueryHookResult = ReturnType<typeof useGetWizardMrfDataLazyQuery>;
export type GetWizardMrfDataSuspenseQueryHookResult = ReturnType<typeof useGetWizardMrfDataSuspenseQuery>;
export type GetWizardMrfDataQueryResult = Apollo.QueryResult<GetWizardMrfDataQuery, GetWizardMrfDataQueryVariables>;
export const UpdateWizardMrfDataDocument = gql`
    mutation UpdateWizardMRFData($step: ID!, $data: InputTourModelReleaseFormV1!, $redirectUrl: String!) {
  tour(name: ModelReleaseFormV1) {
    __typename
    ... on TourModelReleaseFormV1Mutation {
      update(step: $step, data: $data) {
        ...TourDataWizardMrf
      }
    }
  }
}
    ${TourDataWizardMrfFragmentDoc}`;
export type UpdateWizardMrfDataMutationFn = Apollo.MutationFunction<UpdateWizardMrfDataMutation, UpdateWizardMrfDataMutationVariables>;

/**
 * __useUpdateWizardMrfDataMutation__
 *
 * To run a mutation, you first call `useUpdateWizardMrfDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWizardMrfDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWizardMrfDataMutation, { data, loading, error }] = useUpdateWizardMrfDataMutation({
 *   variables: {
 *      step: // value for 'step'
 *      data: // value for 'data'
 *      redirectUrl: // value for 'redirectUrl'
 *   },
 * });
 */
export function useUpdateWizardMrfDataMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateWizardMrfDataMutation, UpdateWizardMrfDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateWizardMrfDataMutation, UpdateWizardMrfDataMutationVariables>(UpdateWizardMrfDataDocument, options);
      }
export type UpdateWizardMrfDataMutationHookResult = ReturnType<typeof useUpdateWizardMrfDataMutation>;
export type UpdateWizardMrfDataMutationResult = Apollo.MutationResult<UpdateWizardMrfDataMutation>;
export type UpdateWizardMrfDataMutationOptions = Apollo.BaseMutationOptions<UpdateWizardMrfDataMutation, UpdateWizardMrfDataMutationVariables>;
export const UpdateWizardMrfFinishedDocument = gql`
    mutation UpdateWizardMRFFinished {
  tour(name: ModelReleaseFormV1) {
    __typename
    ... on TourModelReleaseFormV1Mutation {
      update(step: "ModelReleaseFormV1Finish", data: {}) {
        status
        currentStep {
          id
        }
      }
    }
  }
}
    `;
export type UpdateWizardMrfFinishedMutationFn = Apollo.MutationFunction<UpdateWizardMrfFinishedMutation, UpdateWizardMrfFinishedMutationVariables>;

/**
 * __useUpdateWizardMrfFinishedMutation__
 *
 * To run a mutation, you first call `useUpdateWizardMrfFinishedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWizardMrfFinishedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWizardMrfFinishedMutation, { data, loading, error }] = useUpdateWizardMrfFinishedMutation({
 *   variables: {
 *   },
 * });
 */
export function useUpdateWizardMrfFinishedMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateWizardMrfFinishedMutation, UpdateWizardMrfFinishedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateWizardMrfFinishedMutation, UpdateWizardMrfFinishedMutationVariables>(UpdateWizardMrfFinishedDocument, options);
      }
export type UpdateWizardMrfFinishedMutationHookResult = ReturnType<typeof useUpdateWizardMrfFinishedMutation>;
export type UpdateWizardMrfFinishedMutationResult = Apollo.MutationResult<UpdateWizardMrfFinishedMutation>;
export type UpdateWizardMrfFinishedMutationOptions = Apollo.BaseMutationOptions<UpdateWizardMrfFinishedMutation, UpdateWizardMrfFinishedMutationVariables>;
export const WizardPayoutBankDataBicByIbanDocument = gql`
    query WizardPayoutBankDataBicByIban($iban: String!) {
  finances {
    bicByIban(iban: $iban)
  }
}
    `;

/**
 * __useWizardPayoutBankDataBicByIbanQuery__
 *
 * To run a query within a React component, call `useWizardPayoutBankDataBicByIbanQuery` and pass it any options that fit your needs.
 * When your component renders, `useWizardPayoutBankDataBicByIbanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWizardPayoutBankDataBicByIbanQuery({
 *   variables: {
 *      iban: // value for 'iban'
 *   },
 * });
 */
export function useWizardPayoutBankDataBicByIbanQuery(baseOptions: ApolloReactHooks.QueryHookOptions<WizardPayoutBankDataBicByIbanQuery, WizardPayoutBankDataBicByIbanQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<WizardPayoutBankDataBicByIbanQuery, WizardPayoutBankDataBicByIbanQueryVariables>(WizardPayoutBankDataBicByIbanDocument, options);
      }
export function useWizardPayoutBankDataBicByIbanLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WizardPayoutBankDataBicByIbanQuery, WizardPayoutBankDataBicByIbanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<WizardPayoutBankDataBicByIbanQuery, WizardPayoutBankDataBicByIbanQueryVariables>(WizardPayoutBankDataBicByIbanDocument, options);
        }
export function useWizardPayoutBankDataBicByIbanSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<WizardPayoutBankDataBicByIbanQuery, WizardPayoutBankDataBicByIbanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<WizardPayoutBankDataBicByIbanQuery, WizardPayoutBankDataBicByIbanQueryVariables>(WizardPayoutBankDataBicByIbanDocument, options);
        }
export type WizardPayoutBankDataBicByIbanQueryHookResult = ReturnType<typeof useWizardPayoutBankDataBicByIbanQuery>;
export type WizardPayoutBankDataBicByIbanLazyQueryHookResult = ReturnType<typeof useWizardPayoutBankDataBicByIbanLazyQuery>;
export type WizardPayoutBankDataBicByIbanSuspenseQueryHookResult = ReturnType<typeof useWizardPayoutBankDataBicByIbanSuspenseQuery>;
export type WizardPayoutBankDataBicByIbanQueryResult = Apollo.QueryResult<WizardPayoutBankDataBicByIbanQuery, WizardPayoutBankDataBicByIbanQueryVariables>;
export const WizardPayoutBankDataDocument = gql`
    query WizardPayoutBankData {
  account {
    isAccountFromEU
    isAccountFromGermany
  }
}
    `;

/**
 * __useWizardPayoutBankDataQuery__
 *
 * To run a query within a React component, call `useWizardPayoutBankDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useWizardPayoutBankDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWizardPayoutBankDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useWizardPayoutBankDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<WizardPayoutBankDataQuery, WizardPayoutBankDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<WizardPayoutBankDataQuery, WizardPayoutBankDataQueryVariables>(WizardPayoutBankDataDocument, options);
      }
export function useWizardPayoutBankDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WizardPayoutBankDataQuery, WizardPayoutBankDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<WizardPayoutBankDataQuery, WizardPayoutBankDataQueryVariables>(WizardPayoutBankDataDocument, options);
        }
export function useWizardPayoutBankDataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<WizardPayoutBankDataQuery, WizardPayoutBankDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<WizardPayoutBankDataQuery, WizardPayoutBankDataQueryVariables>(WizardPayoutBankDataDocument, options);
        }
export type WizardPayoutBankDataQueryHookResult = ReturnType<typeof useWizardPayoutBankDataQuery>;
export type WizardPayoutBankDataLazyQueryHookResult = ReturnType<typeof useWizardPayoutBankDataLazyQuery>;
export type WizardPayoutBankDataSuspenseQueryHookResult = ReturnType<typeof useWizardPayoutBankDataSuspenseQuery>;
export type WizardPayoutBankDataQueryResult = Apollo.QueryResult<WizardPayoutBankDataQuery, WizardPayoutBankDataQueryVariables>;
export const GetWizardPayoutTaxTinExtrasDocument = gql`
    query getWizardPayoutTaxTinExtras {
  payment {
    taxData {
      ...TaxData
    }
  }
}
    ${TaxDataFragmentDoc}`;

/**
 * __useGetWizardPayoutTaxTinExtrasQuery__
 *
 * To run a query within a React component, call `useGetWizardPayoutTaxTinExtrasQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWizardPayoutTaxTinExtrasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWizardPayoutTaxTinExtrasQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWizardPayoutTaxTinExtrasQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetWizardPayoutTaxTinExtrasQuery, GetWizardPayoutTaxTinExtrasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWizardPayoutTaxTinExtrasQuery, GetWizardPayoutTaxTinExtrasQueryVariables>(GetWizardPayoutTaxTinExtrasDocument, options);
      }
export function useGetWizardPayoutTaxTinExtrasLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetWizardPayoutTaxTinExtrasQuery, GetWizardPayoutTaxTinExtrasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWizardPayoutTaxTinExtrasQuery, GetWizardPayoutTaxTinExtrasQueryVariables>(GetWizardPayoutTaxTinExtrasDocument, options);
        }
export function useGetWizardPayoutTaxTinExtrasSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetWizardPayoutTaxTinExtrasQuery, GetWizardPayoutTaxTinExtrasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetWizardPayoutTaxTinExtrasQuery, GetWizardPayoutTaxTinExtrasQueryVariables>(GetWizardPayoutTaxTinExtrasDocument, options);
        }
export type GetWizardPayoutTaxTinExtrasQueryHookResult = ReturnType<typeof useGetWizardPayoutTaxTinExtrasQuery>;
export type GetWizardPayoutTaxTinExtrasLazyQueryHookResult = ReturnType<typeof useGetWizardPayoutTaxTinExtrasLazyQuery>;
export type GetWizardPayoutTaxTinExtrasSuspenseQueryHookResult = ReturnType<typeof useGetWizardPayoutTaxTinExtrasSuspenseQuery>;
export type GetWizardPayoutTaxTinExtrasQueryResult = Apollo.QueryResult<GetWizardPayoutTaxTinExtrasQuery, GetWizardPayoutTaxTinExtrasQueryVariables>;
export const GetWizardPayoutDataDocument = gql`
    query GetWizardPayoutData {
  tour(type: PayoutV1) {
    __typename
    ... on TourPayoutV1 {
      ...TourDataWizardPayout
    }
  }
  account {
    isAccountFromGermany
    isAccountFromEU
  }
  profile {
    collection(name: AccountV1) {
      ... on ProfileCollectionAccountV1 {
        fields {
          ...WizardPayoutAccountPrefillFields
        }
      }
    }
  }
}
    ${TourDataWizardPayoutFragmentDoc}
${WizardPayoutAccountPrefillFieldsFragmentDoc}`;

/**
 * __useGetWizardPayoutDataQuery__
 *
 * To run a query within a React component, call `useGetWizardPayoutDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWizardPayoutDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWizardPayoutDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWizardPayoutDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetWizardPayoutDataQuery, GetWizardPayoutDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWizardPayoutDataQuery, GetWizardPayoutDataQueryVariables>(GetWizardPayoutDataDocument, options);
      }
export function useGetWizardPayoutDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetWizardPayoutDataQuery, GetWizardPayoutDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWizardPayoutDataQuery, GetWizardPayoutDataQueryVariables>(GetWizardPayoutDataDocument, options);
        }
export function useGetWizardPayoutDataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetWizardPayoutDataQuery, GetWizardPayoutDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetWizardPayoutDataQuery, GetWizardPayoutDataQueryVariables>(GetWizardPayoutDataDocument, options);
        }
export type GetWizardPayoutDataQueryHookResult = ReturnType<typeof useGetWizardPayoutDataQuery>;
export type GetWizardPayoutDataLazyQueryHookResult = ReturnType<typeof useGetWizardPayoutDataLazyQuery>;
export type GetWizardPayoutDataSuspenseQueryHookResult = ReturnType<typeof useGetWizardPayoutDataSuspenseQuery>;
export type GetWizardPayoutDataQueryResult = Apollo.QueryResult<GetWizardPayoutDataQuery, GetWizardPayoutDataQueryVariables>;
export const UpdateWizardPayoutDataDocument = gql`
    mutation UpdateWizardPayoutData($step: ID!, $data: InputTourPayoutV1!) {
  tour(name: PayoutV1) {
    __typename
    ... on TourPayoutV1Mutation {
      update(step: $step, data: $data) {
        ...TourDataWizardPayout
      }
    }
  }
}
    ${TourDataWizardPayoutFragmentDoc}`;
export type UpdateWizardPayoutDataMutationFn = Apollo.MutationFunction<UpdateWizardPayoutDataMutation, UpdateWizardPayoutDataMutationVariables>;

/**
 * __useUpdateWizardPayoutDataMutation__
 *
 * To run a mutation, you first call `useUpdateWizardPayoutDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWizardPayoutDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWizardPayoutDataMutation, { data, loading, error }] = useUpdateWizardPayoutDataMutation({
 *   variables: {
 *      step: // value for 'step'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateWizardPayoutDataMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateWizardPayoutDataMutation, UpdateWizardPayoutDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateWizardPayoutDataMutation, UpdateWizardPayoutDataMutationVariables>(UpdateWizardPayoutDataDocument, options);
      }
export type UpdateWizardPayoutDataMutationHookResult = ReturnType<typeof useUpdateWizardPayoutDataMutation>;
export type UpdateWizardPayoutDataMutationResult = Apollo.MutationResult<UpdateWizardPayoutDataMutation>;
export type UpdateWizardPayoutDataMutationOptions = Apollo.BaseMutationOptions<UpdateWizardPayoutDataMutation, UpdateWizardPayoutDataMutationVariables>;
export const GetWizardPayoutDataV2Document = gql`
    query GetWizardPayoutDataV2($redirectUrl: String!) {
  tour(type: PayoutV2) {
    __typename
    ... on TourPayoutV2 {
      ...TourDataWizardPayoutV2
    }
  }
  account {
    isAccountFromGermany
    isAccountFromEU
  }
  profile {
    collection(name: AccountV1) {
      ... on ProfileCollectionAccountV1 {
        fields {
          ...WizardPayoutAccountPrefillFields
        }
      }
    }
  }
}
    ${TourDataWizardPayoutV2FragmentDoc}
${WizardPayoutAccountPrefillFieldsFragmentDoc}`;

/**
 * __useGetWizardPayoutDataV2Query__
 *
 * To run a query within a React component, call `useGetWizardPayoutDataV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetWizardPayoutDataV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWizardPayoutDataV2Query({
 *   variables: {
 *      redirectUrl: // value for 'redirectUrl'
 *   },
 * });
 */
export function useGetWizardPayoutDataV2Query(baseOptions: ApolloReactHooks.QueryHookOptions<GetWizardPayoutDataV2Query, GetWizardPayoutDataV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWizardPayoutDataV2Query, GetWizardPayoutDataV2QueryVariables>(GetWizardPayoutDataV2Document, options);
      }
export function useGetWizardPayoutDataV2LazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetWizardPayoutDataV2Query, GetWizardPayoutDataV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWizardPayoutDataV2Query, GetWizardPayoutDataV2QueryVariables>(GetWizardPayoutDataV2Document, options);
        }
export function useGetWizardPayoutDataV2SuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetWizardPayoutDataV2Query, GetWizardPayoutDataV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetWizardPayoutDataV2Query, GetWizardPayoutDataV2QueryVariables>(GetWizardPayoutDataV2Document, options);
        }
export type GetWizardPayoutDataV2QueryHookResult = ReturnType<typeof useGetWizardPayoutDataV2Query>;
export type GetWizardPayoutDataV2LazyQueryHookResult = ReturnType<typeof useGetWizardPayoutDataV2LazyQuery>;
export type GetWizardPayoutDataV2SuspenseQueryHookResult = ReturnType<typeof useGetWizardPayoutDataV2SuspenseQuery>;
export type GetWizardPayoutDataV2QueryResult = Apollo.QueryResult<GetWizardPayoutDataV2Query, GetWizardPayoutDataV2QueryVariables>;
export const UpdateWizardPayoutDataV2Document = gql`
    mutation UpdateWizardPayoutDataV2($step: ID!, $data: InputTourPayoutV2!, $redirectUrl: String!) {
  tour(name: PayoutV2) {
    __typename
    ... on TourPayoutV2Mutation {
      update(step: $step, data: $data) {
        ...TourDataWizardPayoutV2
      }
    }
  }
}
    ${TourDataWizardPayoutV2FragmentDoc}`;
export type UpdateWizardPayoutDataV2MutationFn = Apollo.MutationFunction<UpdateWizardPayoutDataV2Mutation, UpdateWizardPayoutDataV2MutationVariables>;

/**
 * __useUpdateWizardPayoutDataV2Mutation__
 *
 * To run a mutation, you first call `useUpdateWizardPayoutDataV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWizardPayoutDataV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWizardPayoutDataV2Mutation, { data, loading, error }] = useUpdateWizardPayoutDataV2Mutation({
 *   variables: {
 *      step: // value for 'step'
 *      data: // value for 'data'
 *      redirectUrl: // value for 'redirectUrl'
 *   },
 * });
 */
export function useUpdateWizardPayoutDataV2Mutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateWizardPayoutDataV2Mutation, UpdateWizardPayoutDataV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateWizardPayoutDataV2Mutation, UpdateWizardPayoutDataV2MutationVariables>(UpdateWizardPayoutDataV2Document, options);
      }
export type UpdateWizardPayoutDataV2MutationHookResult = ReturnType<typeof useUpdateWizardPayoutDataV2Mutation>;
export type UpdateWizardPayoutDataV2MutationResult = Apollo.MutationResult<UpdateWizardPayoutDataV2Mutation>;
export type UpdateWizardPayoutDataV2MutationOptions = Apollo.BaseMutationOptions<UpdateWizardPayoutDataV2Mutation, UpdateWizardPayoutDataV2MutationVariables>;
export const WizardPayoutAddressV2Document = gql`
    query WizardPayoutAddressV2 {
  profile {
    collection(name: AccountV1) {
      ... on ProfileCollectionAccountV1 {
        fields {
          accountFirstname {
            value
          }
          accountFirstname {
            value
          }
          accountLastname {
            value
          }
          accountAddressStreet {
            value
          }
          accountAddressStreetNumber {
            value
          }
          accountAddressCity {
            value
          }
          accountAddressPostalCode {
            value
          }
          accountAddressCountry {
            ...PrefillProfileEnumField
          }
        }
      }
    }
  }
}
    ${PrefillProfileEnumFieldFragmentDoc}`;

/**
 * __useWizardPayoutAddressV2Query__
 *
 * To run a query within a React component, call `useWizardPayoutAddressV2Query` and pass it any options that fit your needs.
 * When your component renders, `useWizardPayoutAddressV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWizardPayoutAddressV2Query({
 *   variables: {
 *   },
 * });
 */
export function useWizardPayoutAddressV2Query(baseOptions?: ApolloReactHooks.QueryHookOptions<WizardPayoutAddressV2Query, WizardPayoutAddressV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<WizardPayoutAddressV2Query, WizardPayoutAddressV2QueryVariables>(WizardPayoutAddressV2Document, options);
      }
export function useWizardPayoutAddressV2LazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WizardPayoutAddressV2Query, WizardPayoutAddressV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<WizardPayoutAddressV2Query, WizardPayoutAddressV2QueryVariables>(WizardPayoutAddressV2Document, options);
        }
export function useWizardPayoutAddressV2SuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<WizardPayoutAddressV2Query, WizardPayoutAddressV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<WizardPayoutAddressV2Query, WizardPayoutAddressV2QueryVariables>(WizardPayoutAddressV2Document, options);
        }
export type WizardPayoutAddressV2QueryHookResult = ReturnType<typeof useWizardPayoutAddressV2Query>;
export type WizardPayoutAddressV2LazyQueryHookResult = ReturnType<typeof useWizardPayoutAddressV2LazyQuery>;
export type WizardPayoutAddressV2SuspenseQueryHookResult = ReturnType<typeof useWizardPayoutAddressV2SuspenseQuery>;
export type WizardPayoutAddressV2QueryResult = Apollo.QueryResult<WizardPayoutAddressV2Query, WizardPayoutAddressV2QueryVariables>;
export const GetWizardProfileDataDocument = gql`
    query GetWizardProfileData {
  __typename
  tour(type: OnboardingV1) {
    ... on TourOnboardingV1 {
      ...TourDataWizardProfile
    }
  }
}
    ${TourDataWizardProfileFragmentDoc}`;

/**
 * __useGetWizardProfileDataQuery__
 *
 * To run a query within a React component, call `useGetWizardProfileDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWizardProfileDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWizardProfileDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWizardProfileDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetWizardProfileDataQuery, GetWizardProfileDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWizardProfileDataQuery, GetWizardProfileDataQueryVariables>(GetWizardProfileDataDocument, options);
      }
export function useGetWizardProfileDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetWizardProfileDataQuery, GetWizardProfileDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWizardProfileDataQuery, GetWizardProfileDataQueryVariables>(GetWizardProfileDataDocument, options);
        }
export function useGetWizardProfileDataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetWizardProfileDataQuery, GetWizardProfileDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetWizardProfileDataQuery, GetWizardProfileDataQueryVariables>(GetWizardProfileDataDocument, options);
        }
export type GetWizardProfileDataQueryHookResult = ReturnType<typeof useGetWizardProfileDataQuery>;
export type GetWizardProfileDataLazyQueryHookResult = ReturnType<typeof useGetWizardProfileDataLazyQuery>;
export type GetWizardProfileDataSuspenseQueryHookResult = ReturnType<typeof useGetWizardProfileDataSuspenseQuery>;
export type GetWizardProfileDataQueryResult = Apollo.QueryResult<GetWizardProfileDataQuery, GetWizardProfileDataQueryVariables>;
export const GetWizardProfileCurrentStepDocument = gql`
    query GetWizardProfileCurrentStep {
  __typename
  tour(type: OnboardingV1) {
    ... on TourOnboardingV1 {
      ...TourDataWizardProfile
    }
  }
}
    ${TourDataWizardProfileFragmentDoc}`;

/**
 * __useGetWizardProfileCurrentStepQuery__
 *
 * To run a query within a React component, call `useGetWizardProfileCurrentStepQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWizardProfileCurrentStepQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWizardProfileCurrentStepQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWizardProfileCurrentStepQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetWizardProfileCurrentStepQuery, GetWizardProfileCurrentStepQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWizardProfileCurrentStepQuery, GetWizardProfileCurrentStepQueryVariables>(GetWizardProfileCurrentStepDocument, options);
      }
export function useGetWizardProfileCurrentStepLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetWizardProfileCurrentStepQuery, GetWizardProfileCurrentStepQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWizardProfileCurrentStepQuery, GetWizardProfileCurrentStepQueryVariables>(GetWizardProfileCurrentStepDocument, options);
        }
export function useGetWizardProfileCurrentStepSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetWizardProfileCurrentStepQuery, GetWizardProfileCurrentStepQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetWizardProfileCurrentStepQuery, GetWizardProfileCurrentStepQueryVariables>(GetWizardProfileCurrentStepDocument, options);
        }
export type GetWizardProfileCurrentStepQueryHookResult = ReturnType<typeof useGetWizardProfileCurrentStepQuery>;
export type GetWizardProfileCurrentStepLazyQueryHookResult = ReturnType<typeof useGetWizardProfileCurrentStepLazyQuery>;
export type GetWizardProfileCurrentStepSuspenseQueryHookResult = ReturnType<typeof useGetWizardProfileCurrentStepSuspenseQuery>;
export type GetWizardProfileCurrentStepQueryResult = Apollo.QueryResult<GetWizardProfileCurrentStepQuery, GetWizardProfileCurrentStepQueryVariables>;
export const UpdateWizardProfileDataDocument = gql`
    mutation updateWizardProfileData($step: ID!, $data: InputTourOnboardingV1!) {
  tour(name: OnboardingV1) {
    ... on TourOnboardingV1Mutation {
      update(data: $data, step: $step) {
        ...TourDataWizardProfile
      }
    }
  }
}
    ${TourDataWizardProfileFragmentDoc}`;
export type UpdateWizardProfileDataMutationFn = Apollo.MutationFunction<UpdateWizardProfileDataMutation, UpdateWizardProfileDataMutationVariables>;

/**
 * __useUpdateWizardProfileDataMutation__
 *
 * To run a mutation, you first call `useUpdateWizardProfileDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWizardProfileDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWizardProfileDataMutation, { data, loading, error }] = useUpdateWizardProfileDataMutation({
 *   variables: {
 *      step: // value for 'step'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateWizardProfileDataMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateWizardProfileDataMutation, UpdateWizardProfileDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateWizardProfileDataMutation, UpdateWizardProfileDataMutationVariables>(UpdateWizardProfileDataDocument, options);
      }
export type UpdateWizardProfileDataMutationHookResult = ReturnType<typeof useUpdateWizardProfileDataMutation>;
export type UpdateWizardProfileDataMutationResult = Apollo.MutationResult<UpdateWizardProfileDataMutation>;
export type UpdateWizardProfileDataMutationOptions = Apollo.BaseMutationOptions<UpdateWizardProfileDataMutation, UpdateWizardProfileDataMutationVariables>;
export const MarkWizardProfileStepCompleteDocument = gql`
    mutation markWizardProfileStepComplete {
  tour(name: OnboardingV1) {
    ... on TourOnboardingV1Mutation {
      update(data: {}, step: "") {
        status
      }
    }
  }
}
    `;
export type MarkWizardProfileStepCompleteMutationFn = Apollo.MutationFunction<MarkWizardProfileStepCompleteMutation, MarkWizardProfileStepCompleteMutationVariables>;

/**
 * __useMarkWizardProfileStepCompleteMutation__
 *
 * To run a mutation, you first call `useMarkWizardProfileStepCompleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkWizardProfileStepCompleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markWizardProfileStepCompleteMutation, { data, loading, error }] = useMarkWizardProfileStepCompleteMutation({
 *   variables: {
 *   },
 * });
 */
export function useMarkWizardProfileStepCompleteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MarkWizardProfileStepCompleteMutation, MarkWizardProfileStepCompleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MarkWizardProfileStepCompleteMutation, MarkWizardProfileStepCompleteMutationVariables>(MarkWizardProfileStepCompleteDocument, options);
      }
export type MarkWizardProfileStepCompleteMutationHookResult = ReturnType<typeof useMarkWizardProfileStepCompleteMutation>;
export type MarkWizardProfileStepCompleteMutationResult = Apollo.MutationResult<MarkWizardProfileStepCompleteMutation>;
export type MarkWizardProfileStepCompleteMutationOptions = Apollo.BaseMutationOptions<MarkWizardProfileStepCompleteMutation, MarkWizardProfileStepCompleteMutationVariables>;
export const CheckUserNameValidityDocument = gql`
    mutation CheckUserNameValidity($userName: String!) {
  profile {
    validate(name: modelUsername, value: $userName) {
      ...ProfileFieldValidation
    }
  }
}
    ${ProfileFieldValidationFragmentDoc}`;
export type CheckUserNameValidityMutationFn = Apollo.MutationFunction<CheckUserNameValidityMutation, CheckUserNameValidityMutationVariables>;

/**
 * __useCheckUserNameValidityMutation__
 *
 * To run a mutation, you first call `useCheckUserNameValidityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckUserNameValidityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkUserNameValidityMutation, { data, loading, error }] = useCheckUserNameValidityMutation({
 *   variables: {
 *      userName: // value for 'userName'
 *   },
 * });
 */
export function useCheckUserNameValidityMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CheckUserNameValidityMutation, CheckUserNameValidityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CheckUserNameValidityMutation, CheckUserNameValidityMutationVariables>(CheckUserNameValidityDocument, options);
      }
export type CheckUserNameValidityMutationHookResult = ReturnType<typeof useCheckUserNameValidityMutation>;
export type CheckUserNameValidityMutationResult = Apollo.MutationResult<CheckUserNameValidityMutation>;
export type CheckUserNameValidityMutationOptions = Apollo.BaseMutationOptions<CheckUserNameValidityMutation, CheckUserNameValidityMutationVariables>;
export const WizardVerificationDocument = gql`
    query WizardVerification {
  account {
    userId
    actors(leadActorsOnly: true) {
      ... on Actor {
        userId
        personalDocumentsStatus
        address {
          firstname
          lastname
        }
        birthday
      }
    }
  }
  account {
    originator {
      isActor
    }
    isStudio
  }
}
    `;

/**
 * __useWizardVerificationQuery__
 *
 * To run a query within a React component, call `useWizardVerificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useWizardVerificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWizardVerificationQuery({
 *   variables: {
 *   },
 * });
 */
export function useWizardVerificationQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<WizardVerificationQuery, WizardVerificationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<WizardVerificationQuery, WizardVerificationQueryVariables>(WizardVerificationDocument, options);
      }
export function useWizardVerificationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WizardVerificationQuery, WizardVerificationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<WizardVerificationQuery, WizardVerificationQueryVariables>(WizardVerificationDocument, options);
        }
export function useWizardVerificationSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<WizardVerificationQuery, WizardVerificationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<WizardVerificationQuery, WizardVerificationQueryVariables>(WizardVerificationDocument, options);
        }
export type WizardVerificationQueryHookResult = ReturnType<typeof useWizardVerificationQuery>;
export type WizardVerificationLazyQueryHookResult = ReturnType<typeof useWizardVerificationLazyQuery>;
export type WizardVerificationSuspenseQueryHookResult = ReturnType<typeof useWizardVerificationSuspenseQuery>;
export type WizardVerificationQueryResult = Apollo.QueryResult<WizardVerificationQuery, WizardVerificationQueryVariables>;
export const WizardVerificationCreateTourDocument = gql`
    query WizardVerificationCreateTour($userId: Int) {
  documents {
    tour(name: actorVerification, userId: $userId) {
      currentStep {
        ...VerificationTourCurrentStep
      }
      steps {
        ...VerificationTourStep
      }
    }
  }
}
    ${VerificationTourCurrentStepFragmentDoc}
${VerificationTourStepFragmentDoc}`;

/**
 * __useWizardVerificationCreateTourQuery__
 *
 * To run a query within a React component, call `useWizardVerificationCreateTourQuery` and pass it any options that fit your needs.
 * When your component renders, `useWizardVerificationCreateTourQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWizardVerificationCreateTourQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useWizardVerificationCreateTourQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<WizardVerificationCreateTourQuery, WizardVerificationCreateTourQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<WizardVerificationCreateTourQuery, WizardVerificationCreateTourQueryVariables>(WizardVerificationCreateTourDocument, options);
      }
export function useWizardVerificationCreateTourLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WizardVerificationCreateTourQuery, WizardVerificationCreateTourQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<WizardVerificationCreateTourQuery, WizardVerificationCreateTourQueryVariables>(WizardVerificationCreateTourDocument, options);
        }
export function useWizardVerificationCreateTourSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<WizardVerificationCreateTourQuery, WizardVerificationCreateTourQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<WizardVerificationCreateTourQuery, WizardVerificationCreateTourQueryVariables>(WizardVerificationCreateTourDocument, options);
        }
export type WizardVerificationCreateTourQueryHookResult = ReturnType<typeof useWizardVerificationCreateTourQuery>;
export type WizardVerificationCreateTourLazyQueryHookResult = ReturnType<typeof useWizardVerificationCreateTourLazyQuery>;
export type WizardVerificationCreateTourSuspenseQueryHookResult = ReturnType<typeof useWizardVerificationCreateTourSuspenseQuery>;
export type WizardVerificationCreateTourQueryResult = Apollo.QueryResult<WizardVerificationCreateTourQuery, WizardVerificationCreateTourQueryVariables>;
export const SkipVerificationBacksideDocument = gql`
    mutation skipVerificationBackside($userId: Int) {
  documents {
    skipBacksideUpload(type: identityProof, userId: $userId)
  }
}
    `;
export type SkipVerificationBacksideMutationFn = Apollo.MutationFunction<SkipVerificationBacksideMutation, SkipVerificationBacksideMutationVariables>;

/**
 * __useSkipVerificationBacksideMutation__
 *
 * To run a mutation, you first call `useSkipVerificationBacksideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSkipVerificationBacksideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [skipVerificationBacksideMutation, { data, loading, error }] = useSkipVerificationBacksideMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useSkipVerificationBacksideMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SkipVerificationBacksideMutation, SkipVerificationBacksideMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SkipVerificationBacksideMutation, SkipVerificationBacksideMutationVariables>(SkipVerificationBacksideDocument, options);
      }
export type SkipVerificationBacksideMutationHookResult = ReturnType<typeof useSkipVerificationBacksideMutation>;
export type SkipVerificationBacksideMutationResult = Apollo.MutationResult<SkipVerificationBacksideMutation>;
export type SkipVerificationBacksideMutationOptions = Apollo.BaseMutationOptions<SkipVerificationBacksideMutation, SkipVerificationBacksideMutationVariables>;
export const VerificationSaveActorDocument = gql`
    mutation verificationSaveActor($data: InputSaveRealPersonData!) {
  account {
    saveActor(data: $data) {
      success
      errorMessage
      savedActor {
        ...Actor
      }
    }
  }
}
    ${ActorFragmentDoc}`;
export type VerificationSaveActorMutationFn = Apollo.MutationFunction<VerificationSaveActorMutation, VerificationSaveActorMutationVariables>;

/**
 * __useVerificationSaveActorMutation__
 *
 * To run a mutation, you first call `useVerificationSaveActorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerificationSaveActorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verificationSaveActorMutation, { data, loading, error }] = useVerificationSaveActorMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useVerificationSaveActorMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<VerificationSaveActorMutation, VerificationSaveActorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<VerificationSaveActorMutation, VerificationSaveActorMutationVariables>(VerificationSaveActorDocument, options);
      }
export type VerificationSaveActorMutationHookResult = ReturnType<typeof useVerificationSaveActorMutation>;
export type VerificationSaveActorMutationResult = Apollo.MutationResult<VerificationSaveActorMutation>;
export type VerificationSaveActorMutationOptions = Apollo.BaseMutationOptions<VerificationSaveActorMutation, VerificationSaveActorMutationVariables>;
export const AccountStatusProviderDocument = gql`
    query AccountStatusProvider {
  account {
    isModelVerified
    wasOnlineOnVXLive
  }
  profileTour: tour(type: OnboardingV1) {
    ... on TourOnboardingV1 {
      status
      lastVerified
    }
  }
  verificationTour: account {
    modelVerificationStatus
  }
  mrfTour: tour(type: ModelReleaseFormV1) {
    ... on TourModelReleaseFormV1 {
      status
      lastVerified
    }
  }
}
    `;

/**
 * __useAccountStatusProviderQuery__
 *
 * To run a query within a React component, call `useAccountStatusProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountStatusProviderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountStatusProviderQuery({
 *   variables: {
 *   },
 * });
 */
export function useAccountStatusProviderQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AccountStatusProviderQuery, AccountStatusProviderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AccountStatusProviderQuery, AccountStatusProviderQueryVariables>(AccountStatusProviderDocument, options);
      }
export function useAccountStatusProviderLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccountStatusProviderQuery, AccountStatusProviderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AccountStatusProviderQuery, AccountStatusProviderQueryVariables>(AccountStatusProviderDocument, options);
        }
export function useAccountStatusProviderSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AccountStatusProviderQuery, AccountStatusProviderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AccountStatusProviderQuery, AccountStatusProviderQueryVariables>(AccountStatusProviderDocument, options);
        }
export type AccountStatusProviderQueryHookResult = ReturnType<typeof useAccountStatusProviderQuery>;
export type AccountStatusProviderLazyQueryHookResult = ReturnType<typeof useAccountStatusProviderLazyQuery>;
export type AccountStatusProviderSuspenseQueryHookResult = ReturnType<typeof useAccountStatusProviderSuspenseQuery>;
export type AccountStatusProviderQueryResult = Apollo.QueryResult<AccountStatusProviderQuery, AccountStatusProviderQueryVariables>;
export const LoginDocument = gql`
    mutation login($username: String!, $password: String!) {
  auth {
    login(usernameOrEmail: $username, password: $password) {
      __typename
      ... on AuthResultSuccessful {
        accessToken
        refreshToken
        redirectUrl
      }
    }
  }
}
    `;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      username: // value for 'username'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const LoginWithTokenDocument = gql`
    mutation loginWithToken($token: String!) {
  auth {
    loginWithToken(token: $token) {
      ... on AuthResultSuccessful {
        accessToken
        refreshToken
        redirectUrl
      }
    }
  }
}
    `;
export type LoginWithTokenMutationFn = Apollo.MutationFunction<LoginWithTokenMutation, LoginWithTokenMutationVariables>;

/**
 * __useLoginWithTokenMutation__
 *
 * To run a mutation, you first call `useLoginWithTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginWithTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginWithTokenMutation, { data, loading, error }] = useLoginWithTokenMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useLoginWithTokenMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LoginWithTokenMutation, LoginWithTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<LoginWithTokenMutation, LoginWithTokenMutationVariables>(LoginWithTokenDocument, options);
      }
export type LoginWithTokenMutationHookResult = ReturnType<typeof useLoginWithTokenMutation>;
export type LoginWithTokenMutationResult = Apollo.MutationResult<LoginWithTokenMutation>;
export type LoginWithTokenMutationOptions = Apollo.BaseMutationOptions<LoginWithTokenMutation, LoginWithTokenMutationVariables>;
export const GetUserDocument = gql`
    query GetUser {
  auth {
    user {
      ...AuthUser
    }
    accessToken
  }
  account {
    language
  }
}
    ${AuthUserFragmentDoc}`;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
      }
export function useGetUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export function useGetUserSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserSuspenseQueryHookResult = ReturnType<typeof useGetUserSuspenseQuery>;
export type GetUserQueryResult = Apollo.QueryResult<GetUserQuery, GetUserQueryVariables>;
export const GetContestDataDocument = gql`
    query GetContestData($contestId: Int, $type: MediaContestTypeEnum) {
  media {
    contest(id: $contestId, type: $type) {
      ...Contest
    }
  }
}
    ${ContestFragmentDoc}`;

/**
 * __useGetContestDataQuery__
 *
 * To run a query within a React component, call `useGetContestDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContestDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContestDataQuery({
 *   variables: {
 *      contestId: // value for 'contestId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetContestDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetContestDataQuery, GetContestDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetContestDataQuery, GetContestDataQueryVariables>(GetContestDataDocument, options);
      }
export function useGetContestDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetContestDataQuery, GetContestDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetContestDataQuery, GetContestDataQueryVariables>(GetContestDataDocument, options);
        }
export function useGetContestDataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetContestDataQuery, GetContestDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetContestDataQuery, GetContestDataQueryVariables>(GetContestDataDocument, options);
        }
export type GetContestDataQueryHookResult = ReturnType<typeof useGetContestDataQuery>;
export type GetContestDataLazyQueryHookResult = ReturnType<typeof useGetContestDataLazyQuery>;
export type GetContestDataSuspenseQueryHookResult = ReturnType<typeof useGetContestDataSuspenseQuery>;
export type GetContestDataQueryResult = Apollo.QueryResult<GetContestDataQuery, GetContestDataQueryVariables>;
export const GetPictureUploadUrlDocument = gql`
    query GetPictureUploadUrl($umaId: Int!, $pictureType: Int!) {
  media {
    photoalbums {
      pictureUploadUrl(umaId: $umaId, pictureType: $pictureType)
    }
  }
}
    `;

/**
 * __useGetPictureUploadUrlQuery__
 *
 * To run a query within a React component, call `useGetPictureUploadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPictureUploadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPictureUploadUrlQuery({
 *   variables: {
 *      umaId: // value for 'umaId'
 *      pictureType: // value for 'pictureType'
 *   },
 * });
 */
export function useGetPictureUploadUrlQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetPictureUploadUrlQuery, GetPictureUploadUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPictureUploadUrlQuery, GetPictureUploadUrlQueryVariables>(GetPictureUploadUrlDocument, options);
      }
export function useGetPictureUploadUrlLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPictureUploadUrlQuery, GetPictureUploadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPictureUploadUrlQuery, GetPictureUploadUrlQueryVariables>(GetPictureUploadUrlDocument, options);
        }
export function useGetPictureUploadUrlSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetPictureUploadUrlQuery, GetPictureUploadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetPictureUploadUrlQuery, GetPictureUploadUrlQueryVariables>(GetPictureUploadUrlDocument, options);
        }
export type GetPictureUploadUrlQueryHookResult = ReturnType<typeof useGetPictureUploadUrlQuery>;
export type GetPictureUploadUrlLazyQueryHookResult = ReturnType<typeof useGetPictureUploadUrlLazyQuery>;
export type GetPictureUploadUrlSuspenseQueryHookResult = ReturnType<typeof useGetPictureUploadUrlSuspenseQuery>;
export type GetPictureUploadUrlQueryResult = Apollo.QueryResult<GetPictureUploadUrlQuery, GetPictureUploadUrlQueryVariables>;
export const GetVxLiveChannelDeeplinkDocument = gql`
    query GetVXLiveChannelDeeplink($guestUserId: String!) {
  vxlive {
    deepLinkUrl(guestUserId: $guestUserId)
  }
}
    `;

/**
 * __useGetVxLiveChannelDeeplinkQuery__
 *
 * To run a query within a React component, call `useGetVxLiveChannelDeeplinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVxLiveChannelDeeplinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVxLiveChannelDeeplinkQuery({
 *   variables: {
 *      guestUserId: // value for 'guestUserId'
 *   },
 * });
 */
export function useGetVxLiveChannelDeeplinkQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetVxLiveChannelDeeplinkQuery, GetVxLiveChannelDeeplinkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetVxLiveChannelDeeplinkQuery, GetVxLiveChannelDeeplinkQueryVariables>(GetVxLiveChannelDeeplinkDocument, options);
      }
export function useGetVxLiveChannelDeeplinkLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetVxLiveChannelDeeplinkQuery, GetVxLiveChannelDeeplinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetVxLiveChannelDeeplinkQuery, GetVxLiveChannelDeeplinkQueryVariables>(GetVxLiveChannelDeeplinkDocument, options);
        }
export function useGetVxLiveChannelDeeplinkSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetVxLiveChannelDeeplinkQuery, GetVxLiveChannelDeeplinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetVxLiveChannelDeeplinkQuery, GetVxLiveChannelDeeplinkQueryVariables>(GetVxLiveChannelDeeplinkDocument, options);
        }
export type GetVxLiveChannelDeeplinkQueryHookResult = ReturnType<typeof useGetVxLiveChannelDeeplinkQuery>;
export type GetVxLiveChannelDeeplinkLazyQueryHookResult = ReturnType<typeof useGetVxLiveChannelDeeplinkLazyQuery>;
export type GetVxLiveChannelDeeplinkSuspenseQueryHookResult = ReturnType<typeof useGetVxLiveChannelDeeplinkSuspenseQuery>;
export type GetVxLiveChannelDeeplinkQueryResult = Apollo.QueryResult<GetVxLiveChannelDeeplinkQuery, GetVxLiveChannelDeeplinkQueryVariables>;
export const GetFinanceServiceDocument = gql`
    query GetFinanceService {
  account {
    isAccountFromGermany
    isAccountFromEU
    expirationDateOfLastAcceptedTaxDocument
    originator {
      userId
      financialDocuments {
        ...DocumentsFinancialRealPerson
      }
    }
  }
  payoutWizardV1: tour(type: PayoutV1) {
    ... on TourPayoutV1 {
      active
      status
      lastVerified
    }
  }
  payoutWizardV2: tour(type: PayoutV2) {
    ... on TourPayoutV2 {
      active
      status
    }
  }
  finances {
    payoutStatus {
      isFirstPayout
      payoutDate
      status
      minimalPayableAmount
      payableAmount
    }
  }
  profile {
    collection(name: PayoutV1) {
      ... on ProfileCollectionPayoutV1 {
        ...FinanceServiceCollection
      }
    }
  }
}
    ${DocumentsFinancialRealPersonFragmentDoc}
${FinanceServiceCollectionFragmentDoc}`;

/**
 * __useGetFinanceServiceQuery__
 *
 * To run a query within a React component, call `useGetFinanceServiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFinanceServiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFinanceServiceQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFinanceServiceQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetFinanceServiceQuery, GetFinanceServiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetFinanceServiceQuery, GetFinanceServiceQueryVariables>(GetFinanceServiceDocument, options);
      }
export function useGetFinanceServiceLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFinanceServiceQuery, GetFinanceServiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetFinanceServiceQuery, GetFinanceServiceQueryVariables>(GetFinanceServiceDocument, options);
        }
export function useGetFinanceServiceSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetFinanceServiceQuery, GetFinanceServiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetFinanceServiceQuery, GetFinanceServiceQueryVariables>(GetFinanceServiceDocument, options);
        }
export type GetFinanceServiceQueryHookResult = ReturnType<typeof useGetFinanceServiceQuery>;
export type GetFinanceServiceLazyQueryHookResult = ReturnType<typeof useGetFinanceServiceLazyQuery>;
export type GetFinanceServiceSuspenseQueryHookResult = ReturnType<typeof useGetFinanceServiceSuspenseQuery>;
export type GetFinanceServiceQueryResult = Apollo.QueryResult<GetFinanceServiceQuery, GetFinanceServiceQueryVariables>;
export const GetInvoicesDocument = gql`
    query GetInvoices {
  account {
    signupDate
  }
  finances {
    invoices {
      ...OldFinancesInvoices
    }
  }
}
    ${OldFinancesInvoicesFragmentDoc}`;

/**
 * __useGetInvoicesQuery__
 *
 * To run a query within a React component, call `useGetInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoicesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInvoicesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetInvoicesQuery, GetInvoicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetInvoicesQuery, GetInvoicesQueryVariables>(GetInvoicesDocument, options);
      }
export function useGetInvoicesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetInvoicesQuery, GetInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetInvoicesQuery, GetInvoicesQueryVariables>(GetInvoicesDocument, options);
        }
export function useGetInvoicesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetInvoicesQuery, GetInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetInvoicesQuery, GetInvoicesQueryVariables>(GetInvoicesDocument, options);
        }
export type GetInvoicesQueryHookResult = ReturnType<typeof useGetInvoicesQuery>;
export type GetInvoicesLazyQueryHookResult = ReturnType<typeof useGetInvoicesLazyQuery>;
export type GetInvoicesSuspenseQueryHookResult = ReturnType<typeof useGetInvoicesSuspenseQuery>;
export type GetInvoicesQueryResult = Apollo.QueryResult<GetInvoicesQuery, GetInvoicesQueryVariables>;
export const UpdatePayoutCollectionDocument = gql`
    mutation UpdatePayoutCollection($data: InputProfileCollectionPayoutV1!) {
  profile {
    collection(name: PayoutV1) {
      ... on ProfileCollectionPayoutV1Mutation {
        update(data: $data) {
          ... on ProfileFieldValidationSet {
            ...ProfileFieldValidationSet
          }
        }
      }
    }
  }
}
    ${ProfileFieldValidationSetFragmentDoc}`;
export type UpdatePayoutCollectionMutationFn = Apollo.MutationFunction<UpdatePayoutCollectionMutation, UpdatePayoutCollectionMutationVariables>;

/**
 * __useUpdatePayoutCollectionMutation__
 *
 * To run a mutation, you first call `useUpdatePayoutCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePayoutCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePayoutCollectionMutation, { data, loading, error }] = useUpdatePayoutCollectionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdatePayoutCollectionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdatePayoutCollectionMutation, UpdatePayoutCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdatePayoutCollectionMutation, UpdatePayoutCollectionMutationVariables>(UpdatePayoutCollectionDocument, options);
      }
export type UpdatePayoutCollectionMutationHookResult = ReturnType<typeof useUpdatePayoutCollectionMutation>;
export type UpdatePayoutCollectionMutationResult = Apollo.MutationResult<UpdatePayoutCollectionMutation>;
export type UpdatePayoutCollectionMutationOptions = Apollo.BaseMutationOptions<UpdatePayoutCollectionMutation, UpdatePayoutCollectionMutationVariables>;
export const CheckTaxIdValidityDocument = gql`
    mutation CheckTaxIdValidity($taxId: String!) {
  profile {
    validate(name: payoutTaxId, value: $taxId) {
      ...ProfileFieldValidation
    }
  }
}
    ${ProfileFieldValidationFragmentDoc}`;
export type CheckTaxIdValidityMutationFn = Apollo.MutationFunction<CheckTaxIdValidityMutation, CheckTaxIdValidityMutationVariables>;

/**
 * __useCheckTaxIdValidityMutation__
 *
 * To run a mutation, you first call `useCheckTaxIdValidityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckTaxIdValidityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkTaxIdValidityMutation, { data, loading, error }] = useCheckTaxIdValidityMutation({
 *   variables: {
 *      taxId: // value for 'taxId'
 *   },
 * });
 */
export function useCheckTaxIdValidityMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CheckTaxIdValidityMutation, CheckTaxIdValidityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CheckTaxIdValidityMutation, CheckTaxIdValidityMutationVariables>(CheckTaxIdValidityDocument, options);
      }
export type CheckTaxIdValidityMutationHookResult = ReturnType<typeof useCheckTaxIdValidityMutation>;
export type CheckTaxIdValidityMutationResult = Apollo.MutationResult<CheckTaxIdValidityMutation>;
export type CheckTaxIdValidityMutationOptions = Apollo.BaseMutationOptions<CheckTaxIdValidityMutation, CheckTaxIdValidityMutationVariables>;
export const GetIncomeSourceDetailDataDocument = gql`
    query GetIncomeSourceDetailData($id: ID!) {
  helpcenter {
    incomeSources {
      incomeSourceById(id: $id) {
        ...IncomeSourceWithBodyEntry
      }
    }
  }
}
    ${IncomeSourceWithBodyEntryFragmentDoc}`;

/**
 * __useGetIncomeSourceDetailDataQuery__
 *
 * To run a query within a React component, call `useGetIncomeSourceDetailDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIncomeSourceDetailDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIncomeSourceDetailDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetIncomeSourceDetailDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetIncomeSourceDetailDataQuery, GetIncomeSourceDetailDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetIncomeSourceDetailDataQuery, GetIncomeSourceDetailDataQueryVariables>(GetIncomeSourceDetailDataDocument, options);
      }
export function useGetIncomeSourceDetailDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetIncomeSourceDetailDataQuery, GetIncomeSourceDetailDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetIncomeSourceDetailDataQuery, GetIncomeSourceDetailDataQueryVariables>(GetIncomeSourceDetailDataDocument, options);
        }
export function useGetIncomeSourceDetailDataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetIncomeSourceDetailDataQuery, GetIncomeSourceDetailDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetIncomeSourceDetailDataQuery, GetIncomeSourceDetailDataQueryVariables>(GetIncomeSourceDetailDataDocument, options);
        }
export type GetIncomeSourceDetailDataQueryHookResult = ReturnType<typeof useGetIncomeSourceDetailDataQuery>;
export type GetIncomeSourceDetailDataLazyQueryHookResult = ReturnType<typeof useGetIncomeSourceDetailDataLazyQuery>;
export type GetIncomeSourceDetailDataSuspenseQueryHookResult = ReturnType<typeof useGetIncomeSourceDetailDataSuspenseQuery>;
export type GetIncomeSourceDetailDataQueryResult = Apollo.QueryResult<GetIncomeSourceDetailDataQuery, GetIncomeSourceDetailDataQueryVariables>;
export const ActivateIncomeSourceDocument = gql`
    mutation ActivateIncomeSource($id: String!) {
  helpcenter {
    incomeSources {
      activate(id: $id) {
        id
        activatedAt
      }
    }
  }
}
    `;
export type ActivateIncomeSourceMutationFn = Apollo.MutationFunction<ActivateIncomeSourceMutation, ActivateIncomeSourceMutationVariables>;

/**
 * __useActivateIncomeSourceMutation__
 *
 * To run a mutation, you first call `useActivateIncomeSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateIncomeSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateIncomeSourceMutation, { data, loading, error }] = useActivateIncomeSourceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useActivateIncomeSourceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ActivateIncomeSourceMutation, ActivateIncomeSourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ActivateIncomeSourceMutation, ActivateIncomeSourceMutationVariables>(ActivateIncomeSourceDocument, options);
      }
export type ActivateIncomeSourceMutationHookResult = ReturnType<typeof useActivateIncomeSourceMutation>;
export type ActivateIncomeSourceMutationResult = Apollo.MutationResult<ActivateIncomeSourceMutation>;
export type ActivateIncomeSourceMutationOptions = Apollo.BaseMutationOptions<ActivateIncomeSourceMutation, ActivateIncomeSourceMutationVariables>;
export const DeactivateIncomeSourceDocument = gql`
    mutation DeactivateIncomeSource($id: String!) {
  helpcenter {
    incomeSources {
      deactivate(id: $id) {
        id
        activatedAt
      }
    }
  }
}
    `;
export type DeactivateIncomeSourceMutationFn = Apollo.MutationFunction<DeactivateIncomeSourceMutation, DeactivateIncomeSourceMutationVariables>;

/**
 * __useDeactivateIncomeSourceMutation__
 *
 * To run a mutation, you first call `useDeactivateIncomeSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateIncomeSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateIncomeSourceMutation, { data, loading, error }] = useDeactivateIncomeSourceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeactivateIncomeSourceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeactivateIncomeSourceMutation, DeactivateIncomeSourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeactivateIncomeSourceMutation, DeactivateIncomeSourceMutationVariables>(DeactivateIncomeSourceDocument, options);
      }
export type DeactivateIncomeSourceMutationHookResult = ReturnType<typeof useDeactivateIncomeSourceMutation>;
export type DeactivateIncomeSourceMutationResult = Apollo.MutationResult<DeactivateIncomeSourceMutation>;
export type DeactivateIncomeSourceMutationOptions = Apollo.BaseMutationOptions<DeactivateIncomeSourceMutation, DeactivateIncomeSourceMutationVariables>;
export const MarkIncomeSourceAsReadDocument = gql`
    mutation MarkIncomeSourceAsRead($id: String!) {
  helpcenter {
    incomeSources {
      markAsRead(id: $id) {
        id
        readAt
      }
    }
  }
}
    `;
export type MarkIncomeSourceAsReadMutationFn = Apollo.MutationFunction<MarkIncomeSourceAsReadMutation, MarkIncomeSourceAsReadMutationVariables>;

/**
 * __useMarkIncomeSourceAsReadMutation__
 *
 * To run a mutation, you first call `useMarkIncomeSourceAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkIncomeSourceAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markIncomeSourceAsReadMutation, { data, loading, error }] = useMarkIncomeSourceAsReadMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarkIncomeSourceAsReadMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MarkIncomeSourceAsReadMutation, MarkIncomeSourceAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MarkIncomeSourceAsReadMutation, MarkIncomeSourceAsReadMutationVariables>(MarkIncomeSourceAsReadDocument, options);
      }
export type MarkIncomeSourceAsReadMutationHookResult = ReturnType<typeof useMarkIncomeSourceAsReadMutation>;
export type MarkIncomeSourceAsReadMutationResult = Apollo.MutationResult<MarkIncomeSourceAsReadMutation>;
export type MarkIncomeSourceAsReadMutationOptions = Apollo.BaseMutationOptions<MarkIncomeSourceAsReadMutation, MarkIncomeSourceAsReadMutationVariables>;
export const GetIncomeSourcesDataDocument = gql`
    query GetIncomeSourcesData {
  helpcenter {
    incomeSources {
      entries {
        ...IncomeSourceEntry
      }
      experienceTags {
        ...TagEntry
      }
      intentionTags {
        ...TagEntry
      }
    }
  }
}
    ${IncomeSourceEntryFragmentDoc}
${TagEntryFragmentDoc}`;

/**
 * __useGetIncomeSourcesDataQuery__
 *
 * To run a query within a React component, call `useGetIncomeSourcesDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIncomeSourcesDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIncomeSourcesDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetIncomeSourcesDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetIncomeSourcesDataQuery, GetIncomeSourcesDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetIncomeSourcesDataQuery, GetIncomeSourcesDataQueryVariables>(GetIncomeSourcesDataDocument, options);
      }
export function useGetIncomeSourcesDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetIncomeSourcesDataQuery, GetIncomeSourcesDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetIncomeSourcesDataQuery, GetIncomeSourcesDataQueryVariables>(GetIncomeSourcesDataDocument, options);
        }
export function useGetIncomeSourcesDataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetIncomeSourcesDataQuery, GetIncomeSourcesDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetIncomeSourcesDataQuery, GetIncomeSourcesDataQueryVariables>(GetIncomeSourcesDataDocument, options);
        }
export type GetIncomeSourcesDataQueryHookResult = ReturnType<typeof useGetIncomeSourcesDataQuery>;
export type GetIncomeSourcesDataLazyQueryHookResult = ReturnType<typeof useGetIncomeSourcesDataLazyQuery>;
export type GetIncomeSourcesDataSuspenseQueryHookResult = ReturnType<typeof useGetIncomeSourcesDataSuspenseQuery>;
export type GetIncomeSourcesDataQueryResult = Apollo.QueryResult<GetIncomeSourcesDataQuery, GetIncomeSourcesDataQueryVariables>;
export const GetMandatoryEmaiLVerificationProviderDataDocument = gql`
    query getMandatoryEmaiLVerificationProviderData {
  account {
    isRegistrationComplete
    contact {
      emailAddress
      currentEmailAddress
    }
  }
  profile {
    collection(name: AccountV1) {
      ...MandatoryEmailVerificationSection
    }
  }
}
    ${MandatoryEmailVerificationSectionFragmentDoc}`;

/**
 * __useGetMandatoryEmaiLVerificationProviderDataQuery__
 *
 * To run a query within a React component, call `useGetMandatoryEmaiLVerificationProviderDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMandatoryEmaiLVerificationProviderDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMandatoryEmaiLVerificationProviderDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMandatoryEmaiLVerificationProviderDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMandatoryEmaiLVerificationProviderDataQuery, GetMandatoryEmaiLVerificationProviderDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMandatoryEmaiLVerificationProviderDataQuery, GetMandatoryEmaiLVerificationProviderDataQueryVariables>(GetMandatoryEmaiLVerificationProviderDataDocument, options);
      }
export function useGetMandatoryEmaiLVerificationProviderDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMandatoryEmaiLVerificationProviderDataQuery, GetMandatoryEmaiLVerificationProviderDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMandatoryEmaiLVerificationProviderDataQuery, GetMandatoryEmaiLVerificationProviderDataQueryVariables>(GetMandatoryEmaiLVerificationProviderDataDocument, options);
        }
export function useGetMandatoryEmaiLVerificationProviderDataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetMandatoryEmaiLVerificationProviderDataQuery, GetMandatoryEmaiLVerificationProviderDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetMandatoryEmaiLVerificationProviderDataQuery, GetMandatoryEmaiLVerificationProviderDataQueryVariables>(GetMandatoryEmaiLVerificationProviderDataDocument, options);
        }
export type GetMandatoryEmaiLVerificationProviderDataQueryHookResult = ReturnType<typeof useGetMandatoryEmaiLVerificationProviderDataQuery>;
export type GetMandatoryEmaiLVerificationProviderDataLazyQueryHookResult = ReturnType<typeof useGetMandatoryEmaiLVerificationProviderDataLazyQuery>;
export type GetMandatoryEmaiLVerificationProviderDataSuspenseQueryHookResult = ReturnType<typeof useGetMandatoryEmaiLVerificationProviderDataSuspenseQuery>;
export type GetMandatoryEmaiLVerificationProviderDataQueryResult = Apollo.QueryResult<GetMandatoryEmaiLVerificationProviderDataQuery, GetMandatoryEmaiLVerificationProviderDataQueryVariables>;
export const ResendEmailVerificationDocument = gql`
    mutation resendEmailVerification {
  account {
    resendRegistrationMail {
      success
      message
    }
  }
}
    `;
export type ResendEmailVerificationMutationFn = Apollo.MutationFunction<ResendEmailVerificationMutation, ResendEmailVerificationMutationVariables>;

/**
 * __useResendEmailVerificationMutation__
 *
 * To run a mutation, you first call `useResendEmailVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendEmailVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendEmailVerificationMutation, { data, loading, error }] = useResendEmailVerificationMutation({
 *   variables: {
 *   },
 * });
 */
export function useResendEmailVerificationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ResendEmailVerificationMutation, ResendEmailVerificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ResendEmailVerificationMutation, ResendEmailVerificationMutationVariables>(ResendEmailVerificationDocument, options);
      }
export type ResendEmailVerificationMutationHookResult = ReturnType<typeof useResendEmailVerificationMutation>;
export type ResendEmailVerificationMutationResult = Apollo.MutationResult<ResendEmailVerificationMutation>;
export type ResendEmailVerificationMutationOptions = Apollo.BaseMutationOptions<ResendEmailVerificationMutation, ResendEmailVerificationMutationVariables>;
export const ChangeEmailAndResendRegistrationMailDocument = gql`
    mutation changeEmailAndResendRegistrationMail($email: String!) {
  account {
    changeEmailAddressAndSendRegistrationMail(email: $email) {
      success
      message
    }
  }
}
    `;
export type ChangeEmailAndResendRegistrationMailMutationFn = Apollo.MutationFunction<ChangeEmailAndResendRegistrationMailMutation, ChangeEmailAndResendRegistrationMailMutationVariables>;

/**
 * __useChangeEmailAndResendRegistrationMailMutation__
 *
 * To run a mutation, you first call `useChangeEmailAndResendRegistrationMailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeEmailAndResendRegistrationMailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeEmailAndResendRegistrationMailMutation, { data, loading, error }] = useChangeEmailAndResendRegistrationMailMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useChangeEmailAndResendRegistrationMailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ChangeEmailAndResendRegistrationMailMutation, ChangeEmailAndResendRegistrationMailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ChangeEmailAndResendRegistrationMailMutation, ChangeEmailAndResendRegistrationMailMutationVariables>(ChangeEmailAndResendRegistrationMailDocument, options);
      }
export type ChangeEmailAndResendRegistrationMailMutationHookResult = ReturnType<typeof useChangeEmailAndResendRegistrationMailMutation>;
export type ChangeEmailAndResendRegistrationMailMutationResult = Apollo.MutationResult<ChangeEmailAndResendRegistrationMailMutation>;
export type ChangeEmailAndResendRegistrationMailMutationOptions = Apollo.BaseMutationOptions<ChangeEmailAndResendRegistrationMailMutation, ChangeEmailAndResendRegistrationMailMutationVariables>;
export const DeleteSedcardDocument = gql`
    mutation DeleteSedcard($umaId: Int!, $umpId: Int!) {
  profile {
    collection(name: MobileMediaV1) {
      ... on ProfileCollectionMobileMediaV1Mutation {
        deleteSedcardPicture(umaId: $umaId, umpId: $umpId)
      }
    }
  }
}
    `;
export type DeleteSedcardMutationFn = Apollo.MutationFunction<DeleteSedcardMutation, DeleteSedcardMutationVariables>;

/**
 * __useDeleteSedcardMutation__
 *
 * To run a mutation, you first call `useDeleteSedcardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSedcardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSedcardMutation, { data, loading, error }] = useDeleteSedcardMutation({
 *   variables: {
 *      umaId: // value for 'umaId'
 *      umpId: // value for 'umpId'
 *   },
 * });
 */
export function useDeleteSedcardMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteSedcardMutation, DeleteSedcardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteSedcardMutation, DeleteSedcardMutationVariables>(DeleteSedcardDocument, options);
      }
export type DeleteSedcardMutationHookResult = ReturnType<typeof useDeleteSedcardMutation>;
export type DeleteSedcardMutationResult = Apollo.MutationResult<DeleteSedcardMutation>;
export type DeleteSedcardMutationOptions = Apollo.BaseMutationOptions<DeleteSedcardMutation, DeleteSedcardMutationVariables>;
export const GetVxModelsClassicAutoLoginUrlWithPathDocument = gql`
    query GetVxModelsClassicAutoLoginUrlWithPath($path: String!) {
  app {
    autologinLinkVXModels(redirect: $path)
  }
}
    `;

/**
 * __useGetVxModelsClassicAutoLoginUrlWithPathQuery__
 *
 * To run a query within a React component, call `useGetVxModelsClassicAutoLoginUrlWithPathQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVxModelsClassicAutoLoginUrlWithPathQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVxModelsClassicAutoLoginUrlWithPathQuery({
 *   variables: {
 *      path: // value for 'path'
 *   },
 * });
 */
export function useGetVxModelsClassicAutoLoginUrlWithPathQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetVxModelsClassicAutoLoginUrlWithPathQuery, GetVxModelsClassicAutoLoginUrlWithPathQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetVxModelsClassicAutoLoginUrlWithPathQuery, GetVxModelsClassicAutoLoginUrlWithPathQueryVariables>(GetVxModelsClassicAutoLoginUrlWithPathDocument, options);
      }
export function useGetVxModelsClassicAutoLoginUrlWithPathLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetVxModelsClassicAutoLoginUrlWithPathQuery, GetVxModelsClassicAutoLoginUrlWithPathQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetVxModelsClassicAutoLoginUrlWithPathQuery, GetVxModelsClassicAutoLoginUrlWithPathQueryVariables>(GetVxModelsClassicAutoLoginUrlWithPathDocument, options);
        }
export function useGetVxModelsClassicAutoLoginUrlWithPathSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetVxModelsClassicAutoLoginUrlWithPathQuery, GetVxModelsClassicAutoLoginUrlWithPathQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetVxModelsClassicAutoLoginUrlWithPathQuery, GetVxModelsClassicAutoLoginUrlWithPathQueryVariables>(GetVxModelsClassicAutoLoginUrlWithPathDocument, options);
        }
export type GetVxModelsClassicAutoLoginUrlWithPathQueryHookResult = ReturnType<typeof useGetVxModelsClassicAutoLoginUrlWithPathQuery>;
export type GetVxModelsClassicAutoLoginUrlWithPathLazyQueryHookResult = ReturnType<typeof useGetVxModelsClassicAutoLoginUrlWithPathLazyQuery>;
export type GetVxModelsClassicAutoLoginUrlWithPathSuspenseQueryHookResult = ReturnType<typeof useGetVxModelsClassicAutoLoginUrlWithPathSuspenseQuery>;
export type GetVxModelsClassicAutoLoginUrlWithPathQueryResult = Apollo.QueryResult<GetVxModelsClassicAutoLoginUrlWithPathQuery, GetVxModelsClassicAutoLoginUrlWithPathQueryVariables>;
export const GetOnboardingTaskStatusProviderDocument = gql`
    query GetOnboardingTaskStatusProvider {
  account {
    modelVerificationStatus
  }
  tour(type: OnboardingV1) {
    ... on TourOnboardingV1 {
      __typename
      status
      lastVerified
    }
  }
}
    `;

/**
 * __useGetOnboardingTaskStatusProviderQuery__
 *
 * To run a query within a React component, call `useGetOnboardingTaskStatusProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOnboardingTaskStatusProviderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOnboardingTaskStatusProviderQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOnboardingTaskStatusProviderQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetOnboardingTaskStatusProviderQuery, GetOnboardingTaskStatusProviderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetOnboardingTaskStatusProviderQuery, GetOnboardingTaskStatusProviderQueryVariables>(GetOnboardingTaskStatusProviderDocument, options);
      }
export function useGetOnboardingTaskStatusProviderLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetOnboardingTaskStatusProviderQuery, GetOnboardingTaskStatusProviderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetOnboardingTaskStatusProviderQuery, GetOnboardingTaskStatusProviderQueryVariables>(GetOnboardingTaskStatusProviderDocument, options);
        }
export function useGetOnboardingTaskStatusProviderSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetOnboardingTaskStatusProviderQuery, GetOnboardingTaskStatusProviderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetOnboardingTaskStatusProviderQuery, GetOnboardingTaskStatusProviderQueryVariables>(GetOnboardingTaskStatusProviderDocument, options);
        }
export type GetOnboardingTaskStatusProviderQueryHookResult = ReturnType<typeof useGetOnboardingTaskStatusProviderQuery>;
export type GetOnboardingTaskStatusProviderLazyQueryHookResult = ReturnType<typeof useGetOnboardingTaskStatusProviderLazyQuery>;
export type GetOnboardingTaskStatusProviderSuspenseQueryHookResult = ReturnType<typeof useGetOnboardingTaskStatusProviderSuspenseQuery>;
export type GetOnboardingTaskStatusProviderQueryResult = Apollo.QueryResult<GetOnboardingTaskStatusProviderQuery, GetOnboardingTaskStatusProviderQueryVariables>;
export const GetStatisticProviderDocument = gql`
    query GetStatisticProvider {
  statistics {
    entries {
      ...StatisticsEntry
    }
  }
}
    ${StatisticsEntryFragmentDoc}`;

/**
 * __useGetStatisticProviderQuery__
 *
 * To run a query within a React component, call `useGetStatisticProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStatisticProviderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStatisticProviderQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStatisticProviderQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetStatisticProviderQuery, GetStatisticProviderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetStatisticProviderQuery, GetStatisticProviderQueryVariables>(GetStatisticProviderDocument, options);
      }
export function useGetStatisticProviderLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetStatisticProviderQuery, GetStatisticProviderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetStatisticProviderQuery, GetStatisticProviderQueryVariables>(GetStatisticProviderDocument, options);
        }
export function useGetStatisticProviderSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetStatisticProviderQuery, GetStatisticProviderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetStatisticProviderQuery, GetStatisticProviderQueryVariables>(GetStatisticProviderDocument, options);
        }
export type GetStatisticProviderQueryHookResult = ReturnType<typeof useGetStatisticProviderQuery>;
export type GetStatisticProviderLazyQueryHookResult = ReturnType<typeof useGetStatisticProviderLazyQuery>;
export type GetStatisticProviderSuspenseQueryHookResult = ReturnType<typeof useGetStatisticProviderSuspenseQuery>;
export type GetStatisticProviderQueryResult = Apollo.QueryResult<GetStatisticProviderQuery, GetStatisticProviderQueryVariables>;
export const GetTermsAcceptDatesDocument = gql`
    query GetTermsAcceptDates {
  terms {
    termsAndConditions: acceptance(type: VXMODELS_TERMS_AND_CONDITIONS) {
      ...TermAcceptanceState
    }
    privacyPolicy: acceptance(type: VXMODELS_PRIVACY_POLICY) {
      ...TermAcceptanceState
    }
  }
  account {
    isStudio
    hasWebmasterId
  }
}
    ${TermAcceptanceStateFragmentDoc}`;

/**
 * __useGetTermsAcceptDatesQuery__
 *
 * To run a query within a React component, call `useGetTermsAcceptDatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTermsAcceptDatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTermsAcceptDatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTermsAcceptDatesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetTermsAcceptDatesQuery, GetTermsAcceptDatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetTermsAcceptDatesQuery, GetTermsAcceptDatesQueryVariables>(GetTermsAcceptDatesDocument, options);
      }
export function useGetTermsAcceptDatesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTermsAcceptDatesQuery, GetTermsAcceptDatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetTermsAcceptDatesQuery, GetTermsAcceptDatesQueryVariables>(GetTermsAcceptDatesDocument, options);
        }
export function useGetTermsAcceptDatesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetTermsAcceptDatesQuery, GetTermsAcceptDatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetTermsAcceptDatesQuery, GetTermsAcceptDatesQueryVariables>(GetTermsAcceptDatesDocument, options);
        }
export type GetTermsAcceptDatesQueryHookResult = ReturnType<typeof useGetTermsAcceptDatesQuery>;
export type GetTermsAcceptDatesLazyQueryHookResult = ReturnType<typeof useGetTermsAcceptDatesLazyQuery>;
export type GetTermsAcceptDatesSuspenseQueryHookResult = ReturnType<typeof useGetTermsAcceptDatesSuspenseQuery>;
export type GetTermsAcceptDatesQueryResult = Apollo.QueryResult<GetTermsAcceptDatesQuery, GetTermsAcceptDatesQueryVariables>;
export const AcceptTermsDocument = gql`
    mutation AcceptTerms($type: TermsAcceptanceTypeEnum!) {
  terms {
    accept(type: $type) {
      wasSuccsessful
      isPasswordInvalid
    }
  }
}
    `;
export type AcceptTermsMutationFn = Apollo.MutationFunction<AcceptTermsMutation, AcceptTermsMutationVariables>;

/**
 * __useAcceptTermsMutation__
 *
 * To run a mutation, you first call `useAcceptTermsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptTermsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptTermsMutation, { data, loading, error }] = useAcceptTermsMutation({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useAcceptTermsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AcceptTermsMutation, AcceptTermsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AcceptTermsMutation, AcceptTermsMutationVariables>(AcceptTermsDocument, options);
      }
export type AcceptTermsMutationHookResult = ReturnType<typeof useAcceptTermsMutation>;
export type AcceptTermsMutationResult = Apollo.MutationResult<AcceptTermsMutation>;
export type AcceptTermsMutationOptions = Apollo.BaseMutationOptions<AcceptTermsMutation, AcceptTermsMutationVariables>;
export const CreateWebmasterDocument = gql`
    mutation CreateWebmaster {
  vxcash {
    createWebmaster
  }
}
    `;
export type CreateWebmasterMutationFn = Apollo.MutationFunction<CreateWebmasterMutation, CreateWebmasterMutationVariables>;

/**
 * __useCreateWebmasterMutation__
 *
 * To run a mutation, you first call `useCreateWebmasterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWebmasterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWebmasterMutation, { data, loading, error }] = useCreateWebmasterMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateWebmasterMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateWebmasterMutation, CreateWebmasterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateWebmasterMutation, CreateWebmasterMutationVariables>(CreateWebmasterDocument, options);
      }
export type CreateWebmasterMutationHookResult = ReturnType<typeof useCreateWebmasterMutation>;
export type CreateWebmasterMutationResult = Apollo.MutationResult<CreateWebmasterMutation>;
export type CreateWebmasterMutationOptions = Apollo.BaseMutationOptions<CreateWebmasterMutation, CreateWebmasterMutationVariables>;
export const GetTipDetailDataDocument = gql`
    query GetTipDetailData($id: ID!) {
  helpcenter {
    tips {
      tipById(id: $id) {
        ...TipWithBodyEntry
      }
    }
  }
}
    ${TipWithBodyEntryFragmentDoc}`;

/**
 * __useGetTipDetailDataQuery__
 *
 * To run a query within a React component, call `useGetTipDetailDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTipDetailDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTipDetailDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTipDetailDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetTipDetailDataQuery, GetTipDetailDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetTipDetailDataQuery, GetTipDetailDataQueryVariables>(GetTipDetailDataDocument, options);
      }
export function useGetTipDetailDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTipDetailDataQuery, GetTipDetailDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetTipDetailDataQuery, GetTipDetailDataQueryVariables>(GetTipDetailDataDocument, options);
        }
export function useGetTipDetailDataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetTipDetailDataQuery, GetTipDetailDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetTipDetailDataQuery, GetTipDetailDataQueryVariables>(GetTipDetailDataDocument, options);
        }
export type GetTipDetailDataQueryHookResult = ReturnType<typeof useGetTipDetailDataQuery>;
export type GetTipDetailDataLazyQueryHookResult = ReturnType<typeof useGetTipDetailDataLazyQuery>;
export type GetTipDetailDataSuspenseQueryHookResult = ReturnType<typeof useGetTipDetailDataSuspenseQuery>;
export type GetTipDetailDataQueryResult = Apollo.QueryResult<GetTipDetailDataQuery, GetTipDetailDataQueryVariables>;
export const MarkTipAsReadDocument = gql`
    mutation MarkTipAsRead($id: String!) {
  helpcenter {
    tips {
      markAsRead(id: $id) {
        id
        readAt
      }
    }
  }
}
    `;
export type MarkTipAsReadMutationFn = Apollo.MutationFunction<MarkTipAsReadMutation, MarkTipAsReadMutationVariables>;

/**
 * __useMarkTipAsReadMutation__
 *
 * To run a mutation, you first call `useMarkTipAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkTipAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markTipAsReadMutation, { data, loading, error }] = useMarkTipAsReadMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarkTipAsReadMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MarkTipAsReadMutation, MarkTipAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MarkTipAsReadMutation, MarkTipAsReadMutationVariables>(MarkTipAsReadDocument, options);
      }
export type MarkTipAsReadMutationHookResult = ReturnType<typeof useMarkTipAsReadMutation>;
export type MarkTipAsReadMutationResult = Apollo.MutationResult<MarkTipAsReadMutation>;
export type MarkTipAsReadMutationOptions = Apollo.BaseMutationOptions<MarkTipAsReadMutation, MarkTipAsReadMutationVariables>;
export const GetTipsDataDocument = gql`
    query GetTipsData {
  helpcenter {
    tips {
      entries {
        ...TipEntry
      }
      experienceTags {
        ...TagEntry
      }
      intentionTags {
        ...TagEntry
      }
    }
  }
}
    ${TipEntryFragmentDoc}
${TagEntryFragmentDoc}`;

/**
 * __useGetTipsDataQuery__
 *
 * To run a query within a React component, call `useGetTipsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTipsDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTipsDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTipsDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetTipsDataQuery, GetTipsDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetTipsDataQuery, GetTipsDataQueryVariables>(GetTipsDataDocument, options);
      }
export function useGetTipsDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTipsDataQuery, GetTipsDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetTipsDataQuery, GetTipsDataQueryVariables>(GetTipsDataDocument, options);
        }
export function useGetTipsDataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetTipsDataQuery, GetTipsDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetTipsDataQuery, GetTipsDataQueryVariables>(GetTipsDataDocument, options);
        }
export type GetTipsDataQueryHookResult = ReturnType<typeof useGetTipsDataQuery>;
export type GetTipsDataLazyQueryHookResult = ReturnType<typeof useGetTipsDataLazyQuery>;
export type GetTipsDataSuspenseQueryHookResult = ReturnType<typeof useGetTipsDataSuspenseQuery>;
export type GetTipsDataQueryResult = Apollo.QueryResult<GetTipsDataQuery, GetTipsDataQueryVariables>;
export const VxLiveLinkProviderDocument = gql`
    query VxLiveLinkProvider {
  app {
    autologinLinkVXLive
  }
}
    `;

/**
 * __useVxLiveLinkProviderQuery__
 *
 * To run a query within a React component, call `useVxLiveLinkProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useVxLiveLinkProviderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVxLiveLinkProviderQuery({
 *   variables: {
 *   },
 * });
 */
export function useVxLiveLinkProviderQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<VxLiveLinkProviderQuery, VxLiveLinkProviderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<VxLiveLinkProviderQuery, VxLiveLinkProviderQueryVariables>(VxLiveLinkProviderDocument, options);
      }
export function useVxLiveLinkProviderLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<VxLiveLinkProviderQuery, VxLiveLinkProviderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<VxLiveLinkProviderQuery, VxLiveLinkProviderQueryVariables>(VxLiveLinkProviderDocument, options);
        }
export function useVxLiveLinkProviderSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<VxLiveLinkProviderQuery, VxLiveLinkProviderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<VxLiveLinkProviderQuery, VxLiveLinkProviderQueryVariables>(VxLiveLinkProviderDocument, options);
        }
export type VxLiveLinkProviderQueryHookResult = ReturnType<typeof useVxLiveLinkProviderQuery>;
export type VxLiveLinkProviderLazyQueryHookResult = ReturnType<typeof useVxLiveLinkProviderLazyQuery>;
export type VxLiveLinkProviderSuspenseQueryHookResult = ReturnType<typeof useVxLiveLinkProviderSuspenseQuery>;
export type VxLiveLinkProviderQueryResult = Apollo.QueryResult<VxLiveLinkProviderQuery, VxLiveLinkProviderQueryVariables>;
export const VideoLibraryDeleteMediaDocument = gql`
    mutation VideoLibraryDeleteMedia($albumId: Int!) {
  media {
    deleteMedia(albumId: $albumId)
  }
}
    `;
export type VideoLibraryDeleteMediaMutationFn = Apollo.MutationFunction<VideoLibraryDeleteMediaMutation, VideoLibraryDeleteMediaMutationVariables>;

/**
 * __useVideoLibraryDeleteMediaMutation__
 *
 * To run a mutation, you first call `useVideoLibraryDeleteMediaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVideoLibraryDeleteMediaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [videoLibraryDeleteMediaMutation, { data, loading, error }] = useVideoLibraryDeleteMediaMutation({
 *   variables: {
 *      albumId: // value for 'albumId'
 *   },
 * });
 */
export function useVideoLibraryDeleteMediaMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<VideoLibraryDeleteMediaMutation, VideoLibraryDeleteMediaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<VideoLibraryDeleteMediaMutation, VideoLibraryDeleteMediaMutationVariables>(VideoLibraryDeleteMediaDocument, options);
      }
export type VideoLibraryDeleteMediaMutationHookResult = ReturnType<typeof useVideoLibraryDeleteMediaMutation>;
export type VideoLibraryDeleteMediaMutationResult = Apollo.MutationResult<VideoLibraryDeleteMediaMutation>;
export type VideoLibraryDeleteMediaMutationOptions = Apollo.BaseMutationOptions<VideoLibraryDeleteMediaMutation, VideoLibraryDeleteMediaMutationVariables>;
export const GetVideoCommentingProviderDocument = gql`
    query GetVideoCommentingProvider($albumId: Int!, $cursor: String, $first: Int!) {
  media {
    videos {
      videoById(albumId: $albumId) {
        ...Video
      }
    }
    comments(albumId: $albumId, after: $cursor, first: $first) {
      totalCount
      pageInfo {
        hasNextPage
      }
      edges {
        cursor
        node {
          ...MediaComment
        }
      }
    }
  }
}
    ${VideoFragmentDoc}
${MediaCommentFragmentDoc}`;

/**
 * __useGetVideoCommentingProviderQuery__
 *
 * To run a query within a React component, call `useGetVideoCommentingProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVideoCommentingProviderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVideoCommentingProviderQuery({
 *   variables: {
 *      albumId: // value for 'albumId'
 *      cursor: // value for 'cursor'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetVideoCommentingProviderQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetVideoCommentingProviderQuery, GetVideoCommentingProviderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetVideoCommentingProviderQuery, GetVideoCommentingProviderQueryVariables>(GetVideoCommentingProviderDocument, options);
      }
export function useGetVideoCommentingProviderLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetVideoCommentingProviderQuery, GetVideoCommentingProviderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetVideoCommentingProviderQuery, GetVideoCommentingProviderQueryVariables>(GetVideoCommentingProviderDocument, options);
        }
export function useGetVideoCommentingProviderSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetVideoCommentingProviderQuery, GetVideoCommentingProviderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetVideoCommentingProviderQuery, GetVideoCommentingProviderQueryVariables>(GetVideoCommentingProviderDocument, options);
        }
export type GetVideoCommentingProviderQueryHookResult = ReturnType<typeof useGetVideoCommentingProviderQuery>;
export type GetVideoCommentingProviderLazyQueryHookResult = ReturnType<typeof useGetVideoCommentingProviderLazyQuery>;
export type GetVideoCommentingProviderSuspenseQueryHookResult = ReturnType<typeof useGetVideoCommentingProviderSuspenseQuery>;
export type GetVideoCommentingProviderQueryResult = Apollo.QueryResult<GetVideoCommentingProviderQuery, GetVideoCommentingProviderQueryVariables>;
export const CreateReplyCommentDocument = gql`
    mutation CreateReplyComment($commentId: Int!, $text: String!) {
  media {
    replyToComment(commentId: $commentId, text: $text) {
      ...MediaComment
    }
  }
}
    ${MediaCommentFragmentDoc}`;
export type CreateReplyCommentMutationFn = Apollo.MutationFunction<CreateReplyCommentMutation, CreateReplyCommentMutationVariables>;

/**
 * __useCreateReplyCommentMutation__
 *
 * To run a mutation, you first call `useCreateReplyCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReplyCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReplyCommentMutation, { data, loading, error }] = useCreateReplyCommentMutation({
 *   variables: {
 *      commentId: // value for 'commentId'
 *      text: // value for 'text'
 *   },
 * });
 */
export function useCreateReplyCommentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateReplyCommentMutation, CreateReplyCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateReplyCommentMutation, CreateReplyCommentMutationVariables>(CreateReplyCommentDocument, options);
      }
export type CreateReplyCommentMutationHookResult = ReturnType<typeof useCreateReplyCommentMutation>;
export type CreateReplyCommentMutationResult = Apollo.MutationResult<CreateReplyCommentMutation>;
export type CreateReplyCommentMutationOptions = Apollo.BaseMutationOptions<CreateReplyCommentMutation, CreateReplyCommentMutationVariables>;
export const GetPhotoCommentingProviderDocument = gql`
    query GetPhotoCommentingProvider($albumId: Int!, $cursor: String, $first: Int!) {
  media {
    comments(albumId: $albumId, after: $cursor, first: $first) {
      totalCount
      pageInfo {
        hasNextPage
      }
      edges {
        cursor
        node {
          ...MediaComment
        }
      }
    }
  }
}
    ${MediaCommentFragmentDoc}`;

/**
 * __useGetPhotoCommentingProviderQuery__
 *
 * To run a query within a React component, call `useGetPhotoCommentingProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPhotoCommentingProviderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPhotoCommentingProviderQuery({
 *   variables: {
 *      albumId: // value for 'albumId'
 *      cursor: // value for 'cursor'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetPhotoCommentingProviderQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetPhotoCommentingProviderQuery, GetPhotoCommentingProviderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPhotoCommentingProviderQuery, GetPhotoCommentingProviderQueryVariables>(GetPhotoCommentingProviderDocument, options);
      }
export function useGetPhotoCommentingProviderLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPhotoCommentingProviderQuery, GetPhotoCommentingProviderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPhotoCommentingProviderQuery, GetPhotoCommentingProviderQueryVariables>(GetPhotoCommentingProviderDocument, options);
        }
export function useGetPhotoCommentingProviderSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetPhotoCommentingProviderQuery, GetPhotoCommentingProviderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetPhotoCommentingProviderQuery, GetPhotoCommentingProviderQueryVariables>(GetPhotoCommentingProviderDocument, options);
        }
export type GetPhotoCommentingProviderQueryHookResult = ReturnType<typeof useGetPhotoCommentingProviderQuery>;
export type GetPhotoCommentingProviderLazyQueryHookResult = ReturnType<typeof useGetPhotoCommentingProviderLazyQuery>;
export type GetPhotoCommentingProviderSuspenseQueryHookResult = ReturnType<typeof useGetPhotoCommentingProviderSuspenseQuery>;
export type GetPhotoCommentingProviderQueryResult = Apollo.QueryResult<GetPhotoCommentingProviderQuery, GetPhotoCommentingProviderQueryVariables>;
export const VideoLibraryUploadListEntryDocument = gql`
    mutation VideoLibraryUploadListEntry($data: InputVideo!) {
  media {
    video {
      saveVideo(data: $data) {
        ...Video
      }
    }
  }
}
    ${VideoFragmentDoc}`;
export type VideoLibraryUploadListEntryMutationFn = Apollo.MutationFunction<VideoLibraryUploadListEntryMutation, VideoLibraryUploadListEntryMutationVariables>;

/**
 * __useVideoLibraryUploadListEntryMutation__
 *
 * To run a mutation, you first call `useVideoLibraryUploadListEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVideoLibraryUploadListEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [videoLibraryUploadListEntryMutation, { data, loading, error }] = useVideoLibraryUploadListEntryMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useVideoLibraryUploadListEntryMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<VideoLibraryUploadListEntryMutation, VideoLibraryUploadListEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<VideoLibraryUploadListEntryMutation, VideoLibraryUploadListEntryMutationVariables>(VideoLibraryUploadListEntryDocument, options);
      }
export type VideoLibraryUploadListEntryMutationHookResult = ReturnType<typeof useVideoLibraryUploadListEntryMutation>;
export type VideoLibraryUploadListEntryMutationResult = Apollo.MutationResult<VideoLibraryUploadListEntryMutation>;
export type VideoLibraryUploadListEntryMutationOptions = Apollo.BaseMutationOptions<VideoLibraryUploadListEntryMutation, VideoLibraryUploadListEntryMutationVariables>;
export const GetVideoLibraryVideoUploadListEntryDocument = gql`
    query GetVideoLibraryVideoUploadListEntry($albumId: Int) {
  media {
    videos {
      videoById(albumId: $albumId) {
        ...Video
      }
    }
  }
}
    ${VideoFragmentDoc}`;

/**
 * __useGetVideoLibraryVideoUploadListEntryQuery__
 *
 * To run a query within a React component, call `useGetVideoLibraryVideoUploadListEntryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVideoLibraryVideoUploadListEntryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVideoLibraryVideoUploadListEntryQuery({
 *   variables: {
 *      albumId: // value for 'albumId'
 *   },
 * });
 */
export function useGetVideoLibraryVideoUploadListEntryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetVideoLibraryVideoUploadListEntryQuery, GetVideoLibraryVideoUploadListEntryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetVideoLibraryVideoUploadListEntryQuery, GetVideoLibraryVideoUploadListEntryQueryVariables>(GetVideoLibraryVideoUploadListEntryDocument, options);
      }
export function useGetVideoLibraryVideoUploadListEntryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetVideoLibraryVideoUploadListEntryQuery, GetVideoLibraryVideoUploadListEntryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetVideoLibraryVideoUploadListEntryQuery, GetVideoLibraryVideoUploadListEntryQueryVariables>(GetVideoLibraryVideoUploadListEntryDocument, options);
        }
export function useGetVideoLibraryVideoUploadListEntrySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetVideoLibraryVideoUploadListEntryQuery, GetVideoLibraryVideoUploadListEntryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetVideoLibraryVideoUploadListEntryQuery, GetVideoLibraryVideoUploadListEntryQueryVariables>(GetVideoLibraryVideoUploadListEntryDocument, options);
        }
export type GetVideoLibraryVideoUploadListEntryQueryHookResult = ReturnType<typeof useGetVideoLibraryVideoUploadListEntryQuery>;
export type GetVideoLibraryVideoUploadListEntryLazyQueryHookResult = ReturnType<typeof useGetVideoLibraryVideoUploadListEntryLazyQuery>;
export type GetVideoLibraryVideoUploadListEntrySuspenseQueryHookResult = ReturnType<typeof useGetVideoLibraryVideoUploadListEntrySuspenseQuery>;
export type GetVideoLibraryVideoUploadListEntryQueryResult = Apollo.QueryResult<GetVideoLibraryVideoUploadListEntryQuery, GetVideoLibraryVideoUploadListEntryQueryVariables>;
export const GetVideoLibraryUploadListEntryPreviewPicturesDocument = gql`
    query GetVideoLibraryUploadListEntryPreviewPictures($albumId: Int) {
  media {
    videos {
      videoById(albumId: $albumId) {
        pictures {
          ...MediaPicture
        }
      }
    }
  }
}
    ${MediaPictureFragmentDoc}`;

/**
 * __useGetVideoLibraryUploadListEntryPreviewPicturesQuery__
 *
 * To run a query within a React component, call `useGetVideoLibraryUploadListEntryPreviewPicturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVideoLibraryUploadListEntryPreviewPicturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVideoLibraryUploadListEntryPreviewPicturesQuery({
 *   variables: {
 *      albumId: // value for 'albumId'
 *   },
 * });
 */
export function useGetVideoLibraryUploadListEntryPreviewPicturesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetVideoLibraryUploadListEntryPreviewPicturesQuery, GetVideoLibraryUploadListEntryPreviewPicturesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetVideoLibraryUploadListEntryPreviewPicturesQuery, GetVideoLibraryUploadListEntryPreviewPicturesQueryVariables>(GetVideoLibraryUploadListEntryPreviewPicturesDocument, options);
      }
export function useGetVideoLibraryUploadListEntryPreviewPicturesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetVideoLibraryUploadListEntryPreviewPicturesQuery, GetVideoLibraryUploadListEntryPreviewPicturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetVideoLibraryUploadListEntryPreviewPicturesQuery, GetVideoLibraryUploadListEntryPreviewPicturesQueryVariables>(GetVideoLibraryUploadListEntryPreviewPicturesDocument, options);
        }
export function useGetVideoLibraryUploadListEntryPreviewPicturesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetVideoLibraryUploadListEntryPreviewPicturesQuery, GetVideoLibraryUploadListEntryPreviewPicturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetVideoLibraryUploadListEntryPreviewPicturesQuery, GetVideoLibraryUploadListEntryPreviewPicturesQueryVariables>(GetVideoLibraryUploadListEntryPreviewPicturesDocument, options);
        }
export type GetVideoLibraryUploadListEntryPreviewPicturesQueryHookResult = ReturnType<typeof useGetVideoLibraryUploadListEntryPreviewPicturesQuery>;
export type GetVideoLibraryUploadListEntryPreviewPicturesLazyQueryHookResult = ReturnType<typeof useGetVideoLibraryUploadListEntryPreviewPicturesLazyQuery>;
export type GetVideoLibraryUploadListEntryPreviewPicturesSuspenseQueryHookResult = ReturnType<typeof useGetVideoLibraryUploadListEntryPreviewPicturesSuspenseQuery>;
export type GetVideoLibraryUploadListEntryPreviewPicturesQueryResult = Apollo.QueryResult<GetVideoLibraryUploadListEntryPreviewPicturesQuery, GetVideoLibraryUploadListEntryPreviewPicturesQueryVariables>;
export const GetVideoLibraryPreviewPictureUploadUrlDocument = gql`
    query GetVideoLibraryPreviewPictureUploadUrl($albumId: Int!) {
  media {
    videos {
      pictureUploadUrl(albumId: $albumId)
    }
  }
}
    `;

/**
 * __useGetVideoLibraryPreviewPictureUploadUrlQuery__
 *
 * To run a query within a React component, call `useGetVideoLibraryPreviewPictureUploadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVideoLibraryPreviewPictureUploadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVideoLibraryPreviewPictureUploadUrlQuery({
 *   variables: {
 *      albumId: // value for 'albumId'
 *   },
 * });
 */
export function useGetVideoLibraryPreviewPictureUploadUrlQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetVideoLibraryPreviewPictureUploadUrlQuery, GetVideoLibraryPreviewPictureUploadUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetVideoLibraryPreviewPictureUploadUrlQuery, GetVideoLibraryPreviewPictureUploadUrlQueryVariables>(GetVideoLibraryPreviewPictureUploadUrlDocument, options);
      }
export function useGetVideoLibraryPreviewPictureUploadUrlLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetVideoLibraryPreviewPictureUploadUrlQuery, GetVideoLibraryPreviewPictureUploadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetVideoLibraryPreviewPictureUploadUrlQuery, GetVideoLibraryPreviewPictureUploadUrlQueryVariables>(GetVideoLibraryPreviewPictureUploadUrlDocument, options);
        }
export function useGetVideoLibraryPreviewPictureUploadUrlSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetVideoLibraryPreviewPictureUploadUrlQuery, GetVideoLibraryPreviewPictureUploadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetVideoLibraryPreviewPictureUploadUrlQuery, GetVideoLibraryPreviewPictureUploadUrlQueryVariables>(GetVideoLibraryPreviewPictureUploadUrlDocument, options);
        }
export type GetVideoLibraryPreviewPictureUploadUrlQueryHookResult = ReturnType<typeof useGetVideoLibraryPreviewPictureUploadUrlQuery>;
export type GetVideoLibraryPreviewPictureUploadUrlLazyQueryHookResult = ReturnType<typeof useGetVideoLibraryPreviewPictureUploadUrlLazyQuery>;
export type GetVideoLibraryPreviewPictureUploadUrlSuspenseQueryHookResult = ReturnType<typeof useGetVideoLibraryPreviewPictureUploadUrlSuspenseQuery>;
export type GetVideoLibraryPreviewPictureUploadUrlQueryResult = Apollo.QueryResult<GetVideoLibraryPreviewPictureUploadUrlQuery, GetVideoLibraryPreviewPictureUploadUrlQueryVariables>;
export const GetVideoByRequestIdDocument = gql`
    query GetVideoByRequestId($requestId: String) {
  media {
    videos {
      videoById(uploadRequestId: $requestId) {
        ...Video
      }
    }
  }
}
    ${VideoFragmentDoc}`;

/**
 * __useGetVideoByRequestIdQuery__
 *
 * To run a query within a React component, call `useGetVideoByRequestIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVideoByRequestIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVideoByRequestIdQuery({
 *   variables: {
 *      requestId: // value for 'requestId'
 *   },
 * });
 */
export function useGetVideoByRequestIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetVideoByRequestIdQuery, GetVideoByRequestIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetVideoByRequestIdQuery, GetVideoByRequestIdQueryVariables>(GetVideoByRequestIdDocument, options);
      }
export function useGetVideoByRequestIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetVideoByRequestIdQuery, GetVideoByRequestIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetVideoByRequestIdQuery, GetVideoByRequestIdQueryVariables>(GetVideoByRequestIdDocument, options);
        }
export function useGetVideoByRequestIdSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetVideoByRequestIdQuery, GetVideoByRequestIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetVideoByRequestIdQuery, GetVideoByRequestIdQueryVariables>(GetVideoByRequestIdDocument, options);
        }
export type GetVideoByRequestIdQueryHookResult = ReturnType<typeof useGetVideoByRequestIdQuery>;
export type GetVideoByRequestIdLazyQueryHookResult = ReturnType<typeof useGetVideoByRequestIdLazyQuery>;
export type GetVideoByRequestIdSuspenseQueryHookResult = ReturnType<typeof useGetVideoByRequestIdSuspenseQuery>;
export type GetVideoByRequestIdQueryResult = Apollo.QueryResult<GetVideoByRequestIdQuery, GetVideoByRequestIdQueryVariables>;
export const GetVideoLibraryPhotoUploadListEntryDocument = gql`
    query GetVideoLibraryPhotoUploadListEntry($albumId: Int!) {
  media {
    photoalbums {
      photoalbum(albumId: $albumId) {
        ...Photoalbum
      }
    }
  }
}
    ${PhotoalbumFragmentDoc}`;

/**
 * __useGetVideoLibraryPhotoUploadListEntryQuery__
 *
 * To run a query within a React component, call `useGetVideoLibraryPhotoUploadListEntryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVideoLibraryPhotoUploadListEntryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVideoLibraryPhotoUploadListEntryQuery({
 *   variables: {
 *      albumId: // value for 'albumId'
 *   },
 * });
 */
export function useGetVideoLibraryPhotoUploadListEntryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetVideoLibraryPhotoUploadListEntryQuery, GetVideoLibraryPhotoUploadListEntryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetVideoLibraryPhotoUploadListEntryQuery, GetVideoLibraryPhotoUploadListEntryQueryVariables>(GetVideoLibraryPhotoUploadListEntryDocument, options);
      }
export function useGetVideoLibraryPhotoUploadListEntryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetVideoLibraryPhotoUploadListEntryQuery, GetVideoLibraryPhotoUploadListEntryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetVideoLibraryPhotoUploadListEntryQuery, GetVideoLibraryPhotoUploadListEntryQueryVariables>(GetVideoLibraryPhotoUploadListEntryDocument, options);
        }
export function useGetVideoLibraryPhotoUploadListEntrySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetVideoLibraryPhotoUploadListEntryQuery, GetVideoLibraryPhotoUploadListEntryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetVideoLibraryPhotoUploadListEntryQuery, GetVideoLibraryPhotoUploadListEntryQueryVariables>(GetVideoLibraryPhotoUploadListEntryDocument, options);
        }
export type GetVideoLibraryPhotoUploadListEntryQueryHookResult = ReturnType<typeof useGetVideoLibraryPhotoUploadListEntryQuery>;
export type GetVideoLibraryPhotoUploadListEntryLazyQueryHookResult = ReturnType<typeof useGetVideoLibraryPhotoUploadListEntryLazyQuery>;
export type GetVideoLibraryPhotoUploadListEntrySuspenseQueryHookResult = ReturnType<typeof useGetVideoLibraryPhotoUploadListEntrySuspenseQuery>;
export type GetVideoLibraryPhotoUploadListEntryQueryResult = Apollo.QueryResult<GetVideoLibraryPhotoUploadListEntryQuery, GetVideoLibraryPhotoUploadListEntryQueryVariables>;
export const GetPhotoLibraryUploadListEntryDocument = gql`
    query GetPhotoLibraryUploadListEntry($albumId: Int!, $after: String, $first: Int!) {
  media {
    photoalbums {
      pictureList(albumId: $albumId, after: $after, first: $first) {
        ...PictureList
      }
    }
  }
}
    ${PictureListFragmentDoc}`;

/**
 * __useGetPhotoLibraryUploadListEntryQuery__
 *
 * To run a query within a React component, call `useGetPhotoLibraryUploadListEntryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPhotoLibraryUploadListEntryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPhotoLibraryUploadListEntryQuery({
 *   variables: {
 *      albumId: // value for 'albumId'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetPhotoLibraryUploadListEntryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetPhotoLibraryUploadListEntryQuery, GetPhotoLibraryUploadListEntryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPhotoLibraryUploadListEntryQuery, GetPhotoLibraryUploadListEntryQueryVariables>(GetPhotoLibraryUploadListEntryDocument, options);
      }
export function useGetPhotoLibraryUploadListEntryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPhotoLibraryUploadListEntryQuery, GetPhotoLibraryUploadListEntryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPhotoLibraryUploadListEntryQuery, GetPhotoLibraryUploadListEntryQueryVariables>(GetPhotoLibraryUploadListEntryDocument, options);
        }
export function useGetPhotoLibraryUploadListEntrySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetPhotoLibraryUploadListEntryQuery, GetPhotoLibraryUploadListEntryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetPhotoLibraryUploadListEntryQuery, GetPhotoLibraryUploadListEntryQueryVariables>(GetPhotoLibraryUploadListEntryDocument, options);
        }
export type GetPhotoLibraryUploadListEntryQueryHookResult = ReturnType<typeof useGetPhotoLibraryUploadListEntryQuery>;
export type GetPhotoLibraryUploadListEntryLazyQueryHookResult = ReturnType<typeof useGetPhotoLibraryUploadListEntryLazyQuery>;
export type GetPhotoLibraryUploadListEntrySuspenseQueryHookResult = ReturnType<typeof useGetPhotoLibraryUploadListEntrySuspenseQuery>;
export type GetPhotoLibraryUploadListEntryQueryResult = Apollo.QueryResult<GetPhotoLibraryUploadListEntryQuery, GetPhotoLibraryUploadListEntryQueryVariables>;
export const GetPhotoLibraryUploadListEntryDetailsDocument = gql`
    query GetPhotoLibraryUploadListEntryDetails($albumId: Int!) {
  media {
    photoalbums {
      photoalbum(albumId: $albumId) {
        ...Photoalbum
      }
    }
  }
}
    ${PhotoalbumFragmentDoc}`;

/**
 * __useGetPhotoLibraryUploadListEntryDetailsQuery__
 *
 * To run a query within a React component, call `useGetPhotoLibraryUploadListEntryDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPhotoLibraryUploadListEntryDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPhotoLibraryUploadListEntryDetailsQuery({
 *   variables: {
 *      albumId: // value for 'albumId'
 *   },
 * });
 */
export function useGetPhotoLibraryUploadListEntryDetailsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetPhotoLibraryUploadListEntryDetailsQuery, GetPhotoLibraryUploadListEntryDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPhotoLibraryUploadListEntryDetailsQuery, GetPhotoLibraryUploadListEntryDetailsQueryVariables>(GetPhotoLibraryUploadListEntryDetailsDocument, options);
      }
export function useGetPhotoLibraryUploadListEntryDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPhotoLibraryUploadListEntryDetailsQuery, GetPhotoLibraryUploadListEntryDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPhotoLibraryUploadListEntryDetailsQuery, GetPhotoLibraryUploadListEntryDetailsQueryVariables>(GetPhotoLibraryUploadListEntryDetailsDocument, options);
        }
export function useGetPhotoLibraryUploadListEntryDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetPhotoLibraryUploadListEntryDetailsQuery, GetPhotoLibraryUploadListEntryDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetPhotoLibraryUploadListEntryDetailsQuery, GetPhotoLibraryUploadListEntryDetailsQueryVariables>(GetPhotoLibraryUploadListEntryDetailsDocument, options);
        }
export type GetPhotoLibraryUploadListEntryDetailsQueryHookResult = ReturnType<typeof useGetPhotoLibraryUploadListEntryDetailsQuery>;
export type GetPhotoLibraryUploadListEntryDetailsLazyQueryHookResult = ReturnType<typeof useGetPhotoLibraryUploadListEntryDetailsLazyQuery>;
export type GetPhotoLibraryUploadListEntryDetailsSuspenseQueryHookResult = ReturnType<typeof useGetPhotoLibraryUploadListEntryDetailsSuspenseQuery>;
export type GetPhotoLibraryUploadListEntryDetailsQueryResult = Apollo.QueryResult<GetPhotoLibraryUploadListEntryDetailsQuery, GetPhotoLibraryUploadListEntryDetailsQueryVariables>;
export const VideoLibraryDeletePhotoDocument = gql`
    mutation VideoLibraryDeletePhoto($albumId: Int!, $pictureId: Int!) {
  media {
    photoalbum {
      deletePicture(albumId: $albumId, pictureId: $pictureId)
    }
  }
}
    `;
export type VideoLibraryDeletePhotoMutationFn = Apollo.MutationFunction<VideoLibraryDeletePhotoMutation, VideoLibraryDeletePhotoMutationVariables>;

/**
 * __useVideoLibraryDeletePhotoMutation__
 *
 * To run a mutation, you first call `useVideoLibraryDeletePhotoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVideoLibraryDeletePhotoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [videoLibraryDeletePhotoMutation, { data, loading, error }] = useVideoLibraryDeletePhotoMutation({
 *   variables: {
 *      albumId: // value for 'albumId'
 *      pictureId: // value for 'pictureId'
 *   },
 * });
 */
export function useVideoLibraryDeletePhotoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<VideoLibraryDeletePhotoMutation, VideoLibraryDeletePhotoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<VideoLibraryDeletePhotoMutation, VideoLibraryDeletePhotoMutationVariables>(VideoLibraryDeletePhotoDocument, options);
      }
export type VideoLibraryDeletePhotoMutationHookResult = ReturnType<typeof useVideoLibraryDeletePhotoMutation>;
export type VideoLibraryDeletePhotoMutationResult = Apollo.MutationResult<VideoLibraryDeletePhotoMutation>;
export type VideoLibraryDeletePhotoMutationOptions = Apollo.BaseMutationOptions<VideoLibraryDeletePhotoMutation, VideoLibraryDeletePhotoMutationVariables>;
export const VideoLibraryUpdatePhotoAlbumStatusDocument = gql`
    mutation VideoLibraryUpdatePhotoAlbumStatus($albumId: Int!, $status: PhotoalbumReleasedStatusEnum!) {
  media {
    photoalbum {
      updateReleasedStatus(albumId: $albumId, status: $status) {
        albumId
        type
        price
        releasedStatus
      }
    }
  }
}
    `;
export type VideoLibraryUpdatePhotoAlbumStatusMutationFn = Apollo.MutationFunction<VideoLibraryUpdatePhotoAlbumStatusMutation, VideoLibraryUpdatePhotoAlbumStatusMutationVariables>;

/**
 * __useVideoLibraryUpdatePhotoAlbumStatusMutation__
 *
 * To run a mutation, you first call `useVideoLibraryUpdatePhotoAlbumStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVideoLibraryUpdatePhotoAlbumStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [videoLibraryUpdatePhotoAlbumStatusMutation, { data, loading, error }] = useVideoLibraryUpdatePhotoAlbumStatusMutation({
 *   variables: {
 *      albumId: // value for 'albumId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useVideoLibraryUpdatePhotoAlbumStatusMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<VideoLibraryUpdatePhotoAlbumStatusMutation, VideoLibraryUpdatePhotoAlbumStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<VideoLibraryUpdatePhotoAlbumStatusMutation, VideoLibraryUpdatePhotoAlbumStatusMutationVariables>(VideoLibraryUpdatePhotoAlbumStatusDocument, options);
      }
export type VideoLibraryUpdatePhotoAlbumStatusMutationHookResult = ReturnType<typeof useVideoLibraryUpdatePhotoAlbumStatusMutation>;
export type VideoLibraryUpdatePhotoAlbumStatusMutationResult = Apollo.MutationResult<VideoLibraryUpdatePhotoAlbumStatusMutation>;
export type VideoLibraryUpdatePhotoAlbumStatusMutationOptions = Apollo.BaseMutationOptions<VideoLibraryUpdatePhotoAlbumStatusMutation, VideoLibraryUpdatePhotoAlbumStatusMutationVariables>;
export const GetVideoLibraryPhotoUploadListDocument = gql`
    query GetVideoLibraryPhotoUploadList($count: Int!, $cursor: String!, $mediaTypes: [PhotoalbumTypeEnum], $status: [PhotoalbumStatusEnum]) {
  media {
    photoalbums {
      photoalbumList(
        mediaTypes: $mediaTypes
        status: $status
        first: $count
        after: $cursor
      ) {
        pageInfo {
          hasNextPage
        }
        edges {
          cursor
          node {
            ...Photoalbum
          }
        }
        totalCount
      }
    }
  }
}
    ${PhotoalbumFragmentDoc}`;

/**
 * __useGetVideoLibraryPhotoUploadListQuery__
 *
 * To run a query within a React component, call `useGetVideoLibraryPhotoUploadListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVideoLibraryPhotoUploadListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVideoLibraryPhotoUploadListQuery({
 *   variables: {
 *      count: // value for 'count'
 *      cursor: // value for 'cursor'
 *      mediaTypes: // value for 'mediaTypes'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetVideoLibraryPhotoUploadListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetVideoLibraryPhotoUploadListQuery, GetVideoLibraryPhotoUploadListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetVideoLibraryPhotoUploadListQuery, GetVideoLibraryPhotoUploadListQueryVariables>(GetVideoLibraryPhotoUploadListDocument, options);
      }
export function useGetVideoLibraryPhotoUploadListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetVideoLibraryPhotoUploadListQuery, GetVideoLibraryPhotoUploadListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetVideoLibraryPhotoUploadListQuery, GetVideoLibraryPhotoUploadListQueryVariables>(GetVideoLibraryPhotoUploadListDocument, options);
        }
export function useGetVideoLibraryPhotoUploadListSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetVideoLibraryPhotoUploadListQuery, GetVideoLibraryPhotoUploadListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetVideoLibraryPhotoUploadListQuery, GetVideoLibraryPhotoUploadListQueryVariables>(GetVideoLibraryPhotoUploadListDocument, options);
        }
export type GetVideoLibraryPhotoUploadListQueryHookResult = ReturnType<typeof useGetVideoLibraryPhotoUploadListQuery>;
export type GetVideoLibraryPhotoUploadListLazyQueryHookResult = ReturnType<typeof useGetVideoLibraryPhotoUploadListLazyQuery>;
export type GetVideoLibraryPhotoUploadListSuspenseQueryHookResult = ReturnType<typeof useGetVideoLibraryPhotoUploadListSuspenseQuery>;
export type GetVideoLibraryPhotoUploadListQueryResult = Apollo.QueryResult<GetVideoLibraryPhotoUploadListQuery, GetVideoLibraryPhotoUploadListQueryVariables>;
export const GetVideoLibraryUploadListEntryLikesDocument = gql`
    query GetVideoLibraryUploadListEntryLikes($albumId: Int!, $count: Int!, $after: String) {
  media {
    likes(albumId: $albumId, first: $count, after: $after) {
      pageInfo {
        hasNextPage
      }
      edges {
        cursor
        node {
          ...MediaLike
        }
      }
    }
  }
}
    ${MediaLikeFragmentDoc}`;

/**
 * __useGetVideoLibraryUploadListEntryLikesQuery__
 *
 * To run a query within a React component, call `useGetVideoLibraryUploadListEntryLikesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVideoLibraryUploadListEntryLikesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVideoLibraryUploadListEntryLikesQuery({
 *   variables: {
 *      albumId: // value for 'albumId'
 *      count: // value for 'count'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetVideoLibraryUploadListEntryLikesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetVideoLibraryUploadListEntryLikesQuery, GetVideoLibraryUploadListEntryLikesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetVideoLibraryUploadListEntryLikesQuery, GetVideoLibraryUploadListEntryLikesQueryVariables>(GetVideoLibraryUploadListEntryLikesDocument, options);
      }
export function useGetVideoLibraryUploadListEntryLikesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetVideoLibraryUploadListEntryLikesQuery, GetVideoLibraryUploadListEntryLikesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetVideoLibraryUploadListEntryLikesQuery, GetVideoLibraryUploadListEntryLikesQueryVariables>(GetVideoLibraryUploadListEntryLikesDocument, options);
        }
export function useGetVideoLibraryUploadListEntryLikesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetVideoLibraryUploadListEntryLikesQuery, GetVideoLibraryUploadListEntryLikesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetVideoLibraryUploadListEntryLikesQuery, GetVideoLibraryUploadListEntryLikesQueryVariables>(GetVideoLibraryUploadListEntryLikesDocument, options);
        }
export type GetVideoLibraryUploadListEntryLikesQueryHookResult = ReturnType<typeof useGetVideoLibraryUploadListEntryLikesQuery>;
export type GetVideoLibraryUploadListEntryLikesLazyQueryHookResult = ReturnType<typeof useGetVideoLibraryUploadListEntryLikesLazyQuery>;
export type GetVideoLibraryUploadListEntryLikesSuspenseQueryHookResult = ReturnType<typeof useGetVideoLibraryUploadListEntryLikesSuspenseQuery>;
export type GetVideoLibraryUploadListEntryLikesQueryResult = Apollo.QueryResult<GetVideoLibraryUploadListEntryLikesQuery, GetVideoLibraryUploadListEntryLikesQueryVariables>;
export const GetVideoLibraryUploadListEntrySalesDocument = gql`
    query GetVideoLibraryUploadListEntrySales($albumId: Int!, $count: Int!, $after: String) {
  media {
    sales(albumId: $albumId, first: $count, after: $after) {
      pageInfo {
        hasNextPage
      }
      edges {
        cursor
        node {
          ...MediaSale
        }
      }
    }
  }
}
    ${MediaSaleFragmentDoc}`;

/**
 * __useGetVideoLibraryUploadListEntrySalesQuery__
 *
 * To run a query within a React component, call `useGetVideoLibraryUploadListEntrySalesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVideoLibraryUploadListEntrySalesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVideoLibraryUploadListEntrySalesQuery({
 *   variables: {
 *      albumId: // value for 'albumId'
 *      count: // value for 'count'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetVideoLibraryUploadListEntrySalesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetVideoLibraryUploadListEntrySalesQuery, GetVideoLibraryUploadListEntrySalesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetVideoLibraryUploadListEntrySalesQuery, GetVideoLibraryUploadListEntrySalesQueryVariables>(GetVideoLibraryUploadListEntrySalesDocument, options);
      }
export function useGetVideoLibraryUploadListEntrySalesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetVideoLibraryUploadListEntrySalesQuery, GetVideoLibraryUploadListEntrySalesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetVideoLibraryUploadListEntrySalesQuery, GetVideoLibraryUploadListEntrySalesQueryVariables>(GetVideoLibraryUploadListEntrySalesDocument, options);
        }
export function useGetVideoLibraryUploadListEntrySalesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetVideoLibraryUploadListEntrySalesQuery, GetVideoLibraryUploadListEntrySalesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetVideoLibraryUploadListEntrySalesQuery, GetVideoLibraryUploadListEntrySalesQueryVariables>(GetVideoLibraryUploadListEntrySalesDocument, options);
        }
export type GetVideoLibraryUploadListEntrySalesQueryHookResult = ReturnType<typeof useGetVideoLibraryUploadListEntrySalesQuery>;
export type GetVideoLibraryUploadListEntrySalesLazyQueryHookResult = ReturnType<typeof useGetVideoLibraryUploadListEntrySalesLazyQuery>;
export type GetVideoLibraryUploadListEntrySalesSuspenseQueryHookResult = ReturnType<typeof useGetVideoLibraryUploadListEntrySalesSuspenseQuery>;
export type GetVideoLibraryUploadListEntrySalesQueryResult = Apollo.QueryResult<GetVideoLibraryUploadListEntrySalesQuery, GetVideoLibraryUploadListEntrySalesQueryVariables>;
export const GetVideoLibraryTusUploadDataDocument = gql`
    query GetVideoLibraryTusUploadData($type: VideoTypeEnum, $albumId: Int) {
  media {
    videos {
      tusUploadData(type: $type, albumId: $albumId) {
        url
        metaData
      }
    }
  }
}
    `;

/**
 * __useGetVideoLibraryTusUploadDataQuery__
 *
 * To run a query within a React component, call `useGetVideoLibraryTusUploadDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVideoLibraryTusUploadDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVideoLibraryTusUploadDataQuery({
 *   variables: {
 *      type: // value for 'type'
 *      albumId: // value for 'albumId'
 *   },
 * });
 */
export function useGetVideoLibraryTusUploadDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetVideoLibraryTusUploadDataQuery, GetVideoLibraryTusUploadDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetVideoLibraryTusUploadDataQuery, GetVideoLibraryTusUploadDataQueryVariables>(GetVideoLibraryTusUploadDataDocument, options);
      }
export function useGetVideoLibraryTusUploadDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetVideoLibraryTusUploadDataQuery, GetVideoLibraryTusUploadDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetVideoLibraryTusUploadDataQuery, GetVideoLibraryTusUploadDataQueryVariables>(GetVideoLibraryTusUploadDataDocument, options);
        }
export function useGetVideoLibraryTusUploadDataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetVideoLibraryTusUploadDataQuery, GetVideoLibraryTusUploadDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetVideoLibraryTusUploadDataQuery, GetVideoLibraryTusUploadDataQueryVariables>(GetVideoLibraryTusUploadDataDocument, options);
        }
export type GetVideoLibraryTusUploadDataQueryHookResult = ReturnType<typeof useGetVideoLibraryTusUploadDataQuery>;
export type GetVideoLibraryTusUploadDataLazyQueryHookResult = ReturnType<typeof useGetVideoLibraryTusUploadDataLazyQuery>;
export type GetVideoLibraryTusUploadDataSuspenseQueryHookResult = ReturnType<typeof useGetVideoLibraryTusUploadDataSuspenseQuery>;
export type GetVideoLibraryTusUploadDataQueryResult = Apollo.QueryResult<GetVideoLibraryTusUploadDataQuery, GetVideoLibraryTusUploadDataQueryVariables>;
export const GetVideoLibraryVideoUploadListDocument = gql`
    query GetVideoLibraryVideoUploadList($count: Int!, $cursor: String!, $types: [VideoTypeEnum], $status: [VideoStatusEnum], $group: VideoGroupEnum) {
  media {
    videos {
      videosList(
        types: $types
        status: $status
        first: $count
        after: $cursor
        group: $group
      ) {
        pageInfo {
          hasNextPage
        }
        edges {
          cursor
          node {
            ...Video
          }
        }
        totalCount
      }
    }
  }
}
    ${VideoFragmentDoc}`;

/**
 * __useGetVideoLibraryVideoUploadListQuery__
 *
 * To run a query within a React component, call `useGetVideoLibraryVideoUploadListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVideoLibraryVideoUploadListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVideoLibraryVideoUploadListQuery({
 *   variables: {
 *      count: // value for 'count'
 *      cursor: // value for 'cursor'
 *      types: // value for 'types'
 *      status: // value for 'status'
 *      group: // value for 'group'
 *   },
 * });
 */
export function useGetVideoLibraryVideoUploadListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetVideoLibraryVideoUploadListQuery, GetVideoLibraryVideoUploadListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetVideoLibraryVideoUploadListQuery, GetVideoLibraryVideoUploadListQueryVariables>(GetVideoLibraryVideoUploadListDocument, options);
      }
export function useGetVideoLibraryVideoUploadListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetVideoLibraryVideoUploadListQuery, GetVideoLibraryVideoUploadListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetVideoLibraryVideoUploadListQuery, GetVideoLibraryVideoUploadListQueryVariables>(GetVideoLibraryVideoUploadListDocument, options);
        }
export function useGetVideoLibraryVideoUploadListSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetVideoLibraryVideoUploadListQuery, GetVideoLibraryVideoUploadListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetVideoLibraryVideoUploadListQuery, GetVideoLibraryVideoUploadListQueryVariables>(GetVideoLibraryVideoUploadListDocument, options);
        }
export type GetVideoLibraryVideoUploadListQueryHookResult = ReturnType<typeof useGetVideoLibraryVideoUploadListQuery>;
export type GetVideoLibraryVideoUploadListLazyQueryHookResult = ReturnType<typeof useGetVideoLibraryVideoUploadListLazyQuery>;
export type GetVideoLibraryVideoUploadListSuspenseQueryHookResult = ReturnType<typeof useGetVideoLibraryVideoUploadListSuspenseQuery>;
export type GetVideoLibraryVideoUploadListQueryResult = Apollo.QueryResult<GetVideoLibraryVideoUploadListQuery, GetVideoLibraryVideoUploadListQueryVariables>;
export const GetVideoLibraryTranscodingCountDocument = gql`
    query GetVideoLibraryTranscodingCount($count: Int!, $types: [VideoTypeEnum], $status: [VideoStatusEnum]) {
  media {
    videos {
      videosList(types: $types, status: $status, first: $count) {
        totalCount
      }
    }
  }
}
    `;

/**
 * __useGetVideoLibraryTranscodingCountQuery__
 *
 * To run a query within a React component, call `useGetVideoLibraryTranscodingCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVideoLibraryTranscodingCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVideoLibraryTranscodingCountQuery({
 *   variables: {
 *      count: // value for 'count'
 *      types: // value for 'types'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetVideoLibraryTranscodingCountQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetVideoLibraryTranscodingCountQuery, GetVideoLibraryTranscodingCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetVideoLibraryTranscodingCountQuery, GetVideoLibraryTranscodingCountQueryVariables>(GetVideoLibraryTranscodingCountDocument, options);
      }
export function useGetVideoLibraryTranscodingCountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetVideoLibraryTranscodingCountQuery, GetVideoLibraryTranscodingCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetVideoLibraryTranscodingCountQuery, GetVideoLibraryTranscodingCountQueryVariables>(GetVideoLibraryTranscodingCountDocument, options);
        }
export function useGetVideoLibraryTranscodingCountSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetVideoLibraryTranscodingCountQuery, GetVideoLibraryTranscodingCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetVideoLibraryTranscodingCountQuery, GetVideoLibraryTranscodingCountQueryVariables>(GetVideoLibraryTranscodingCountDocument, options);
        }
export type GetVideoLibraryTranscodingCountQueryHookResult = ReturnType<typeof useGetVideoLibraryTranscodingCountQuery>;
export type GetVideoLibraryTranscodingCountLazyQueryHookResult = ReturnType<typeof useGetVideoLibraryTranscodingCountLazyQuery>;
export type GetVideoLibraryTranscodingCountSuspenseQueryHookResult = ReturnType<typeof useGetVideoLibraryTranscodingCountSuspenseQuery>;
export type GetVideoLibraryTranscodingCountQueryResult = Apollo.QueryResult<GetVideoLibraryTranscodingCountQuery, GetVideoLibraryTranscodingCountQueryVariables>;
export const GetVideoLibraryMarketingVideoDateDocument = gql`
    query GetVideoLibraryMarketingVideoDate($contestId: Int!) {
  media {
    contest(id: $contestId) {
      ...ContestVideo
    }
  }
}
    ${ContestVideoFragmentDoc}`;

/**
 * __useGetVideoLibraryMarketingVideoDateQuery__
 *
 * To run a query within a React component, call `useGetVideoLibraryMarketingVideoDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVideoLibraryMarketingVideoDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVideoLibraryMarketingVideoDateQuery({
 *   variables: {
 *      contestId: // value for 'contestId'
 *   },
 * });
 */
export function useGetVideoLibraryMarketingVideoDateQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetVideoLibraryMarketingVideoDateQuery, GetVideoLibraryMarketingVideoDateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetVideoLibraryMarketingVideoDateQuery, GetVideoLibraryMarketingVideoDateQueryVariables>(GetVideoLibraryMarketingVideoDateDocument, options);
      }
export function useGetVideoLibraryMarketingVideoDateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetVideoLibraryMarketingVideoDateQuery, GetVideoLibraryMarketingVideoDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetVideoLibraryMarketingVideoDateQuery, GetVideoLibraryMarketingVideoDateQueryVariables>(GetVideoLibraryMarketingVideoDateDocument, options);
        }
export function useGetVideoLibraryMarketingVideoDateSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetVideoLibraryMarketingVideoDateQuery, GetVideoLibraryMarketingVideoDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetVideoLibraryMarketingVideoDateQuery, GetVideoLibraryMarketingVideoDateQueryVariables>(GetVideoLibraryMarketingVideoDateDocument, options);
        }
export type GetVideoLibraryMarketingVideoDateQueryHookResult = ReturnType<typeof useGetVideoLibraryMarketingVideoDateQuery>;
export type GetVideoLibraryMarketingVideoDateLazyQueryHookResult = ReturnType<typeof useGetVideoLibraryMarketingVideoDateLazyQuery>;
export type GetVideoLibraryMarketingVideoDateSuspenseQueryHookResult = ReturnType<typeof useGetVideoLibraryMarketingVideoDateSuspenseQuery>;
export type GetVideoLibraryMarketingVideoDateQueryResult = Apollo.QueryResult<GetVideoLibraryMarketingVideoDateQuery, GetVideoLibraryMarketingVideoDateQueryVariables>;